/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 82);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(90)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(47);
var isBuffer = __webpack_require__(139);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-topo-candidato-laranja--5a0aa5ac.jpg";

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatBRL; });
/* unused harmony export cleanPhone */
/* unused harmony export formatDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatCNPJ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeAccented; });
/* unused harmony export formatDateBasic */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatBRLDec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return randomizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
function validate(fields) {
  var keys = Object.keys(fields);
  var errors = {};
  var valid = true;

  // eslint-disable-next-line
  keys.map(function (item) {
    if (fields[item] === "") {
      valid = false;
      errors[item] = "Campo obrigatório";
    }
  });

  return { valid: valid, errors: errors };
}

function formatBRLDec(amount) {
  var formated = "" + amount;
  formated = formated.replace(/([0-9]{2})$/g, ",$1");

  if (formated.length > 6) {
    formated = formated.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
  }

  return formated;
}

function formatBRL(amount) {
  var formated = "" + amount;

  formated = formated.substring(0, formated.length - 2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

  return formated;
}

function cleanPhone(phone) {
  return "+55" + phone.trim().replace(/\W+/g, "").replace(/\D+/g, "");
}

function formatDate(data) {
  var week = ["Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado", "Domingo"];
  var months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  var date = new Date(data);

  var weekDay = week[date.getDay()];
  var day = date.getDate();
  var month = months[date.getMonth()];
  var year = date.getFullYear();

  var time = data.split("T")[1].replace(":", "h").split(":")[0];

  return weekDay + ", " + day + " de " + month + " de " + year + " - " + time;
}

function removeAccented(value) {
  var newString = value.toLowerCase();
  var mapaAcentosHex = {
    a: /[\xE0-\xE6]/g,
    e: /[\xE8-\xEB]/g,
    i: /[\xEC-\xEF]/g,
    o: /[\xF2-\xF6]/g,
    u: /[\xF9-\xFC]/g,
    c: /\xE7/g,
    n: /\xF1/g
  };
  var keys = Object.keys(mapaAcentosHex);

  keys.map(function (item) {
    var expressaoRegular = mapaAcentosHex[item];
    newString = newString.replace(expressaoRegular, item);
  });

  return newString;
}

function formatDateBasic(date) {
  if (date) {
    var newDate = date.split(" ")[0].split("-");
    return newDate.reverse().join("/");
  }
  return date;
}

function formatCNPJ(value) {
  return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

function randomizer(toRandomize) {
  var currentIndex = toRandomize.length;
  var randomIndex = 0;
  var temporaryValue = null;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue = toRandomize[currentIndex];
    toRandomize[currentIndex] = toRandomize[randomIndex];
    toRandomize[randomIndex] = temporaryValue;
  }

  return toRandomize;
}

function getQueryString(url) {
  var queryString = url.indexOf('?') !== -1 ? url.split('?')[1] : [];
  var params = {};
  var queries = queryString.indexOf('&') !== -1 ? queryString.split('&') : [queryString];

  for (var i = 0; i < queries.length; i += 1) {
    var element = queries[i].indexOf('=') !== -1 ? queries[i].split('=') : [queries[i], null];
    params[decodeURIComponent(element[0])] = decodeURIComponent(element[1] || '');
  }
  return params;
}

// eslint-disable-next-line


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "votolegal-white--c2b2fdd3.png";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "loading--6c437d18.svg";

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* unused harmony export mapGetters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapMutations; });
/* unused harmony export mapState */
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
  if (!valid && haveExpectedTypes) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType (value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (
    expectedTypes.length === 1 &&
    isExplicable(expectedType) &&
    isExplicable(typeof value) &&
    !isBoolean(expectedType, receivedType)
  ) {
    message += " with value " + (styleValue(value, expectedType));
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + (styleValue(value, receivedType)) + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable (value) {
  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (
      !vnode ||
      (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallbackRender,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes =
      scopedSlotFn(props) ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes =
      this.$slots[name] ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
  return eventKeyCode === undefined
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  // we know it's MountedComponentVNode but flow doesn't
  vnode,
  // activeInstance in lifecycle state
  parent
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
    (!newScopedSlots && vm.$scopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + (this.expression) + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn(("The computed property \"" + key + "\" is already defined as a method."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */





function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance,
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  updated: function updated () {
    this.cacheVNode();
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.asyncFactory === b.asyncFactory && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!(
    el.component ||
    el.attrsMap[':is'] ||
    el.attrsMap['v-bind:is'] ||
    !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
  ); };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + ".apply(null, arguments)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ").apply(null, arguments)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11), __webpack_require__(83).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "twitter-icon--c3d9d107.png";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "youtube-icon--ca29681f.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "facebook-icon--610bfb58.png";

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var config = {
  contract: 'https://participe.votolegal.com.br/files/Termo%20de%20uso%20e%20Politica%20de%20privacidade%20(unificado)%20-%20Voto%20Legal%20-%202020%402020-09-23.pdf',
  taxes: {
    CREDIT_CARD_TEXT: '5,5%',
    PAYMENT_SLIP_TEXT: '3,5% + R$ 3,90',
    PAYMENT_PIX_TEXT: '2,99%',
    CREDIT_CARD_TAX_PERCENT: 0.055,
    PAYMENT_SLIP_TAX_PERCENT: 0.035,
    PAYMENT_PIX_PERCENT: 0.0299,
    CREDIT_CARD_TAX: 0,
    PAYMENT_SLIP_TAX: 299
  }
};

module.exports = config;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueTheMask=t():e.VueTheMask=t()})(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p=".",t(t.s=10)}([function(e,t){e.exports={"#":{pattern:/\d/},X:{pattern:/[0-9a-zA-Z]/},S:{pattern:/[a-zA-Z]/},A:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleUpperCase()}},a:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleLowerCase()}},"!":{escape:!0}}},function(e,t,n){"use strict";function r(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}var a=n(2),o=n(0),i=n.n(o);t.a=function(e,t){var o=t.value;if((Array.isArray(o)||"string"==typeof o)&&(o={mask:o,tokens:i.a}),"INPUT"!==e.tagName.toLocaleUpperCase()){var u=e.getElementsByTagName("input");if(1!==u.length)throw new Error("v-mask directive requires 1 input, found "+u.length);e=u[0]}e.oninput=function(t){if(t.isTrusted){var i=e.selectionEnd,u=e.value[i-1];for(e.value=n.i(a.a)(e.value,o.mask,!0,o.tokens);i<e.value.length&&e.value.charAt(i-1)!==u;)i++;e===document.activeElement&&(e.setSelectionRange(i,i),setTimeout(function(){e.setSelectionRange(i,i)},0)),e.dispatchEvent(r("input"))}};var s=n.i(a.a)(e.value,o.mask,!0,o.tokens);s!==e.value&&(e.value=s,e.dispatchEvent(r("input")))}},function(e,t,n){"use strict";var r=n(6),a=n(5);t.a=function(e,t){var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=arguments[3];return Array.isArray(t)?n.i(a.a)(r.a,t,i)(e,t,o,i):n.i(r.a)(e,t,o,i)}},function(e,t,n){"use strict";function r(e){e.component(s.a.name,s.a),e.directive("mask",i.a)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),o=n.n(a),i=n(1),u=n(7),s=n.n(u);n.d(t,"TheMask",function(){return s.a}),n.d(t,"mask",function(){return i.a}),n.d(t,"tokens",function(){return o.a}),n.d(t,"version",function(){return c});var c="0.11.1";t.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),a=n(0),o=n.n(a),i=n(2);t.default={name:"TheMask",props:{value:[String,Number],mask:{type:[String,Array],required:!0},masked:{type:Boolean,default:!1},tokens:{type:Object,default:function(){return o.a}}},directives:{mask:r.a},data:function(){return{lastValue:null,display:this.value}},watch:{value:function(e){e!==this.lastValue&&(this.display=e)},masked:function(){this.refresh(this.display)}},computed:{config:function(){return{mask:this.mask,tokens:this.tokens,masked:this.masked}}},methods:{onInput:function(e){e.isTrusted||this.refresh(e.target.value)},refresh:function(e){this.display=e;var e=n.i(i.a)(e,this.mask,this.masked,this.tokens);e!==this.lastValue&&(this.lastValue=e,this.$emit("input",e))}}}},function(e,t,n){"use strict";function r(e,t,n){return t=t.sort(function(e,t){return e.length-t.length}),function(r,a){for(var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=0;i<t.length;){var u=t[i];i++;var s=t[i];if(!(s&&e(r,s,!0,n).length>u.length))return e(r,u,o,n)}return""}}t.a=r},function(e,t,n){"use strict";function r(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=arguments[3];e=e||"",t=t||"";for(var a=0,o=0,i="";a<t.length&&o<e.length;){var u=t[a],s=r[u],c=e[o];s&&!s.escape?(s.pattern.test(c)&&(i+=s.transform?s.transform(c):c,a++),o++):(s&&s.escape&&(a++,u=t[a]),n&&(i+=u),c===u&&o++,a++)}for(var f="";a<t.length&&n;){var u=t[a];if(r[u]){f="";break}f+=u,a++}return i+f}t.a=r},function(e,t,n){var r=n(8)(n(4),n(9),null,null);e.exports=r.exports},function(e,t){e.exports=function(e,t,n,r){var a,o=e=e||{},i=typeof e.default;"object"!==i&&"function"!==i||(a=e,o=e.default);var u="function"==typeof o?o.options:o;if(t&&(u.render=t.render,u.staticRenderFns=t.staticRenderFns),n&&(u._scopeId=n),r){var s=u.computed||(u.computed={});Object.keys(r).forEach(function(e){var t=r[e];s[e]=function(){return t}})}return{esModule:a,exports:o,options:u}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{directives:[{name:"mask",rawName:"v-mask",value:e.config,expression:"config"}],attrs:{type:"text"},domProps:{value:e.display},on:{input:e.onInput}})},staticRenderFns:[]}},function(e,t,n){e.exports=n(3)}])});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-pricing--20d5f626.png";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(138);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(4);
var normalizeHeaderName = __webpack_require__(141);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(48);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(48);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "selo--aed1062f.jpg";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "twitter-dark--83ef163c.png";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "whatsapp-dark--e098fad6.png";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "youtube-dark--276e992d.png";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "instagram-dark--868f8387.png";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "facebook-dark--07c734f8.png";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "website-dark--3ae915ad.png";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "email-dark--a4560d42.png";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-topo-candidato-vermelho--3b4f6827.jpg";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-topo-candidato-azul--fb9f3c85.jpg";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-topo-candidato-verde--d4b7d517.jpg";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "votolegal-icon-small--73884fcb.png";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "votolegal-icon--111ae335.jpg";

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_theader_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tfooter_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_head__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: {
    theader: __WEBPACK_IMPORTED_MODULE_0__components_theader_vue__["a" /* default */],
    tfooter: __WEBPACK_IMPORTED_MODULE_1__components_tfooter_vue__["a" /* default */]
  },
  data: function data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  mounted: function mounted() {
    window.prerenderReady = window.prerenderReady || true;
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Theader',

	data: function data() {
		return {};
	},
	created: function created() {
		this.$nextTick(function () {
			this.next();
			this.scrollMenu();
			this.showMenu();
		});
	},

	methods: {
		next: function next() {
			var dom = document.querySelectorAll('nav li a');
			dom.forEach(function (element) {
				element.addEventListener('click', function (e) {
					if (e.target.href.search('#contato')) {
						console.log('teste');
					}
				});
			}, this);
		},
		scrollMenu: function scrollMenu() {
			var _this = this;

			var element = document.querySelector('.nav');
			var resizeLogo = document.querySelector('.votolegal');

			window.addEventListener('scroll', function (e) {
				var newOffset = window.scrollY;
				var currentRouteName = _this.$route.name;

				if (currentRouteName === 'home') {
					if (newOffset > 95 && window.matchMedia("(min-width: 1200px)").matches) {
						element.classList.add('animate');

						if (newOffset > 200) {
							resizeLogo.classList.add('votolegal-small');
						}
					} else if (newOffset > 62 && window.matchMedia("(min-width: 928px)").matches) {
						element.classList.add('animate');
						resizeLogo.classList.add('votolegal-small');
					} else if (newOffset > 0 && window.matchMedia("(max-width: 929px)").matches) {
						element.classList.add('animate-small');
						resizeLogo.classList.add('votolegal-small');
					} else {
						element.classList.remove('animate');
						element.classList.remove('animate-small');
						resizeLogo.classList.remove('votolegal-small');
					}
				} else {
					if (newOffset > 1) {
						element.classList.add('animate');
						resizeLogo.classList.add('votolegal-small');
					} else {
						element.classList.remove('animate');
						resizeLogo.classList.remove('votolegal-small');
					}
				}
			});
		},
		showMenu: function showMenu() {
			var element = document.querySelector('.mobile-button');
			var menu = document.querySelector('.menu-wrap');
			element.addEventListener('click', function () {
				menu.classList.toggle('show');
			});
		}
	}
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'tfooter'
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
;(function() {

  'use strict'

  var opt = {
    complement: window.document.title,
    separator: '|'
  }

  var diffTitle = {}
  var els = []
  var diffEls = []
  var installed = false

  var util = {
    /**
     * Shorthand
     * @type {Object}
     */
    shorthand: {
      ch: 'charset',
      tg: 'target',
      n: 'name',
      he: 'http-equiv',
      ip: 'itemprop',
      c: 'content',
      p: 'property',
      sc: 'scheme',
      r: 'rel',
      h: 'href',
      sz: 'sizes',
      t: 'type',
      s: 'src',
      a: 'async',
      d: 'defer',
      i: 'inner'
    },

    /**
     * This function return the element <head>
     * @type {Function}
     * @return {Object}
     */
    getPlace: function (place) {
      return window.document.getElementsByTagName(place)[0]
    },

    /**
     * Undo the window.document title for previous state
     * @type {Function}
     * @param  {Object} state
     */
    undoTitle: function (state) {
      if (!state.before) return
      window.document.title = state.before
    },

    /**
     * Undo elements to its previous state
     * @type {Function}
     */
    undo: function () {
      if (!els.length) return
      els.forEach(function (el) {
        el.parentElement.removeChild(el)
      })
      els = []
    },

    /**
     * Set attributes in element
     * @type {Function}
     * @param  {Object} obj
     * @param  {HTMLElement} el
     * @return {HTMLElement} with defined attributes
     */
    prepareElement: function (obj, el) {
      var self = this
      Object.keys(obj).forEach(function (prop) {
        var sh = self.shorthand[prop] || prop
        if (sh.match(/(body|undo|replace)/g)) return
        if (sh === 'inner') {
          el.textContent = obj[prop]
          return
        }
        el.setAttribute(sh, obj[prop])
      })
      return el
    },

    /**
     * Change window.document title
     * @type {Function}
     * @param  {Object} obj
     */
    title: function (obj) {
      if (!obj) return
      diffTitle.before = opt.complement
      var title = obj.inner + ' ' + (obj.separator || opt.separator) +
        ' ' +  (obj.complement || opt.complement)
      window.document.title = title.trim()
    },

    /**
     * Update Element
     */
    update: function () {
      if (!els.length) return
      els.forEach(function(el, key) {
        if (diffEls[key] && !diffEls[key].isEqualNode(el)) {
          el.parentElement.replaceChild(diffEls[key], els[key])
          els.splice(key, 1, diffEls[key])
          return
        }
      })
      diffEls = []
    },

    /**
     * Add Elements
     * @param {Object} obj
     * @param {HTMLElement} el
     * @param {HTMLElement} parent
     */
    add: function (obj, el, parent) {
      parent.appendChild(el)
      // Fixed elements that do not suffer removal
      if (obj.undo !== undefined && !obj.undo) return
      // Elements which are removed
      els.push(el)
    },

    /**
     * Handle of create elements
     * @type {Function}
     * @param  {Array} arr
     * @param  {String} tag   - style, link, meta, script, base
     * @param  {String} place - Default 'head'
     * @param  {Boolean} update
     */
    handle: function (arr, tag, place, update) {
      var self = this
      if (!arr) return
      arr.forEach(function (obj) {
        var parent = (obj.body) ? self.getPlace('body') : self.getPlace(place)
        var el = window.document.getElementById(obj.id)
        if (!el) {
          el = window.document.createElement(tag)
          update = false
        }
        // Elements that will substitute data
        if (el.hasAttribute('id')) {
          self.prepareElement(obj, el)
          return
        }
        // Other elements
        el = self.prepareElement(obj, el)
        // Updated elements
        if (update) {
          diffEls.push(el)
          return
        }
        // Append Elements
        self.add(obj, el, parent)
      })
    }
  }

  /**
   * Plugin | vue-head
   * @param  {Function} Vue
   * @param  {Object} options
   */
  function VueHead (Vue, options) {
    if (installed) return

    installed = true

    if (options) {
      Vue.util.extend(opt, options)
    }

    /**
     * Initializes and updates the elements in the head
     * @param  {Boolean} update
     */
    function init (update) {
      var self = this
      var head = (typeof self.$options.head === 'function') ? self.$options.head.bind(self)() : self.$options.head
      if (!head) return
      Object.keys(head).forEach(function (key) {
        var prop = head[key]
        if (!prop) return
        var obj = (typeof prop === 'function') ? head[key].bind(self)() : head[key]
        if (key === 'title') {
          util[key](obj)
          return
        }
        util.handle(obj, key, 'head', update)
      })
      self.$emit('okHead')
    }

    /**
     * Remove the meta tags elements in the head
     */
    function destroy () {
      if (!this.$options.head) return
      util.undoTitle(diffTitle)
      util.undo()
    }

    // v1
    if (Vue.version.match(/[1].(.)+/g)) {
      Vue.mixin({
        ready: function () {
          init.call(this)
        },
        destroyed: function () {
          destroy.call(this)
        },
        events: {
          updateHead: function () {
            init.call(this, true)
            util.update()
          }
        }
      })
    }
    // v2
    if (Vue.version.match(/[2].(.)+/g)) {
      Vue.mixin({
        created: function () {
          var self = this
          self.$on('updateHead', function () {
            init.call(this, true)
            util.update()
          })
        },
        mounted: function () {
          init.call(this)
        },
        beforeDestroy: function () {
          destroy.call(this)
        }
      })
    }
  }

  VueHead.version = '2.2.0'

  // auto install
  if (typeof Vue !== 'undefined') {
    Vue.use(VueHead)
  }

  if(true) {
    module.exports = VueHead
  } else if(typeof define === 'function' && define.amd) {
    define(function () { return VueHead })
  } else if (typeof window !== 'undefined') {
    window.VueHead = VueHead
  }

})()


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-pricing-small--ba458abb.png";

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "notFound",
  head: {
    title: function title() {
      return {
        inner: 'Não encontrado',
        complement: 'Voto Legal'
      };
    },
    meta: function meta() {
      return [{
        name: 'prerender-status-code',
        content: 404
      }];
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authenticitysection_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mentorshipsection_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chatbotsection_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__candidatesSection_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__facedetectsection_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__managementsection_vue__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__midiasection_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pricingsection_vue__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__statisticssection_vue__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__advantagessection_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__videosection_vue__ = __webpack_require__(220);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  components: {
    authenticitysection: __WEBPACK_IMPORTED_MODULE_0__authenticitysection_vue__["a" /* default */],
    facedetectsection: __WEBPACK_IMPORTED_MODULE_4__facedetectsection_vue__["a" /* default */],
    mentorshipsection: __WEBPACK_IMPORTED_MODULE_1__mentorshipsection_vue__["a" /* default */],
    chatbotsection: __WEBPACK_IMPORTED_MODULE_2__chatbotsection_vue__["a" /* default */],
    videosection: __WEBPACK_IMPORTED_MODULE_10__videosection_vue__["a" /* default */],
    managementsection: __WEBPACK_IMPORTED_MODULE_5__managementsection_vue__["a" /* default */],
    midiasection: __WEBPACK_IMPORTED_MODULE_6__midiasection_vue__["a" /* default */],
    pricingsection: __WEBPACK_IMPORTED_MODULE_7__pricingsection_vue__["a" /* default */],
    candidatesSection: __WEBPACK_IMPORTED_MODULE_3__candidatesSection_vue__["a" /* default */],
    statisticssection: __WEBPACK_IMPORTED_MODULE_8__statisticssection_vue__["a" /* default */],
    advantagessection: __WEBPACK_IMPORTED_MODULE_9__advantagessection_vue__["a" /* default */]
  },
  data: function data() {
    return {
      promotionalPrice: 699
    };
  },
  mounted: function mounted() {
    window.fbq('init', '258660308900348');
    window.fbq('track', 'PageView');
  },

  methods: {
    scrollTo: function scrollTo($event) {
      var targetQuery = $event.target.getAttribute('href');
      var targetEl = document.querySelector(targetQuery);

      targetEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.history.pushState(null, null, targetQuery);
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Authenticitysection"
});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-blockchain--2b72976e.png";

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Mentorshipsection"
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "chatbotsection",
  methods: {
    scrollTo: function scrollTo($event) {
      var targetQuery = $event.target.getAttribute('href');
      var targetEl = document.querySelector(targetQuery);

      targetEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.history.pushState(null, null, targetQuery);
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sites--c9a5470a.jpg";

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config_development_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_config_development_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__store_config_development_js__);
var _this = this;





var images = __webpack_require__(155);

var sortByOffice = function sortByOffice(list) {
	if (list.length > 0) {
		var officeNames = ["Presidenta", "Presidente", "Deputada Federal", "Deputado Federal", "Deputado(a) Federal", "Senadora", "Senador", "Senador(a)", "Governadora", "Governador", "Governador(a)", "Deputada Distrital", "Deputado Distrital", "Deputado(a) Distrital", "Deputada Estadual", "Deputado Estadual", "Deputado(a) Estadual", "Prefeito", "Prefeita", "Prefeito(a)", "Vice-prefeita", "Vice-prefeito", "Vice-prefeito(a)", "Vereadora", "Vereador", "Vereador(a)"];

		return (list || []).sort(function (a, b) {
			var officeA = officeNames.indexOf(a.office);
			var officeB = officeNames.indexOf(b.office);

			if (officeA !== officeB) {
				return officeA < officeB ? -1 : 1;
			} else {
				return 0;
			}
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'candidatesSection',
	data: function data() {
		return {
			electionList: [],

			loading: true
		};
	},

	computed: {
		sortedElectionList: function sortedElectionList() {
			return this.electionList.sort(function (a, b) {
				return a.year < b.year ? 1 : -1;
			});
		}
	},
	methods: {
		imgUrl: function imgUrl(path) {
			return images('./' + path);
		},

		$_getCandidates: function $_getCandidates() {
			var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/api/candidate-metadata';

			_this.loading = true;

			return new Promise(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(endpoint).then(function (response) {
					var candidates = response.data.candidates || [];

					_this.loading = false;

					resolve(candidates);
				}).catch(function (error) {
					reject(error);
				});
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.$_getCandidates().then(function (result) {
			_this2.electionList.push({
				intro: 'Conheca alguns dos lideres que já estão usando o Voto Legal em 2020',
				candidates: result,
				year: 2020
			});
		});
		this.$_getCandidates('/static/candidate-metadata.json').then(function (result) {
			_this2.electionList.push({
				intro: 'Alguns dos lideres que usaram o Voto Legal em 2018',
				candidates: sortByOffice(Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["e" /* randomizer */])(result)),
				year: 2018
			});
		});
	}
});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var settle = __webpack_require__(142);
var buildURL = __webpack_require__(144);
var parseHeaders = __webpack_require__(145);
var isURLSameOrigin = __webpack_require__(146);
var createError = __webpack_require__(49);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(147);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(143);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

var config = {
  api: window.location.host === 'votolegal.com.br' || window.location.host === 'votolegal.com' || window.location.host === '2020.votolegal.com.br' || window.location.host === '2020.votolegal.com' ? 'https://api2020vl.appcivico.com' : 'https://votolegal-test-api.appcivico.com'
};

module.exports = config;

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Facedetectsection"
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-gestao@2x--d04e5e11.jpg";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-gestao@3x--5ded3984.jpg";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-gestao-top@2x--2d36f7ae.png";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-gestao-top@3x--eaa41bff.png";

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Managementsection',
  methods: {
    scrollTo: function scrollTo($event) {
      var targetQuery = $event.target.getAttribute('href');
      var targetEl = document.querySelector(targetQuery);

      targetEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.history.pushState(null, null, targetQuery);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'midiasection',

	methods: {
		next: function next() {
			var dom = document.querySelectorAll('nav li a');
			dom.forEach(function (element) {
				element.addEventListener('click', function (e) {
					console.log(e.target);
				});
			}, this);
		}
	},
	created: function created() {
		this.$nextTick(function () {});
	}
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      email: '',

      creditCard: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.CREDIT_CARD_TEXT,
      paymentSlip: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.PAYMENT_SLIP_TEXT,
      paymentPix: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.PAYMENT_PIX_TEXT,
      promotionalPrice: 699,

      errorMessage: '',
      successMessage: '',

      discountedOfferingId: '26894679-ea65-4f93-a181-29e809638a98',

      validation: {
        errors: {
          zip_code: ''
        }
      },

      ref: '',
      pcLog: '',
      canRedirect: 1
    };
  },


  computed: {
    api: function api() {
      return window.location.host === 'votolegal.com.br' || window.location.host === 'votolegal.com' || window.location.host === '2018.votolegal.com.br' || window.location.host === '2018.votolegal.com' ? 'https://touchbase-api.appcivico.com' : 'https://dev-touchbase-api.appcivico.com';
    }
  },

  created: function created() {
    this.ref = window.localStorage.getItem('ref') || this.$route.query.ref;

    this.pcLog = window.localStorage.getItem('pcLog');

    this.initTrackRefs();
  },


  methods: {
    initTrackRefs: function initTrackRefs() {
      var _this = this;

      var apiRequestPath = this.api + '/referrer-pageview';
      var ref = this.ref,
          pcLog = this.pcLog;


      if (ref) {
        var data = { ref: ref };

        if (pcLog) {
          data.pclog = pcLog;
        }

        fetch(apiRequestPath, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams(data).toString()
        }).then(function (response) {
          var contentType = response.headers.get('content-type');
          if (!response.ok) {
            throw new Error(String(response.status));
          }

          if (!contentType || !contentType.includes('application/json')) {
            throw new Error('Oops, we haven\'t got JSON!');
          }

          return response.json();
        }).then(function (jsonData) {
          if (jsonData.pclog) {
            _this.pcLog = jsonData.pclog;
            window.localStorage.setItem('pclog', jsonData.pclog);
          }
        }).catch(function (err) {
          throw new Error(err.message);
        });
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      var submissionUrl = this.api + '/quick_purchase/request_token';

      // append querystring existing parameters to post
      // submissionUrl += `?querystring=${window.location.search}`;

      var canRedirect = this.canRedirect,
          ref = this.ref,
          pcLog = this.pcLog;


      var data = {
        email: this.email,
        discounted_offering_id: this.discountedOfferingId
      };

      if (canRedirect) {
        data.can_redirect = this.canRedirect;
      }

      if (pcLog) {
        data.pclog = this.pcLog;
      }

      if (ref) {
        data.ref = this.ref;
      }

      data.querystring = location.search;

      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';

      fetch(submissionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data).toString()
      }).then(function (response) {
        var contentType = response.headers.get('content-type');
        if (!response.ok) {
          return response.json().then(function (x) {
            throw new Error(x.message);
          });
        }

        if (!contentType || !contentType.includes('application/json')) {
          _this2.errorMessage = 'Oops, we haven\'t got JSON!';

          throw new Error('Oops, we haven\'t got JSON!');
        }

        return response.json();
      }).then(function (jsonData) {
        if (jsonData.redirect_to) {
          window.location = jsonData.redirect_to;
          return;
        }
        _this2.successMessage = jsonData.message || 'Solicitação efetivada com sucesso. Consulte a caixa de entrada de sua conta de email';
      }).catch(function (err) {
        _this2.errorMessage = err.message;
        _this2.loading = false;
      });
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "statisticssection"
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "advantagessection",

  data: function data() {
    return {
      cards: [{
        title: 'Doação via celular!',
        description: 'Você não precisa de aplicativo, nem maquininha. Capte doações direto do celular em todos os momentos.',
        imgPath: 'static/cards/phone.svg'
      }, {
        title: 'Domínio personalizado',
        description: 'Crie um domínio personalizado para sua campanha, sem custo adicional.',
        imgPath: 'static/cards/computer.svg'
      }, {
        title: 'Taxas sem pegadinhas!',
        description: 'Não há taxas adicionais para transferências de recursos semanais, sistemas de antifraude ou operadora de cartão de crédito.',
        imgPath: 'static/cards/tax.svg'
      }, {
        title: 'Arquivo de importação',
        description: 'Não perca tempo digitando doações no SPCE, gere arquivos de importação em cliques.',
        imgPath: 'static/cards/file.svg'
      }, {
        title: 'Sistema antifraude',
        description: 'Conte com um sistema dedicado ao combate de fraudes e ataques.',
        imgPath: 'static/cards/security.svg'
      }, {
        title: 'Redes sociais',
        description: 'Facilite o compartilhamento de sua campanha nas redes sociais e apps de mensagens.',
        imgPath: 'static/cards/connect.svg'
      }, {
        title: '15 minutos',
        description: 'É o tempo que você precisa para colocar sua campanha no ar. Gerencie seu conteúdo por conta própria!',
        imgPath: 'static/cards/stopwatch.svg'
      }, {
        title: 'Homologado no TSE',
        description: '100% de aprovação da prestação de contas do financiamento coletivo dos nossos clientes. Plataforma homologada pelo TSE',
        imgPath: 'static/cards/gavel.svg'
      }]
    };
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_micromodal__ = __webpack_require__(224);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Videosection",

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_micromodal__["a" /* default */].init({
      onClose: function onClose(modal) {
        document.querySelector('#modal-1 iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    });
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'parceiros'
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'perguntasfrequentes',
	data: function data() {
		return {};
	},

	methods: {
		clearClass: function clearClass() {
			var el = document.querySelectorAll('#perguntas-frequentes .panel');
			el.forEach(function (e) {
				e.classList.remove('show');
			}, this);
		},
		controlAcordion: function controlAcordion() {
			var _this = this;

			var ac = document.querySelectorAll('#perguntas-frequentes .accordion');
			ac.forEach(function (e) {
				e.addEventListener('click', function (e) {
					_this.clearClass();
					e.target.nextElementSibling.classList.toggle('show');
				});
			});
		}
	},
	created: function created() {
		this.$nextTick(function () {
			this.controlAcordion();
		});
	}
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_loadme_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_loadme_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vendor_loadme_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Payment_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Ticket_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pagination_pagination_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_animated_number_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_animated_number_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_animated_number_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Candidate',
	directives: {
		money: __WEBPACK_IMPORTED_MODULE_1_v_money__["VMoney"]
	},
	components: {
		Payment: __WEBPACK_IMPORTED_MODULE_3__Payment_vue__["a" /* default */],
		Ticket: __WEBPACK_IMPORTED_MODULE_4__Ticket_vue__["a" /* default */],
		AnimatedNumber: __WEBPACK_IMPORTED_MODULE_6_animated_number_vue___default.a
	},
	data: function data() {
		return {
			money: {
				decimal: ',',
				thousands: '.',
				prefix: 'R$ ',
				suffix: '',
				precision: 2
			},
			videoId: '',
			status: true,
			errorMessage: '',
			teste: '',
			activeSection: 'projetos',
			colors: {
				'default': '#ff6633',
				'theme--default': '#ff6633',
				'theme--orange': '#ff6633',
				'theme--red': '#ed1941',
				'theme--blue': '#0072bc',
				'theme--green': '#339966'
			},
			defaultDescription: 'Voto Legal - Transparência e segurança em doações eleitorais'
		};
	},


	computed: {
		isCrawler: function isCrawler() {
			return (/bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(navigator.userAgent)
			);
		},
		offices: function offices() {
			return this.$store.state.offices || {};
		},
		getMergeCandidate: function getMergeCandidate() {
			return this.$store.getters.generateCandidateObject;
		},
		donations: function donations() {
			return this.$store.state.donations;
		},
		hasMoreDonations: function hasMoreDonations() {
			return this.$store.state.hasMoreDonations;
		},
		tickets: function tickets() {
			return this.$store.state.tickets;
		},
		hasMoreTickets: function hasMoreTickets() {
			return this.$store.state.hasMoreTickets;
		},
		goal: function goal() {
			return this.candidate.raising_goal;
		},
		candidate: function candidate() {
			return this.getMergeCandidate.candidate;
		},
		donationSources: function donationSources() {
			var opacity = 0;
			return this.$store.state.donationSources.map(function (x) {
				var y = x;
				y.opacity = opacity;
				opacity += 0.25;
				return y;
			});
		},
		totalAmount: function totalAmount() {
			return this.donationSources.length ? this.donationSources.reduce(function (accumulator, currentValue) {
				return accumulator + currentValue.total_donated;
			}, 0) : this.candidate.total_donated || 0;
		},
		totalDonors: function totalDonors() {
			return this.donationSources.length ? this.donationSources.reduce(function (accumulator, currentValue) {
				return accumulator + Number.parseInt(currentValue.people_donated || 0, 10);
			}, 0) : Number.parseInt(this.candidate.people_donated || 0, 10);
		}
	},
	created: function created() {
		window.addEventListener('message', this.receiveMessage, false);
	},
	mounted: function mounted() {
		this.getCandidateNameUrl();
		this.$store.dispatch('getOffices');
		this.handleSession();
		this.getReferral();
	},
	destroyed: function destroyed() {
		window.removeEventListener('message', this.receiveMessage);
	},

	methods: {
		getCandidateNameUrl: function getCandidateNameUrl() {
			var _this = this;

			this.$store.dispatch('getCandidate', this.$route.params.candidate).then(function (response) {
				//this.$store.dispatch('getCandidateProjects', response.id);
				var videoUrl = _this.candidate.video_url;
				var youtubeMatch = videoUrl.match(/(?:[?&]vi?=|\/embed\/|\/\d\d?\/|\/vi?\/|https?:\/\/(?:www\.)?youtu\.be\/)([^&\n?#]+)/);
				if (youtubeMatch && youtubeMatch[1].length == 11) {
					_this.videoId = youtubeMatch[1];
				} else {
					// TODO Throw error.
				}

				_this.$emit('updateHead');

				_this.activeSection = _this.candidate.projects.length ? 'projetos' : 'sobre';

				if (_this.candidate.google_analytics) {
					ga('create', _this.candidate.google_analytics, 'auto', 'VTcandidate');
					ga('VTcandidate.send', 'pageview');
				}
			}).catch(function (err) {
				if (err.status === 403) {
					_this.errorMessage = 'Candidato desabilitado';
				} else if (err.status === 404) {
					_this.errorMessage = 'Página não encontrada';
				} else if (err.status === 502) {
					_this.errorMessage = 'Página em manutenção. Tente novamente em alguns minutos.';
				} else if (err.status === 429) {
					_this.errorMessage = 'O seu IP acessou nosso serviço numa frequência maior que a esperada. Tente novamente em alguns segundos.';
				} else {
					_this.errorMessage = err.message || err.name || err.data[0].message || '';
				}

				_this.status = false;
			});

			this.$nextTick(function () {
				window.prerenderReady = true;
			});
		},
		handleSession: function handleSession() {
			if (window.localStorage) {
				var tokenName = window.location.host === 'votolegal.com.br' || window.location.host === 'votolegal.com' ? 'prod_vlm_token' : 'dev_vlm_token';
				var token = localStorage.getItem(tokenName);
				if (token !== null) {
					this.$store.dispatch('ADD_TOKEN', token);
				} else {
					this.$store.dispatch('GET_TOKEN').then(function (res) {
						localStorage.setItem(tokenName, res.data.device_authorization_token_id);
					});
				}
			}
		},
		getReferral: function getReferral() {
			var referral = Object(__WEBPACK_IMPORTED_MODULE_7__utilities__["d" /* getQueryString */])(window.location.search).ref;

			if (referral) {
				this.$store.dispatch('ADD_REFERRAL', referral);
			}
		},
		changeSection: function changeSection(section) {
			this.activeSection = section;
		},
		getDonationsList: function getDonationsList() {
			this.$store.dispatch('getCandidateDonations', this.getMergeCandidate.candidate.id);
		},
		getTicketsList: function getTicketsList() {
			this.$store.dispatch('getCandidateTickets', this.getMergeCandidate.candidate.id);
		},
		FormatFixedBRL: function FormatFixedBRL(amount) {
			var formated = '' + (amount / 100).toFixed(2);

			return formated.substring(0, formated.length - 2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.").replace(/\.+$/, '');
		},
		getPlatformName: function getPlatformName(platformCNPJ) {
			return this.$store.state.donationPlatforms.filter(function (x) {
				return x.cnpj === platformCNPJ;
			}).map(function (x) {
				return x.name;
			})[0] || platformCNPJ;
		},
		porcentage: function porcentage() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.totalAmount;

			return Math.round(parseFloat(amount) * 100 / Math.max(this.totalAmount, this.goal));
		},
		progressBarStyle: function progressBarStyle(source) {
			return {
				backgroundImage: 'linear-gradient(rgba(0, 0, 0, ' + source.opacity + '), rgba(0, 0, 0, ' + source.opacity + '))',
				width: this.porcentage(source.total_donated) + '%'
			};
		},
		receiveMessage: function receiveMessage(event) {
			if (event.origin.indexOf('participe.votolegal.com') === -1 && event.origin.indexOf('//dev') === -1 && event.origin.indexOf('//localhost') === -1 && event.origin.indexOf('.local') === -1 && event.origin.indexOf('//192.168.') === -1) {
				return;
			}

			if (!event.data.theme) return;
			this.$refs.candidateRoot.className = event.data.theme;
		}
	},
	head: {
		title: function title() {
			return {
				inner: this.candidate.popular_name || this.$route.params.candidate,
				complement: 'Voto Legal'
			};
		},
		meta: function meta() {
			return [{
				id: 'description',
				name: 'description',
				content: this.candidate.description || this.defaultDescription
			}, {
				id: 'og:locale',
				property: 'og:locale',
				content: 'pt_BR'
			}, {
				id: 'fb:admins',
				property: 'fb:admins',
				content: '1063503096997131'
			}, {
				id: 'og:type',
				property: 'og:type',
				content: 'website'
			}, {
				id: 'twitter:card',
				name: 'twitter:card',
				content: 'summary'
			}, {
				id: 'twitter:creator',
				name: 'twitter:creator',
				content: '@appcivico'
			}, {
				id: 'twitter:description',
				itemprop: 'description',
				name: 'twitter:description',
				property: 'og:description',
				content: this.candidate.description || this.defaultDescription
			}, {
				id: 'image',
				itemprop: 'image',
				name: 'image',
				content: this.candidate.picture || ''
			}, {
				id: 'twitter:title',
				itemprop: 'name',
				name: 'twitter:title',
				property: 'og:title',
				content: 'Eu apoio ' + (this.candidate.popular_name || this.$route.params.candidate) + '! Apoie voc\xEA tamb\xE9m!'
			}, {
				id: 'twitter:url',
				name: 'twitter:url',
				property: 'og:url',
				content: 'https://votolegal.com.br/' + this.candidate.slug
			}, {
				id: 'twitter:site',
				name: 'twitter:site',
				content: this.candidate.twitter_profile || ''
			}, {
				id: 'og:image',
				name: 'twitter:image:src',
				property: 'og:image',
				content: this.candidate.picture || ''
			}];
		}
	}
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps_selectValue_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__steps_userData_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__steps_cardData_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__steps_finalMessage_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_addressData_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_certFaceVerify_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps_printBoleto_vue__ = __webpack_require__(268);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payment',
  components: {
    selectValue: __WEBPACK_IMPORTED_MODULE_0__steps_selectValue_vue__["a" /* default */],
    userData: __WEBPACK_IMPORTED_MODULE_1__steps_userData_vue__["a" /* default */],
    addressData: __WEBPACK_IMPORTED_MODULE_4__steps_addressData_vue__["a" /* default */],
    certFaceVerify: __WEBPACK_IMPORTED_MODULE_5__steps_certFaceVerify_vue__["a" /* default */],
    cardData: __WEBPACK_IMPORTED_MODULE_2__steps_cardData_vue__["a" /* default */],
    finalMessage: __WEBPACK_IMPORTED_MODULE_3__steps_finalMessage_vue__["a" /* default */],
    printBoleto: __WEBPACK_IMPORTED_MODULE_6__steps_printBoleto_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      dataBusyMessage: '',
      certifaceError: false
    };
  },

  computed: {
    paymentStep: function paymentStep() {
      return this.$store.state.paymentStep;
    },
    amount: function amount() {
      return this.$store.state.amount;
    },
    candidate: function candidate() {
      return this.getMergeCandidate.candidate;
    },
    getMergeCandidate: function getMergeCandidate() {
      return this.$store.getters.generateCandidateObject;
    },
    allowedPaymentMethods: function allowedPaymentMethods() {
      return (this.candidate || {}).allowed_payment_methods || ['credit_card', 'boleto'];
    }
  },
  mounted: function mounted() {
    this.getCertiFaceQueryString();
    this.scrollToDonate();
  },

  methods: {
    scrollToDonate: function scrollToDonate() {
      if (this.certifaceError) {
        var form = document.getElementById('doar');
        form.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    },
    toggleLoading: function toggleLoading() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.loading = !this.loading;

      this.dataBusyMessage = this.dataBusyMessage !== message ? message : '';
    },
    getCertiFaceQueryString: function getCertiFaceQueryString() {
      var _this = this;

      if (this.$route.query.donation_id) {
        this.toggleLoading();

        this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'printBoleto' });
        var payload = {
          donationId: this.$route.query.donation_id
        };
        this.$store.dispatch('START_DONATION_BOLETO', payload).then(function (response) {
          _this.toggleLoading();
        }, function (error) {
          _this.toggleLoading();
          _this.certifaceError = true;
          console.error(error);
        });
      }
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'SelectValue',
	directives: {
		mask: __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__["mask"]
	},
	data: function data() {
		return {
			contract: __WEBPACK_IMPORTED_MODULE_2__config_js___default.a.contract,
			errorMessage: '',
			amount: '',
			other: 0,
			pledges: [2000, 5000, 11000, 20000, 25000, 32000, 50000, 75000, 106400],
			maxdonation: false
		};
	},

	computed: {
		candidate: function candidate() {
			return this.$store.state.candidate;
		},
		formatedOther: function formatedOther() {
			return this.other > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["b" /* formatBRLDec */])(this.other) : '';
		}
	},
	mounted: function mounted() {
		this.getDonationAmount();
	},

	methods: {
		validateForm: function validateForm() {
			var amount = this.amount,
			    other = this.other,
			    maxdonation = this.maxdonation;

			var values = amount === 'other' ? { amount: amount, other: other } : { amount: amount };
			var maxvalue = this.candidate ? this.candidate.max_donation_value : 106400;
			var minvalue = this.candidate ? this.candidate.min_donation_value : 2000;

			if (maxdonation) {
				var validation = Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["g" /* validate */])(values);

				if (amount === 'other' && other < minvalue) {
					this.errorMessage = 'O valor m\xEDnimo da doa\xE7\xE3o \xE9 de R$ ' + Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["a" /* formatBRL */])(minvalue);
					this.$refs.otherAmountField.focus();
					return;
				} else if (amount === 'other' && other > maxvalue) {
					this.errorMessage = 'O valor m\xE1ximo da doa\xE7\xE3o \xE9 de R$ ' + Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["a" /* formatBRL */])(maxvalue);
					this.$refs.otherAmountField.focus();
					return;
				}

				if (validation.valid) {
					this.saveStep(values);
				} else {
					this.errorMessage = 'Todos os campos são obrigatórios';
					this.$refs.errorMessageEl.focus();
				}
			} else {
				this.errorMessage = 'É obrigatório concordar com as condições acima.';
				this.$refs.maxdonation.focus();
			}
		},
		saveStep: function saveStep(values) {
			var data = {
				amount: values.amount !== 'other' ? values.amount : this.cleanOther(values.other),
				step: 'userData'
			};

			this.$store.dispatch('CHANGE_PAYMENT_AMOUNT', data);
		},
		cleanOther: function cleanOther(value) {
			return (value + '').replace(/\d{2}$/g, '00');
		},
		checkAmount: function checkAmount() {
			if (this.amount !== '') {
				this.validateForm();
			}
		},
		getDonationAmount: function getDonationAmount() {
			var amount = Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["d" /* getQueryString */])(window.location.search).valor || '';

			/*
   accepted formats:
   10
   R$20
   R$30,00
   R$ 30,00
   R$    60,00
   R$  60,0
   $10
   $ 10
   20reais
   r$20
   10,00
   50 reais
   500   reais
   500,00 reais
   1000,00   reais
   */

			amount = amount.replace(/(?:^r*\$\s*)|(?:(?:,\d{1,2})*(?:\s*reais)*$)/gi, '');
			amount = parseInt(amount, 10) || 0;

			if (amount) {
				amount *= 100;
				window.location.hash = '#outro-valor';
				this.$refs.maxdonation.focus();

				if (this.$data.pledges.indexOf(amount) === -1) {
					this.$data.amount = 'other';
					return this.$data.other = amount;
				} else {
					return this.$data.amount = amount;
				}
			}
		}
	}
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userData_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a6896d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userData_vue__ = __webpack_require__(261);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a6896d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function encode(e) {
    var t = "";
    var n = void 0,
        r = void 0,
        i = void 0,
        s = void 0,
        o = void 0,
        u = void 0,
        a = void 0;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
    }
    return t;
  },
  _utf8_encode: function _utf8_encode(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      } else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }
    return t;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UserData",
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["mask"]
  },
  props: {
    isTicket: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      creditCard: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.CREDIT_CARD_TEXT,
      paymentSlip: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.PAYMENT_SLIP_TEXT,
      creditCardTaxPercent: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.CREDIT_CARD_TAX_PERCENT,
      paymentSlipTaxPercent: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.PAYMENT_SLIP_TAX_PERCENT,
      creditCardTax: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.CREDIT_CARD_TAX,
      paymentSlipTax: __WEBPACK_IMPORTED_MODULE_1__config_js___default.a.taxes.PAYMENT_SLIP_TAX,

      loading: false,
      dataBusyMessage: '',
      errorMessage: "",
      name: "",
      surname: "",
      cpf: "",
      email: "",
      payment_method: "",
      donationFp: "",
      validation: {
        errors: {}
      },
      formData: {}
    };
  },

  computed: {
    candidate: function candidate() {
      return this.getMergeCandidate.candidate;
    },
    getMergeCandidate: function getMergeCandidate() {
      return this.$store.getters.generateCandidateObject;
    },
    amount: function amount() {
      return this.$store.state.amount;
    },
    token: function token() {
      return this.$store.state.token;
    },
    candidateId: function candidateId() {
      return this.$store.state.candidateId;
    },
    getAddress: function getAddress() {
      return this.$store.state.userData;
    },
    candidateAmount: function candidateAmount() {
      var newAmount = null;
      if (this.payment_method === 'credit_card') {
        newAmount = this.amount - this.amount * this.creditCardTaxPercent;
        newAmount = newAmount - this.creditCardTax;
      } else if (this.payment_method === 'boleto') {
        newAmount = this.amount - this.amount * this.paymentSlipTaxPercent;
        newAmount = newAmount - this.paymentSlipTax;
      }
      if (newAmount) {
        return Math.floor(newAmount).toFixed(0);
      }
    },
    allowedPaymentMethods: function allowedPaymentMethods() {
      var allowedMethods = (this.candidate || {}).allowed_payment_methods || ['credit_card', 'boleto'];

      if (allowedMethods.length === 1) {
        this.payment_method = allowedMethods[0];
      }

      return allowedMethods;
    }
  },
  watch: {
    payment_method: function payment_method(newValue, oldValue) {
      if (newValue && !oldValue) {
        if (this.validation.errors.payment_method) {
          this.validation.errors.payment_method = undefined;
        }
      }
    }
  },
  methods: _extends({
    isPaymentMethodAllowed: function isPaymentMethodAllowed() {
      var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return this.allowedPaymentMethods.indexOf(method.toLowerCase()) !== -1;
    },
    goBack: function goBack() {
      if (!this.isTicket) {
        this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'selectValue' });
      } else {
        this.SET_TICKET_STEP({ step: 'intro' });
      }
    },
    scrollToForm: function scrollToForm() {
      var form = this.isTicket ? document.getElementById('votar') : document.getElementById('doar');
      form.scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    toggleLoading: function toggleLoading() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.loading = !this.loading;

      this.dataBusyMessage = this.dataBusyMessage !== message ? message : '';
    },
    validateForm: function validateForm() {
      this.toggleLoading('Validando valor e método...');

      var payment_method = this.payment_method,
          name = this.name,
          surname = this.surname,
          cpf = this.cpf,
          email = this.email;


      var fields = {
        name: name,
        surname: surname,
        cpf: cpf,
        email: email
      };

      if (!this.isTicket) fields.payment_method = payment_method;

      var validation = Object(__WEBPACK_IMPORTED_MODULE_0__utilities__["g" /* validate */])(fields);

      if (validation.valid) {
        this.formData = fields;
        this.registerUser(fields);
        var _name = (this.name + ' ' + this.surname).toUpperCase().trim().replace(/\s/g, "");
        var _cpf = this.cpf.replace(/[^\d]+/g, "");
        var donerData = {
          name: _name,
          cpf: _cpf,
          email: this.email,
          firstName: this.name,
          surname: this.surname,
          cpfDirty: this.cpf,
          amount: this.amount
        };

        var currentDonerData = sessionStorage.getItem('doner-data');

        if (currentDonerData) {
          currentDonerData = JSON.parse(currentDonerData);
          donerData = Object.assign(currentDonerData, donerData);
        }

        // ==  session storage data to ckeck user and cpf in credit card payment == /
        sessionStorage.setItem("doner-data", JSON.stringify(donerData));
      } else {
        this.validation = validation;
        this.toggleLoading();
      }
    },
    registerUser: function registerUser(data) {
      var _this = this;

      this.getDonationFP().then(function () {
        _this.setData(data);
      }).catch(function (error) {
        _this.donationFp = Base64.encode(JSON.stringify({
          id: "error",
          msg: error.toString()
        }));
        _this.setData(data);
      });
    },
    handleErrorMessage: function handleErrorMessage(err) {
      this.errorMessage = err.data[0].message;
    },
    controlSession: function controlSession() {
      var dataSession = JSON.parse(sessionStorage.getItem('doner-data'));
      if (dataSession != null) {
        var data = {
          amount: this.amount != undefined ? this.amount : dataSession.amount,
          step: 'userData'
        };

        if (!this.isTicket) this.$store.dispatch('CHANGE_PAYMENT_AMOUNT', data);

        this.name = dataSession.firstName;
        this.surname = dataSession.surname;
        this.cpf = dataSession.cpf;
        this.email = dataSession.email;
      }
    },
    getDonationFP: function getDonationFP() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var d1 = new Date();
        var fp = new VotolegalFP({
          excludeUserAgent: true,
          dontUseFakeFontInCanvas: true
        });

        fp.get(function (result, components) {
          var d2 = new Date();

          var info = {
            ms: d2 - d1,
            id: result
          };

          for (var index in components) {
            var obj = components[index];

            if (obj.key == 'canvas' || obj.key == 'webgl') {
              info[obj.key] = obj.value.toString().length;
            } else {
              info[obj.key] = obj.value.toString();
            }
          }

          var Base64 = {
            _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            encode: function encode(e) {
              var t = "";
              var n = void 0,
                  r = void 0,
                  i = void 0,
                  s = void 0,
                  o = void 0,
                  u = void 0,
                  a = void 0;
              var f = 0;
              e = Base64._utf8_encode(e);
              while (f < e.length) {
                n = e.charCodeAt(f++);
                r = e.charCodeAt(f++);
                i = e.charCodeAt(f++);
                s = n >> 2;
                o = (n & 3) << 4 | r >> 4;
                u = (r & 15) << 2 | i >> 6;
                a = i & 63;
                if (isNaN(r)) {
                  u = a = 64;
                } else if (isNaN(i)) {
                  a = 64;
                }
                t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
              }
              return t;
            },
            _utf8_encode: function _utf8_encode(e) {
              e = e.replace(/rn/g, "n");
              var t = "";
              for (var n = 0; n < e.length; n++) {
                var r = e.charCodeAt(n);
                if (r < 128) {
                  t += String.fromCharCode(r);
                } else if (r > 127 && r < 2048) {
                  t += String.fromCharCode(r >> 6 | 192);
                  t += String.fromCharCode(r & 63 | 128);
                } else {
                  t += String.fromCharCode(r >> 12 | 224);
                  t += String.fromCharCode(r >> 6 & 63 | 128);
                  t += String.fromCharCode(r & 63 | 128);
                }
              }
              return t;
            }
          };

          var donation_fp = Base64.encode(JSON.stringify(info));

          if (donation_fp) {
            _this2.donationFp = donation_fp;
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    setData: function setData(data) {
      var payload = {
        device_authorization_token_id: this.token,
        email: this.email,
        name: this.name + ' ' + this.surname,
        cpf: this.cpf,
        candidate_id: this.candidateId,
        donation_fp: this.donationFp,
        referral_code: this.$store.state.referral
      };

      if (!this.isTicket) {
        payload.payment_method = this.payment_method;
        payload.amount = this.amount;
      } else {
        payload.name = this.name;
        payload.surname = this.surname;
      }

      var user = {
        name: data.name,
        surname: data.surname
      };

      this.$store.dispatch('SAVE_PAYMENT_DATA', payload);
      this.$store.dispatch('SAVE_USERNAME', user);

      if (!this.isTicket) {
        this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'boleto' });
      } else {
        this.SET_TICKET_STEP({ step: 'addressData' });
      }
    },
    handleSession: function handleSession() {
      if (window.localStorage) {
        var tokenName = window.location.host === "votolegal.com.br" || window.location.host === "votolegal.com" ? "prod_vlm_token" : "dev_vlm_token";
        var token = localStorage.getItem(tokenName);
        if (token !== null) {
          this.$store.dispatch("ADD_TOKEN", token);
        } else {
          this.$store.dispatch("GET_TOKEN").then(function (res) {
            localStorage.setItem(tokenName, res.data.device_authorization_token_id);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['SET_TICKET_STEP'])),
  mounted: function mounted() {
    this.scrollToForm();
    this.handleSession();
    this.controlSession();
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'CardData',
	directives: {
		mask: __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__["mask"]
	},
	data: function data() {
		return {
			loading: false,
			dataBusyMessage: '',
			errorMessage: '',
			name: '',
			cpf: '',
			csc: '',
			number: '',
			validity_month: '',
			validity_year: '',
			brand: '',
			validation: {
				errors: {}
			}
		};
	},

	computed: {
		username: function username() {
			return this.$store.state.username;
		},
		paymentData: function paymentData() {
			return this.$store.state.paymentData;
		}
	},
	mounted: function mounted() {
		this.scrollToDonate();
	},

	methods: {
		goBack: function goBack() {
			this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'userData' });
		},
		scrollToDonate: function scrollToDonate() {
			var form = document.getElementById('doar');
			form.scrollIntoView({ block: 'start', behavior: 'smooth' });
		},
		toggleLoading: function toggleLoading() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			this.loading = !this.loading;

			this.dataBusyMessage = this.dataBusyMessage !== message ? message : '';
		},
		validateForm: function validateForm() {
			this.toggleLoading('Validando dados de pagamento...');

			var name = this.name,
			    cpf = this.cpf,
			    csc = this.csc,
			    number = this.number,
			    validity_year = this.validity_year,
			    validity_month = this.validity_month;


			var fields = {
				name: name,
				cpf: cpf,
				csc: csc,
				number: number,
				validity_year: validity_year,
				validity_month: validity_month
			};

			var validation = Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["g" /* validate */])(fields);
			var validationCPF = {
				cpf: cpf
			};

			if (validation.valid && this.validateSessionData(validationCPF.cpf)) {
				this.saveCard({
					name: Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["f" /* removeAccented */])(name),
					csc: csc,
					number: number.replace(/\s+/g, ''),
					validity_year: validity_year,
					validity_month: validity_month
				});
			} else {
				this.validation = validation;
				this.toggleLoading();
			}
		},
		validateSessionData: function validateSessionData(cpf) {
			var _this = this;

			var dataSession = JSON.parse(sessionStorage.getItem('doner-data'));

			if (this.paymentData.cpf !== cpf) {
				this.errorMessage = "O CPF do titular do cartão deve ser o mesmo informado no formulário anterior";
				setTimeout(function () {
					_this.errorMessage = "";
				}, 5000);
				return false;
			}
			return true;
		},
		saveCard: function saveCard(card) {
			var _this2 = this;

			var cc_hash = this.getCardHash(card.number);

			var cc = Iugu.CreditCard(card.number, card.validity_month, card.validity_year, this.username.name, this.username.surname, card.csc);

			Iugu.createPaymentToken(cc, function (response) {
				if (response.errors) {

					_this2.toggleLoading();
					_this2.errorMessage = 'Por favor, verifique os dados do cartão de crédito';
				} else {
					var payload = {
						cc_hash: cc_hash,
						id: response.id,
						cpf: _this2.cpf,
						name: _this2.name
					};
					_this2.$store.dispatch('START_DONATION', payload).then(function (response) {
						sessionStorage.clear();
					}).catch(function (err) {
						_this2.toggleLoading();
						_this2.handleErrorMessage(err);
					});
				}
			});
		},
		handleErrorMessage: function handleErrorMessage(err) {
			this.errorMessage = err.data[0].message;
		},
		getCardHash: function getCardHash(number) {
			var fp = new VotolegalFP({
				excludeUserAgent: true,
				dontUseFakeFontInCanvas: true
			});

			var hash = fp.x64hash128(number, 31);
			return hash;
		}
	}
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_finalMessage_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33224ae4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_finalMessage_vue__ = __webpack_require__(264);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_finalMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33224ae4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_finalMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'FinalMessage',
	computed: {
		messages: function messages() {
			return this.$store.state.messages;
		},
		candidate: function candidate() {
			return this.getMergeCandidate.candidate;
		},
		getMergeCandidate: function getMergeCandidate() {
			return this.$store.getters.generateCandidateObject;
		}
	},
	mounted: function mounted() {
		this.scrollToDonate();
	},

	methods: {
		scrollToDonate: function scrollToDonate() {
			var form = document.getElementById('doar');
			form.scrollIntoView({ block: 'start', behavior: 'smooth' });
		},
		goBack: function goBack() {
			this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'selectValue' });
		}
	}
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addressData_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f06614_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addressData_vue__ = __webpack_require__(265);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addressData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f06614_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addressData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdressData',
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__["mask"]
  },
  props: {
    isTicket: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      dataBusyMessage: '',
      states: {
        AC: 'Acre',
        AL: 'Alagoas',
        AP: 'Amapá',
        AM: 'Amazonas',
        BA: 'Bahia',
        CE: 'Ceará',
        DF: 'Distrito Federal',
        ES: 'Espírito Santo',
        GO: 'Goiás',
        MA: 'Maranhão',
        MT: 'Mato Grosso',
        MS: 'Mato Grosso do Sul',
        MG: 'Minas Gerais',
        PR: 'Paraná',
        PB: 'Paraíba',
        PA: 'Pará',
        PE: 'Pernambuco',
        PI: 'Piauí',
        RJ: 'Rio de Janeiro',
        RN: 'Rio Grande do Norte',
        RS: 'Rio Grande do Sul',
        RO: 'Rondônia',
        RR: 'Roraima',
        SC: 'Santa Catarina',
        SE: 'Sergipe',
        SP: 'São Paulo',
        TO: 'Tocantins'
      },
      errorMessage: '',
      zip_code: '',
      state: '',
      city: '',
      street: '',
      district: '',
      number: '',
      complement: '',
      phone: '',
      birthdate: '',
      validation: {
        errors: {
          zip_code: '',
          state: '',
          city: '',
          street: '',
          district: ''
        }
      }
    };
  },

  computed: {
    paymentData: function paymentData() {
      return this.$store.state.paymentData;
    },
    iugu: function iugu() {
      return this.$store.state.iugu;
    }
  },
  methods: _extends({
    controlSession: function controlSession() {
      var data = {
        step: 'boleto'
      };
      var dataSession = JSON.parse(sessionStorage.getItem('doner-data'));
      if (dataSession != null) {
        this.zip_code = dataSession.zip_code || this.zip_code;
        this.state = dataSession.state || this.state;
        this.city = dataSession.city || this.city;
        this.street = dataSession.street || this.street;
        this.district = dataSession.district || this.district;
        this.number = dataSession.number || this.number;
        this.complement = dataSession.complement || this.complement;
        this.birthdate = dataSession.birthdate ? dataSession.birthdate.split('-').reverse().join('/') : this.birthdate;
        this.phone = dataSession.phone || this.phone;
      }
    },
    goBack: function goBack() {
      if (!this.isTicket) {
        this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'userData' });
      } else {
        this.SET_TICKET_STEP({ step: 'userData' });
      }
    },
    scrollToForm: function scrollToForm() {
      var form = this.isTicket ? document.getElementById('votar') : document.getElementById('doar');
      form.scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    toggleLoading: function toggleLoading() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.loading = !this.loading;

      this.dataBusyMessage = this.dataBusyMessage !== message ? message : '';
    },
    validateForm: function validateForm() {
      this.toggleLoading('Validando endereço...');
      var birthdate = this.birthdate.split('/').reverse().join('-');

      var phone = this.phone ? this.phone.replace(/[^\d]+/g, "") : '';
      var address = {
        zip_code: this.zip_code,
        state: this.state,
        city: this.city,
        street: this.street,
        district: this.district,
        number: this.number,
        phone: phone
      };

      if (this.paymentData.payment_method === 'boleto' || this.isTicket) {
        address.birthdate = birthdate;
      }

      var validation = Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["g" /* validate */])(address);

      if (validation.valid) {
        this.saveAddress();

        var donerData = {
          zip_code: this.zip_code,
          state: this.state,
          city: this.city,
          street: this.street,
          district: this.district,
          number: this.number,
          phone: phone,
          birthdate: birthdate
        };

        var currentDonerData = sessionStorage.getItem('doner-data');

        if (currentDonerData) {
          currentDonerData = JSON.parse(currentDonerData);
          donerData = Object.assign(currentDonerData, donerData);
        }

        sessionStorage.setItem("doner-data", JSON.stringify(donerData));
      } else {
        this.validation = validation;
        this.toggleLoading();
      }
    },
    saveAddress: function saveAddress() {
      var _this = this;

      var payload = this.$store.state.paymentData;
      var phone = this.phone ? this.phone.replace(/[^\d]+/g, "") : '';

      payload.address_zipcode = this.zip_code;
      payload.address_state = this.state;
      payload.address_city = this.city;
      payload.address_street = this.street;
      payload.address_district = this.district;
      payload.address_house_number = this.number;
      payload.address_complement = this.complement;
      payload.phone = phone;

      var birthdate = this.birthdate.split('/');
      birthdate.reverse();
      birthdate = birthdate.join('-');
      payload.birthdate = birthdate;

      if (this.paymentData.payment_method === 'boleto' || this.isTicket) {
        payload.billing_address_zipcode = this.zip_code;
        payload.billing_address_state = this.state;
        payload.billing_address_city = this.city;
        payload.billing_address_street = this.street;
        payload.billing_address_district = this.district;
        payload.billing_address_house_number = this.number;
        payload.billing_address_complement = this.complement;
      }
      if (!this.isTicket) {
        this.$store.dispatch('GET_DONATION', payload).then(function (res) {
          var stepToGoTo = _this.paymentData.payment_method === 'credit_card' ? 'cardData' : 'certFaceVerify';

          _this.handleIugu();

          _this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: stepToGoTo });
        }).catch(function (err) {
          _this.toggleLoading();
          _this.handleErrorMessage(err);
        });
      } else {
        this.SEND_TICKET(payload).then(function (res) {
          _this.SET_TICKET_STEP({ step: 'finalMessage' });
        }).catch(function (err) {
          _this.handleErrorMessage(err);
        }).finally(function (err) {
          _this.toggleLoading();
        });
      }
    },
    searchAddress: function searchAddress(event) {
      var _this2 = this;

      this.$data.validation.errors.zip_code = '';
      this.$data.validation.errors.state = '';
      this.$data.validation.errors.city = '';
      this.$data.validation.errors.street = '';
      this.$data.validation.errors.district = '';
      this.$data.state = '';
      this.$data.city = '';
      this.$data.street = '';
      this.$data.district = '';
      this.errorMessage = '';

      if (event.target.value.length !== parseInt(event.target.getAttribute('minlength'), 10)) {
        this.$data.validation.errors.zip_code = 'CEP inválido';

        return this.$refs.zipCode.select() || this.$refs.zipCode.focus();
      }

      this.toggleLoading('Procurando endereço...');

      this.$store.dispatch('getAddress', event.target.value).then(function (response) {
        if (!response.state) {
          _this2.$refs.state.disabled = false;
        } else {
          _this2.$refs.state.disabled = true;
          _this2.state = response.state;
        }

        if (!response.city) {
          _this2.$refs.city.disabled = false;
        } else {
          _this2.$refs.city.disabled = true;
          _this2.city = response.city;
        }

        if (!response.street) {
          _this2.$refs.street.disabled = false;
        } else {
          _this2.$refs.street.disabled = true;
          _this2.street = response.street;
        }

        if (!response.district) {
          _this2.$refs.district.disabled = false;
        } else {
          _this2.$refs.district.disabled = true;
          _this2.district = response.district;
        }
        return _this2.toggleLoading();
      }).catch(function (error) {
        _this2.toggleLoading();
        if (error.response.status === 404) {
          _this2.$refs.state.disabled = true;
          _this2.$refs.city.disabled = true;
          _this2.$refs.street.disabled = true;
          _this2.$refs.district.disabled = true;

          _this2.$refs.zipCode.select() || _this2.$refs.zipCode.focus();

          return _this2.$data.validation.errors.zip_code = 'CEP não encontrado. Confira-o e preencha os campos restantes.';
        }

        _this2.$refs.state.disabled = false;
        _this2.$refs.city.disabled = false;
        _this2.$refs.street.disabled = false;
        _this2.$refs.district.disabled = false;

        _this2.$refs.zipCode.focus();

        if (error.response.data.form_error && error.response.data.form_error.CEP) {
          return _this2.$data.validation.errors.zip_code = error.response.data.form_error.CEP.indexOf('dismembered') !== -1 ? 'Alguns endereços desse CEP mudaram. Por favor, confira o seu e preencha os campos restantes.' : error.response.data.form_error.CEP;
        } else {
          return _this2.$data.validation.errors.zip_code = error.response.data.form_error;
        }
      });
    },
    disableField: function disableField(field) {
      this.$nextTick(function () {
        var element = document.getElementsByName(field);
        element[0].disabled = false;
        return '';
      });
    },
    handleErrorMessage: function handleErrorMessage(err) {
      this.errorMessage = err.data[0].message;
    },
    handleIugu: function handleIugu() {
      Iugu.setAccountID(this.iugu.account_id);
      Iugu.setTestMode(this.iugu.is_testing === 1 ? true : false);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['SEND_TICKET']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['CHANGE_PAYMENT_STEP', 'SET_TICKET_STEP'])),
  mounted: function mounted() {
    this.scrollToForm();
    this.controlSession();
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'CertFaceVerify',
	data: function data() {
		return {
			loading: false,
			dataBusyMessage: '',
			errorMessage: '',

			validation: {
				errors: {}
			}
		};
	},

	computed: {
		username: function username() {
			return this.$store.state.username;
		},
		messages: function messages() {
			return this.$store.state.messages;
		},
		candidate: function candidate() {
			return this.getMergeCandidate.candidate;
		},
		getMergeCandidate: function getMergeCandidate() {
			return this.$store.getters.generateCandidateObject;
		}
	},
	mounted: function mounted() {
		this.scrollToDonate();
	},

	methods: {
		goBack: function goBack() {
			this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'boleto' });
		},
		scrollToDonate: function scrollToDonate() {
			var form = document.getElementById('doar');
			form.scrollIntoView({ block: 'start', behavior: 'smooth' });
		},
		toggleLoading: function toggleLoading() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			this.loading = !this.loading;

			this.dataBusyMessage = this.dataBusyMessage !== message ? message : '';
		},
		handleErrorMessage: function handleErrorMessage(err) {
			this.errorMessage = err.data[0].message;
		}
	}
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'PrintBoleto',
	data: function data() {
		return {
			loading: false,
			dataBusyMessage: '',
			errorMessage: '',

			validation: {
				errors: {}
			}
		};
	},

	computed: {
		username: function username() {
			return this.$store.state.username;
		},
		messages: function messages() {
			return this.$store.state.messages.messages;
		},
		candidate: function candidate() {
			return this.getMergeCandidate.candidate;
		},
		getMergeCandidate: function getMergeCandidate() {
			return this.$store.getters.generateCandidateObject;
		}
	},
	mounted: function mounted() {
		this.scrollToDonate();
	},

	methods: {
		scrollToDonate: function scrollToDonate() {
			var form = document.getElementById('doar');
			form.scrollIntoView({ block: 'start', behavior: 'smooth' });
		},
		toggleLoading: function toggleLoading() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			this.loading = !this.loading;

			this.dataBusyMessage = this.dataBusyMessage !== message ? message : '';
		},
		handleErrorMessage: function handleErrorMessage(err) {
			this.errorMessage = err.data[0].message;
		},
		redirectUser: function redirectUser(ui) {
			if (ui.value === "pay_with_cc") {
				this.$router.replace(this.$route.path);
				this.$store.dispatch("CHANGE_PAYMENT_STEP", {
					step: "userData"
				});
			} else {
				sessionStorage.clear();
				window.open(ui.href);
			}
		}
	}
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps_userData_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__steps_finalMessage_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__steps_addressData_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Ticket',
	components: {
		userData: __WEBPACK_IMPORTED_MODULE_0__steps_userData_vue__["a" /* default */],
		addressData: __WEBPACK_IMPORTED_MODULE_2__steps_addressData_vue__["a" /* default */]
	},
	data: function data() {
		return {
			loading: false,
			dataBusyMessage: ''
		};
	},

	computed: {
		ticketStep: function ticketStep() {
			return this.$store.state.ticketStep;
		},
		candidate: function candidate() {
			return this.getMergeCandidate.candidate;
		},
		getMergeCandidate: function getMergeCandidate() {
			return this.$store.getters.generateCandidateObject;
		}
	},

	methods: _extends({
		toggleLoading: function toggleLoading() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

			this.loading = !this.loading;

			this.dataBusyMessage = this.dataBusyMessage !== message ? message : '';
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapMutations */])(['SET_TICKET_STEP']))
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pagination',
  props: {
    results: {
      type: Number,
      required: false,
      default: 20
    },
    classNames: {
      type: String,
      required: false
    },
    condition: {
      type: [Array, Object],
      required: false
    },
    dispatchToCall: {
      type: String,
      required: true
    },

    lastPageProp: {
      type: Number,
      required: true
    },
    idCategory: {
      type: [Number, String],
      required: false,
      validator: function validator(value) {
        return parseInt(value, 10);
      }
    }
  },
  data: function data() {
    return {
      totalPages: '',
      session: {
        page: 1,
        results: 20,
        apiKey: sessionStorage.getItem('apiKey'),
        userId: sessionStorage.getItem('userId')
      }
    };
  },
  mounted: function mounted() {
    this.startPageinate(this.idCategory);
  },

  methods: {
    firstPage: function firstPage() {
      this.emitEvent();
      this.callDispach(1, this.idCategory);
    },
    nextPage: function nextPage() {
      this.emitEvent();
      var pageToShow = parseInt(this.$route.query.page, 10) + 1;

      if (this.$route.query.page && pageToShow <= Math.ceil(this.lastPageProp / this.results)) {
        this.callDispach(pageToShow, this.idCategory);
      }
    },
    backPage: function backPage() {
      this.emitEvent();

      var pageToShow = parseInt(this.$route.query.page, 10) - 1;

      if (this.$route.query.page && pageToShow >= 1) {
        this.callDispach(pageToShow, this.idCategory);
      }
    },
    lastPage: function lastPage() {
      this.emitEvent();

      var lastPage = Math.ceil(this.lastPageProp / this.results);

      this.callDispach(lastPage, this.idCategory);
    },
    callDispach: function callDispach() {
      var pageToShow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var idCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: pageToShow
        })
      });

      this.session.page = pageToShow;
      this.session.idCategory = parseInt(idCategory, 10);

      this.$store.dispatch('' + this.dispatchToCall, this.session);
    },
    emitEvent: function emitEvent() {
      this.$emit('changePage', false);
    },
    startPageinate: function startPageinate() {
      var idCategory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.session.idCategory = parseInt(idCategory, 10);
      if (!this.$route.query.page || this.$route.query.page <= 1) {
        this.$router.push({
          query: Object.assign({}, this.$route.query, {
            page: 1
          })
        });

        this.$store.dispatch('' + this.dispatchToCall, this.session);
      } else {
        this.session.page = this.$route.query.page;
        this.$store.dispatch('' + this.dispatchToCall, this.session);
      }
    },
    pageChange: function pageChange() {
      this.pagination.recipients = this.computedRecipients;
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'receipt',

  data: function data() {
    return {
      contract: __WEBPACK_IMPORTED_MODULE_0__config_js___default.a.contract
    };
  },
  mounted: function mounted() {
    var payload = {
      candidateId: this.$route.params.candidate,
      digest: this.$route.params.digest
    };
    this.$store.dispatch('GET_RECEIPT', payload);
  },

  computed: {
    receipt: function receipt() {
      return this.$store.state.receipt;
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deposit',
  data: function data() {
    return {
      depositId: 0
    };
  },
  mounted: function mounted() {
    this.depositId = this.$route.params.depositId;

    var payload = {
      candidateId: this.$route.params.candidate,
      depositId: this.$route.params.depositId
    };
    this.$store.dispatch('GET_DEPOSIT', payload);
  },

  computed: {
    donations: function donations() {
      return this.$store.state.deposit.donations || [];
    },
    candidate: function candidate() {
      return this.$store.state.deposit.candidate || {};
    },
    deposit: function deposit() {
      return this.$store.state.deposit.meta || {};
    }
  },
  methods: {
    paymentMethod: function paymentMethod(item) {
      return item.is_boleto ? 'boleto' : 'cartão de crédito';
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__javascript_App_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_agile__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_agile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_agile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translations__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__javascript_utilities__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_head__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_focus__ = __webpack_require__(291);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("officeName", function (key) {
	switch (key) {
		case 1:
			return "Prefeito";
			break;
		case 2:
			return "Vereador";
			break;
		case 3:
			return "Vice-prefeito";
			break;
		case 4:
			return "Presidente";
			break;
		case 5:
			return "Senador";
			break;
		case 6:
			return "Governador";
			break;
		case 7:
			return "Deputado Estadual";
			break;
		case 8:
			return "Deputado Federal";
			break;
		case 9:
			return "Deputado Distrital";
			break;
		default:
			break;
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("sentenceCase", function (value) {
	if (!value) return "";
	return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("lowerCase", function (value) {
	return value.toLowerCase();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("upperCase", function (value) {
	return value.toUpperCase();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('titleCase', function (str) {
	return str.split(/\s+/).map(function (item) {
		if (item.length > 2) {
			if (item.toLowerCase() === 'dos') {
				return item.toLowerCase();
			}
			return item.charAt(0).toUpperCase() + item.substring(1).toLowerCase();
		}
		return item.toLowerCase();
	}).join(' ');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', function (value) {
	if (!value) return;
	var newDate = new Date(value.replace(' ', 'T'));
	return (newDate.getDate() <= 9 ? "0" + newDate.getDate() : newDate.getDate()) + "/" + (newDate.getMonth() + 1 <= 9 ? "0" + (newDate.getMonth() + 1) : newDate.getMonth() + 1) + "/" + newDate.getFullYear() + " - " + (newDate.getHours() <= 9 ? "0" + newDate.getHours() : newDate.getHours()) + ":" + (newDate.getUTCMinutes() <= 9 ? "0" + newDate.getUTCMinutes() : newDate.getUTCMinutes());
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatCPF', function (value) {
	return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("formatCNPJ", __WEBPACK_IMPORTED_MODULE_6__javascript_utilities__["c" /* formatCNPJ */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("formatBRL", __WEBPACK_IMPORTED_MODULE_6__javascript_utilities__["a" /* formatBRL */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("formatBRLDec", __WEBPACK_IMPORTED_MODULE_6__javascript_utilities__["b" /* formatBRLDec */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__plugins_focus__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_agile___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: "#app",
	router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
	translations: __WEBPACK_IMPORTED_MODULE_5__translations__["a" /* default */],
	data: function data() {
		return {
			currentRoute: window.location.pathname
		};
	},

	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_1__javascript_App_vue__["a" /* default */]);
	}
}).$mount("#app");

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(84);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(33)))

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce0af2bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(100);
function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce0af2bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(87);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3936b50f", content, true, {});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports
exports.i(__webpack_require__(88), "");

// module
exports.push([module.i, ".container{position:relative;padding-right:1rem;padding-left:1rem;margin:auto}@media (min-width:768px){.container{max-width:720px;padding-right:2rem;padding-left:2rem}}@media (min-width:991px){.container{max-width:940px}}@media (min-width:1200px){.container{max-width:1200px}}.container:after{clear:both;display:table;content:\"\"}.row{position:relative;width:100%;margin:auto}.section{padding-top:3.125rem;padding-bottom:3.125rem}@media (min-width:768px){.section{padding-top:4.375rem;padding-bottom:4.375rem}}@media (min-width:991px){.section{padding-top:6.25rem;padding-bottom:6.25rem}}@media (min-width:1200px){.section{padding-top:12.5em;padding-bottom:12.5em}}.section:after{clear:both;display:table;content:\"\"}.wrap-info{position:relative}.wrap-info--6{float:left;width:48%;margin-right:1%;margin-left:1%}@media (max-width:768px){.wrap-info--6{width:100%;margin-bottom:1.25rem}}.wrap-info--7{float:left;width:56.33%;margin-right:1%;margin-left:1%}@media (max-width:768px){.wrap-info--7{width:100%;margin-bottom:1.25rem}}.wrap-info--9{float:left;width:73%;margin-right:1%;margin-left:1%}@media (max-width:768px){.wrap-info--9{width:100%;margin-bottom:1.25rem}}.wrap-info--text{width:80%;text-align:left}.btn{display:block;width:335px;max-width:100%;padding:22px 0;margin:10px 0;text-align:center;color:#fff;border-radius:8px;opacity:.9}.btn-white-opacity{background:hsla(0,0%,100%,.35)}.btn-white-opacity:hover{background:hsla(0,0%,100%,.5)}.btn-green{background-color:#4bb958}.btn-green:hover{color:#fff;background-color:#55d164}.img-full{display:block;width:100%}img{max-width:100%}.text-bold{font-weight:700}.text-blue{color:#2c3e50}.text-green{color:#4bb958}.clear-fix{clear:both;display:table;content:\"\"}h1,h2,h3,h4,h5,h6{line-height:normal;text-align:left}h1{font-weight:400;font-size:2.2em;text-transform:uppercase}@media (min-width:500px){h1{font-size:3em}}@media (min-width:1200px){h1{font-size:4em}}h2{font-weight:700;font-size:35px;letter-spacing:-1.2px}@media (min-width:500px){h2{font-size:38px}}@media (min-width:1200px){h2{font-size:48px}}.big-title{font-size:40px}@media (min-width:500px){.big-title{font-size:48px}}@media (min-width:1200px){.big-title{font-size:58px}}h3{font-size:16px}@media (min-width:380px){h3{font-size:17px}}@media (min-width:1200px){h3{font-size:18px}}p{font-weight:400;line-height:1.5}li,p{font-size:16px}@media (min-width:380px){li{font-size:17px}}@media (min-width:1200px){li{font-size:18px}}.huge-title{font-size:50px}@media (min-width:500px){.huge-title{font-size:70px}}@media (min-width:1200px){.huge-title{font-size:80px}}.title{padding:0;margin:0;font-weight:700;color:#35d34f}.block-element,.title{display:block}.to-right{float:right}.date-warning{position:absolute;left:50%;display:block;min-width:10em;padding:.5em;font-size:15px;color:#fff;background-color:#203f57;border-radius:8px;opacity:0;transform:translateX(-50%);transition-duration:1s;transition-property:opacity}.date-warning:before{position:absolute;top:-6px;left:50%;width:0;height:0;margin-left:-3px;border-width:0 6px 6px;border-style:solid;border-color:transparent transparent #203f57;content:\"\"}:focus>.date-warning,:hover>.date-warning{opacity:1}", ""]);

// exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports
exports.i(__webpack_require__(89), "");

// module
exports.push([module.i, "html{height:100%;padding:0;margin:0;font-size:100.01%;tab-size:4}body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Miriam Libre,sans-serif;font-size:100%;line-height:1.5;min-width:320px;margin:0;font-weight:700;flex-direction:column}#app,body{min-height:100%;display:flex}#app{flex-direction:column;flex:1 0 auto}main{flex-grow:1}#tfooter,main{flex-shrink:0}", ""]);

// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1.3}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}a{text-decoration:none}", ""]);

// exports


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_theader_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7792671a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_theader_vue__ = __webpack_require__(95);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_theader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7792671a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_theader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(93);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7cacd6b4", content, true, {});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".home-page .nav{position:absolute}@media (min-width:929px){.home-page .nav{height:70px;background-color:transparent;padding-top:4rem}}@media (min-width:1200px){.home-page .nav{padding-top:5.625rem}}.internal-pages .nav{position:absolute;background-color:#fff;padding-top:0}@media (min-width:929px){.internal-pages .nav{height:70px;padding-top:.5em}}.nav{position:relative;margin:0;width:100%;z-index:2;font-weight:400;background-color:#fff;padding-top:.25rem;padding-bottom:.25rem;height:60px;transition-property:background-color,height;transition-duration:.3s,1s}@media (min-width:929px){.nav{height:70px}}.nav.animate,.nav.animate-small{position:fixed;height:50px;background-color:#fff;padding-top:.25em;padding-bottom:.25rem}@media (min-width:929px){.nav.animate,.nav.animate-small{height:58px}}.nav ul{list-style-type:none}.nav li{display:block;float:left;margin:0 10px}.nav .brand-wrap{position:absolute;transform:translate(-50%,-50%);margin-top:.25em;top:50%;left:50%}@media (min-width:929px){.nav .brand-wrap{margin-top:.25em;transform:translateX(0);left:2rem;top:0}}.nav .brand-wrap:after{content:\"\";display:table;clear:both}.nav .brand-wrap a{display:block;height:100%}.nav .logo{background-image:url(" + escape(__webpack_require__(94)) + ");float:none;overflow:hidden;text-indent:110%;white-space:nowrap;background-repeat:no-repeat;direction:ltr}.nav .votolegal{background-size:140px auto;width:140px;height:40px;overflow:hidden}@media (min-width:480px){.nav .votolegal{transition:background-size,.8s;background-size:180px auto;width:180px;height:55px}}@media (min-width:1200px){.nav .votolegal{background-size:220px auto;width:220px;height:63px}}@media (min-width:480px){.nav .votolegal-small{background-size:150px auto;width:150px;height:50px;background-size:160px auto;width:160px}}.nav .menu-wrap{margin-top:.25em;position:absolute;text-align:center;overflow:hidden}@media (max-width:928px){.nav .menu-wrap{opacity:0;max-height:0;overflow:hidden}.nav .menu-wrap.show{transition:opacity,.3s;opacity:1;display:block;margin-left:auto;margin-right:auto;margin-top:.25em;background-color:#fff;width:100%;max-height:1000px;position:absolute;padding:0;padding-top:.2em;max-height:none;right:0;left:0;top:100%}.nav .menu-wrap.show:last-child{padding-bottom:2rem}}@media (min-width:929px){.nav .menu-wrap{margin-left:2em;margin-left:14em}}@media (min-width:1200px){.nav .menu-wrap{margin-left:18em}}.nav .menu-item{width:auto;padding:1rem}@media (max-width:928px){.nav .menu-item{float:none}}.nav .menu-item a{color:#366;font-size:1em;font-weight:700}.nav .menu-item a:hover{color:#4ab957}.nav a.login-button{position:relative;color:#fff!important;border-radius:8px;background-color:#366;margin-top:.5rem;padding:.5rem .8rem}.nav a.login-button:hover{background-color:#4ab957;color:#fff!important}.nav:after{display:table;content:\"\";clear:both}.nav .greetingsection .nav-bar{padding-top:5.5625rem}.nav .nav-bar button{display:none;outline:none}@media (max-width:928px){.nav .nav-bar button{display:block}}.nav .nav-bar button.mobile-button{cursor:pointer;width:50px;height:40px;border-radius:8px;border:2px solid #76848f;background-color:transparent;float:left;margin-left:0;margin-top:.25rem;text-align:center;position:relative;z-index:2;transition:all .5s}.nav .nav-bar button.mobile-button span{display:block;border-bottom:2px solid #76848f;width:80%;padding:3px;transition:all .5s}.nav .nav-bar button.mobile-button span:first-child{padding-top:0}.nav .nav-bar button.mobile-button span:hover{border-bottom:2px solid #4bb958}.nav .nav-bar button.mobile-button:hover{border:2px solid #4bb958;background-color:#fff;transition:all 1s}.nav .nav-bar button.mobile-button:hover span{border-bottom:2px solid #4bb958;transition:all 1s}", ""]);

// exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "votolegal--e9946c90.png";

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((this.$route.name === 'home' ? 'home-page' : 'internal-pages') + " nav-top")},[_c('header',{staticClass:"nav"},[_c('nav',{staticClass:"nav-bar container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"menu-wrap"},[_vm._m(2),_vm._v(" "),_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":"/perguntas-frequentes#contato"}},[_vm._v("\n            Fale com a gente\n          ")])],1),_vm._v(" "),_vm._m(3)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mobile-button"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"brand-wrap"},[_c('li',{staticClass:"logo votolegal"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Voto Legal")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item"},[_c('a',{attrs:{"href":"https://comunidade.appcivico.com/c/voto-legal/5","target":"_blank"}},[_vm._v("\n            Perguntas frequentes\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item"},[_c('a',{staticClass:"login-button",attrs:{"target":"_blank","href":"https://participe.votolegal.com.br/"}},[_vm._v("Entrar")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tfooter_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49827f84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tfooter_vue__ = __webpack_require__(99);
function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tfooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49827f84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tfooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(98);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("dba453e0", content, true, {});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#tfooter{position:relative;background-color:#2de36d}#tfooter section{padding-top:8em;padding-bottom:3em}#tfooter section a{font-weight:700;text-decoration:none;color:#366}#tfooter section a:hover{color:#fff;text-decoration:underline}.wrap-logos{text-align:center;margin:0}.wrap-logos ul{margin:auto}.wrap-logos li{float:none;margin-top:30px;font-size:19px}.wrap-logos li a{color:#4bb958}.wrap-logos li a:hover{color:#676767}.wrap-votolegal a{margin:0;margin-right:auto;margin-left:auto;display:block;padding:0}.wrap-votolegal a.votolegal{background:url(" + escape(__webpack_require__(7)) + ");background-repeat:no-repeat;width:171px;height:49px}.wrap-social li{display:inline-block;border-radius:50%;margin-top:1.42em;margin-left:.5em;margin-right:.5em}.wrap-social a{display:block;padding:0}.wrap-social a.twitter{background:url(" + escape(__webpack_require__(12)) + ");width:26px;height:21px}.wrap-social a.youtube{background:url(" + escape(__webpack_require__(13)) + ");width:31px;height:21px}.wrap-social a.facebook{background:url(" + escape(__webpack_require__(14)) + ");width:12px;height:22px}.wrap-informations{margin-top:2.3125em;color:#366;text-align:center}.wrap-informations p+p{margin-top:1.625em}.candidate-footer .wrap-informations{color:#fff}", ""]);

// exports


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"tfooter"}},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"wrap-logos"},[_c('ul',{staticClass:"wrap-votolegal"},[_c('li',[_c('a',{staticClass:"votolegal",attrs:{"href":"/"}})])])]),_vm._v(" "),_c('div',{staticClass:"wrap-informations"},[_c('p',[_c('a',{attrs:{"href":"https://votolegal.com.br","target":"_blank"}},[_vm._v("Voto Legal")]),_vm._v(" é uma plataforma de doações. Todas são registradas na blockchain da Decred com objetivo de garantir a autenticidade das transações, promovendo a confiabilidade no processo de doação eleitoral.\n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("\n              © 2016-2020 "),_c('a',{attrs:{"href":"https://votolegal.com.br","target":"_blank"}},[_vm._v("Voto Legal")]),_vm._v("\n              • Uma iniciativa "),_c('a',{attrs:{"href":"http://appcivico.com","target":"_blank"}},[_vm._v("AppCívico")]),_vm._v(" - Tecnologias Cívicas\n              • "),_c('a',{attrs:{"href":"https://comunidade.appcivico.com/c/voto-legal/","target":"_blank"}},[_vm._v("Comunidade")]),_vm._v("\n              • "),_c('a',{attrs:{"href":"https://docs.google.com/forms/d/e/1FAIpQLSfy6O6A80gtkCM---KuOwA2PsLZwh4GapJLrflP9TVZ8CgkPg/viewform","target":"_blank"}},[_vm._v("Afiliados")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name != 'candidate' && _vm.$route.name != 'receipt' && _vm.$route.name != 'deposit')?_c('theader'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$route.name != 'receipt')?_c('tfooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports["vue-agile"]=e():t["vue-agile"]=e()}(this,function(){return function(t){function e(s){if(i[s])return i[s].exports;var n=i[s]={exports:{},id:s,loaded:!1};return t[s].call(n.exports,n,n.exports,e),n.loaded=!0,n.exports}var i={};return e.m=t,e.c=i,e.p="/",e(0)}([function(t,e,i){"use strict";function s(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.Agile=void 0;var n=i(4),o=s(n),a=function(t){t.component("agile",o.default)};e.default={install:a},e.Agile=o.default},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={name:"agile",props:{prevArrow:{type:String,default:'<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M16.2,21c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L9.6,12L17,4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L6.8,12l8.8,8.7C15.7,20.9,16,21,16.2,21z"/></svg>'},nextArrow:{type:String,default:'<svg x="0px" y="0px" viewBox="0 0 24 24"><path d="M7.8,21c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l7.4-7.3L7,4.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l8.8,8.7l-8.8,8.7C8.3,20.9,8,21,7.8,21z"/></svg>'},arrows:{type:Boolean,default:!0},autoplay:{type:Boolean,default:!1},autoplaySpeed:{type:Number,default:3e3},dots:{type:Boolean,default:!0},fade:{type:Boolean,default:!1},infinite:{type:Boolean,default:!0},pauseOnDotsHover:{type:Boolean,default:!1},pauseOnHover:{type:Boolean,default:!0},speed:{type:Number,default:300},timing:{type:String,default:"ease"}},data:function(){return{el:{dots:null,list:null,track:null,slides:null},slidesCount:0,autoplayTimeout:null,allSlidesCount:0,currentSlide:0,mouseDown:!1,dragStartX:0,dragStaryY:0,dragDistance:0,swipeDistance:50,transform:0,transitionDelay:0,width:{document:0,container:0,slide:0,track:0},slidesToShow:1,prevArrow_:this.prevArrow,nextArrow_:this.nextArrow,arrows_:this.arrows,autoplay_:this.autoplay,autoplaySpeed_:this.autoplaySpeed,dots_:this.dots,fade_:this.fade,infinite_:this.infinite,pauseOnDotsHover_:this.pauseOnDotsHover,pauseOnHover_:this.pauseOnHover,speed_:this.speed,timing_:this.timing}},mounted:function(){this.autoplay_&&(this.infinite_=!0),this.pauseOnDotsHover_&&(this.dots_=!0),this.el.list=this.$el.getElementsByClassName("agile__list")[0],this.dots_&&(this.el.dots=this.$el.getElementsByClassName("agile__dots")[0].children),this.el.slides=this.$el.getElementsByClassName("agile__track")[0].children,this.slidesCount=this.el.slides.length,this.infinite_&&!this.fade_?this.allSlidesCount=this.slidesCount+2:this.allSlidesCount=this.slidesCount;for(var t=0;t<this.slidesCount;++t)this.el.slides[t].classList.add("agile__slide"),this.fade_&&(this.el.slides[t].style.transition="opacity "+this.timing+" "+this.speed+"ms");if(this.el.track=this.$el.getElementsByClassName("agile__track")[0],this.infinite_&&!this.fade_){var e=this.el.track.firstChild.cloneNode(!0),i=this.el.track.lastChild.cloneNode(!0);e.classList.add("agile__slide--cloned"),i.classList.add("agile__slide--cloned"),this.el.track.insertBefore(i,this.el.slides[0]),this.el.track.insertBefore(e,this.el.slides[this.slidesCount].nextSibling)}if(this.autoplay_&&this.startAutoplay(),window.addEventListener("resize",this.getWidth),this.getWidth(),"ontouchstart"in window?(this.el.track.addEventListener("touchstart",this.handleMouseDown),this.el.track.addEventListener("touchend",this.handleMouseUp),this.el.track.addEventListener("touchmove",this.handleMouseMove)):(this.el.track.addEventListener("mousedown",this.handleMouseDown),this.el.track.addEventListener("mouseup",this.handleMouseUp),this.el.track.addEventListener("mousemove",this.handleMouseMove)),this.autoplay_&&(this.pauseOnHover_&&(this.el.track.addEventListener("mouseover",this.stopAutoplay),this.el.track.addEventListener("mouseout",this.startAutoplay)),this.pauseOnDotsHover_))for(var s=0;s<this.slidesCount;++s)this.el.dots[s].addEventListener("mouseover",this.stopAutoplay),this.el.dots[s].addEventListener("mouseout",this.startAutoplay)},beforeDestroy:function(){if(window.removeEventListener("resize",this.getWidth),"ontouchstart"in window?(this.el.track.removeEventListener("touchstart",this.handleMouseDown),this.el.track.removeEventListener("touchend",this.handleMouseUp),this.el.track.removeEventListener("touchmove",this.handleMouseMove)):(this.el.track.removeEventListener("mousedown",this.handleMouseDown),this.el.track.removeEventListener("mouseup",this.handleMouseUp),this.el.track.removeEventListener("mousemove",this.handleMouseMove)),this.autoplay_&&(this.pauseOnHover_&&(this.el.track.removeEventListener("mouseover",this.stopAutoplay),this.el.track.removeEventListener("mouseout",this.startAutoplay)),this.pauseOnDotsHover_))for(var t=0;t<this.slidesCount;++t)this.el.dots[t].removeEventListener("mouseover",this.stopAutoplay),this.el.dots[t].removeEventListener("mouseout",this.startAutoplay)},methods:{getWidth:function(){this.width={document:window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,container:this.el.list.clientWidth,slide:this.el.list.clientWidth/this.slidesToShow}},handleMouseDown:function(t){t.touches||t.preventDefault(),this.mouseDown=!0,this.dragStartX="ontouchstart"in window?t.touches[0].clientX:t.clientX,this.dragStartY="ontouchstart"in window?t.touches[0].clientY:t.clientY},handleMouseMove:function(t){var e="ontouchstart"in window?t.touches[0].clientX:t.clientX,i="ontouchstart"in window?t.touches[0].clientY:t.clientY,s=Math.abs(e-this.dragStartX),n=Math.abs(i-this.dragStartY);s>3*n&&(this.dragDistance=e-this.dragStartX,this.disableScroll())},handleMouseUp:function(){this.mouseDown=!1,this.enableScroll()},disableScroll:function(){document.ontouchmove=function(t){t.preventDefault()}},enableScroll:function(){document.ontouchmove=function(t){return!0}},addActiveClass:function(t){this.el.slides[t].classList.add("agile__slide--active")},startAutoplay:function(){var t=this;this.autoplayTimeout=setTimeout(function(){t.nextSlide()},this.autoplaySpeed)},stopAutoplay:function(){clearTimeout(this.autoplayTimeout)},setSlide:function(t){var e=this,i=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],s=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];if(this.autoplay_&&s&&(this.stopAutoplay(),this.startAutoplay()),this.fade_){i===!1&&(this.el.slides[t].style.transition="0ms",setTimeout(function(){e.el.slides[t].style.transition="opacity "+e.timing+" "+e.speed+"ms"},10));for(var n=0;n<this.allSlidesCount;++n)this.el.slides[n].classList.remove("agile__slide--expiring");this.infinite_&&t<0?t=this.slidesCount-1:t>=this.slidesCount&&(t=0);var o=this.currentSlide;this.el.slides[o].classList.add("agile__slide--expiring"),setTimeout(function(){e.el.slides[o].classList.remove("agile__slide--expiring")},this.speed_),this.transform=0}else this.transform=t*this.width.slide;for(var a=0;a<this.allSlidesCount;++a)this.el.slides[a].classList.remove("agile__slide--active");this.infinite_&&!this.fade_?(this.transform+=this.width.slide,this.addActiveClass(t+1)):this.addActiveClass(t),i?this.transitionDelay=this.speed:this.transitionDelay=0,this.infinite_&&t<0?(this.currentSlide=this.slidesCount-1,setTimeout(function(){e.setSlide(e.slidesCount-1,!1)},this.speed)):this.infinite_&&t>=this.slidesCount?(this.currentSlide=0,setTimeout(function(){e.setSlide(0,!1)},this.speed_)):this.currentSlide=t},nextSlide:function(){this.setSlide(this.currentSlide+1)},prevSlide:function(){this.setSlide(this.currentSlide-1)}},watch:{width:function(){for(var t=0;t<this.allSlidesCount;++t)this.el.slides[t].style.width=this.width.container+"px",this.fade_&&(this.el.slides[t].style.transform="translate(-"+t*this.width.slide+"px)");this.width.track=this.width.container*this.allSlidesCount,this.setSlide(this.currentSlide,!1,!1)},dragDistance:function(){if(this.mouseDown){if(this.dragDistance>this.swipeDistance){if(!this.infinite_&&0===this.currentSlide)return;this.prevSlide(),this.handleMouseUp()}if(this.dragDistance<-1*this.swipeDistance){if(!this.infinite_&&this.currentSlide===this.slidesCount-1)return;this.nextSlide(),this.handleMouseUp()}}}}}},function(t,e,i){e=t.exports=i(3)(),e.push([t.id,".agile{position:relative}.agile:active,.agile :active,.agile:focus,.agile :focus{outline:none}.agile__list{display:block;margin:0;overflow:hidden;padding:0;position:relative;width:100%}.agile__track{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start}.agile__slide{display:block}.agile--fade .agile__slide{opacity:0;position:relative;z-index:0}.agile--fade .agile__slide--active{opacity:1;z-index:2}.agile--fade .agile__slide--expiring{opacity:1;transition-duration:0s;z-index:1}.agile__arrow{border:none;bottom:-10px;margin:0;padding:0;position:absolute;transition-duration:.3s}.agile__arrow[disabled]{cursor:default;opacity:.4}.agile__arrow:hover svg{fill:#333}.agile__arrow--prev{left:0}.agile__arrow--next{right:0}.agile__arrow svg{fill:#888;height:24px;transition-duration:.3s}.agile__dots{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;list-style:none;margin:20px 0;padding:0;text-align:center;white-space:nowrap}.agile__dot{margin:0 10px}.agile__dot button{background-color:#eee;border:none;border-radius:50%;cursor:pointer;display:block;height:10px;font-size:0;line-height:0;margin:0;transition-duration:.3s;width:10px}.agile__dot--current button,.agile__dot:hover button{background-color:#888}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var i=this[e];i[2]?t.push("@media "+i[2]+"{"+i[1]+"}"):t.push(i[1])}return t.join("")},t.i=function(e,i){"string"==typeof e&&(e=[[null,e,""]]);for(var s={},n=0;n<this.length;n++){var o=this[n][0];"number"==typeof o&&(s[o]=!0)}for(n=0;n<e.length;n++){var a=e[n];"number"==typeof a[0]&&s[a[0]]||(i&&!a[2]?a[2]=i:i&&(a[2]="("+a[2]+") and ("+i+")"),t.push(a))}},t}},function(t,e,i){var s,n;i(7),s=i(1);var o=i(5);n=s=s||{},"object"!=typeof s.default&&"function"!=typeof s.default||(n=s=s.default),"function"==typeof n&&(n=n.options),n.render=o.render,n.staticRenderFns=o.staticRenderFns,t.exports=s},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"agile",class:{"agile--fade":t.fade_}},[i("div",{staticClass:"agile__list"},[i("div",{staticClass:"agile__track",style:{width:t.width.track+"px",transform:"translate(-"+t.transform+"px)",transition:"transform "+t.timing_+" "+t.transitionDelay+"ms"}},[t._t("default")],2)]),t._v(" "),t.dots_?i("ul",{staticClass:"agile__dots"},t._l(t.slidesCount,function(e){return i("li",{staticClass:"agile__dot",class:{"agile__dot--current":e-1===t.currentSlide}},[i("button",{on:{click:function(i){t.setSlide(e-1)}}},[t._v(t._s(e))])])})):t._e(),t._v(" "),t.arrows_?i("button",{staticClass:"agile__arrow agile__arrow--prev",attrs:{disabled:0===t.currentSlide&&!t.infinite_},domProps:{innerHTML:t._s(t.prevArrow_)},on:{click:t.prevSlide}}):t._e(),t._v(" "),t.arrows_?i("button",{staticClass:"agile__arrow agile__arrow--next",attrs:{disabled:t.currentSlide===t.slidesCount-1&&!t.infinite_},domProps:{innerHTML:t._s(t.nextArrow_)},on:{click:t.nextSlide}}):t._e()])},staticRenderFns:[]}},function(t,e,i){function s(t,e){for(var i=0;i<t.length;i++){var s=t[i],n=h[s.id];if(n){n.refs++;for(var o=0;o<n.parts.length;o++)n.parts[o](s.parts[o]);for(;o<s.parts.length;o++)n.parts.push(l(s.parts[o],e))}else{for(var a=[],o=0;o<s.parts.length;o++)a.push(l(s.parts[o],e));h[s.id]={id:s.id,refs:1,parts:a}}}}function n(t){for(var e=[],i={},s=0;s<t.length;s++){var n=t[s],o=n[0],a=n[1],r=n[2],l=n[3],d={css:a,media:r,sourceMap:l};i[o]?i[o].parts.push(d):e.push(i[o]={id:o,parts:[d]})}return e}function o(t,e){var i=f(),s=g[g.length-1];if("top"===t.insertAt)s?s.nextSibling?i.insertBefore(e,s.nextSibling):i.appendChild(e):i.insertBefore(e,i.firstChild),g.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");i.appendChild(e)}}function a(t){t.parentNode.removeChild(t);var e=g.indexOf(t);e>=0&&g.splice(e,1)}function r(t){var e=document.createElement("style");return e.type="text/css",o(t,e),e}function l(t,e){var i,s,n;if(e.singleton){var o=_++;i=v||(v=r(e)),s=d.bind(null,i,o,!1),n=d.bind(null,i,o,!0)}else i=r(e),s=u.bind(null,i),n=function(){a(i)};return s(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;s(t=e)}else n()}}function d(t,e,i,s){var n=i?"":s.css;if(t.styleSheet)t.styleSheet.cssText=m(e,n);else{var o=document.createTextNode(n),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(o,a[e]):t.appendChild(o)}}function u(t,e){var i=e.css,s=e.media,n=e.sourceMap;if(s&&t.setAttribute("media",s),n&&(i+="\n/*# sourceURL="+n.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */"),t.styleSheet)t.styleSheet.cssText=i;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(i))}}var h={},c=function(t){var e;return function(){return"undefined"==typeof e&&(e=t.apply(this,arguments)),e}},p=c(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),f=c(function(){return document.head||document.getElementsByTagName("head")[0]}),v=null,_=0,g=[];t.exports=function(t,e){e=e||{},"undefined"==typeof e.singleton&&(e.singleton=p()),"undefined"==typeof e.insertAt&&(e.insertAt="bottom");var i=n(t);return s(i,e),function(t){for(var o=[],a=0;a<i.length;a++){var r=i[a],l=h[r.id];l.refs--,o.push(l)}if(t){var d=n(t);s(d,e)}for(var a=0;a<o.length;a++){var l=o[a];if(0===l.refs){for(var u=0;u<l.parts.length;u++)l.parts[u]();delete h[l.id]}}}};var m=function(){var t=[];return function(e,i){return t[e]=i,t.filter(Boolean).join("\n")}}()},function(t,e,i){var s=i(2);"string"==typeof s&&(s=[[t.id,s,""]]);i(6)(s,{});s.locals&&(t.exports=s.locals)}])});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__javascript_components_404_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__javascript_components_home_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__javascript_components_parceiros_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__javascript_components_perguntasfrequentes_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__javascript_components_candidate_candidate_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__javascript_components_receipt_Receipt_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__javascript_components_deposit_Deposit_vue__ = __webpack_require__(283);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'home',
        component: __WEBPACK_IMPORTED_MODULE_3__javascript_components_home_vue__["a" /* default */]
    }, {
        path: '*',
        name: '404',
        component: __WEBPACK_IMPORTED_MODULE_2__javascript_components_404_vue__["a" /* default */]
    }, {
        path: '/parceiros',
        name: 'parceiros',
        component: __WEBPACK_IMPORTED_MODULE_4__javascript_components_parceiros_vue__["a" /* default */]
    }, {
        path: '/perguntas-frequentes',
        name: 'perguntasfrequentes',
        component: __WEBPACK_IMPORTED_MODULE_5__javascript_components_perguntasfrequentes_vue__["a" /* default */]
    }, {
        path: '/:candidate',
        name: 'candidate',
        component: __WEBPACK_IMPORTED_MODULE_6__javascript_components_candidate_candidate_vue__["a" /* default */]
    }, {
        path: '/:candidate/recibo/:digest',
        name: 'receipt',
        component: __WEBPACK_IMPORTED_MODULE_7__javascript_components_receipt_Receipt_vue__["a" /* default */]
    }, {
        path: '/:candidate/deposito/:depositId',
        name: 'deposit',
        component: __WEBPACK_IMPORTED_MODULE_8__javascript_components_deposit_Deposit_vue__["a" /* default */]
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {

        if (to.hash) {
            return {
                selector: to.hash,
                offset: { x: 0, y: 88 }
            };
        } else {
            return { x: 0, y: 0 };
        }
    }
}));

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.3
  * (c) 2021 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.3';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c949d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5c949d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c949d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2f3d66eb", content, true, {});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#not-found[data-v-b5c949d4]{background-image:url(" + escape(__webpack_require__(38)) + ");background-repeat:no-repeat;background-position:90% 120%;background-size:310px auto;background-color:#1167ac;color:#fff;width:100%;height:40vh;min-height:300px;padding-top:7em;padding-bottom:4em}@media (min-width:450px){#not-found[data-v-b5c949d4]{padding-top:8em;padding-bottom:5em}}@media (min-width:680px){#not-found[data-v-b5c949d4]{padding-top:8em;background-image:url(" + escape(__webpack_require__(17)) + ");background-position:90% 140%;background-size:400px auto;height:40vh}}@media (min-width:768px){#not-found[data-v-b5c949d4]{padding-top:10em;background-image:url(" + escape(__webpack_require__(17)) + ");background-size:450px auto;background-position:100% 150%}}.call-to-action[data-v-b5c949d4]{font-size:30px;font-weight:700;font-style:normal;color:#71fcc3;text-transform:lowercase;cursor:pointer;position:relative}.call-to-action[data-v-b5c949d4]:hover{color:#3c6}.not-found-section p[data-v-b5c949d4]{margin-top:1em;margin-bottom:1em;font-size:18px;line-height:2;color:#fff}", ""]);

// exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"not-found"}},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"not-found-section"},[_c('h1',[_vm._v("\n\t\t\t\t\tErro 404\n\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("Essa página não existe.")]),_vm._v(" "),_c('a',{staticClass:"call-to-action",attrs:{"href":"/"}},[_vm._v("\n\t\t\t\t\t> Voltar\n\t\t\t\t")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfe9165c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(226);
function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfe9165c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfe9165c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(110);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("46cd605c", content, true, {});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "html[data-v-dfe9165c]{color:#fff}img[data-v-dfe9165c]{width:100%}s[data-v-dfe9165c],strong[data-v-dfe9165c],time[data-v-dfe9165c]{font-weight:700}.container[data-v-dfe9165c]{height:100%;max-width:1200px}#greetings[data-v-dfe9165c]{min-height:50vh;background-image:url(" + escape(__webpack_require__(111)) + ");background-position:50% 150%;background-size:auto 500px;background-repeat:no-repeat}@media (min-width:450px){#greetings[data-v-dfe9165c]{background-position:100% 110%}}@media (min-width:768px){#greetings[data-v-dfe9165c]{background-image:url(" + escape(__webpack_require__(112)) + ");background-position:84% 80%;background-size:auto 100%}}@media (min-width:944px){#greetings[data-v-dfe9165c]{background-image:url(" + escape(__webpack_require__(113)) + ");background-position:100% 0}}@media (min-width:1200px){#greetings[data-v-dfe9165c]{background-image:url(" + escape(__webpack_require__(114)) + ")}}#greetings p[data-v-dfe9165c]{max-width:20em;margin-bottom:1.5em}@media (min-width:800px){#greetings p[data-v-dfe9165c]{max-width:28em}}#greetings .wrap-info--text[data-v-dfe9165c]{padding-top:.5em;padding-bottom:2.5rem;line-height:1.5rem;color:#676767}#greetings .innovare[data-v-dfe9165c]{width:8rem;margin-top:30px;opacity:.3;filter:grayscale(1)}.home-section[data-v-dfe9165c]{padding-top:7em;padding-bottom:4em;overflow:hidden}@media (min-width:450px){.home-section[data-v-dfe9165c]{padding-top:8em;padding-bottom:6em}}@media (min-width:680px){.home-section[data-v-dfe9165c]{padding-top:8em}}@media (min-width:768px){.home-section[data-v-dfe9165c]{padding-top:10em;padding-bottom:5em}}@media (min-width:991px){.home-section[data-v-dfe9165c]{padding-top:13em;padding-bottom:6em}}@media (min-width:1199px){.home-section[data-v-dfe9165c]{padding-top:15em;padding-bottom:10em}}.home-section[data-v-dfe9165c] :after{clear:both;display:table}.home-section .call-to-action[data-v-dfe9165c]{white-space:nowrap;position:relative;padding:.35em .5em;font-style:normal;font-weight:700;font-size:30px;text-transform:lowercase;cursor:pointer;color:#fff;background-color:#1e5b66;border-radius:8px}.home-section .call-to-action[data-v-dfe9165c]:before{color:#3c6;content:\">\"}.home-section .call-to-action[data-v-dfe9165c]:hover{background-color:#3c6}.home-section .call-to-action[data-v-dfe9165c]:hover:before{color:#1e5b66}.home-section h1[data-v-dfe9165c]{margin-bottom:.5em;line-height:1;text-transform:none;color:#399}h1[data-v-dfe9165c]{display:block;width:8em;font-weight:700}.credit-home[data-v-dfe9165c]{position:relative;z-index:1;padding-bottom:1.2em}.credit-home h1[data-v-dfe9165c]{display:inline;font-weight:400;font-size:15px;text-indent:.21em;vertical-align:middle;color:#6b6b6b}.appcivico-home[data-v-dfe9165c]{display:inline-block;width:115px;height:19px;padding-left:.2em;overflow:hidden;text-indent:110%;white-space:nowrap;background-image:url(" + escape(__webpack_require__(115)) + ");background-position:40%;background-repeat:no-repeat}", ""]);

// exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-greetings-320w--92ab9707.jpg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-greetings-768w--29c602e5.jpg";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-greetings-1024w--01d548f1.jpg";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-greetings-1430w--9eef01a6.jpg";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "appcivico-logo--f85e3b01.svg";

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authenticitysection_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f2739b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_authenticitysection_vue__ = __webpack_require__(119);
function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54f2739b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_authenticitysection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f2739b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_authenticitysection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6f8e6a95", content, true, {});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".call-to-action-button[data-v-54f2739b]{display:inline-block;padding:.6rem 2rem;margin-top:1rem;font-weight:600;font-size:1em;line-height:1.5;text-align:center;text-transform:uppercase;color:#fff;background-color:transparent;border:2px solid #fff;border-radius:8px}p[data-v-54f2739b]{margin-bottom:1.5em}.authenticity[data-v-54f2739b]{background-color:#2e656f}.section[data-v-54f2739b]{overflow:hidden}@media screen and (min-width:768px){.text-authenticity[data-v-54f2739b]{float:right;width:50%}}.title-authenticity[data-v-54f2739b]{color:#fff}.text-authenticity p[data-v-54f2739b]{font-size:18px;line-height:2;color:#fff}@media (max-width:913px){.text-authenticity p[data-v-54f2739b]{margin-bottom:2em}}.img-authenticity[data-v-54f2739b]{display:block;margin-right:auto;margin-left:auto;---position:relative}", ""]);

// exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row authenticity"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"text-authenticity"},[_c('h2',[_c('span',{staticClass:"title-authenticity"},[_vm._v(" Autenticidade Garantida das transações!")])]),_vm._v(" "),_c('p',[_vm._v("Todas as transações realizadas são registradas em uma rede pública de blockchain, garantindo sua autenticidade. Essas operações poderão ser verificadas de qualquer lugar e momento no futuro, para comprovar a lisura do processo de captação de recursos.")]),_vm._v(" "),_c('p',[_vm._v("\n          Veja todas as doações realizadas na interface do Voto Legal.\n        ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"call-to-action-button",attrs:{"href":"https://blockchain2020.votolegal.com.br"}},[_vm._v("\n            Explore\n          ")])])]),_vm._v(" "),_c('img',{staticClass:"img-authenticity",attrs:{"src":__webpack_require__(42),"srcset":__webpack_require__(42) + " 1x, " + __webpack_require__(120) + " 2x, " + __webpack_require__(121) + " 3x","alt":"O Voto Legal e Decred"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-blockchain@2x--28a69fe9.png";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-blockchain@3x--07671e2b.png";

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mentorshipsection_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cb018f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mentorshipsection_vue__ = __webpack_require__(125);
function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cb018f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mentorshipsection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cb018f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mentorshipsection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3e9c23fc", content, true, {});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".call-to-action-button[data-v-7cb018f4]{margin-top:1rem;display:inline-block;padding:.6rem 2rem;color:#fff;text-align:center;text-transform:uppercase;font-size:1em;font-weight:600;border:2px solid #fff;border-radius:8px;background-color:transparent}a[data-v-7cb018f4]{color:inherit;text-decoration:underline}.boletos-section[data-v-7cb018f4]{background-color:#119783}.boletos-section .section[data-v-7cb018f4]{align-items:center;flex-wrap:wrap}.section[data-v-7cb018f4]{overflow:hidden}@media screen and (min-width:768px){.text-boletos[data-v-7cb018f4]{float:left;width:50%;padding-right:1rem;box-sizing:border-box}}.title-boletos[data-v-7cb018f4]{color:#fff}.text-boletos p[data-v-7cb018f4]{font-size:18px;line-height:2;margin-bottom:1rem;color:#fff}@media (max-width:913px){.text-boletos p[data-v-7cb018f4]{margin-bottom:2em}}.img-authenticity[data-v-7cb018f4]{---position:relative;margin-left:auto;margin-right:auto;display:block;width:100%}@media (min-width:768px){.img-authenticity[data-v-7cb018f4]{width:50%}}.call-to-action[data-v-7cb018f4]{font-size:18px;font-weight:700;font-style:normal;color:#fff;text-transform:lowercase;text-decoration:underline;cursor:pointer;position:relative}.call-to-action[data-v-7cb018f4]:hover{color:#3c6}", ""]);

// exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row boletos-section"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"text-boletos"},[_c('h2',[_c('span',{staticClass:"title-boletos"},[_vm._v("Tenha uma mentoria especializada para sua pré-campanha!")])]),_vm._v(" "),_c('p',[_vm._v("\n          Muito mais que uma plataforma: O Voto Legal tem uma equipe de especialistas que irão te ajudar a começar a seu financiamento coletivo.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Aprenda fazendo: Temos uma mentoria mão na massa, onde você aprende na prática como ter sucesso com a sua arrecadação.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Da arrecadação a prestação de contas: Além da plataforma que facilita e dá segurança para seus doadores, tenha também um Mentor Voto Legal, que vai acompanhar de perto a construção da sua vaquinha digital.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Junte-se ao nosso\n          "),_c('a',{attrs:{"href":"https://t.me/votolegal_eleicoes","target":"_blank"}},[_vm._v("\n            canal no Telegram\n          ")]),_vm._v("\n          para acompanhar análises, recomendações e informações sobre financiamento eleitoral.\n        ")])]),_vm._v(" "),_c('img',{staticClass:"img-authenticity",attrs:{"src":__webpack_require__(126),"alt":"Integração votolegal"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mentoria--4d02de64.svg";

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chatbotsection_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bcbef55_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chatbotsection_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(128)
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bcbef55"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chatbotsection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bcbef55_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chatbotsection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4d3ce557", content, true, {});

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".call-to-action-button[data-v-4bcbef55]{margin-top:1rem;display:inline-block;padding:.6rem 2rem;color:#fff;text-align:center;text-transform:uppercase;font-size:1em;font-weight:600;border:2px solid #fff;border-radius:8px;background-color:transparent}.chatbot-section[data-v-4bcbef55]{background-color:#0aba7e}.section[data-v-4bcbef55]{overflow:hidden}@media screen and (min-width:768px){.text-chatbot[data-v-4bcbef55]{float:right;width:50%}}.title-chatbot[data-v-4bcbef55]{color:#fff}.text-chatbot p[data-v-4bcbef55]{font-size:18px;line-height:2;color:#fff}@media (max-width:913px){.text-chatbot p[data-v-4bcbef55]{margin-bottom:2em}}.img-chatbot[data-v-4bcbef55]{---position:relative;margin-left:0;margin-right:auto;display:block}", ""]);

// exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("984f029e", content, true, {});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row chatbot-section"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"text-chatbot"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("\n                  Inicie sua campanha de arrecadação em minutos. Com o Voto Legal é fácil você criar e publicar um site atraente e personalizável. Use vídeos, apresente suas propostas para doadores e acompanhe em tempo real o progresso da sua meta.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  Em poucos cliques, sem burocracia, você coloca no ar sua campanha integrada com meios de pagamentos que dão segurança aos doadores. Com o voto Legal, sua arrecadação está segura.\n                ")]),_vm._v(" "),_c('a',{staticClass:"call-to-action-button",attrs:{"href":"#email"},on:{"click":function($event){$event.preventDefault();return _vm.scrollTo.apply(null, arguments)}}},[_vm._v("\n                  Quero começar\n                ")])]),_vm._v(" "),_c('img',{staticClass:"img-chatbot",attrs:{"src":__webpack_require__(45),"srcset":__webpack_require__(45) + " 1x, " + __webpack_require__(133) + " 2x, " + __webpack_require__(134) + " 3x","alt":"Construtor de sites"}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('span',{staticClass:"title-chatbot"},[_vm._v("Construa seu site com a gente")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sites@2x--535fa98f.jpg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sites@3x--fe9a29ae.jpg";

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_candidatesSection_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fcc78c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_candidatesSection_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_candidatesSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fcc78c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_candidatesSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(137);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ea4b7efc", content, true, {});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#candidates{background-color:#2e656f}#candidates .section{text-align:left}#candidates .section+section{padding-top:0}#candidates .section h2{text-transform:uppercase;padding-bottom:0}#candidates .section .candidatos-wrap{position:relative;padding-top:25px;overflow:hidden;width:100%;margin:0 auto;text-align:center}#candidates .section .candidatos-wrap:after{content:\"\";display:table;clear:both}#candidates .section .candidatos-wrap .img-content{background-color:#fff;margin-left:auto;margin-right:auto}#candidates .section .candidatos-wrap img{max-width:100%;min-width:100%;min-height:100%;object-fit:cover}#candidates .section .candidatos-wrap .candidato{color:#fff;display:inline-block;min-width:230px;text-align:center;font-weight:700;text-transform:uppercase;margin-bottom:40px}@media screen and (min-width:410px){#candidates .section .candidatos-wrap .candidato{padding-right:22px;padding-left:22px}}#candidates .section .candidatos-wrap .candidato .img-content{width:180px;height:180px;object-fit:contain;border-radius:50%;overflow:hidden;margin-top:25px}@media screen and (min-width:640px){#candidates .section .candidatos-wrap .candidato .img-content{width:180px;height:180px}}#candidates .section .candidatos-wrap .candidato h3,#candidates .section .candidatos-wrap .candidato h4{color:inherit;text-align:inherit}#candidates .section .candidatos-wrap .candidato h3{margin-top:10px}#candidates .section .candidatos-wrap .candidato h4{font-size:smaller}#candidates .section .candidatos-wrap .candidato p{font-weight:700;margin-top:10px}", ""]);

// exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var bind = __webpack_require__(47);
var Axios = __webpack_require__(140);
var defaults = __webpack_require__(19);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(51);
axios.CancelToken = __webpack_require__(153);
axios.isCancel = __webpack_require__(50);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(154);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(19);
var utils = __webpack_require__(4);
var InterceptorManager = __webpack_require__(148);
var dispatchRequest = __webpack_require__(149);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(49);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var transformData = __webpack_require__(150);
var isCancel = __webpack_require__(50);
var defaults = __webpack_require__(19);
var isAbsoluteURL = __webpack_require__(151);
var combineURLs = __webpack_require__(152);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(51);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./andre_bolini.jpg": 156,
	"./aurea_carolina.jpg": 157,
	"./cristal_lopez.jpg": 158,
	"./denys_grellmann.jpg": 159,
	"./diogo_pastorello.jpg": 160,
	"./dremerson.jpg": 161,
	"./eduardo_suplicy.jpg": 162,
	"./francisco_junior.jpg": 163,
	"./goura.jpg": 164,
	"./hendel_machado.jpg": 165,
	"./jose_police_neto.jpg": 166,
	"./luciana_santos.jpg": 167,
	"./margarida_salomao.jpg": 168,
	"./pedro_markun.jpg": 169,
	"./ricardo_tripoli.jpg": 170,
	"./ricardo_young.jpg": 171,
	"./tarcisio_secoli.jpg": 172
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "andre_bolini--63409b94.jpg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aurea_carolina--d81cbaab.jpg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cristal_lopez--4d731833.jpg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "denys_grellmann--fe842d8c.jpg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "diogo_pastorello--6e49fc3c.jpg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dremerson--18c89a6e.jpg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eduardo_suplicy--1f111123.jpg";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "francisco_junior--7c8744e2.jpg";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "goura--81543745.jpg";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hendel_machado--00484d5b.jpg";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jose_police_neto--2a652884.jpg";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "luciana_santos--526af78a.jpg";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "margarida_salomao--8f2a7ba7.jpg";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pedro_markun--751ed7d1.jpg";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ricardo_tripoli--0dd37f56.jpg";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ricardo_young--d1076ca4.jpg";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tarcisio_secoli--c722e1bc.jpg";

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sortedElectionList.length)?_c('div',{staticClass:"row background-green",attrs:{"id":"candidates","aria-busy":_vm.loading}},[_c('div',{staticClass:"container"},_vm._l((_vm.sortedElectionList),function(election,idx){return _c('section',{key:idx,staticClass:"section"},[_c('h2',{staticClass:"title"},[_vm._v("\n\t\t\t\t"+_vm._s(election.intro)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"candidatos-wrap"},[_vm._l((election.candidates),function(candidate){return [(candidate.avatar || candidate.picture)?_c('a',{key:candidate.name,staticClass:"candidato",attrs:{"target":"_blank","href":candidate.url+'?ref=votolegal'}},[_c('div',{staticClass:"img-content"},[_c('img',{attrs:{"src":candidate.avatar || candidate.picture,"alt":candidate.popular_name}})]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(candidate.popular_name))]),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(candidate.address_state_name),expression:"candidate.address_state_name"}]},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(candidate.address_state_name)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(candidate.office),expression:"candidate.office"}]},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(candidate.office)+"\n\t\t\t\t\t\t")])]):_vm._e()]})],2)])}),0)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facedetectsection_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6ffd89_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facedetectsection_vue__ = __webpack_require__(177);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e6ffd89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facedetectsection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e6ffd89_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facedetectsection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(176);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("01bd5f8b", content, true, {});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".call-to-action-button[data-v-0e6ffd89]{margin-top:1rem;display:inline-block;padding:.6rem 2rem;color:#fff;text-align:center;text-transform:uppercase;font-size:1em;font-weight:600;border:2px solid #fff;border-radius:8px;background-color:transparent}.boletos-section[data-v-0e6ffd89]{background-color:#119783}.boletos-section .section[data-v-0e6ffd89]{align-items:center;flex-wrap:wrap}.section[data-v-0e6ffd89]{overflow:hidden}@media screen and (min-width:768px){.text-boletos[data-v-0e6ffd89]{float:left;width:50%}}.title-boletos[data-v-0e6ffd89]{color:#fff}.text-boletos p[data-v-0e6ffd89]{font-size:18px;line-height:2;color:#fff}@media (max-width:913px){.text-boletos p[data-v-0e6ffd89]{margin-bottom:2em}}.img-authenticity[data-v-0e6ffd89]{margin-left:auto;margin-right:auto;display:block;width:100%}@media (min-width:768px){.img-authenticity[data-v-0e6ffd89]{width:50%}}.call-to-action[data-v-0e6ffd89]{font-size:18px;font-weight:700;font-style:normal;color:#fff;text-transform:lowercase;text-decoration:underline;cursor:pointer;position:relative}.call-to-action[data-v-0e6ffd89]:hover{color:#3c6}", ""]);

// exports


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row boletos-section"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"text-boletos"},[_c('h2',[_c('span',{staticClass:"title-boletos"},[_vm._v("Transforme sua audiência em doadores")])]),_vm._v(" "),_c('p',[_vm._v("\n          Você pode transformar seguidores das redes sociais e  listas de contatos em doadores, integrando seu Voto Legal com o JUNTOS.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Veja como funciona.\n        ")]),_vm._v(" "),_c('a',{staticClass:"call-to-action-button",attrs:{"target":"_blank","href":"https://juntos.digital/"}},[_vm._v("\n          Conheça agora\n        ")])]),_vm._v(" "),_c('img',{staticClass:"img-authenticity",attrs:{"src":__webpack_require__(178),"alt":"Integração votolegal"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "integration--8f5454c9.svg";

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_managementsection_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db37fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_managementsection_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57db37fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_managementsection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db37fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_managementsection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(181);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("33cea1c0", content, true, {});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "span[data-v-57db37fa]{color:#4bb958}.call-to-action-button[data-v-57db37fa]{margin-top:1rem;display:inline-block;padding:.6rem 2rem;color:#fff;text-align:center;text-transform:uppercase;font-size:1em;font-weight:600;border:2px solid #fff;border-radius:8px;background-color:transparent}#management[data-v-57db37fa]{color:#fff;background-color:#203f57;padding-top:12.5rem;background-image:url(" + escape(__webpack_require__(182)) + ");background-size:cover;box-sizing:border-box}@media screen and (min-width:480px){#management[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(183)) + ")}}@media screen and (min-width:640px){#management[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(184)) + ")}}@media screen and (min-width:960px){#management[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(185)) + ")}}@media screen and (min-width:1280px){#management[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(186)) + ")}}@media screen and (min-width:1920px){#management[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(187)) + ")}}#management p[data-v-57db37fa]{margin-bottom:1em;max-width:33em}#management .call-to-action[data-v-57db37fa]{font-size:18px;font-weight:700;font-style:normal;color:#fff;text-transform:lowercase;text-decoration:underline;cursor:pointer;position:relative}#management .call-to-action[data-v-57db37fa]:hover{color:#3c6}#management .wrap-info[data-v-57db37fa]{box-sizing:border-box;background-color:#204057;background-repeat:no-repeat;background-image:url(" + escape(__webpack_require__(188)) + ");background-position:100% 0;background-size:522px 465px;min-height:465px;padding:10rem 1rem 5rem;position:relative}@media (min-width:380px){#management .wrap-info[data-v-57db37fa]{padding:3rem 2rem}}@media (min-width:500px){#management .wrap-info[data-v-57db37fa]{padding:4rem 3rem}}@media (min-width:1200px){#management .wrap-info[data-v-57db37fa]{padding:5rem 4rem}}@media only screen and (min-resolution:192dpi){#management .wrap-info[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(54)) + ")}}@media only screen and (min-resolution:2dppx){#management .wrap-info[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(54)) + ")}}@media only screen and (min-resolution:288dpi){#management .wrap-info[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(55)) + ")}}@media only screen and (min-resolution:3dppx){#management .wrap-info[data-v-57db37fa]{background-image:url(" + escape(__webpack_require__(55)) + ")}}#management .wrap-info[data-v-57db37fa]:before{position:absolute;background-image:url(" + escape(__webpack_require__(189)) + ");background-size:436px 152px;width:436px;height:152px;content:\"\";top:-152px;right:0}@media only screen and (min-resolution:192dpi){#management .wrap-info[data-v-57db37fa]:before{background-image:url(" + escape(__webpack_require__(56)) + ")}}@media only screen and (min-resolution:2dppx){#management .wrap-info[data-v-57db37fa]:before{background-image:url(" + escape(__webpack_require__(56)) + ")}}@media only screen and (min-resolution:288dpi){#management .wrap-info[data-v-57db37fa]:before{background-image:url(" + escape(__webpack_require__(57)) + ")}}@media only screen and (min-resolution:3dppx){#management .wrap-info[data-v-57db37fa]:before{background-image:url(" + escape(__webpack_require__(57)) + ")}}#management .wrap-info h2[data-v-57db37fa]{position:absolute;right:0;bottom:100%;z-index:1;max-width:100%}#management .wrap-info p+p[data-v-57db37fa]{padding-bottom:3.75rem;margin:0}", ""]);

// exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-gestao--320w--10e7d724.jpg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-gestao--480w--3f9cd18b.jpg";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-gestao--640w--11fd0996.jpg";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-gestao--960w--f6bcb532.jpg";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-gestao--1280w--7ab37a10.jpg";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-gestao--1920w--cb554584.jpg";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-gestao--c66b7fdf.jpg";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img-gestao-top--21a1c27b.png";

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"management"}},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"wrap-info"},[_c('h2',{staticClass:"huge-title"},[_vm._v("\n          Gestão de campanhas\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Além de ser uma plataforma que atua com as melhores tecnologias para segurança e suportar o maior número de acessos simultâneos, oferecemos uma plataforma autônoma para acompanhamento em tempo real das doações, automatização na emissão de recibos eleitorais e importação dos dados de maneira prática com o sistema de prestação de contas do TSE (SPCE).\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Nos preocupamos muito com os doadores, oferecendo informações detalhadas sobre quais são suas obrigações e responsabilidades com relação ao processo de doação, assim como seus limites e os auxiliando na declaração de imposto de renda.\n        ")]),_vm._v(" "),_c('a',{staticClass:"call-to-action-button",attrs:{"href":"#email"},on:{"click":function($event){$event.preventDefault();return _vm.scrollTo.apply(null, arguments)}}},[_vm._v("\n          estou interessado\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_midiasection_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba83072_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_midiasection_vue__ = __webpack_require__(205);
function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ba83072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_midiasection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba83072_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_midiasection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(193);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("cac55e70", content, true, {});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#midia[data-v-2ba83072]{background-color:#fff;color:#35d34f}#midia h2[data-v-2ba83072]{text-align:center}.midia-wrap[data-v-2ba83072]{width:100%;margin-left:auto;margin-right:auto;text-align:center;margin-top:5rem}@media (max-width:700px){.midia-wrap[data-v-2ba83072]{margin-top:2em}}.midia-wrap[data-v-2ba83072]:after{content:\"\";display:table;clear:both}.midia-wrap .img-content[data-v-2ba83072]{display:inline-block;float:none;margin:20px 1.5em 40px;overflow:hidden;text-indent:110%;white-space:nowrap;background-repeat:no-repeat;direction:ltr}@media (min-width:480px){.midia-wrap .img-content[data-v-2ba83072]{display:inline-block;float:none;margin-right:2.5em;margin-left:2.5em}}@media (min-width:800px){.midia-wrap .img-content[data-v-2ba83072]{margin-top:30px;margin-bottom:30px}}.midia-wrap[data-v-2ba83072]{padding:0}.midia-wrap a[data-v-2ba83072]{display:block;height:100%}.tedx[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(194)) + ");width:148px;height:54px}.cbn[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(195)) + ");width:136px;height:54px}.el-pais[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(196)) + ");width:205px;height:54px}.estadao[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(197)) + ");width:216px;height:54px}.jornal-nacional[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(198)) + ");width:100px;height:54px}.nexo[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(199)) + ");width:202px;height:54px}.super-interessante[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(200)) + ");width:152px;height:54px}.folha-sp[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(201)) + ");width:200px;height:54px;background-size:contain}@media (min-width:768px){.folha-sp[data-v-2ba83072]{width:290px;height:54px}}.yahoo[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(202)) + ");width:156px;height:54px}.livecoins[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(203)) + ");width:156px;height:54px}.portal-bitcoin[data-v-2ba83072]{background-image:url(" + escape(__webpack_require__(204)) + ");width:224px;height:54px;background-size:contain}@media (min-width:768px){.portal-bitcoin[data-v-2ba83072]{width:224px;height:57px}}", ""]);

// exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-TEDx-branco--9065b027.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-cbn-branco--698f3e30.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-elpais-branco--4c96b560.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-estadao-branco--a0de0356.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-jn-branco--7d0b47d1.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-nexo-branco--ae065627.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-superinteressante-branco--680e9592.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-folha-branco--4b5d8996.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "yahoo--4b70a993.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "livecoins--0fab42d0.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "portal-bitcoin--3b79919d.png";

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"midia"}},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('h2',{staticClass:"title big-title"},[_vm._v("Voto Legal na mídia")]),_vm._v(" "),_c('ul',{staticClass:"midia-wrap"},[_c('li',{staticClass:"img-content tedx"},[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=49J9g5gCcWM&t=2s","target":"_blank"}},[_vm._v("TEDx")])]),_vm._v(" "),_c('li',{staticClass:"img-content el-pais"},[_c('a',{attrs:{"href":"https://brasil.elpais.com/brasil/2016/07/08/politica/1468011468_841041.html","target":"_blank"}},[_vm._v("El País")])]),_vm._v(" "),_c('li',{staticClass:"img-content cbn"},[_c('a',{attrs:{"href":"http://cbn.globoradio.globo.com/sao-paulo/2016/09/23/NA-RETA-FINAL-DIVERSOS-SITES-E-APLICATIVOS-AJUDAM-O-ELEITOR-A-DEFINIR-O-VOTO.htm","target":"_blank"}},[_vm._v("CBN")])]),_vm._v(" "),_c('li',{staticClass:"img-content estadao"},[_c('a',{attrs:{"href":"http://politica.estadao.com.br/noticias/geral,iniciativas-querem-estimular-doacoes-de-pessoa-fisica,10000053676","target":"_blank"}},[_vm._v("Estadão")])]),_vm._v(" "),_c('li',{staticClass:"img-content jornal-nacional"},[_c('a',{attrs:{"href":"http://g1.globo.com/jornal-nacional/noticia/2016/08/eleicoes-de-2016-tem-novidade-empresas-nao-podem-fazer-doacoes.html","target":"_blank"}},[_vm._v("Jornal Nacional")])]),_vm._v(" "),_c('li',{staticClass:"img-content folha-sp"},[_c('a',{attrs:{"href":"http://www1.folha.uol.com.br/tec/2016/06/1783365-por-transparencia-grupo-quer-usar-tecnologia-do-bitcoin-em-eleicoes-de-sp.shtml","target":"_blank"}},[_vm._v("Folha de São Paulo")])]),_vm._v(" "),_c('li',{staticClass:"img-content super-interessante"},[_c('a',{attrs:{"href":"https://super.abril.com.br/ideias/quem-e-que-paga-a-politica","target":"_blank"}},[_vm._v("Super Interessante")])]),_vm._v(" "),_c('li',{staticClass:"img-content nexo"},[_c('a',{attrs:{"href":"https://www.nexojornal.com.br/ensaio/2016/Elei%C3%A7%C3%B5es-e-a-oportunidade-de-um-maior-engajamento-dos-cidad%C3%A3os-com-seus-representantes","target":"_blank"}},[_vm._v("Nexo")])]),_vm._v(" "),_c('li',{staticClass:"img-content yahoo"},[_c('a',{attrs:{"href":"https://br.noticias.yahoo.com/doacoes-de-marina-silva-serao-registradas-em-blockchain-entenda-145118346.html","target":"_blank"}},[_vm._v("Yahoo")])]),_vm._v(" "),_c('li',{staticClass:"img-content portal-bitcoin"},[_c('a',{attrs:{"href":"https://portaldobitcoin.com/marina-silva-usa-blockchain-para-financiar-campanha-e-arrecada-r-100-mil-em-quatro-dias/","target":"_blank"}},[_vm._v("Portal do Bitcoin")])]),_vm._v(" "),_c('li',{staticClass:"img-content livecoins"},[_c('a',{attrs:{"href":"https://livecoins.com.br/marina-silva-utilizando-blockchain-da-decred-para-deixar-transparente-o-financiamento-coletivo-de-sua-campanha-eleitoral/","target":"_blank"}},[_vm._v("Livecoins")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pricingsection_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ff7722_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pricingsection_vue__ = __webpack_require__(211);
function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05ff7722"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pricingsection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05ff7722_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pricingsection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(208);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("466e9f0e", content, true, {});

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".pricing[data-v-05ff7722]{position:relative;width:100%;text-align:center;color:#fff;background-image:url(" + escape(__webpack_require__(38)) + ");background-position:center 50%;background-size:310px 306px;background-repeat:no-repeat;background-color:#1167ac}@media screen and (min-width:450px){.pricing[data-v-05ff7722]{background-image:url(" + escape(__webpack_require__(17)) + ");background-position:60% 60%;background-size:400px 395px}}@media screen and (min-width:580px){.pricing[data-v-05ff7722]{background-image:url(" + escape(__webpack_require__(209)) + ");background-position:center 58%;background-size:550px 543px}}@media screen and (min-width:980px){.pricing[data-v-05ff7722]{background-size:550px 543px}}.pricing h2[data-v-05ff7722]{font-weight:700;text-align:center}.pricing p[data-v-05ff7722]{text-align:center}.section[data-v-05ff7722]{overflow:hidden}.pricing-text p[data-v-05ff7722]{margin-top:1em;margin-bottom:1em;font-size:25px}.pricing-text strong[data-v-05ff7722]{font-weight:700}.pricing-boxes-wrap[data-v-05ff7722]{width:100%;margin-top:3rem;font-size:0;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed}.campaign-box[data-v-05ff7722],.pre-campaign-box[data-v-05ff7722]{height:auto;max-width:100%;padding:2em;font-size:1rem;text-align:center;text-transform:uppercase;background-color:#2078bc;border:2px dashed #fff;border-radius:3px}@media screen and (min-width:500px){.campaign-box[data-v-05ff7722],.pre-campaign-box[data-v-05ff7722]{width:310px;height:250px;margin-top:1em;margin-right:2.5em;margin-left:2.5em}}.pre-campaign-box h3[data-v-05ff7722]{margin-bottom:.9em}.campaign-box[data-v-05ff7722]{background-color:#0f5893}.fee-box[data-v-05ff7722],.pricing-box[data-v-05ff7722]{position:relative;margin-bottom:1rem;font-size:1em;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1}@media screen and (min-width:500px){.fee-box[data-v-05ff7722],.pricing-box[data-v-05ff7722]{display:inline-block}}@media screen and (min-width:1024px){.fee-box[data-v-05ff7722]{min-height:152px}}@media screen and (min-width:1024px){.fee-box--first[data-v-05ff7722]{padding-top:20px;box-sizing:border-box}}.pricing-box h3[data-v-05ff7722]{font-weight:700;font-size:23px;text-align:center;text-transform:uppercase;color:#fff}.box-subtitle[data-v-05ff7722]{margin-bottom:0;font-weight:700;font-size:14px;color:#aadaff}.full-price[data-v-05ff7722]{font-size:xx-large;text-transform:lowercase;opacity:.75}.full-price s[data-v-05ff7722]{position:relative;display:inline-block;text-decoration:none}.full-price s[data-v-05ff7722]:after{position:absolute;right:0;bottom:50%;left:0;width:100%;border-top:2px solid currentColor;content:\"\";transform:skewY(-10deg)}.box-currency[data-v-05ff7722]{margin-top:.5em;font-size:35px}.box-currency[data-v-05ff7722],.box-price[data-v-05ff7722]{display:inline-block;font-weight:700;text-transform:uppercase}.box-price[data-v-05ff7722]{margin-top:15px;font-size:65px}.box-cents[data-v-05ff7722]{display:inline-block;margin-top:.7em;margin-left:-.1em;font-size:35px;text-transform:uppercase;vertical-align:top}.box-price-subtitle[data-v-05ff7722]{width:15em;margin-top:-.5em;margin-right:auto;margin-left:auto;font-size:14px}.box-price-information[data-v-05ff7722]{max-width:20em;margin-top:1em;margin-right:auto;margin-left:auto;text-transform:none;font-size:13px}.fee-box[data-v-05ff7722]{display:block;width:95%;margin-right:auto;margin-bottom:2rem;margin-left:auto;font-weight:700;font-size:1em;line-height:.8em;background-color:#143d5d;opacity:.9}@media screen and (min-width:500px){.fee-box[data-v-05ff7722]{width:345px;margin-bottom:2rem}}.fee-box span[data-v-05ff7722]{font-size:22px;color:#fff}.pricing-boxes-wrap .fee-box[data-v-05ff7722]{margin-top:.5em;margin-bottom:1em}.fee-box-title[data-v-05ff7722]{padding-top:1em;padding-bottom:0;margin:auto;font-weight:700;text-align:center}@media screen and (max-width:400px){.fee-box-title[data-v-05ff7722]{font-size:15px}}.fee-box-text[data-v-05ff7722]{max-width:18em;padding-top:0;margin:auto;text-align:center}.fee-box-text[data-v-05ff7722]:last-child{padding-bottom:1em}.fee-box-text--footnote[data-v-05ff7722]{width:100%;max-width:none;margin-top:1.5rem;font-size:.75rem;line-height:1.5}.img-pricing[data-v-05ff7722]{position:relative;display:block;margin-right:auto;margin-left:auto}.call-to-buy[data-v-05ff7722]{width:100%;margin-top:1.5rem;margin-bottom:0;text-align:center}@media screen and (min-width:500px){.call-to-buy[data-v-05ff7722]{margin-top:2.5rem}}.call-to-buy p[data-v-05ff7722]{margin-bottom:2rem;font-size:1.5em}.call-to-buy p a[data-v-05ff7722]{font-weight:700;text-decoration:underline;color:#fff}.input-wrapper[data-v-05ff7722]{display:flex;align-items:flex-start;flex-wrap:wrap;justify-content:center;margin-top:.375em;margin-bottom:.375em}.input-wrapper .nav-link[data-v-05ff7722],.input-wrapper input[data-v-05ff7722],.input-wrapper label[data-v-05ff7722],.input-wrapper small[data-v-05ff7722]{display:flex;align-items:center;height:3rem;padding:.5em 1.5em;margin-bottom:3rem;line-height:1.5rem;border-radius:8px;box-sizing:border-box}.input-wrapper label[data-v-05ff7722],.input-wrapper small[data-v-05ff7722]{margin-bottom:0;line-height:1}.input-wrapper div[data-v-05ff7722]{width:min-content;padding-right:.5em;padding-bottom:3rem;padding-left:.5em}.input-wrapper input[data-v-05ff7722]{width:25em;max-width:100%;margin-bottom:0;border:2px solid #fff}.nav-link[data-v-05ff7722]{width:max-content;max-width:100%;font-weight:700;font-size:larger;text-align:center;cursor:pointer;color:#fff;background-color:#0aba7e;border:0;border:2px solid #0aba7e}.input-wrapper label[data-v-05ff7722]{padding-right:0;padding-left:0;font-weight:700}.message[data-v-05ff7722]{display:block;padding-bottom:0;margin-top:.5em;font-weight:700;font-size:small;line-height:1;border-radius:8px}.message--success[data-v-05ff7722]{background-color:green}.message--error[data-v-05ff7722]{background-color:red}", ""]);

// exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-pricing-big--399f4007.png";

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Headers */
/* unused harmony export Request */
/* unused harmony export Response */
/* unused harmony export DOMException */
/* unused harmony export fetch */
var global =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  (typeof global !== 'undefined' && global)

var support = {
  searchParams: 'URLSearchParams' in global,
  iterable: 'Symbol' in global && 'iterator' in Symbol,
  blob:
    'FileReader' in global &&
    'Blob' in global &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in global,
  arrayBuffer: 'ArrayBuffer' in global
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this)
        if (isConsumed) {
          return isConsumed
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = global.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && global.location.href ? global.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer &&
        request.headers.get('Content-Type') &&
        request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!global.fetch) {
  global.fetch = fetch
  global.Headers = Headers
  global.Request = Request
  global.Response = Response
}


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pricing"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section",attrs:{"id":"valores"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pricing-boxes-wrap"},[_c('div',{staticClass:"pricing-box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"fee-box fee-box--first"},[_c('p',{staticClass:"fee-box-title"},[_vm._v("\n              + Taxas administrativas por doação:\n            ")]),_vm._v(" "),_c('p',{staticClass:"fee-box-text"},[_vm._v("\n              "+_vm._s(_vm.creditCard)+" via cartão de crédito\n            ")]),_vm._v(" "),_c('p',{staticClass:"fee-box-text"},[_vm._v("\n              "+_vm._s(_vm.paymentSlip)+" via boleto pago\n            ")]),_vm._v(" "),_c('p',{staticClass:"fee-box-text"},[_vm._v("\n              "+_vm._s(_vm.paymentPix)+" via pix\n            ")])])])]),_vm._v(" "),_c('form',{staticClass:"call-to-buy",attrs:{"id":"call-to-buy","target":"_blank"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('p',[_vm._v("\n          Solicite sua licença\n        ")]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:_vm.errorMessage ? 'has-error' : ''},[_c('label',{attrs:{"for":"email"}},[_vm._v("\n            Seu melhor e-mail\n          ")]),_vm._v(" "),_c('div',{staticClass:"input-and-message"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"email","type":"email","name":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.errorMessage)?_c('small',{staticClass:"message message--error"},[_vm._v("\n              "+_vm._s(_vm.errorMessage)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.successMessage)?_c('small',{staticClass:"message message--success"},[_vm._v("\n              "+_vm._s(_vm.successMessage)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"nav-link",attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("\n            Comprar\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricing-text"},[_c('h2',{staticClass:"huge",attrs:{"id":"pre-cadastro-com-desconto"}},[_vm._v("\n          Valores & Taxas\n        ")]),_vm._v(" "),_c('p',{staticClass:"pricing-subtitle"},[_vm._v("\n          Confira preços e condições para contratação em "),_c('strong',[_vm._v("2020")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre-campaign-box"},[_c('h3',[_vm._v("Taxa única")]),_vm._v(" "),_c('p',[_vm._v("Pré-campanha e campanha")]),_vm._v(" "),_c('p',{staticClass:"box-currency"},[_vm._v("\n              R$\n            ")]),_vm._v(" "),_c('p',{staticClass:"box-price"},[_vm._v("\n              495,\n            ")]),_vm._v(" "),_c('p',{staticClass:"box-cents"},[_vm._v("\n              00\n            ")]),_vm._v(" "),_c('p',{staticClass:"box-price-subtitle"},[_vm._v("\n              Parcela única para setup\n            ")]),_vm._v(" "),_c('p',{staticClass:"box-price-information"},[_vm._v("\n                 Plataforma para doação eleitoral em 2022\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_statisticssection_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38d4369f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_statisticssection_vue__ = __webpack_require__(215);
function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38d4369f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_statisticssection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38d4369f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_statisticssection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(214);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("42756586", content, true, {});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".pricing[data-v-38d4369f]{position:relative;background-color:#1e5b66;color:#fff;text-align:center;width:100%}.pricing .section[data-v-38d4369f]{display:flex;flex-wrap:wrap;padding-top:3.125rem;padding-bottom:3.125rem}@media (min-width:768px){.pricing .section[data-v-38d4369f]{padding-top:4.375rem;padding-bottom:0}}@media (min-width:991px){.pricing .section[data-v-38d4369f]{padding-top:6.25rem;padding-bottom:0}}.pricing .section[data-v-38d4369f]:after{content:\"\";display:table;clear:both}.statistics-title[data-v-38d4369f]{margin-bottom:6em}@media (min-width:768px){.statistics-title[data-v-38d4369f]{margin-top:-3em}}@media (min-width:768px){.statistics-boxes-wrap[data-v-38d4369f]{display:flex}}.statistics-box[data-v-38d4369f]{flex-direction:column;flex:1 33%}@media (min-width:768px){.statistic-box-title[data-v-38d4369f]{min-height:4em;display:flex;flex-direction:column;align-content:flex-end;margin-bottom:1em}}.statistics-title h2[data-v-38d4369f]{width:100%;margin-bottom:0;line-height:1}.statistics-box h3[data-v-38d4369f],.statistics-box p[data-v-38d4369f]{max-width:25rem;text-align:left}@media (min-width:768px){.statistics-box h3[data-v-38d4369f],.statistics-box p[data-v-38d4369f]{margin-left:1.5rem;margin-right:1.5rem}}.statistics-box p[data-v-38d4369f]{margin-bottom:1rem}.statistics-box h3[data-v-38d4369f]{color:#35d34f;line-height:1}.statistics-box .big[data-v-38d4369f]{font-weight:700;letter-spacing:-1.2px;font-size:35px}@media (min-width:500px){.statistics-box .big[data-v-38d4369f]{font-size:38px}}@media (min-width:1200px){.statistics-box .big[data-v-38d4369f]{font-size:48px}}.statistics-box h2[data-v-38d4369f]{margin-top:auto}.statistic-box-text[data-v-38d4369f]{margin-bottom:1em}@media (min-width:768px){.statistic-box-text[data-v-38d4369f]{border-left:2px dotted #fff;min-height:100%;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pricing"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section",attrs:{"id":"porque"}},[_c('div',{staticClass:"statistics-title"},[_c('h2',[_vm._v("\n\t\t\t\t\t\tPor que\n\t\t\t\t\t\tVoto Legal?\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"statistics-boxes-wrap"},[_c('div',{staticClass:"statistics-box"},[_c('div',{staticClass:"statistic-box-title"},[_c('h3',{staticClass:"big"},[_vm._v("\n                R$ 2.5\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('h3',[_vm._v("\n                milhões arrecadados\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"statistic-box-text"},[_c('p',[_vm._v("\n                Segurança e agilidade no processamento de pagamentos\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"statistics-box"},[_c('div',{staticClass:"statistic-box-title"},[_c('h3',{staticClass:"big"},[_vm._v("\n                +500\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('h3',[_vm._v("\n                campanhas\n                realizadas\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"statistic-box-text"},[_c('p',[_vm._v("\n                Suporte especializado desde a mobilização até a prestação de contas\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"statistics-box"},[_c('div',{staticClass:"statistic-box-title"},[_c('h3',{staticClass:"big"},[_vm._v("\n                15 mil\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('h3',[_vm._v("\n                doadores atendidos\n              ")])]),_vm._v(" "),_c('div',{staticClass:"statistic-box-text"},[_c('p',[_vm._v("\n                Confiança e praticidade no processo de doação e emissão de recibos.\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"statistics-box"},[_c('div',{staticClass:"statistic-box-title"},[_c('h3',{staticClass:"big"},[_vm._v("\n                100%\n              ")]),_vm._v(" "),_c('h3',[_vm._v("\n                das contas aprovadas em 2018\n              ")])]),_vm._v(" "),_c('div',{staticClass:"statistic-box-text"},[_c('p',[_vm._v("\n                A prestação de contas do financiamento coletivo feita com tecnologia e seriedade por especialistas no assunto.\n\t\t\t\t\t\t\t")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_advantagessection_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c776556_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_advantagessection_vue__ = __webpack_require__(219);
function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c776556"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_advantagessection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c776556_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_advantagessection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(218);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6552eb69", content, true, {});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "[data-v-1c776556]{box-sizing:border-box}.row[data-v-1c776556]{background-color:#214157}h2[data-v-1c776556]{text-align:center;color:#fff;margin-bottom:2rem}.cards__list[data-v-1c776556]{display:flex;flex-wrap:wrap}.cards__card[data-v-1c776556]{justify-content:center;flex-grow:1;width:100%;padding-top:3rem;margin-right:1%;margin-bottom:2%;text-align:center;list-style:none;color:#214157;background-color:#fff;border-radius:10px;box-shadow:6px 6px 7px 0 rgba(0,0,0,.26)}@media (min-width:768px){.cards__card[data-v-1c776556]{width:42%}}@media (min-width:991px){.cards__card[data-v-1c776556]{width:32%}}@media (min-width:1200px){.cards__card[data-v-1c776556]{width:21%}}.cards__image[data-v-1c776556]{margin-bottom:1.4rem;height:7rem}.cards__text[data-v-1c776556]{width:100%;padding-right:1rem;padding-bottom:1.5em;padding-left:1rem}", ""]);

// exports


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"cards__list"},_vm._l((_vm.cards),function(card){return _c('li',{staticClass:"cards__card"},[_c('img',{staticClass:"cards__image",attrs:{"src":card.imgPath,"alt":card.title}}),_vm._v(" "),_c('div',{staticClass:"cards__text"},[_c('strong',[_vm._v(_vm._s(card.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.description))])])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-authenticity"},[_c('h2',[_c('span',[_vm._v("A melhor plataforma pelo menor custo")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videosection_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eda28e5a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videosection_vue__ = __webpack_require__(225);
function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eda28e5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_videosection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eda28e5a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_videosection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(222);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("46d98c12", content, true, {});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "[data-v-eda28e5a]{box-sizing:border-box}.row[data-v-eda28e5a]{background-color:#0aba7e;background-image:url(" + escape(__webpack_require__(223)) + ");background-size:cover;background-repeat:no-repeat;background-position:50%}.text-authenticity[data-v-eda28e5a]{display:flex;flex-direction:column;justify-content:center;align-items:center}.text-authenticity button[data-v-eda28e5a]{display:flex;align-items:center;max-width:200px;border-radius:8px;background-color:#366;margin-top:.5rem;padding:.5rem .8rem;border:0;color:#fff;font-size:1em;font-weight:700;cursor:pointer;font-family:Miriam Libre,sans-serif}.text-authenticity button[data-v-eda28e5a]:before{content:\"\\25BA\";display:inline-block;margin-right:5px;font-size:1.5rem;vertical-align:middle}h2[data-v-eda28e5a]{text-align:center;color:#2e656f;margin-bottom:2rem}@media (max-width:480px){h2[data-v-eda28e5a]{font-size:28px}}@media (max-width:400px){h2[data-v-eda28e5a]{font-size:25px}}h2 span[data-v-eda28e5a]{color:#fff}.text-authenticity p[data-v-eda28e5a]{max-width:39.5rem;font-size:16px;line-height:2;color:#fff;text-align:center;margin-bottom:2rem}@media (min-width:480px){.text-authenticity p[data-v-eda28e5a]{font-size:18px}}.modal iframe[data-v-eda28e5a]{max-width:100%}.modal[data-v-eda28e5a]{font-family:-apple-system,BlinkMacSystemFont,avenir next,avenir,helvetica neue,helvetica,ubuntu,roboto,noto,segoe ui,arial,sans-serif}.modal__overlay[data-v-eda28e5a]{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);display:flex;justify-content:center;align-items:center;z-index:2}.modal__container[data-v-eda28e5a]{background-color:#fff;padding:10px;max-width:100vw;max-height:100vh;border-radius:4px;overflow-y:auto;box-sizing:border-box}.modal__header[data-v-eda28e5a]{display:flex;justify-content:flex-end;align-items:center}.modal__title[data-v-eda28e5a]{margin-top:0;margin-bottom:0;font-weight:600;font-size:1.25rem;line-height:1.25;color:#00449e;box-sizing:border-box}.modal__close[data-v-eda28e5a]{background:transparent;border:0}.modal__header .modal__close[data-v-eda28e5a]:before{content:\"\\2715\"}.modal__content[data-v-eda28e5a]{margin-top:.5rem;line-height:1.5;color:rgba(0,0,0,.8)}.modal__btn[data-v-eda28e5a]{font-size:.875rem;padding:.5rem 1rem;background-color:#e6e6e6;color:rgba(0,0,0,.8);border-radius:.25rem;border-style:none;border-width:0;cursor:pointer;-webkit-appearance:button;text-transform:none;overflow:visible;line-height:1.15;margin:0;will-change:transform;-moz-osx-font-smoothing:grayscale;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);transform:translateZ(0);transition:-webkit-transform .25s ease-out;transition:transform .25s ease-out;transition:transform .25s ease-out,-webkit-transform .25s ease-out}.modal__btn[data-v-eda28e5a]:focus,.modal__btn[data-v-eda28e5a]:hover{-webkit-transform:scale(1.05);transform:scale(1.05)}.modal__btn-primary[data-v-eda28e5a]{background-color:#00449e;color:#fff}@keyframes mmfadeIn-data-v-eda28e5a{0%{opacity:0}to{opacity:1}}@keyframes mmfadeOut-data-v-eda28e5a{0%{opacity:1}to{opacity:0}}@keyframes mmslideIn-data-v-eda28e5a{0%{transform:translateY(15%)}to{transform:translateY(0)}}@keyframes mmslideOut-data-v-eda28e5a{0%{transform:translateY(0)}to{transform:translateY(-10%)}}.micromodal-slide[data-v-eda28e5a]{display:none}.micromodal-slide.is-open[data-v-eda28e5a]{display:block}.micromodal-slide[aria-hidden=false] .modal__overlay[data-v-eda28e5a]{animation:mmfadeIn-data-v-eda28e5a .3s cubic-bezier(0,0,.2,1)}.micromodal-slide[aria-hidden=false] .modal__container[data-v-eda28e5a]{animation:mmslideIn-data-v-eda28e5a .3s cubic-bezier(0,0,.2,1)}.micromodal-slide[aria-hidden=true] .modal__overlay[data-v-eda28e5a]{animation:mmfadeOut-data-v-eda28e5a .3s cubic-bezier(0,0,.2,1)}.micromodal-slide[aria-hidden=true] .modal__container[data-v-eda28e5a]{animation:mmslideOut-data-v-eda28e5a .3s cubic-bezier(0,0,.2,1)}.micromodal-slide .modal__container[data-v-eda28e5a],.micromodal-slide .modal__overlay[data-v-eda28e5a]{will-change:transform}", ""]);

// exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "video-bg--789122dd.svg";

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function t(e){return function(e){if(Array.isArray(e))return o(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return o(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return o(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function o(e,t){(null==t||t>e.length)&&(t=e.length);for(var o=0,n=new Array(t);o<t;o++)n[o]=e[o];return n}var n,i,a,r,s,l=(n=["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',"select:not([disabled]):not([aria-hidden])","textarea:not([disabled]):not([aria-hidden])","button:not([disabled]):not([aria-hidden])","iframe","object","embed","[contenteditable]",'[tabindex]:not([tabindex^="-"])'],i=function(){function o(e){var n=e.targetModal,i=e.triggers,a=void 0===i?[]:i,r=e.onShow,s=void 0===r?function(){}:r,l=e.onClose,c=void 0===l?function(){}:l,d=e.openTrigger,u=void 0===d?"data-micromodal-trigger":d,f=e.closeTrigger,h=void 0===f?"data-micromodal-close":f,v=e.openClass,g=void 0===v?"is-open":v,m=e.disableScroll,b=void 0!==m&&m,y=e.disableFocus,p=void 0!==y&&y,w=e.awaitCloseAnimation,E=void 0!==w&&w,k=e.awaitOpenAnimation,M=void 0!==k&&k,A=e.debugMode,C=void 0!==A&&A;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,o),this.modal=document.getElementById(n),this.config={debugMode:C,disableScroll:b,openTrigger:u,closeTrigger:h,openClass:g,onShow:s,onClose:c,awaitCloseAnimation:E,awaitOpenAnimation:M,disableFocus:p},a.length>0&&this.registerTriggers.apply(this,t(a)),this.onClick=this.onClick.bind(this),this.onKeydown=this.onKeydown.bind(this)}var i,a,r;return i=o,(a=[{key:"registerTriggers",value:function(){for(var e=this,t=arguments.length,o=new Array(t),n=0;n<t;n++)o[n]=arguments[n];o.filter(Boolean).forEach((function(t){t.addEventListener("click",(function(t){return e.showModal(t)}))}))}},{key:"showModal",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(this.activeElement=document.activeElement,this.modal.setAttribute("aria-hidden","false"),this.modal.classList.add(this.config.openClass),this.scrollBehaviour("disable"),this.addEventListeners(),this.config.awaitOpenAnimation){var o=function t(){e.modal.removeEventListener("animationend",t,!1),e.setFocusToFirstNode()};this.modal.addEventListener("animationend",o,!1)}else this.setFocusToFirstNode();this.config.onShow(this.modal,this.activeElement,t)}},{key:"closeModal",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=this.modal;if(this.modal.setAttribute("aria-hidden","true"),this.removeEventListeners(),this.scrollBehaviour("enable"),this.activeElement&&this.activeElement.focus&&this.activeElement.focus(),this.config.onClose(this.modal,this.activeElement,e),this.config.awaitCloseAnimation){var o=this.config.openClass;this.modal.addEventListener("animationend",(function e(){t.classList.remove(o),t.removeEventListener("animationend",e,!1)}),!1)}else t.classList.remove(this.config.openClass)}},{key:"closeModalById",value:function(e){this.modal=document.getElementById(e),this.modal&&this.closeModal()}},{key:"scrollBehaviour",value:function(e){if(this.config.disableScroll){var t=document.querySelector("body");switch(e){case"enable":Object.assign(t.style,{overflow:""});break;case"disable":Object.assign(t.style,{overflow:"hidden"})}}}},{key:"addEventListeners",value:function(){this.modal.addEventListener("touchstart",this.onClick),this.modal.addEventListener("click",this.onClick),document.addEventListener("keydown",this.onKeydown)}},{key:"removeEventListeners",value:function(){this.modal.removeEventListener("touchstart",this.onClick),this.modal.removeEventListener("click",this.onClick),document.removeEventListener("keydown",this.onKeydown)}},{key:"onClick",value:function(e){(e.target.hasAttribute(this.config.closeTrigger)||e.target.parentNode.hasAttribute(this.config.closeTrigger))&&(e.preventDefault(),e.stopPropagation(),this.closeModal(e))}},{key:"onKeydown",value:function(e){27===e.keyCode&&this.closeModal(e),9===e.keyCode&&this.retainFocus(e)}},{key:"getFocusableNodes",value:function(){var e=this.modal.querySelectorAll(n);return Array.apply(void 0,t(e))}},{key:"setFocusToFirstNode",value:function(){var e=this;if(!this.config.disableFocus){var t=this.getFocusableNodes();if(0!==t.length){var o=t.filter((function(t){return!t.hasAttribute(e.config.closeTrigger)}));o.length>0&&o[0].focus(),0===o.length&&t[0].focus()}}}},{key:"retainFocus",value:function(e){var t=this.getFocusableNodes();if(0!==t.length)if(t=t.filter((function(e){return null!==e.offsetParent})),this.modal.contains(document.activeElement)){var o=t.indexOf(document.activeElement);e.shiftKey&&0===o&&(t[t.length-1].focus(),e.preventDefault()),!e.shiftKey&&t.length>0&&o===t.length-1&&(t[0].focus(),e.preventDefault())}else t[0].focus()}}])&&e(i.prototype,a),r&&e(i,r),o}(),a=null,r=function(e){if(!document.getElementById(e))return console.warn("MicroModal: ❗Seems like you have missed %c'".concat(e,"'"),"background-color: #f8f9fa;color: #50596c;font-weight: bold;","ID somewhere in your code. Refer example below to resolve it."),console.warn("%cExample:","background-color: #f8f9fa;color: #50596c;font-weight: bold;",'<div class="modal" id="'.concat(e,'"></div>')),!1},s=function(e,t){if(function(e){e.length<=0&&(console.warn("MicroModal: ❗Please specify at least one %c'micromodal-trigger'","background-color: #f8f9fa;color: #50596c;font-weight: bold;","data attribute."),console.warn("%cExample:","background-color: #f8f9fa;color: #50596c;font-weight: bold;",'<a href="#" data-micromodal-trigger="my-modal"></a>'))}(e),!t)return!0;for(var o in t)r(o);return!0},{init:function(e){var o=Object.assign({},{openTrigger:"data-micromodal-trigger"},e),n=t(document.querySelectorAll("[".concat(o.openTrigger,"]"))),r=function(e,t){var o=[];return e.forEach((function(e){var n=e.attributes[t].value;void 0===o[n]&&(o[n]=[]),o[n].push(e)})),o}(n,o.openTrigger);if(!0!==o.debugMode||!1!==s(n,r))for(var l in r){var c=r[l];o.targetModal=l,o.triggers=t(c),a=new i(o)}},show:function(e,t){var o=t||{};o.targetModal=e,!0===o.debugMode&&!1===r(e)||(a&&a.removeEventListeners(),(a=new i(o)).showModal())},close:function(e){e?a.closeModalById(e):a.closeModal()}});"undefined"!=typeof window&&(window.MicroModal=l);/* harmony default export */ __webpack_exports__["a"] = (l);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('div',{staticClass:"text-authenticity"},[_c('h2',[_vm._v("\n          #Digitalizesua"),_c('span',[_vm._v("campanha")])]),_vm._v(" "),_c('p',[_vm._v("\n          Acreditamos que realizar sua campanha de financiamento coletivo vai muito além de tecnologia, envolve planejamento e estratégias. Por isso, oferecemos a todos que estão no Voto Legal uma mentoria exclusiva. Veja como funciona nesse vídeo.\n        ")]),_vm._v(" "),_c('button',{attrs:{"data-micromodal-trigger":"modal-1"}},[_vm._v("\n          Assista o vídeo\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal micromodal-slide",attrs:{"id":"modal-1","aria-hidden":"true"}},[_c('div',{staticClass:"modal__overlay",attrs:{"tabindex":"-1","data-micromodal-close":""}},[_c('div',{staticClass:"modal__container",attrs:{"role":"dialog","aria-modal":"true","aria-labelledby":"modal-1-title"}},[_c('header',{staticClass:"modal__header"},[_c('button',{staticClass:"modal__close",attrs:{"aria-label":"Close modal","data-micromodal-close":""}})]),_vm._v(" "),_c('main',{staticClass:"modal__content",attrs:{"id":"modal-1-content"}},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/CxFtSQ-6C_A?rel=0&enablejsapi=1","width":"600","height":"400","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row",attrs:{"id":"greetings"}},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"home-section"},[_c('div',{staticClass:"wrap-info wrap-info--7"},[_vm._m(0),_vm._v(" "),_c('h1',[_vm._v("\n            De o primeiro passo para sua campanha eleitoral de 2022!\n          ")]),_vm._v(" "),_c('div',{staticClass:"wrap-info--text"},[_c('p',[_vm._v("\n                    O Voto Legal é a plataforma pioneira no financiamento coletivo\n                    de campanhas eleitorais e com maior média de doações entre todas\n                    as plataformas! Além de tecnologia, acreditamos que é necessário\n                    estratégia! Conte com a melhor plataforma e com a equipe mais\n                    experiente do mercado para ajudar na sua pré campanha!\n                  ")]),_vm._v(" "),(699 != _vm.promotionalPrice)?_c('p',[_vm._v("\n                    Aproveite nossa promoção e garanta a sua licença de\n                    pré-campanha+campanha, de "),_c('s',[_vm._v("R$ 699,00")]),_vm._v(" por\n                    "),_c('strong',[_vm._v("R$ "+_vm._s(_vm.promotionalPrice)+",00")])]):_c('p',[_vm._v("\n                    Garanta a sua licença única, para ser usada na pré-campanha e\n                    também na campanha, por R$ 699,00.\n                  ")]),_vm._v(" "),_c('a',{staticClass:"call-to-action",attrs:{"href":"#email"},on:{"click":function($event){$event.preventDefault();return _vm.scrollTo.apply(null, arguments)}}},[_vm._v("\n                    Comprar\n                  ")])])])])])]),_vm._v(" "),_c('statisticssection'),_vm._v(" "),_c('mentorshipsection'),_vm._v(" "),_c('chatbotsection'),_vm._v(" "),_c('facedetectsection'),_vm._v(" "),_c('authenticitysection'),_vm._v(" "),_c('videosection'),_vm._v(" "),_c('advantagessection'),_vm._v(" "),_c('managementsection'),_vm._v(" "),_c('pricingsection'),_vm._v(" "),_c('midiasection'),_vm._v(" "),_c('candidates-section')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credit-home"},[_c('h1',[_vm._v("\n              Uma iniciativa "),_c('a',{staticClass:"appcivico-home",attrs:{"href":"https://appcivico.com/pt/","target":"_blank"}},[_vm._v("AppCívico")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parceiros_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47816e08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_parceiros_vue__ = __webpack_require__(230);
function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47816e08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parceiros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47816e08_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_parceiros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(229);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1346bf20", content, true, {});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#parceiros[data-v-47816e08]{background-color:#4bb958;padding-top:100px}#parceiros .parceiros-wrap[data-v-47816e08]{position:relative;overflow:hidden;text-align:center}#parceiros .parceiro[data-v-47816e08]{display:inline-block;margin-bottom:30px;margin:20px;background-color:#fff;border-radius:15px}#parceiros .img-content[data-v-47816e08]{width:150px;height:150px;object-fit:contain;overflow:hidden;margin:20px 30px;display:inline-block}#parceiros .img-content a[data-v-47816e08]{display:block}#parceiros .img-content img[data-v-47816e08]{width:100%;display:inline-block}", ""]);

// exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"parceiros"}},[_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('h2',{staticClass:"title"},[_vm._v("PARCEIROS")]),_vm._v(" "),_c('div',{staticClass:"parceiros-wrap"},[_c('div',{staticClass:"parceiro margin-ajust"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"http://www.mcce.org.br/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(231),"alt":"MCCE"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro margin-ajust"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://www.catarse.me/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(232),"alt":"Catarse"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://www.ciclocidade.org.br/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(233),"alt":"Ciclo Cidade"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://cidadeape.org/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(234),"alt":"Cidade a p"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://cidadedossonhos.org/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(235),"alt":"Cidade dos sonhos"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"http://cidadesparapessoas.com/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(236),"alt":"Cidade para pessoas"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"http://www.dadocapital.com/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(237),"alt":"Dado capital"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://br.okfn.org/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(238),"alt":"Open konwledge"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"http://www.paiolfilmes.com.br/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(239),"alt":"Paiol"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"http://www.politize.com.br/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(240),"alt":"politize"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"http://www.questtono.com/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(241),"alt":"Questto"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://www.raps.org.br/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(242),"alt":"raps"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://github.com/thacker","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(243),"alt":"Transparencia hacker"}})])])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('img',{attrs:{"src":__webpack_require__(244),"alt":"Update"}})])]),_vm._v(" "),_c('div',{staticClass:"parceiro"},[_c('div',{staticClass:"img-content"},[_c('a',{attrs:{"href":"https://www.w3.org/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(245),"alt":"W3c"}})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-mcce--2eab5ae9.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "catarse--0b72d36f.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ciclo-cidade--11288ab5.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cidade-a-p--301fba60.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cidade-dos-sonhos--05a239a5.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cidades-para-pessoas--76cf14be.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dado-capital--6af8462e.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "open-knowledge--a3f09dcd.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "paiol--062e6859.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "politize--0c532760.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "questto--29709dad.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "raps--93d067f6.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "transparencia-hacker--eb475782.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "update--1551f706.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "w-3-c--d843527c.png";

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_perguntasfrequentes_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11def55c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_perguntasfrequentes_vue__ = __webpack_require__(250);
function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11def55c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_perguntasfrequentes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11def55c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_perguntasfrequentes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(248);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2fa21219", content, true, {});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#perguntas-frequentes[data-v-11def55c]{background-color:#2c3e50;padding-top:100px}#perguntas-frequentes .wrap-info--text[data-v-11def55c]{font-size:25px;color:#676767;font-weight:300;width:100%;color:#fff}#perguntas-frequentes .wrap-info--text p[data-v-11def55c]{font-size:20px}#perguntas-frequentes .wrap-info--text [data-v-11def55c]{margin-bottom:20px}#perguntas-frequentes h1[data-v-11def55c]{display:block;margin-bottom:54px;font-weight:600;color:#4ab957}#perguntas-frequentes li[data-v-11def55c]{display:list-item;list-style-type:circle}#perguntas-frequentes .wrap-acordion[data-v-11def55c]{margin-bottom:20px}#perguntas-frequentes .accordion[data-v-11def55c]{outline:none;border:none;background:hsla(0,0%,100%,.35);border-radius:8px;color:#fff;font-size:20px;text-align:left;width:100%;cursor:pointer;padding:15px 15px 15px 64px}#perguntas-frequentes .panel[data-v-11def55c]{margin:15px;color:#fff;display:none}#perguntas-frequentes .panel.show[data-v-11def55c]{display:block}#perguntas-frequentes .panel ul li[data-v-11def55c]{float:none}#perguntas-frequentes .panel[data-v-11def55c]:after{content:\"\";display:table;clear:both}#perguntas-frequentes .panel p[data-v-11def55c]{margin-bottom:1rem;margin-top:1rem}#perguntas-frequentes blockquote[data-v-11def55c]{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee;margin:20px}#perguntas-frequentes code[data-v-11def55c]{padding:2px 4px;font-size:90%;color:#c7254e;background-color:#f9f2f4;border-radius:4px}#perguntas-frequentes .subtitle[data-v-11def55c]{font-weight:700;margin-top:2rem;margin-bottom:0}#perguntas-frequentes .campaign[data-v-11def55c]{margin-top:2rem}#perguntas-frequentes .table-title[data-v-11def55c]{font-weight:700;margin-bottom:0;color:#4ab957;padding-bottom:-.5em}#contato[data-v-11def55c]{margin:auto;text-align:center}#contato .img-bg[data-v-11def55c]{background-image:url(" + escape(__webpack_require__(249)) + ");background-size:cover;background-repeat:no-repeat;position:absolute;width:100%;height:100%;top:0;bottom:0;right:0;left:0;z-index:-1}#contato h2[data-v-11def55c]{color:#fff;text-transform:uppercase}#contato form .field-row[data-v-11def55c]{width:100%;box-sizing:border-box;background-clip:padding-box;position:relative}#contato form .field-row input[data-v-11def55c],#contato form .field-row textarea[data-v-11def55c]{width:100%;overflow:visible;display:table;outline:none;border:none;margin-bottom:20px;box-sizing:border-box;padding:20px 10px 20px 20px;border-radius:8px;font-size:20px;font-weight:700;background-color:#fff;display:block;color:#686868}#contato form .field-row input[type=submit][data-v-11def55c],#contato form .field-row textarea[type=submit][data-v-11def55c]{width:40%;margin:0 auto}#contato form .field-row.radio-buttons[data-v-11def55c]{min-height:60px}#contato form .field-row.radio-buttons span.mask[data-v-11def55c]{float:left;margin-left:20px}#contato form .field-row.radio-buttons li[data-v-11def55c]{position:relative;display:inline-block;color:#fff;width:30%}@media (max-width:768px){#contato form .field-row.radio-buttons li[data-v-11def55c]{width:100%}}#contato form .field-row.radio-buttons li label[data-v-11def55c]{width:20px;height:20px;border:2px solid #fff;display:block;position:absolute;top:0;left:2px;border-radius:50px;white-space:nowrap;cursor:pointer;text-indent:100%;float:left}#contato form .field-row.radio-buttons li label input[data-v-11def55c]{display:inline-block}#contato form .field-row.radio-buttons input[data-v-11def55c]{float:left;width:auto;visibility:hidden}#contato form .field-row.radio-buttons input:checked+label[data-v-11def55c]{background-color:gray}table[data-v-11def55c],tbody[data-v-11def55c],td[data-v-11def55c],tfoot[data-v-11def55c],th[data-v-11def55c],thead[data-v-11def55c],tr[data-v-11def55c]{width:auto;height:auto;font-size:1em;vertical-align:top;background-color:transparent;border:0;padding:1em}@media screen and (max-width:400px){table[data-v-11def55c],tbody[data-v-11def55c],td[data-v-11def55c],tfoot[data-v-11def55c],th[data-v-11def55c],thead[data-v-11def55c],tr[data-v-11def55c]{display:block}}table[data-v-11def55c]{width:100%;max-width:100%;font-size:100%;font-family:inherit;font-feature-settings:\"kern\" 1,\"liga\" 1,\"calt\" 1,\"pnum\" 0,\"tnum\" 1,\"onum\" 0,\"lnum\" 1,\"dlig\" 0;border-collapse:collapse;empty-cells:show}@media screen and (max-width:400px){table[data-v-11def55c]{padding:0}}table li[data-v-11def55c],table p[data-v-11def55c]{font-size:1em}@media screen and (max-width:400px){tr[data-v-11def55c]{padding:0;padding-bottom:.5em;padding-top:.5em;border-bottom:2px solid #fff}tr[data-v-11def55c]:last-child{margin-bottom:0}}th[data-v-11def55c]{font-weight:700;text-transform:capitalize}@media screen and (max-width:400px){th[data-v-11def55c]{text-transform:capitalize;padding-top:.5em}}td[data-v-11def55c]{border-bottom:2px solid #fff;font-family:inherit}@media screen and (max-width:400px){td[data-v-11def55c]{border-bottom:0;padding-bottom:.5em;padding-top:.5em}}@media screen and (max-width:400px){td[data-v-11def55c]:empty,thead[data-v-11def55c]{display:none}}thead td[data-v-11def55c],thead th[data-v-11def55c]{background-color:#4ab957;color:#fff;text-align:left;vertical-align:bottom}tbody[data-v-11def55c],tfoot th[data-v-11def55c]:first-child,thead th[data-v-11def55c]:first-child{text-align:left}@media screen and (max-width:400px){tbody[data-v-11def55c]{padding:0}}tbody th[data-v-11def55c]{text-align:left}tbody td[data-v-11def55c]{text-align:left;font-variant-numeric:lining-nums oldstyle-nums}@media screen and (max-width:400px){tbody td[data-v-11def55c]{text-align:left}tbody td[title][data-v-11def55c]{text-align:right}tbody td[title][data-v-11def55c]:before{float:left;font-style:italic;content:attr(title) \": \"}}tbody tr[data-v-11def55c]:nth-child(odd){background-color:palette(\"box\",\"base\")}td img[data-v-11def55c]{vertical-align:top}@media screen and (max-width:400px){tbody tr:nth-of-type(odd)>td[data-v-11def55c],tbody tr:nth-of-type(odd)>th[data-v-11def55c]{background-color:transparent}}tfoot td[data-v-11def55c],tfoot th[data-v-11def55c]{background-color:#4ab957;color:#fff;vertical-align:top;text-align:left}@media screen and (max-width:400px){tfoot td[data-v-11def55c],tfoot th[data-v-11def55c]{display:none}}", ""]);

// exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg-perguntas--1c1fd8de.jpg";

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row",attrs:{"id":"contato"}},[_c('div',{staticClass:"img-bg"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('section',{staticClass:"section"},[_c('h2',{staticClass:"title"},[_vm._v("contato")]),_vm._v(" "),_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":"https://eokoe2.typeform.com/to/DCN5XL?typeform-embed=embed-widget&embed-hide-footer=true&embed-hide-headers=true&embed-opacity=0","frameborder":"0","data-transparency":"100","data-hide-headers":"true","data-hide-footer":"true","allowtransparency":"true"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_candidate_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb47cbe4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_candidate_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_candidate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb47cbe4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_candidate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(253);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5f9c16e0", content, true, {});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "*,:after,:before{background-repeat:no-repeat;box-sizing:inherit;tab-size:inherit}::selection{text-shadow:none;color:#fff;background-color:#14698c}[aria-busy=true]{cursor:progress}[aria-busy=true][aria-hidden=true]:before{content:none}[aria-busy=true][aria-hidden=true]:after{position:static;display:inline-block;width:0;overflow:hidden;vertical-align:bottom;background:none;content:\"\\2026\";opacity:.5;animation:ellipsis steps(4) .9s infinite}@keyframes ellipsis{to{width:1.25em}}main[aria-busy=true]{overflow:hidden}[aria-controls]{cursor:pointer}[aria-disabled]{cursor:default}[tabindex],a,area,button,input,label,select,summary,textarea{touch-action:manipulation}html{height:100%;padding:0;margin:0;overflow-y:scroll;font-size:100.01%;text-size-adjust:100%;background:#f1f1f1;box-sizing:border-box;tab-size:4}body{max-width:1400px;min-height:100%;margin:0;margin:auto;color:#333;background:#fff}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section{display:block}summary{display:list-item;list-style-type:none;cursor:pointer}summary::-webkit-details-marker{display:none}summary:focus{outline:5px auto -webkit-focus-ring-color}summary:before{padding-right:.5em;content:\"\\25B6\"}details[open]>summary:before{content:\"\\25BC\"}[hidden],template{display:none}[hidden][aria-hidden=false]{position:absolute;display:inherit;clip:rect(0,0,0,0)}[hidden][aria-hidden=false]:focus{clip:auto}hr{margin:calc(1.5em - 1px) 0 1.5em;clear:both;display:block;height:0;padding:0;overflow:visible;color:#999;border:0;border-top:1px solid #999;box-sizing:content-box}svg:not(:root){overflow:hidden}svg{fill:currentColor}a>svg{pointer-events:none}audio,canvas,iframe,progress,svg,video{display:inline-block;vertical-align:middle}audio:not([controls]){display:none;height:0}meter,progress{background-size:auto;appearance:none}iframe,img,object{font-size:83.3333%;color:currentColor;border-style:none}embed,img,object,video{max-width:100%}video>source{width:100%;height:auto}.ie:not(.ie6-8),object>img{position:relative;z-index:-1;font-size:1em;pointer-events:none}img{height:auto;max-width:100%;max-height:90vh;image-rendering:optimizeQuality;-ms-interpolation-mode:bicubic}[usemap]{color:#06c}li img,p img{vertical-align:middle}a>picture,a img{border:0}a{padding:0;margin:0;font-weight:700;font-size:100%;vertical-align:baseline;color:#333}a,a:active,a:focus,a:hover,a:link{text-decoration:underline}a:link{cursor:pointer;-webkit-tap-highlight-color:rgba(0,0,0,0)}a:visited:active,a:visited:focus,a:visited:hover{text-decoration:underline}a:focus,a:hover{color:#f63}a:focus{overflow:hidden;outline:none;outline-offset:2px}a:active,a:hover{outline-width:0}a:active{background-color:transparent}address{padding:0;margin:0;font-style:italic}*,:after,:before{line-height:inherit;text-decoration:inherit;vertical-align:inherit}body{font-weight:400;font-size:1em;line-height:1.875;font-family:Miriam Libre,sans-serif;color:#212121}caption,details>summary,h1,h2,h3,h4,h5,h6,legend{font-weight:600;font-family:Miriam Libre,sans-serif;font-feature-settings:\"case\" 1,\"cpsp\" 1,\"cswh\" 1,\"liga\" 1,\"locl\" 1,\"lnum\" 1,\"pnum\" 1,\"titl\" 1,\"zero\" 1;break-after:avoid;page-break-after:avoid}caption a,caption a:link,dt a,dt a:link,h1 a,h1 a:link,h2 a,h2 a:link,h3 a,h3 a:link,h4 a,h4 a:link,h5 a,h5 a:link,h6 a,h6 a:link,legend a,legend a:link{text-decoration:inherit;color:inherit}h1{font-size:3.05176rem;font-weight:100;text-transform:capitalize}h2{font-size:1.95312rem;font-weight:400}h3{font-size:1.5625rem}h3,h4{font-weight:700}h4{font-size:1.25rem}p{padding:0;margin:0}article p{orphans:3;widows:3}article fieldset>p:first-child,article h1+p,article h2+p,article h3+p,article h4+p,article h5+p,article h6+p,article legend+p{margin-top:0;text-indent:0}abbr[title],dfn[title]{text-decoration:none;cursor:help;border-bottom:1px dotted}@supports (text-decoration:dotted underline){abbr[title],dfn[title]{text-decoration:none;border-bottom:inherit}}abbr{letter-spacing:.1em}dfn{font-style:italic;font-size:1em}b,strong{font-weight:700;font-weight:inherit;font-weight:600}mark{color:#333;background:#d7ff5a}small{line-height:inherit}small,sub,sup{font-size:83.3333%}sub,sup{position:relative;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}time{font-style:italic}time[pubdate]{cursor:help}code,kbd,pre,samp,var{font-size:1em;font-family:Consolas,Liberation Mono,Menlo,Courier,monospace,monospace,monospace}pre{padding:0;margin:0;overflow:auto;word-wrap:break-word;white-space:pre;white-space:pre-wrap;white-space:pre-line}samp,var{font-style:italic}del,s{text-decoration:line-through}s{font-style:italic}del:before,ins:before{font-weight:700;text-decoration:none;content:\"[update] \"}del[datetime]:before,ins[datetime]:before{content:\"[update\\A0\\2192\\A0\" attr(datetime) \"] \"}del:after,ins:after{text-decoration:none;content:\" [/update] \"}ins{text-decoration:underline}ins:lang(pt):before{content:\" [inserido] \"}ins[datetime]:lang(pt):before{content:\" [inserido\\A0\\2192\\A0\" attr(datetime) \"] \"}ins:lang(pt):after{content:\" [/inserido] \"}del:lang(pt):before{content:\" [exclu\\ED  do] \"}del[datetime]:lang(pt):before{content:\" [exclu\\ED  do\\A0\\2192\\A0\" attr(datetime) \"] \"}del:lang(pt):after{content:\" [/exclu\\ED  do] \"}blockquote,q{font-style:italic;color:#575757}cite{font-style:italic;font-size:1em}blockquote footer:before{content:\"\\2014   \\A0\"}blockquote footer cite{font-style:italic}blockquote li,blockquote p,blockquote pre{font-size:1em}blockquote.verse{text-align:center}blockquote.verse p{display:inline-block;width:auto;margin-right:auto;margin-left:auto;text-align:left}embed,input[aria-busy=true],keygen[aria-busy=true],output[aria-busy=true],textarea[aria-busy=true]{background-image:url(" + escape(__webpack_require__(8)) + ");background-position:50% 50%;background-repeat:no-repeat;background-color:hsla(0,0%,7%,.8)}[aria-busy=true]:not(html),[aria-busy=true]>body{cursor:wait}:not(html)[aria-busy=true]:before,[aria-busy=true]>body:before{position:absolute;top:-.9375rem;right:-.9375rem;bottom:-.9375rem;left:-.9375rem;z-index:3000;padding:1.875rem;text-align:center;color:#fff;background-image:url(" + escape(__webpack_require__(8)) + ");background-position:50% 50%;background-repeat:no-repeat;background-color:hsla(0,0%,7%,.8);border-radius:20px;content:\"\"}:not(html)[aria-busy=true][data-busy-message]:before,[aria-busy=true]>body[data-busy-message]:before{padding-top:3.75rem;content:attr(data-busy-message)}[aria-busy=true]:not(html),[aria-busy=true]>body{position:relative}img{background-size:auto}img:after{content:none}embed{background-size:auto}embed:after{content:none}input[aria-busy=true],keygen[aria-busy=true],output[aria-busy=true],textarea[aria-busy=true]{background-size:auto}.grid:after,.grid:root:before{position:fixed;top:0;right:0;z-index:5000;font-size:1rem;pointer-events:none;content:\"breakpoint: phone\"}.grid:after{bottom:0;left:0;background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35));background-position:top;content:\"\"}@media screen and (min-width:30em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% + 1.25rem),transparent calc(33.33333% + 1.25rem),transparent calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% + .625rem),transparent calc(66.66667% + .625rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:48em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(25% - .46875rem),rgba(255,0,0,.35) calc(25% - .46875rem),rgba(255,0,0,.35) calc(25% + 1.40625rem),transparent calc(25% + 1.40625rem),transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(75% - 1.40625rem),rgba(255,0,0,.35) calc(75% - 1.40625rem),rgba(255,0,0,.35) calc(75% + .46875rem),transparent calc(75% + .46875rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:64em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(20% - .375rem),rgba(255,0,0,.35) calc(20% - .375rem),rgba(255,0,0,.35) calc(20% + 1.5rem),transparent calc(20% + 1.5rem),transparent calc(40% - .75rem),rgba(255,0,0,.35) calc(40% - .75rem),rgba(255,0,0,.35) calc(40% + 1.125rem),transparent calc(40% + 1.125rem),transparent calc(60% - 1.125rem),rgba(255,0,0,.35) calc(60% - 1.125rem),rgba(255,0,0,.35) calc(60% + .75rem),transparent calc(60% + .75rem),transparent calc(80% - 1.5rem),rgba(255,0,0,.35) calc(80% - 1.5rem),rgba(255,0,0,.35) calc(80% + .375rem),transparent calc(80% + .375rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:75em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(16.66667% - .3125rem),rgba(255,0,0,.35) calc(16.66667% - .3125rem),rgba(255,0,0,.35) calc(16.66667% + 1.5625rem),transparent calc(16.66667% + 1.5625rem),transparent calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% + 1.25rem),transparent calc(33.33333% + 1.25rem),transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% + .625rem),transparent calc(66.66667% + .625rem),transparent calc(83.33333% - 1.5625rem),rgba(255,0,0,.35) calc(83.33333% - 1.5625rem),rgba(255,0,0,.35) calc(83.33333% + .3125rem),transparent calc(83.33333% + .3125rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35));background-size:1400px 100%}}.grid:root:before{padding:1.875rem;background-color:red;opacity:.75}@media screen and (min-width:30em){.grid:root:before{content:\"breakpoint: phablet\"}}@media screen and (min-width:48em){.grid:root:before{content:\"breakpoint: tablet\"}}@media screen and (min-width:64em){.grid:root:before{content:\"breakpoint: desktop\"}}@media screen and (min-width:75em){.grid:root:before{content:\"breakpoint: wide\"}}ol,ul{margin:0 0 1.5rem;padding-left:1em;margin:0}ol{counter-reset:li}article li{position:relative;padding-left:0;margin:0;list-style:none}article li:last-child{margin-bottom:0}dl{margin:0 0 1rem}dd,dl,dt{padding:0}dd,dt{margin:0}dd{margin:0 0 1rem}dd:last-child{margin-bottom:0}menu ol,menu ul,nav ol,nav ul{padding:0;margin:0;list-style:none}menu li,nav li{padding:0;margin:0}menu li:before,nav li:before{content:none}menu a,nav a{display:block;overflow:hidden}menu a:link,nav a:link{text-decoration:underline}.current>a{pointer-events:none}[for=menu-controller]:before{font-size:2em;line-height:.75;font-family:sans-serif;vertical-align:middle;content:\" \\2261   \"}@media screen and (min-width:64em){[for=menu-controller]{display:none}}table,tbody,td,tfoot,th,thead,tr{background:red;padding:1em}.irregular td,.irregular th{text-decoration:line-through}tbody td,tbody th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}table,tbody,td,tfoot,th,thead,tr{width:auto;height:auto;font-size:1rem;vertical-align:top;background-color:transparent;border:0}@media screen and (max-width:74.99em){table,tbody,td,tfoot,th,thead,tr{display:block}}table{width:100%;max-width:100%;font-size:100%;font-family:inherit;font-feature-settings:\"kern\" 1,\"liga\" 1,\"calt\" 1,\"pnum\" 0,\"tnum\" 1,\"onum\" 0,\"lnum\" 1,\"dlig\" 0;border-collapse:collapse;empty-cells:show}@media screen and (max-width:74.99em){table{padding:0}}table li,table p{font-size:1rem}.blockchain-cell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media screen and (max-width:74.99em){tr{padding:0;padding-bottom:.46875em;padding-top:.46875em;margin:0 0 1.5rem}tr:last-child{margin-bottom:0}}th{font-weight:700;text-transform:capitalize}@media screen and (max-width:74.99em){th{text-transform:capitalize;padding-top:.46875em}}td{font-family:inherit}@media screen and (max-width:74.99em){td{padding-bottom:.46875em;padding-top:.46875em}}@media screen and (max-width:74.99em){td:empty,thead{display:none}}thead td,thead th{background-color:#f63;color:#fff;text-align:left;vertical-align:bottom}tbody,tfoot th:first-child,thead th:first-child{text-align:left}@media screen and (max-width:74.99em){tbody{padding:0}}tbody td,tbody th{text-align:left}tbody td{font-variant-numeric:lining-nums oldstyle-nums}@media screen and (max-width:74.99em){tbody td{text-align:left}tbody td[title]{text-align:right}tbody td[title]:before{float:left;font-style:italic;content:attr(title) \": \"}}tbody tr:nth-child(odd){background-color:#f1f1f1}td img{vertical-align:top}@media screen and (max-width:74.99em){tbody tr:nth-of-type(odd)>td,tbody tr:nth-of-type(odd)>th{background-color:transparent}}tfoot td,tfoot th{background-color:#f63;color:#fff;vertical-align:top;text-align:left}@media screen and (max-width:74.99em){tfoot td,tfoot th{display:none}}form{margin:0}fieldset{max-width:none;min-width:0;padding:0;border:0}fieldset>legend,legend{display:table;max-width:100%;padding:0;font-weight:bolder;white-space:normal;color:inherit;box-sizing:border-box}label{padding:0;margin:0;font-size:small;line-height:inherit}label *{font-size:1em}form br{clear:both}[role=button],[type=button],[type=email],[type=number],[type=password],[type=reset],[type=search],[type=submit],[type=tel],[type=text],[type=url],button,html [type=button],optgroup,textarea{display:inline-block;padding:1px;margin:0;overflow:visible;font-size:inherit;line-height:inherit;font-family:inherit;-webkit-font-smoothing:inherit;letter-spacing:inherit;text-align:inherit;text-transform:inherit;white-space:normal;vertical-align:top;color:inherit;border:1px solid #ddd;border-radius:20px;outline:none;box-sizing:border-box}:focus[role=button],:focus[type=button],:focus[type=email],:focus[type=number],:focus[type=password],:focus[type=reset],:focus[type=search],:focus[type=submit],:focus[type=tel],:focus[type=text],:focus[type=url],button:focus,optgroup:focus,textarea:focus{outline:none;outline-offset:0}:disabled,:readonly{color:#6b6b6b;background:#f0f0f0}:disabled{cursor:not-allowed}:readonly{cursor:default}:-moz-placeholder{color:#575757;opacity:1}:focus:-moz-placeholder{color:#8f8f8f}::-moz-placeholder{color:#575757;opacity:1}:focus::-moz-placeholder{color:#8f8f8f}::-webkit-input-placeholder{color:#575757;opacity:1}:focus::-webkit-input-placeholder{color:#8f8f8f}:-ms-input-placeholder{color:#575757;opacity:1}:focus:-ms-input-placeholder{color:#8f8f8f}::placeholder{color:#575757;opacity:1}:focus::placeholder{color:#8f8f8f}[type=color],[type=file],[type=image]{padding:0;vertical-align:middle;cursor:pointer;border:0}[type=image]{display:inline-block}[type=color]{background-color:#fff}::-webkit-color-swatch{border:0}::-moz-color-swatch{border:0}::-webkit-color-swatch-wrapper{padding:0}::-moz-color-swatch-wrapper{padding:0}[type=file]{height:2em;min-width:250px;padding:0!important;margin:0;font-family:inherit;text-align:start!important;white-space:nowrap;cursor:default;background-color:transparent;border-style:none!important;-webkit-box-align:baseline;-webkit-appearance:none;-moz-appearance:none;appearance:normal;-moz-binding:none}[type=file]>[type=text]{height:inherit;font-size:inherit;letter-spacing:inherit;color:inherit;background-color:inherit;border-color:inherit}[type=file]>[type=button]{height:inherit;padding:0;font-size:inherit;white-space:normal;-webkit-box-align:center;box-sizing:content-box;appearance:button}::-webkit-file-upload-button{font:inherit;cursor:pointer;background-color:#f63;border:1px solid #ddd;-webkit-appearance:button}::-webkit-file-upload-button:hover{background-color:#fff}:focus::-webkit-color-swatch,:focus::-webkit-file-upload-button{outline:none}::-ms-browse{border:1px solid #ddd}::-ms-browse:hover{background-color:#fff}:focus::-ms-browse{outline:none}:required,[required]{box-shadow:none}[type=checkbox]:-moz-focusring,[type=radio]:-moz-focusring,[type=range]:-moz-focusring{outline-width:0}.checkbox-custom{zoom:1\\9;color:#fff;padding-right:.9375rem}.checkbox-custom:after,.checkbox-custom:before{display:table;content:\"\";border-collapse:collapse}.checkbox-custom:after{clear:both}.checkbox-custom [type=checkbox]{position:relative;display:inline-block;opacity:1;width:auto;height:auto}.checkbox-custom .input-wrapper label{position:relative;color:#000;display:inline;line-height:0;font-weight:400}.checkbox-custom .input-wrapper label a{color:inherit}.of-radios-and-checks .input-wrapper{position:relative;display:block;width:33.33333%;float:left;padding-right:.1875rem;padding-left:.1875rem;margin-bottom:0;white-space:nowrap;list-style-type:none;overflow:hidden}.of-radios-and-checks .input-wrapper:before{content:none}@media (max-width:480px){.of-radios-and-checks .input-wrapper{width:50%}}.of-radios-and-checks .input-wrapper label{padding-left:0}.of-radios-and-checks .input-wrapper--full-width{width:100%}.of-radios-and-checks .has-real-value{background-color:#fff;border-radius:30px;color:#212121;float:none;margin-right:.1875rem;margin-left:.1875rem;padding-top:.75rem;padding-bottom:.75rem;position:relative;width:auto;padding-left:2.25rem}.has-real-value label{display:block;background-color:transparent;padding:0;margin-left:-1.25rem;font-size:1em}.has-real-value label:focus,.has-real-value label:hover{color:inherit;background-color:transparent}.has-real-value [type=tel]{color:inherit;position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:100%;color:transparent;background:transparent;margin:0;padding:0;border:none}.has-real-value .real-value{font-size:1em;display:block;min-height:30px;line-height:2em;padding-left:.46875rem}.has-real-value [type=button]{border:0;border-radius:50%;background-color:#999;color:#fff;padding-right:.80625rem;padding-left:.80625rem;position:absolute;top:.1875rem;right:.1875rem;z-index:2}.site-footer{text-align:center;font-size:.8rem;color:#fff;background-color:#f63}.donations-sources{padding-top:.9375rem;padding-bottom:.9375rem;font-weight:400;font-size:.8rem;line-height:1.875;color:rgba(33,33,33,.65)}.donations-sources *{font-size:inherit!important}.donations-sources ul{padding-left:0}.donations-sources li:before{display:inline-block;width:1em;height:1em;background-color:#f63;border:1px solid #fff;border-radius:50%;content:\"\"}.donations-sources li:nth-child(2):before{background-image:linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25))}.donations-sources li:nth-child(3):before{background-image:linear-gradient(rgba(0,0,0,.5),rgba(0,0,0,.5))}.donations-sources li:nth-child(4):before{background-image:linear-gradient(rgba(0,0,0,.75),rgba(0,0,0,.75))}.donations-sources li:nth-child(5):before,.donations-sources li:nth-child(6):before,.donations-sources li:nth-child(7):before,.donations-sources li:nth-child(8):before,.donations-sources li:nth-child(9):before,.donations-sources li:nth-child(10):before{background-image:linear-gradient(#000,#000)}.donations-sources em,.donations-sources strong{font-weight:400}.donations-sources details,.donations-sources details[open]{display:inline}.donations-sources summary{display:inline;font-weight:400;list-style-type:none;cursor:help}.donations-sources summary:before{content:none}.donations-sources summary:after{display:inline-block;width:1.875em;height:1.875em;margin-right:.5em;margin-left:.5em;line-height:1.875em;text-align:center;background-color:#000;border-width:1px;border-color:currentColor;border-radius:50%;content:\"?\";transition-duration:1s;transition-property:background-color}.donations-sources summary:focus,.donations-sources summary:hover{text-decoration:underline}.donations-sources summary:focus:after,.donations-sources summary:hover:after{text-decoration:none;background-color:#3298ff}.donations-sources [open] summary:before{content:none}.donations-sources [open] summary~*{overflow:hidden;animation:here-comes-the-detail .5s ease-in-out}@keyframes here-comes-the-detail{0%{opacity:0}to{opacity:1}}@media screen and (min-width:30em){.donations-sources [open] summary~:after{content:\"\\A0; \"}.donations-sources [open] summary+:before{content:\"(\\A0\"}.donations-sources [open] summary~:last-child:after{content:\"\\A0)\"}}.donations-sources details p{display:inline}.donations-sources details em{font-style:normal}.donations-sources__amount{font-size:1rem}figure{margin:1em 2.5rem;margin:0}figcaption{font-size:83.3333%;line-height:inherit}figcaption p,figcaption small{margin:0;font-size:1em}[role=button],[type=button],[type=reset],[type=submit],button,html [type=button]{width:auto;padding:.5em 1.2em;border-radius:1.25rem;font-weight:700;border:0;overflow:visible;text-indent:0;white-space:inherit;cursor:pointer;box-sizing:inherit;appearance:button}[role=button]::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border:0}:active[role=button],:active[type=button],:active[type=reset],:active[type=submit],:focus[role=button],:focus[type=button],:focus[type=reset],:focus[type=submit],:hover[role=button],:hover[type=button],:hover[type=reset],:hover[type=submit],button:active,button:focus,button:hover{background-color:#fff}[role=button]:focus,[role=button]:hover,[type=button]:focus,[type=button]:hover,button:focus,button:hover{background-color:#f63;color:#fff}[role=button]:active,[type=button]:active,button:active{background-color:#666;color:#fff}[type=submit]{background-color:#fff;color:#f63}[type=submit]:focus,[type=submit]:hover{background-color:#f63;color:#fff}[type=submit]:active{background-color:#f63}button:-moz-focusring,input:-moz-focusring{outline:1px dotted ButtonText}.button--load-more[class]{display:block;margin:1.875rem auto 3.75rem;background-color:#999;text-transform:lowercase}fieldset ol,fieldset ul{padding:0;margin:0}fieldset li{text-align:center;display:block;white-space:nowrap;list-style-type:none}fieldset li:before{content:none}li label{display:inline;padding:0 .5em}[type=checkbox],[type=radio]{width:auto;height:auto;padding:0;vertical-align:middle;cursor:pointer;box-sizing:border-box}[type=checkbox]:focus,[type=radio]:focus{outline-style:auto}li:hover>input,li:hover>label{color:#000}li :checked+label{font-weight:700}:disabled+label,[disabled]+label{cursor:default;color:#6b6b6b}.of-radios-and-checks [type=radio]:checked+label,.of-radios-and-checks [type=radio]:not(:checked)+label{font-size:1rem}@media screen and (min-width:75em){.of-radios-and-checks [type=radio]:checked+label,.of-radios-and-checks [type=radio]:not(:checked)+label{font-size:1.25rem}}[type=radio]:checked+label,[type=radio]:not(:checked)+label{position:relative;width:100%;margin-top:.25em;margin-bottom:.5em;padding-top:.25em;padding-bottom:.25em;border-radius:20px;text-align:center;display:block;white-space:nowrap;list-style-type:none;cursor:pointer;z-index:3;font-size:1rem;font-weight:700;outline:none}[type=radio]:checked+label .donation-form__currency-item,[type=radio]:not(:checked)+label .donation-form__currency-item{font-size:1rem}[type=radio]+label:hover,[type=radio]:checked+label{color:#fff}input[type=checkbox],input[type=radio]{position:absolute;height:100%;width:100%;opacity:0}[type=radio]:checked,[type=radio]:not(:checked){position:absolute;left:0;top:0;z-index:2}[type=radio]:checked+label:before,[type=radio]:not(:checked)+label:before{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;border-radius:20px;background:#fff;z-index:-1}[type=radio]:checked+label:hover:before,[type=radio]:not(:checked)+label:hover:before{content:\"\";background:#f63}[type=radio]:checked+label:after,[type=radio]:not(:checked)+label:after{content:\"\";position:absolute;width:100%;height:100%;border-radius:20px;background:#f63;left:0;top:0;-webkit-transition:all .2s ease;transition:all .2s ease;z-index:-1}[type=radio]:not(:checked)+label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0)}[type=radio]:checked+label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1)}[role=progressbar],progress{width:100%;height:5px;line-height:5px;border-radius:5px;color:#fff;overflow:hidden;border:0;background:#e0e0e0}[role=progressbar][value]::-moz-progress-bar,progress[value]::-moz-progress-bar{border-radius:5px;background:#f63;transition:width .5s}[role=progressbar][value]::-webkit-progress-value,progress[value]::-webkit-progress-value{border-radius:5px;background:#f63;transition:width .5s}[role=progressbar]>div,progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;border-radius:5px;background:#f63;transition:width .5s;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}[role=progressbar]>div:first-child,progress>div:first-child{border-radius:5px 0 0 5px}[role=progressbar]>div:last-child,progress>div:last-child{border-radius:0 5px 5px 0}[role=progressbar]::-webkit-progress-bar,progress::-webkit-progress-bar{background:#e0e0e0}option,select{width:auto;min-width:1.5em;cursor:pointer}select{text-indent:.01px;text-overflow:\"\";box-sizing:content-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}select::-ms-expand{display:none}.ie6-9:invalid,select{padding-right:1.5em;background-image:url(\"data:image/png;base64,R0lGODlhDwAUAIABAAAAAP///yH5BAEAAAEALAAAAAAPABQAAAIXjI+py+0Po5wH2HsXzmw//lHiSJZmUAAAOw==\");background-position:95% 50%}optgroup{font-weight:700}option{padding:0 .4em 0 .1em;margin:0}option:focus,option:hover{color:#000}select[multiple] option:checked{font-weight:700}[type=range]{display:block;width:100%;padding:0;vertical-align:middle;cursor:pointer;background:transparent;border:0;appearance:none}[type=range]::-webkit-slider-runnable-track{width:100%;background-color:#f63}[type=range]::-webkit-slider-runnable-track:focus{outline:none}[type=range]::-moz-range-track{background-color:#f63}[type=range]::-moz-range-track:focus{outline:none}[type=range]::-ms-track{width:100%;color:transparent;background:transparent;border-width:.6875rem 0;border-color:transparent}[type=range]::-ms-fill-lower{background-color:#f63}[type=range]::-ms-fill-lower:focus{outline:none}[type=range]::-ms-fill-upper{background-color:#f63}[type=range]::-ms-fill-upper:focus{outline:none}[type=range]::-webkit-slider-thumb{background-color:#fff;border:0;margin-top:-.6875rem;appearance:none}[type=range]::-moz-range-thumb{background-color:#fff;border:0;appearance:none}[type=range]::-ms-thumb{margin-top:0;appearance:none;background-color:#fff;border:0}[type=range]::-moz-focus-outer{border:0}[type=range]:-moz-focusring{outline:1px solid transparent;outline-offset:-1px}[type=email],[type=number],[type=password],[type=search],[type=tel],[type=text],[type=url],textarea{width:100%;height:3.125rem;padding-top:1.2em;padding-left:.2em;font-size:1rem;text-indent:.5ex;cursor:text;border-radius:6px;box-sizing:inherit;appearance:none}:invalid[type=email],:invalid[type=number],:invalid[type=password],:invalid[type=search],:invalid[type=tel],:invalid[type=text],:invalid[type=url],textarea:invalid{border-radius:6px;box-shadow:0}:disabled[type=email],:disabled[type=number],:disabled[type=password],:disabled[type=search],:disabled[type=tel],:disabled[type=text],:disabled[type=url],textarea:disabled{cursor:not-allowed;background-color:#bababa;border-radius:6px;box-shadow:0}:-moz-ui-invalid[type=email],:-moz-ui-invalid[type=number],:-moz-ui-invalid[type=password],:-moz-ui-invalid[type=search],:-moz-ui-invalid[type=tel],:-moz-ui-invalid[type=text],:-moz-ui-invalid[type=url],textarea:-moz-ui-invalid{border-radius:6px;box-shadow:0}:focus[type=email],:focus[type=number],:focus[type=password],:focus[type=search],:focus[type=tel],:focus[type=text],:focus[type=url],textarea:focus{outline:none}[type=number]{-moz-appearance:textfield}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto;margin:0;-webkit-appearance:none}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto;line-height:inherit;white-space:pre;vertical-align:top;cursor:text;resize:vertical}.embed-container{padding-bottom:56.25%;height:0;overflow:hidden;position:relative;border-top-left-radius:2em;border-bottom-left-radius:2em;border-top-right-radius:2em;border-bottom-right-radius:2em;margin-bottom:1.875em}@media (min-width:64em){.embed-container{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:2em;border-bottom-right-radius:0}}.embed-container iframe{position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:100%}#receipt{background:#f1f1f1}#receipt .container{padding-right:3rem;padding-left:3rem}#receipt a{overflow-wrap:break-word;word-wrap:break-word;-ms-word-break:break-all;word-break:break-all;word-break:break-word;-ms-hyphens:auto;-moz-hyphens:auto;-webkit-hyphens:auto;hyphens:auto}.receipts-header{background-color:#1d384d;flex-direction:column;flex-wrap:wrap;align-items:flex-start;max-width:45em;padding-top:7.5em;padding-bottom:7.5em;background-image:url(" + escape(__webpack_require__(7)) + ");background-repeat:no-repeat;background-position:center 2em}.receipt__avatar,.receipts-header{margin-right:auto;margin-left:auto}.receipt__avatar{display:block;object-fit:cover;border:5px solid #f1f1f1;background-color:#f1f1f1;max-height:180px;max-width:180px;border-radius:50%;margin-top:2em;object-position:center;position:relative}.receipts{background-color:#fff;max-width:45em;margin:-12.1875em auto 0;padding-top:11.25em;border-top-left-radius:50px;border-top-right-radius:50px;background-image:url(" + escape(__webpack_require__(20)) + ");background-repeat:no-repeat;background-position:90% 4em;background-size:100px 100px}@media screen and (min-width:48em){.receipts{padding-top:10.3125em;background-position:90% 3.5em;background-size:125px 125px;border-top-left-radius:90px;border-top-right-radius:90px}}.receipts h1{font-size:1.95312rem;text-transform:none}.receipts h1,.receipts h2{color:#1d384d;font-weight:600;margin-bottom:.5em}.receipts h2{font-size:1.25rem}.receipts li{font-size:1rem;list-style-type:disc;color:#676767}.receipts a,.receipts a:active,.receipts a:focus,.receipts a:hover{color:#01d022}.receipts h3{font-size:1.25rem}.receipts p{color:#676767;margin-bottom:1em;line-height:1.5}.receipts hr{border-radius:2px;border:4px solid #1d384d;margin-bottom:1em}.receipt-blockchain,.receipt-donation,.receipt-donation__blockchain,.receipt-donation__got,.receipt-greetings,.receipt-share{margin-bottom:3em}.receipt-donation__donator,.receipt-share a{margin-bottom:1em}.receipt-share a{margin-top:1em;text-align:center;display:block;padding:.5em 1.2em;border-radius:20px;background-color:#f63;text-decoration:none;width:16em}.receipt-share a:hover{color:#366666}.receipt-footer{background-color:#1d384d;padding-top:4em;padding-bottom:2em}.receipts .receipt-footer a{text-decoration:underline;color:#fff}.receipt-footer p{margin-top:2em;margin-bottom:2em;font-size:.8em;color:#fff;text-align:center}.receipts .wrap-logos{text-align:center}.receipts .wrap-logos li{list-style:none;float:none;font-size:19px}.receipts .wrap-votolegal a{margin:0;margin-right:auto;margin-left:auto;display:block;padding:0}.receipts .wrap-votolegal a.votolegal{background:url(" + escape(__webpack_require__(7)) + ");background-repeat:no-repeat;width:171px;height:49px}.receipts .wrap-share-buttons li{background-color:#1d384d;margin-top:1em}.error{margin-bottom:.9375rem;font-weight:700;font-size:.8rem;color:#ed1941}.form__disclaimer{clear:both;margin-top:3.75rem;margin-bottom:.46875rem;font-size:.8rem}.form__disclaimer:before{content:\"\\2022   \"}.donation-form h3{margin:0;margin-top:1.875em;margin-bottom:.46875em;font-size:1rem;text-align:center}.donation-form h3 strong{font-weight:700;font-size:1.25rem;color:#000}.btn-accept-terms-of-use{display:block;height:30px;text-align:center;padding:24px;font-size:18px;cursor:pointer;width:100%;margin-bottom:10px}#maxdonation{display:none}.input-wrapper{margin-top:.46875em;margin-bottom:.46875em}.input-wrapper label{position:absolute;display:block;padding-top:2px;padding-left:10px;font-weight:700}.payment-type{display:inline-block;min-width:10rem}@media (min-width:1020px) and (max-width:1200px){.payment-type{display:block}}#doar .payment-type label{padding-top:0;padding-bottom:0}.payment-choices{padding:0;text-align:center}.certiface-verify h3{margin-bottom:1em}.certiface-verify div{margin-bottom:.5em;text-align:center}.certiface-verify p{margin-bottom:1em}.certiface-verify .donation-nav--rewind{padding-top:.5rem;padding-bottom:.5rem}.certiface-verify .donation-nav--forward{float:right;padding:.5rem .8rem}.donation-nav.donation-nav--block{display:block;text-align:center}.donations-table{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;table-layout:fixed;margin-top:1.875em;margin-bottom:1.875em}.donations-table a{text-decoration:none}.donations-table thead th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media (max-width:64em){.donations-table thead th{font-size:.8rem}}@media screen and (max-width:74.99em){.donations-table thead th{width:auto}}.donations-table thead th:first-child{width:auto}.donations-table thead th:nth-child(2),.donations-table thead th:nth-child(3){width:18%}.donations-table thead th:nth-child(4),.donations-table thead th:nth-child(5),.donations-table thead th:nth-child(6){width:15%}.donations-table tbody td:first-child{width:auto}@media screen and (max-width:74.99em){.donations-table tbody td:first-child{width:auto}}.donations-table tbody td:nth-child(2){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(2){width:auto}}.donations-table tbody td:nth-child(3){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(3){width:auto}}.donations-table tbody td:nth-child(4){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(4){width:auto}}.donations-table tbody td:nth-child(5){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(5){width:auto}}.donations-table tbody td:nth-child(6){width:20%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(6){width:auto}}.entry-content__nav ul{margin-top:2.8125em;margin-bottom:2.8125em}.entry-content__nav li{display:inline-block;margin-right:1em;position:relative;font-weight:700;font-size:1rem;color:#333}.entry-content__nav a{color:#333}.active-nav-item a{color:#f63}.active-nav-item a:hover,.active-nav-item a:link{text-decoration:none}.active-nav-item a:before{background-color:#f63;position:absolute;width:10px;height:10px;border-bottom:1px solid #f63;border-radius:50%;left:50%;top:0;margin-top:-10px;content:\"\"}.donation-form__navigation{margin-top:1.875em;margin-bottom:1.875em}.donation-form__navigation ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed}.donation-form__navigation li{display:inline-block;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;font-weight:700;font-size:1rem}.donation-form--rewind a{color:#f63}.donation-form--rewind a:hover{color:#333}.donation-nav--rewind{float:left;padding-top:.5em}.donation-nav--rewind:before{content:\"< \"}.donation-nav--forward{float:right;background-color:#fff;border-radius:20px;text-align:center}.donation-nav--forward:hover{background-color:#f63;color:#fff}.donation-nav--forward.bigger{font-size:1.25rem}.donation-form__forward a{width:100%}.donation-form__forward a:link{text-decoration:none}.donation-form__forward a:hover{color:#fff}.donate-service__nav a:link{text-decoration:none}.nav-links__donation-service a{width:100%;margin-top:.2em;margin-bottom:.2em;padding-top:.25em;padding-bottom:.25em;border-radius:20px;text-align:center;display:block;white-space:nowrap;list-style-type:none;cursor:pointer;font-size:1rem;font-weight:700;outline:none;background:#fff;color:#f63}.nav-links__donation-service a:link:hover{background:#f63;color:#fff}.donate__nav ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-right:-.9375rem;margin-left:-.9375rem;margin-left:-1.875rem;margin-right:-1.875rem;margin-bottom:1em}.donate__nav li{display:inline-block;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;width:50%;position:relative;font-weight:700;font-size:1rem;color:#fff}.donate__nav a{padding:.5625rem .9375rem;text-align:center;color:#fff;background-color:#c5c5c5}.donate__nav a:link{text-decoration:none}.donate__nav__active a{background-color:#f1f1f1}.service-list a{border-radius:20px;margin-bottom:.46875rem;margin-top:.46875rem;padding:.5em 1em;font-weight:400;background:#fff;display:block;text-decoration:none}.service-list a:hover{color:#ed1941}.service-list .service-nav{margin-top:1.875rem;text-align:center;text-transform:uppercase;color:#ed1941;font-weight:700}.wrap-social-candidate{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;padding:0;margin-top:.5em;margin-right:-.46875rem;margin-left:-.46875rem}@media (min-width:48em){.wrap-social-candidate{position:absolute;right:0;bottom:0;margin-right:2rem}}.wrap-social-candidate li{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;position:relative;width:20px;height:20px;margin:1em .46875rem 0;border-radius:50%}.wrap-social-candidate li:first-child{margin-left:.2em}@media (min-width:48em){.wrap-social-candidate li:first-child{margin-left:.46875rem}.wrap-social-candidate li:last-child{margin-right:0}}.wrap-social-candidate a{position:absolute;top:50%;left:50%;width:36px;height:36px;transform:translate(-50%,-50%)}.wrap-social-candidate a.twitter{background:url(" + escape(__webpack_require__(21)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-social-candidate a.whatsapp{background:url(" + escape(__webpack_require__(22)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-social-candidate a.youtube{background:url(" + escape(__webpack_require__(23)) + ");background-position:50%;background-size:auto 14px;background-repeat:no-repeat}.wrap-social-candidate a.instagram{background:url(" + escape(__webpack_require__(24)) + ");background-position:50%;background-size:auto 14px;background-repeat:no-repeat}.wrap-social-candidate a.facebook{background:url(" + escape(__webpack_require__(25)) + ");background-position:50%;background-size:auto 16px;background-repeat:no-repeat}.wrap-social-candidate a.website{background:url(" + escape(__webpack_require__(26)) + ");background-position:50%;background-size:auto 13px;background-repeat:no-repeat}.wrap-social-candidate a.email{background:url(" + escape(__webpack_require__(27)) + ");background-position:50%;background-size:auto 16px;background-repeat:no-repeat}.wrap-share-buttons{padding:0;margin:0;text-align:center}.wrap-share-buttons li{position:relative;display:inline-block;width:36px;height:36px;margin:0 .1em;background-color:red;border-radius:50%}.wrap-share-buttons a{position:absolute;top:50%;left:50%;width:36px;height:36px;transform:translate(-50%,-50%)}.wrap-share-buttons a.twitter{background:url(" + escape(__webpack_require__(12)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-share-buttons a.mail{background:url(" + escape(__webpack_require__(13)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-share-buttons a.facebook{background:url(" + escape(__webpack_require__(14)) + ");background-position:50%;background-size:auto 18px;background-repeat:no-repeat}.donation-form__breadcrumbs ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-top:.9375em;margin-bottom:.9375em}.donation-form__breadcrumbs li{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;font-size:.8rem;position:relative;width:25px;height:25px;z-index:1;background-color:#bababa;border-radius:50%;margin-right:.5em}li.active-breadcrumbs{background-color:#666}.donation-form__breadcrumbs a{position:absolute;color:#fff;transform:translate(-50%,-50%);top:50%;left:50%}.donation-form__breadcrumbs a:link{text-decoration:none}#candidate.default #doar h2,#candidate.default .campaign-progress__meta-item--expected dd,#candidate.default .campaign-progress__meta__service .candidate-goals,#candidate.default .donate__nav__active a,#candidate.default .donation-nav,#candidate.default .entry-contents a,#candidate.default .input-wrapper a,#candidate.default .site-header h2{color:#f63}#candidate.default .donation-nav--rewind:hover{color:#333}#candidate.default .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.default .active-nav-item a:before,#candidate.default [type=radio]:checked+label:after,#candidate.default [type=radio]:not(:checked)+label:after,#candidate.default tfoot td,#candidate.default tfoot th,#candidate.default thead td,#candidate.default thead th{background-color:#f63}#candidate.default .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.default+#tfooter{background-color:#f63}#candidate.default+#tfooter .wrap-informations{color:#fff}#candidate.default+#tfooter .wrap-informations a{color:inherit}#candidate.default .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.default progress[value]::-moz-progress-bar{background:#f63}#candidate.default progress[value]::-webkit-progress-value{background:#f63}#candidate.default progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.default progress>div:first-child{border-radius:5px 0 0 5px}#candidate.default progress>div:last-child{border-radius:0 5px 5px 0}#candidate.default button{color:#f63}#candidate.default [type=radio]:checked+label:hover:before,#candidate.default [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.default [type=radio]:checked+label{color:#fff}#candidate.default [role=button]:active,#candidate.default [role=button]:focus,#candidate.default [role=button]:hover,#candidate.default [type=button]:active,#candidate.default [type=button]:focus,#candidate.default [type=button]:hover,#candidate.default button:active,#candidate.default button:focus,#candidate.default button:hover{color:#fff;background-color:#f63}#candidate.default [type=button]{color:#fff}#candidate.default .wrap-share-buttons li{background-color:#f63}#candidate.theme--default #doar h2,#candidate.theme--default .campaign-progress__meta-item--expected dd,#candidate.theme--default .campaign-progress__meta__service .candidate-goals,#candidate.theme--default .donate__nav__active a,#candidate.theme--default .donation-nav,#candidate.theme--default .entry-contents a,#candidate.theme--default .input-wrapper a,#candidate.theme--default .site-header h2{color:#f63}#candidate.theme--default .donation-nav--rewind:hover{color:#333}#candidate.theme--default .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.theme--default .active-nav-item a:before,#candidate.theme--default [type=radio]:checked+label:after,#candidate.theme--default [type=radio]:not(:checked)+label:after,#candidate.theme--default tfoot td,#candidate.theme--default tfoot th,#candidate.theme--default thead td,#candidate.theme--default thead th{background-color:#f63}#candidate.theme--default .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.theme--default+#tfooter{background-color:#f63}#candidate.theme--default+#tfooter .wrap-informations{color:#fff}#candidate.theme--default+#tfooter .wrap-informations a{color:inherit}#candidate.theme--default .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.theme--default progress[value]::-moz-progress-bar{background:#f63}#candidate.theme--default progress[value]::-webkit-progress-value{background:#f63}#candidate.theme--default progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--default progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--default progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--default button{color:#f63}#candidate.theme--default [type=radio]:checked+label:hover:before,#candidate.theme--default [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.theme--default [type=radio]:checked+label{color:#fff}#candidate.theme--default [role=button]:active,#candidate.theme--default [role=button]:focus,#candidate.theme--default [role=button]:hover,#candidate.theme--default [type=button]:active,#candidate.theme--default [type=button]:focus,#candidate.theme--default [type=button]:hover,#candidate.theme--default button:active,#candidate.theme--default button:focus,#candidate.theme--default button:hover{color:#fff;background-color:#f63}#candidate.theme--default [type=button]{color:#fff}#candidate.theme--default .wrap-share-buttons li{background-color:#f63}#candidate.theme--orange #doar h2,#candidate.theme--orange .campaign-progress__meta-item--expected dd,#candidate.theme--orange .campaign-progress__meta__service .candidate-goals,#candidate.theme--orange .donate__nav__active a,#candidate.theme--orange .donation-nav,#candidate.theme--orange .entry-contents a,#candidate.theme--orange .input-wrapper a,#candidate.theme--orange .site-header h2{color:#f63}#candidate.theme--orange .donation-nav--rewind:hover{color:#333}#candidate.theme--orange .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.theme--orange .active-nav-item a:before,#candidate.theme--orange [type=radio]:checked+label:after,#candidate.theme--orange [type=radio]:not(:checked)+label:after,#candidate.theme--orange tfoot td,#candidate.theme--orange tfoot th,#candidate.theme--orange thead td,#candidate.theme--orange thead th{background-color:#f63}#candidate.theme--orange .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.theme--orange+#tfooter{background-color:#f63}#candidate.theme--orange+#tfooter .wrap-informations{color:#fff}#candidate.theme--orange+#tfooter .wrap-informations a{color:inherit}#candidate.theme--orange .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.theme--orange progress[value]::-moz-progress-bar{background:#f63}#candidate.theme--orange progress[value]::-webkit-progress-value{background:#f63}#candidate.theme--orange progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--orange progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--orange progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--orange button{color:#f63}#candidate.theme--orange [type=radio]:checked+label:hover:before,#candidate.theme--orange [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.theme--orange [type=radio]:checked+label{color:#fff}#candidate.theme--orange [role=button]:active,#candidate.theme--orange [role=button]:focus,#candidate.theme--orange [role=button]:hover,#candidate.theme--orange [type=button]:active,#candidate.theme--orange [type=button]:focus,#candidate.theme--orange [type=button]:hover,#candidate.theme--orange button:active,#candidate.theme--orange button:focus,#candidate.theme--orange button:hover{color:#fff;background-color:#f63}#candidate.theme--orange [type=button]{color:#fff}#candidate.theme--orange .wrap-share-buttons li{background-color:#f63}#candidate.theme--red #doar h2,#candidate.theme--red .campaign-progress__meta-item--expected dd,#candidate.theme--red .campaign-progress__meta__service .candidate-goals,#candidate.theme--red .donate__nav__active a,#candidate.theme--red .donation-nav,#candidate.theme--red .entry-contents a,#candidate.theme--red .input-wrapper a,#candidate.theme--red .site-header h2{color:#ed1941}#candidate.theme--red .donation-nav--rewind:hover{color:#333}#candidate.theme--red .donation-nav--forward:hover{color:#fff;background-color:#ed1941}#candidate.theme--red .active-nav-item a:before,#candidate.theme--red [type=radio]:checked+label:after,#candidate.theme--red [type=radio]:not(:checked)+label:after,#candidate.theme--red tfoot td,#candidate.theme--red tfoot th,#candidate.theme--red thead td,#candidate.theme--red thead th{background-color:#ed1941}#candidate.theme--red .active-nav-item a:before{border-bottom:1px solid #ed1941}#candidate.theme--red+#tfooter{background-color:#ed1941}#candidate.theme--red+#tfooter .wrap-informations{color:#fff}#candidate.theme--red+#tfooter .wrap-informations a{color:inherit}#candidate.theme--red .site-header{background-image:url(" + escape(__webpack_require__(28)) + ")}#candidate.theme--red progress[value]::-moz-progress-bar{background:#ed1941}#candidate.theme--red progress[value]::-webkit-progress-value{background:#ed1941}#candidate.theme--red progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#ed1941;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--red progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--red progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--red button{color:#ed1941}#candidate.theme--red [type=radio]:checked+label:hover:before,#candidate.theme--red [type=radio]:not(:checked)+label:hover:before{background:#f93156;content:\"\"}#candidate.theme--red [type=radio]:checked+label{color:#fff}#candidate.theme--red [role=button]:active,#candidate.theme--red [role=button]:focus,#candidate.theme--red [role=button]:hover,#candidate.theme--red [type=button]:active,#candidate.theme--red [type=button]:focus,#candidate.theme--red [type=button]:hover,#candidate.theme--red button:active,#candidate.theme--red button:focus,#candidate.theme--red button:hover{color:#fff;background-color:#ed1941}#candidate.theme--red [type=button]{color:#fff}#candidate.theme--red .wrap-share-buttons li{background-color:#ed1941}#candidate.theme--blue #doar h2,#candidate.theme--blue .campaign-progress__meta-item--expected dd,#candidate.theme--blue .campaign-progress__meta__service .candidate-goals,#candidate.theme--blue .donate__nav__active a,#candidate.theme--blue .donation-nav,#candidate.theme--blue .entry-contents a,#candidate.theme--blue .input-wrapper a,#candidate.theme--blue .site-header h2{color:#0072bc}#candidate.theme--blue .donation-nav--rewind:hover{color:#333}#candidate.theme--blue .donation-nav--forward:hover{color:#fff;background-color:#0072bc}#candidate.theme--blue .active-nav-item a:before,#candidate.theme--blue [type=radio]:checked+label:after,#candidate.theme--blue [type=radio]:not(:checked)+label:after,#candidate.theme--blue tfoot td,#candidate.theme--blue tfoot th,#candidate.theme--blue thead td,#candidate.theme--blue thead th{background-color:#0072bc}#candidate.theme--blue .active-nav-item a:before{border-bottom:1px solid #0072bc}#candidate.theme--blue+#tfooter{background-color:#0072bc}#candidate.theme--blue+#tfooter .wrap-informations{color:#fff}#candidate.theme--blue+#tfooter .wrap-informations a{color:inherit}#candidate.theme--blue .site-header{background-image:url(" + escape(__webpack_require__(29)) + ")}#candidate.theme--blue progress[value]::-moz-progress-bar{background:#0072bc}#candidate.theme--blue progress[value]::-webkit-progress-value{background:#0072bc}#candidate.theme--blue progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#0072bc;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--blue progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--blue progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--blue button{color:#0072bc}#candidate.theme--blue [type=radio]:checked+label:hover:before,#candidate.theme--blue [type=radio]:not(:checked)+label:hover:before{background:#2b7fb8;content:\"\"}#candidate.theme--blue [type=radio]:checked+label{color:#fff}#candidate.theme--blue [role=button]:active,#candidate.theme--blue [role=button]:focus,#candidate.theme--blue [role=button]:hover,#candidate.theme--blue [type=button]:active,#candidate.theme--blue [type=button]:focus,#candidate.theme--blue [type=button]:hover,#candidate.theme--blue button:active,#candidate.theme--blue button:focus,#candidate.theme--blue button:hover{color:#fff;background-color:#0072bc}#candidate.theme--blue [type=button]{color:#fff}#candidate.theme--blue .wrap-share-buttons li{background-color:#0072bc}#candidate.theme--green #doar h2,#candidate.theme--green .campaign-progress__meta-item--expected dd,#candidate.theme--green .campaign-progress__meta__service .candidate-goals,#candidate.theme--green .donate__nav__active a,#candidate.theme--green .donation-nav,#candidate.theme--green .entry-contents a,#candidate.theme--green .input-wrapper a,#candidate.theme--green .site-header h2{color:#396}#candidate.theme--green .donation-nav--rewind:hover{color:#333}#candidate.theme--green .donation-nav--forward:hover{color:#fff;background-color:#396}#candidate.theme--green .active-nav-item a:before,#candidate.theme--green [type=radio]:checked+label:after,#candidate.theme--green [type=radio]:not(:checked)+label:after,#candidate.theme--green tfoot td,#candidate.theme--green tfoot th,#candidate.theme--green thead td,#candidate.theme--green thead th{background-color:#396}#candidate.theme--green .active-nav-item a:before{border-bottom:1px solid #396}#candidate.theme--green+#tfooter{background-color:#396}#candidate.theme--green+#tfooter .wrap-informations{color:#fff}#candidate.theme--green+#tfooter .wrap-informations a{color:inherit}#candidate.theme--green .site-header{background-image:url(" + escape(__webpack_require__(30)) + ")}#candidate.theme--green progress[value]::-moz-progress-bar{background:#396}#candidate.theme--green progress[value]::-webkit-progress-value{background:#396}#candidate.theme--green progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#396;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--green progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--green progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--green button{color:#396}#candidate.theme--green [type=radio]:checked+label:hover:before,#candidate.theme--green [type=radio]:not(:checked)+label:hover:before{background:#62a282;content:\"\"}#candidate.theme--green [type=radio]:checked+label{color:#fff}#candidate.theme--green [role=button]:active,#candidate.theme--green [role=button]:focus,#candidate.theme--green [role=button]:hover,#candidate.theme--green [type=button]:active,#candidate.theme--green [type=button]:focus,#candidate.theme--green [type=button]:hover,#candidate.theme--green button:active,#candidate.theme--green button:focus,#candidate.theme--green button:hover{color:#fff;background-color:#396}#candidate.theme--green [type=button]{color:#fff}#candidate.theme--green .wrap-share-buttons li{background-color:#396}.site-header{background-size:70% auto}@media (min-width:20em){.site-header{background-position:center -50px}}@media (min-width:30em){.site-header{background-position:center -100px}}@media (min-width:48em){.site-header{background-position:center 650%;background-size:auto}}.site-header .container{padding-top:10rem;background-image:url(" + escape(__webpack_require__(31)) + ");background-position:1em 30%;background-repeat:no-repeat}@media (min-width:30em){.site-header .container{padding-top:12.5rem}}@media (min-width:64em){.site-header .container{padding-top:12.5rem;background-image:url(" + escape(__webpack_require__(32)) + ");background-position:2em 25%}}#candidate .site-header h2{font-weight:700;font-size:1.5625rem;text-transform:uppercase}#candidate #intro{margin-top:1.875em}.candidate-wrap{position:relative}@media screen and (min-width:64em){.candidate-wrap{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-right:-.9375rem;margin-left:-.9375rem}}@media screen and (min-width:64em){#intro{width:70%}}@media screen and (min-width:64em){#campaign-progress,#intro{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;padding-right:.9375rem;padding-left:.9375rem}#campaign-progress{width:30%}}.intro__meta{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;overflow:hidden}@media screen and (min-width:64em){.intro__meta{border-bottom:1px solid #e5e7ea}}.intro__meta-item{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;max-width:100%;margin-right:2em;margin-bottom:.9375em;line-height:1.3}.intro__meta-item .intro__meta-item:last-child{margin-bottom:0}@media screen and (min-width:48em){.intro__meta-item{margin-bottom:0}}@media screen and (min-width:64em){.intro__meta-item{padding-bottom:.9375em}}.intro__meta-item dt{font-weight:700;font-size:.8rem;text-transform:uppercase;color:#999}.intro__meta-item dd{display:flex;max-width:100%;font-size:1.5625rem}@media screen and (min-width:75em){.intro__meta-item dd{font-size:1.95312rem}}.intro__meta-item .locality,.intro__meta-item .region{display:table-cell}.intro__meta-item .locality{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#campaign-progress{margin-top:.9375em;margin-bottom:1.875em;line-height:1.3}@media screen and (min-width:64em){#campaign-progress{margin-top:1.875em;margin-bottom:1.875em}}.campaign-progress__meta-item dt{font-size:1.95312rem}.campaign-progress__meta-item dd{font-weight:700;font-size:1rem;color:#999}.campaign-progress__meta-currency{font-size:1.5625rem}@media screen and (min-width:75em){.campaign-progress__meta-currency{display:block}}.campaign-progress__donated{font-weight:700}.campaign-progress__meta-captured{font-weight:700;font-size:1rem;color:#999}dt .campaign-progress__value-minor{font-weight:700;font-size:1.25rem}dd .campaign-progress__value-minor{font-weight:700;font-size:1rem}.campaign-progress__meta-item{margin-bottom:1.5em}.campaign-progress__meta-item--expected dt{font-size:2.44141rem}.campaign-progress__meta-item--expected dd{font-size:1.25rem;color:#f63}.campaign-progress__meta-item--expected dd:first-child{margin-bottom:0}@media (min-width:75em){.campaign-progress__meta__service{margin-top:2.8125em}}.campaign-progress__meta__service dt{font-size:1.95312rem}.campaign-progress__meta__service dd{margin-bottom:0;font-weight:700;font-size:1rem;color:#999}.campaign-progress__meta__service .candidate-goals{font-size:1.25rem;color:#f63}.candidate-content{position:relative;width:100%;padding-bottom:3.75rem}@media (max-width:768px){.candidate-content{padding-bottom:1.875rem}}#doar,[id=votar]{position:relative;float:none;display:table;z-index:10;width:100%;max-width:none;padding:1.875rem;margin-bottom:1.875em;overflow:hidden;color:#666;background-color:#f1f1f1;border-radius:1.875rem}@media (min-width:64em){#doar,[id=votar]{position:relative;float:right;clear:right;max-width:36%;margin-top:-10%}}#doar h2,[id=votar] h2{font-weight:700;font-size:1.5625rem;text-align:center;color:#f63}#doar h4,[id=votar] h4{font-weight:700;font-size:.9em;text-align:left}@media (min-width:64em){[id=votar]{margin-top:1.875rem}}#doar section,[id=votar] section{margin-top:.9375em;margin-bottom:.9375em}[id=votar] p{margin-bottom:1.875em}#doar__valores legend{font-size:1.25rem}.donation-panel-title{padding-bottom:.46875em;border-bottom:1px solid #e5e7ea}.payment-confirmation-message{font-weight:700;font-size:1rem;text-align:center;text-transform:uppercase}.final-message{text-align:center}.payment-final-message{font-weight:700;color:#333}.donation-form__chosen-value,.payment-final-message{margin-bottom:.9375em;font-size:1.25rem;text-align:center}.donation-form__currency-value{font-weight:700;font-size:1rem}.donation-form__navigation li{padding:0}.entry-contents{position:relative;width:100%;margin-top:.9375em;margin-bottom:9.375em}@media (max-width:1024px){.entry-contents{float:none;max-width:none}}@media screen and (min-width:64em){.entry-contents h3,.entry-contents h4,.entry-contents p{max-width:63%}}.candidate-summary{margin-bottom:3.75em}.candidate-summary p{white-space:pre-line}.entry-contents section h2,.entry-contents section h4{margin-bottom:.9375em}.entry-contents section p{margin-bottom:1.875em}.entry-content{display:none}.candidate-cnpj{font-size:.8rem}.candidate-biography{white-space:pre-line}.entry-content-active{display:block}.candidate-amount-select{margin-bottom:.9375em;text-align:center}.candidate-amount p{margin-bottom:.9375em;font-weight:700;font-size:.9em}@media print{*{text-shadow:none!important;color:#000!important;background:transparent!important}body{font:12pt/1.33333 Palatino Linotype,Palatino,Times New Roman,Times,serif;color:#000;background:#fff none}a,a:link,a:visited{font-weight:700;text-decoration:underline;color:#444!important;background:transparent}a[href]:after{font-style:italic;word-wrap:break-word;white-space:pre-wrap;color:#333;content:\" (\" attr(href) \") \"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}abbr[title]:after{font-style:italic;content:\" (\" attr(title) \")\"}blockquote,pre{page-break-inside:avoid;border:1px solid #999}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important;vertical-align:bottom}@page{margin:.5cm}h2,h3,p{orphans:3;widows:3}caption,h1,h2,h3,h4,h5,h6,legend{page-break-after:avoid;page-break-inside:never}[role=main]{float:none!important;width:auto;padding:0;margin:0 5%;border:0}.access,.secondary,nav{display:none}}", ""]);

// exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VMoney=t():e.VMoney=t()})(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p=".",t(t.s=9)}([function(e,t,n){"use strict";t.a={prefix:"",suffix:"",thousands:",",decimal:".",precision:2}},function(e,t,n){"use strict";var r=n(2),i=n(5),u=n(0);t.a=function(e,t){if(t.value){var o=n.i(i.a)(u.a,t.value);if("INPUT"!==e.tagName.toLocaleUpperCase()){var a=e.getElementsByTagName("input");1!==a.length||(e=a[0])}e.oninput=function(){var t=e.value.length-e.selectionEnd;e.value=n.i(r.a)(e.value,o),t=Math.max(t,o.suffix.length),t=e.value.length-t,t=Math.max(t,o.prefix.length+1),n.i(r.b)(e,t),e.dispatchEvent(n.i(r.c)("change"))},e.onfocus=function(){n.i(r.b)(e,e.value.length-o.suffix.length)},e.oninput(),e.dispatchEvent(n.i(r.c)("input"))}}},function(e,t,n){"use strict";function r(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:m.a;"number"==typeof e&&(e=e.toFixed(o(t.precision)));var n=e.indexOf("-")>=0?"-":"",r=u(e),i=c(r,t.precision),a=d(i).split("."),p=a[0],l=a[1];return p=f(p,t.thousands),t.prefix+n+s(p,l,t.decimal)+t.suffix}function i(e,t){var n=e.indexOf("-")>=0?-1:1,r=u(e),i=c(r,t);return parseFloat(i)*n}function u(e){return d(e).replace(/\D+/g,"")||"0"}function o(e){return a(0,e,20)}function a(e,t,n){return Math.max(e,Math.min(t,n))}function c(e,t){var n=Math.pow(10,t);return(parseFloat(e)/n).toFixed(o(t))}function f(e,t){return e.replace(/(\d)(?=(?:\d{3})+\b)/gm,"$1"+t)}function s(e,t,n){return t?e+n+t:e}function d(e){return e?e.toString():""}function p(e,t){var n=function(){e.setSelectionRange(t,t)};e===document.activeElement&&(n(),setTimeout(n,1))}function l(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}var m=n(0);n.d(t,"a",function(){return r}),n.d(t,"d",function(){return i}),n.d(t,"b",function(){return p}),n.d(t,"c",function(){return l})},function(e,t,n){"use strict";function r(e,t){t&&Object.keys(t).map(function(e){a.a[e]=t[e]}),e.directive("money",o.a),e.component("money",u.a)}Object.defineProperty(t,"__esModule",{value:!0});var i=n(6),u=n.n(i),o=n(1),a=n(0);n.d(t,"Money",function(){return u.a}),n.d(t,"VMoney",function(){return o.a}),n.d(t,"options",function(){return a.a}),n.d(t,"VERSION",function(){return c});var c="0.8.1";t.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),i=n(0),u=n(2);t.default={name:"Money",props:{value:{required:!0,type:[Number,String],default:0},masked:{type:Boolean,default:!1},precision:{type:Number,default:function(){return i.a.precision}},decimal:{type:String,default:function(){return i.a.decimal}},thousands:{type:String,default:function(){return i.a.thousands}},prefix:{type:String,default:function(){return i.a.prefix}},suffix:{type:String,default:function(){return i.a.suffix}}},directives:{money:r.a},data:function(){return{formattedValue:""}},watch:{value:{immediate:!0,handler:function(e,t){var r=n.i(u.a)(e,this.$props);r!==this.formattedValue&&(this.formattedValue=r)}}},methods:{change:function(e){this.$emit("input",this.masked?e.target.value:n.i(u.d)(e.target.value,this.precision))}}}},function(e,t,n){"use strict";t.a=function(e,t){return e=e||{},t=t||{},Object.keys(e).concat(Object.keys(t)).reduce(function(n,r){return n[r]=void 0===t[r]?e[r]:t[r],n},{})}},function(e,t,n){var r=n(7)(n(4),n(8),null,null);e.exports=r.exports},function(e,t){e.exports=function(e,t,n,r){var i,u=e=e||{},o=typeof e.default;"object"!==o&&"function"!==o||(i=e,u=e.default);var a="function"==typeof u?u.options:u;if(t&&(a.render=t.render,a.staticRenderFns=t.staticRenderFns),n&&(a._scopeId=n),r){var c=a.computed||(a.computed={});Object.keys(r).forEach(function(e){var t=r[e];c[e]=function(){return t}})}return{esModule:i,exports:u,options:a}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{directives:[{name:"money",rawName:"v-money",value:{precision:e.precision,decimal:e.decimal,thousands:e.thousands,prefix:e.prefix,suffix:e.suffix},expression:"{precision, decimal, thousands, prefix, suffix}"}],staticClass:"v-money",attrs:{type:"tel"},domProps:{value:e.formattedValue},on:{change:e.change}})},staticRenderFns:[]}},function(e,t,n){e.exports=n(3)}])});

/***/ }),
/* 255 */
/***/ (function(module, exports) {

(function (p, a, c) {
  "function" === typeof window.define && window.define.amd ? window.define(c) : "undefined" !== typeof module && module.exports ? module.exports = c() : a.exports ? a.exports = c() : a[p] = c();
})("VotolegalFP", this, function () {
  var p = function p(a) {
    if (!(this instanceof p)) {
      return new p(a);
    }
    this.options = this.extend(a, { swfContainerId: "fingerprintjs2", swfPath: "flash/compiled/FontList.swf", detectScreenOrientation: !0, sortPluginsFor: [/palemoon/i], userDefinedFonts: [], excludeDoNotTrack: !0, excludePixelRatio: !0 });this.nativeForEach = Array.prototype.forEach;this.nativeMap = Array.prototype.map;
  };p.prototype = { extend: function extend(a, c) {
      if (null == a) {
        return c;
      }
      for (var b in a) {
        null != a[b] && c[b] !== a[b] && (c[b] = a[b]);
      }
      return c;
    }, get: function get(a) {
      var c = this,
          b = { data: [], addPreprocessedComponent: function addPreprocessedComponent(a) {
          var d = a.value;"function" === typeof c.options.preprocessor && (d = c.options.preprocessor(a.key, d));b.data.push({ key: a.key, value: d });
        } };b = this.userAgentKey(b);b = this.languageKey(b);b = this.colorDepthKey(b);b = this.deviceMemoryKey(b);b = this.pixelRatioKey(b);b = this.hardwareConcurrencyKey(b);b = this.screenResolutionKey(b);b = this.availableScreenResolutionKey(b);b = this.timezoneOffsetKey(b);b = this.sessionStorageKey(b);b = this.localStorageKey(b);b = this.indexedDbKey(b);b = this.addBehaviorKey(b);b = this.openDatabaseKey(b);b = this.cpuClassKey(b);b = this.platformKey(b);b = this.doNotTrackKey(b);b = this.pluginsKey(b);b = this.canvasKey(b);b = this.webglKey(b);b = this.webglVendorAndRendererKey(b);b = this.adBlockKey(b);b = this.hasLiedLanguagesKey(b);b = this.hasLiedResolutionKey(b);b = this.hasLiedOsKey(b);b = this.hasLiedBrowserKey(b);b = this.touchSupportKey(b);b = this.customEntropyFunction(b);this.fontsKey(b, function (b) {
        var d = [];c.each(b.data, function (a) {
          (a = a.value) && "function" === typeof a.join && (a = a.join(";"));d.push(a);
        });var h = c.x64hash128(d.join("~~~"), 31);return a(h, b.data);
      });
    }, customEntropyFunction: function customEntropyFunction(a) {
      "function" === typeof this.options.customFunction && a.addPreprocessedComponent({ key: "custom", value: this.options.customFunction() });return a;
    }, userAgentKey: function userAgentKey(a) {
      this.options.excludeUserAgent || a.addPreprocessedComponent({ key: "user_agent", value: this.getUserAgent() });return a;
    }, getUserAgent: function getUserAgent() {
      return navigator.userAgent;
    }, languageKey: function languageKey(a) {
      this.options.excludeLanguage || a.addPreprocessedComponent({ key: "language", value: navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || "" });return a;
    }, colorDepthKey: function colorDepthKey(a) {
      this.options.excludeColorDepth || a.addPreprocessedComponent({ key: "color_depth", value: window.screen.colorDepth || -1 });return a;
    }, deviceMemoryKey: function deviceMemoryKey(a) {
      this.options.excludeDeviceMemory || a.addPreprocessedComponent({ key: "device_memory", value: this.getDeviceMemory() });return a;
    }, getDeviceMemory: function getDeviceMemory() {
      return navigator.deviceMemory || -1;
    }, pixelRatioKey: function pixelRatioKey(a) {
      this.options.excludePixelRatio || a.addPreprocessedComponent({ key: "pixel_ratio", value: this.getPixelRatio() });return a;
    }, getPixelRatio: function getPixelRatio() {
      return window.devicePixelRatio || "";
    }, screenResolutionKey: function screenResolutionKey(a) {
      return this.options.excludeScreenResolution ? a : this.getScreenResolution(a);
    }, getScreenResolution: function getScreenResolution(a) {
      a.addPreprocessedComponent({ key: "resolution", value: this.options.detectScreenOrientation ? window.screen.height > window.screen.width ? [window.screen.height, window.screen.width] : [window.screen.width, window.screen.height] : [window.screen.width, window.screen.height] });return a;
    }, availableScreenResolutionKey: function availableScreenResolutionKey(a) {
      return this.options.excludeAvailableScreenResolution ? a : this.getAvailableScreenResolution(a);
    }, getAvailableScreenResolution: function getAvailableScreenResolution(a) {
      var c;window.screen.availWidth && window.screen.availHeight && (c = this.options.detectScreenOrientation ? window.screen.availHeight > window.screen.availWidth ? [window.screen.availHeight, window.screen.availWidth] : [window.screen.availWidth, window.screen.availHeight] : [window.screen.availHeight, window.screen.availWidth]);"undefined" !== typeof c && a.addPreprocessedComponent({ key: "available_resolution", value: c });return a;
    }, timezoneOffsetKey: function timezoneOffsetKey(a) {
      this.options.excludeTimezoneOffset || a.addPreprocessedComponent({ key: "timezone_offset", value: new Date().getTimezoneOffset() });return a;
    }, sessionStorageKey: function sessionStorageKey(a) {
      !this.options.excludeSessionStorage && this.hasSessionStorage() && a.addPreprocessedComponent({ key: "session_storage", value: 1 });return a;
    }, localStorageKey: function localStorageKey(a) {
      !this.options.excludeSessionStorage && this.hasLocalStorage() && a.addPreprocessedComponent({ key: "local_storage", value: 1 });return a;
    }, indexedDbKey: function indexedDbKey(a) {
      !this.options.excludeIndexedDB && this.hasIndexedDB() && a.addPreprocessedComponent({ key: "indexed_db", value: 1 });return a;
    }, addBehaviorKey: function addBehaviorKey(a) {
      !this.options.excludeAddBehavior && document.body && document.body.addBehavior && a.addPreprocessedComponent({ key: "add_behavior", value: 1 });return a;
    }, openDatabaseKey: function openDatabaseKey(a) {
      !this.options.excludeOpenDatabase && window.openDatabase && a.addPreprocessedComponent({ key: "open_database", value: 1 });return a;
    }, cpuClassKey: function cpuClassKey(a) {
      this.options.excludeCpuClass || a.addPreprocessedComponent({ key: "cpu_class", value: this.getNavigatorCpuClass() });return a;
    }, platformKey: function platformKey(a) {
      this.options.excludePlatform || a.addPreprocessedComponent({ key: "navigator_platform", value: this.getNavigatorPlatform() });return a;
    }, doNotTrackKey: function doNotTrackKey(a) {
      this.options.excludeDoNotTrack || a.addPreprocessedComponent({ key: "do_not_track", value: this.getDoNotTrack() });return a;
    }, canvasKey: function canvasKey(a) {
      !this.options.excludeCanvas && this.isCanvasSupported() && a.addPreprocessedComponent({ key: "canvas", value: this.getCanvasFp() });return a;
    }, webglKey: function webglKey(a) {
      !this.options.excludeWebGL && this.isWebGlSupported() && a.addPreprocessedComponent({ key: "webgl", value: this.getWebglFp() });return a;
    }, webglVendorAndRendererKey: function webglVendorAndRendererKey(a) {
      !this.options.excludeWebGLVendorAndRenderer && this.isWebGlSupported() && a.addPreprocessedComponent({ key: "webgl_vendor", value: this.getWebglVendorAndRenderer() });return a;
    }, adBlockKey: function adBlockKey(a) {
      this.options.excludeAdBlock || a.addPreprocessedComponent({ key: "adblock", value: this.getAdBlock() });return a;
    }, hasLiedLanguagesKey: function hasLiedLanguagesKey(a) {
      this.options.excludeHasLiedLanguages || a.addPreprocessedComponent({ key: "has_lied_languages", value: this.getHasLiedLanguages() });return a;
    }, hasLiedResolutionKey: function hasLiedResolutionKey(a) {
      this.options.excludeHasLiedResolution || a.addPreprocessedComponent({ key: "has_lied_resolution", value: this.getHasLiedResolution() });return a;
    }, hasLiedOsKey: function hasLiedOsKey(a) {
      this.options.excludeHasLiedOs || a.addPreprocessedComponent({ key: "has_lied_os", value: this.getHasLiedOs() });return a;
    }, hasLiedBrowserKey: function hasLiedBrowserKey(a) {
      this.options.excludeHasLiedBrowser || a.addPreprocessedComponent({ key: "has_lied_browser", value: this.getHasLiedBrowser() });return a;
    }, fontsKey: function fontsKey(a, c) {
      return this.options.excludeJsFonts ? this.flashFontsKey(a, c) : this.jsFontsKey(a, c);
    }, flashFontsKey: function flashFontsKey(a, c) {
      if (this.options.excludeFlashFonts || !this.hasSwfObjectLoaded() || !this.hasMinFlashInstalled() || "undefined" === typeof this.options.swfPath) {
        return c(a);
      }
      this.loadSwfAndDetectFonts(function (b) {
        a.addPreprocessedComponent({ key: "swf_fonts", value: b.join(";") });c(a);
      });
    }, jsFontsKey: function jsFontsKey(a, c) {
      var b = this;return setTimeout(function () {
        var h = ["monospace", "sans-serif", "serif"],
            d = "Andale Mono;Arial;Arial Black;Arial Hebrew;Arial MT;Arial Narrow;Arial Rounded MT Bold;Arial Unicode MS;Bitstream Vera Sans Mono;Book Antiqua;Bookman Old Style;Calibri;Cambria;Cambria Math;Century;Century Gothic;Century Schoolbook;Comic Sans;Comic Sans MS;Consolas;Courier;Courier New;Geneva;Georgia;Helvetica;Helvetica Neue;Impact;Lucida Bright;Lucida Calligraphy;Lucida Console;Lucida Fax;LUCIDA GRANDE;Lucida Handwriting;Lucida Sans;Lucida Sans Typewriter;Lucida Sans Unicode;Microsoft Sans Serif;Monaco;Monotype Corsiva;MS Gothic;MS Outlook;MS PGothic;MS Reference Sans Serif;MS Sans Serif;MS Serif;MYRIAD;MYRIAD PRO;Palatino;Palatino Linotype;Segoe Print;Segoe Script;Segoe UI;Segoe UI Light;Segoe UI Semibold;Segoe UI Symbol;Tahoma;Times;Times New Roman;Times New Roman PS;Trebuchet MS;Verdana;Wingdings;Wingdings 2;Wingdings 3".split(";"),
            f = [];b.options.extendedJsFonts && (d = d.concat(f));d = d.concat(b.options.userDefinedFonts);d = d.filter(function (a, b) {
          return d.indexOf(a) === b;
        });f = document.getElementsByTagName("body")[0];var e = document.createElement("div"),
            g = document.createElement("div"),
            l = {},
            n = {},
            k = function k() {
          var a = document.createElement("span");a.style.position = "absolute";a.style.left = "-9999px";a.style.fontSize = "72px";a.style.fontStyle = "normal";a.style.fontWeight = "normal";a.style.letterSpacing = "normal";a.style.lineBreak = "auto";a.style.lineHeight = "normal";a.style.textTransform = "none";a.style.textAlign = "left";a.style.textDecoration = "none";a.style.textShadow = "none";a.style.whiteSpace = "normal";a.style.wordBreak = "normal";a.style.wordSpacing = "normal";a.innerHTML = "mmmmmmmmmmlli";return a;
        },
            p = function p(a) {
          for (var b = !1, c = 0; c < h.length && !(b = a[c].offsetWidth !== l[h[c]] || a[c].offsetHeight !== n[h[c]]); c++) {}
          return b;
        },
            q = function () {
          for (var a = [], b = 0, c = h.length; b < c; b++) {
            var d = k();d.style.fontFamily = h[b];e.appendChild(d);a.push(d);
          }
          return a;
        }();f.appendChild(e);for (var m = 0, r = h.length; m < r; m++) {
          l[h[m]] = q[m].offsetWidth, n[h[m]] = q[m].offsetHeight;
        }
        q = function () {
          for (var a = {}, b = 0, c = d.length; b < c; b++) {
            for (var e = [], f = 0, n = h.length; f < n; f++) {
              var l = d[b];var q = h[f],
                  m = k();m.style.fontFamily = "'" + l + "'," + q;l = m;g.appendChild(l);e.push(l);
            }
            a[d[b]] = e;
          }
          return a;
        }();f.appendChild(g);m = [];r = 0;for (var t = d.length; r < t; r++) {
          p(q[d[r]]) && m.push(d[r]);
        }
        f.removeChild(g);f.removeChild(e);a.addPreprocessedComponent({ key: "js_fonts", value: m });c(a);
      }, 1);
    }, pluginsKey: function pluginsKey(a) {
      this.options.excludePlugins || (this.isIE() ? this.options.excludeIEPlugins || a.addPreprocessedComponent({ key: "ie_plugins", value: this.getIEPlugins() }) : a.addPreprocessedComponent({ key: "regular_plugins", value: this.getRegularPlugins() }));return a;
    }, getRegularPlugins: function getRegularPlugins() {
      var a = [];if (navigator.plugins) {
        for (var c = 0, b = navigator.plugins.length; c < b; c++) {
          navigator.plugins[c] && a.push(navigator.plugins[c]);
        }
      }
      this.pluginsShouldBeSorted() && (a = a.sort(function (a, b) {
        return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
      }));return this.map(a, function (a) {
        var b = this.map(a, function (a) {
          return [a.type, a.suffixes].join("~");
        }).join(",");return [a.name, a.description, b].join("::");
      }, this);
    }, getIEPlugins: function getIEPlugins() {
      var a = [];if (Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, "ActiveXObject") || "ActiveXObject" in window) {
        a = this.map("AcroPDF.PDF;Adodb.Stream;AgControl.AgControl;DevalVRXCtrl.DevalVRXCtrl.1;MacromediaFlashPaper.MacromediaFlashPaper;Msxml2.DOMDocument;Msxml2.XMLHTTP;PDF.PdfCtrl;QuickTime.QuickTime;QuickTimeCheckObject.QuickTimeCheck.1;RealPlayer;RealPlayer.RealPlayer(tm) ActiveX Control (32-bit);RealVideo.RealVideo(tm) ActiveX Control (32-bit);Scripting.Dictionary;SWCtl.SWCtl;Shell.UIHelper;ShockwaveFlash.ShockwaveFlash;Skype.Detection;TDCCtl.TDCCtl;WMPlayer.OCX;rmocx.RealPlayer G2 Control;rmocx.RealPlayer G2 Control.1".split(";"), function (a) {
          try {
            return new window.ActiveXObject(a), a;
          } catch (b) {
            return null;
          }
        });
      }
      navigator.plugins && (a = a.concat(this.getRegularPlugins()));return a;
    }, pluginsShouldBeSorted: function pluginsShouldBeSorted() {
      for (var a = !1, c = 0, b = this.options.sortPluginsFor.length; c < b; c++) {
        if (navigator.userAgent.match(this.options.sortPluginsFor[c])) {
          a = !0;break;
        }
      }
      return a;
    }, touchSupportKey: function touchSupportKey(a) {
      this.options.excludeTouchSupport || a.addPreprocessedComponent({ key: "touch_support", value: this.getTouchSupport() });return a;
    }, hardwareConcurrencyKey: function hardwareConcurrencyKey(a) {
      this.options.excludeHardwareConcurrency || a.addPreprocessedComponent({ key: "hardware_concurrency", value: this.getHardwareConcurrency() });return a;
    }, hasSessionStorage: function hasSessionStorage() {
      try {
        return !!window.sessionStorage;
      } catch (a) {
        return !0;
      }
    }, hasLocalStorage: function hasLocalStorage() {
      try {
        return !!window.localStorage;
      } catch (a) {
        return !0;
      }
    }, hasIndexedDB: function hasIndexedDB() {
      try {
        return !!window.indexedDB;
      } catch (a) {
        return !0;
      }
    }, getHardwareConcurrency: function getHardwareConcurrency() {
      return navigator.hardwareConcurrency ? navigator.hardwareConcurrency : "unknown";
    }, getNavigatorCpuClass: function getNavigatorCpuClass() {
      return navigator.cpuClass ? navigator.cpuClass : "unknown";
    }, getNavigatorPlatform: function getNavigatorPlatform() {
      return navigator.platform ? navigator.platform : "unknown";
    }, getDoNotTrack: function getDoNotTrack() {
      return navigator.doNotTrack ? navigator.doNotTrack : navigator.msDoNotTrack ? navigator.msDoNotTrack : window.doNotTrack ? window.doNotTrack : "unknown";
    }, getTouchSupport: function getTouchSupport() {
      var a = 0,
          c = !1;"undefined" !== typeof navigator.maxTouchPoints ? a = navigator.maxTouchPoints : "undefined" !== typeof navigator.msMaxTouchPoints && (a = navigator.msMaxTouchPoints);try {
        document.createEvent("TouchEvent"), c = !0;
      } catch (b) {}
      return [a, c, "ontouchstart" in window];
    }, getCanvasFp: function getCanvasFp() {
      var a = [],
          c = document.createElement("canvas");c.width = 2000;c.height = 200;c.style.display = "inline";var b = c.getContext("2d");b.rect(0, 0, 10, 10);b.rect(2, 2, 6, 6);a.push("canvas winding:" + (!1 === b.isPointInPath(5, 5, "evenodd") ? "yes" : "no"));b.textBaseline = "alphabetic";b.fillStyle = "#f60";b.fillRect(125, 1, 62, 20);b.fillStyle = "#069";b.font = this.options.dontUseFakeFontInCanvas ? "11pt Arial" : "11pt no-real-font-123";b.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 2, 15);b.fillStyle = "rgba(102, 204, 0, 0.2)";b.font = "18pt Arial";b.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 4, 45);b.globalCompositeOperation = "multiply";b.fillStyle = "rgb(255,0,255)";b.beginPath();b.arc(50, 50, 50, 0, 2 * Math.PI, !0);b.closePath();b.fill();b.fillStyle = "rgb(0,255,255)";b.beginPath();b.arc(100, 50, 50, 0, 2 * Math.PI, !0);b.closePath();b.fill();b.fillStyle = "rgb(255,255,0)";b.beginPath();b.arc(75, 100, 50, 0, 2 * Math.PI, !0);b.closePath();b.fill();b.fillStyle = "rgb(255,0,255)";b.arc(75, 75, 75, 0, 2 * Math.PI, !0);b.arc(75, 75, 25, 0, 2 * Math.PI, !0);b.fill("evenodd");c.toDataURL && a.push("canvas fp:" + c.toDataURL());return a.join("~");
    }, getWebglFp: function getWebglFp() {
      var a = function a(_a) {
        c.clearColor(0.0, 0.0, 0.0, 1.0);c.enable(c.DEPTH_TEST);c.depthFunc(c.LEQUAL);c.clear(c.COLOR_BUFFER_BIT | c.DEPTH_BUFFER_BIT);return "[" + _a[0] + ", " + _a[1] + "]";
      };var c = this.getWebglCanvas();if (!c) {
        return null;
      }
      var b = [],
          h = c.createBuffer();c.bindBuffer(c.ARRAY_BUFFER, h);var d = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0]);c.bufferData(c.ARRAY_BUFFER, d, c.STATIC_DRAW);h.itemSize = 3;h.numItems = 3;d = c.createProgram();var f = c.createShader(c.VERTEX_SHADER);c.shaderSource(f, "attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}");c.compileShader(f);var e = c.createShader(c.FRAGMENT_SHADER);c.shaderSource(e, "precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}");c.compileShader(e);c.attachShader(d, f);c.attachShader(d, e);c.linkProgram(d);c.useProgram(d);d.vertexPosAttrib = c.getAttribLocation(d, "attrVertex");d.offsetUniform = c.getUniformLocation(d, "uniformOffset");c.enableVertexAttribArray(d.vertexPosArray);c.vertexAttribPointer(d.vertexPosAttrib, h.itemSize, c.FLOAT, !1, 0, 0);c.uniform2f(d.offsetUniform, 1, 1);c.drawArrays(c.TRIANGLE_STRIP, 0, h.numItems);try {
        b.push(c.canvas.toDataURL());
      } catch (n) {}
      b.push("extensions:" + (c.getSupportedExtensions() || []).join(";"));b.push("webgl aliased line width range:" + a(c.getParameter(c.ALIASED_LINE_WIDTH_RANGE)));b.push("webgl aliased point size range:" + a(c.getParameter(c.ALIASED_POINT_SIZE_RANGE)));b.push("webgl alpha bits:" + c.getParameter(c.ALPHA_BITS));b.push("webgl antialiasing:" + (c.getContextAttributes().antialias ? "yes" : "no"));b.push("webgl blue bits:" + c.getParameter(c.BLUE_BITS));b.push("webgl depth bits:" + c.getParameter(c.DEPTH_BITS));b.push("webgl green bits:" + c.getParameter(c.GREEN_BITS));b.push("webgl max anisotropy:" + function (a) {
        var b = a.getExtension("EXT_texture_filter_anisotropic") || a.getExtension("WEBKIT_EXT_texture_filter_anisotropic") || a.getExtension("MOZ_EXT_texture_filter_anisotropic");return b ? (a = a.getParameter(b.MAX_TEXTURE_MAX_ANISOTROPY_EXT), 0 === a && (a = 2), a) : null;
      }(c));b.push("webgl max combined texture image units:" + c.getParameter(c.MAX_COMBINED_TEXTURE_IMAGE_UNITS));b.push("webgl max cube map texture size:" + c.getParameter(c.MAX_CUBE_MAP_TEXTURE_SIZE));b.push("webgl max fragment uniform vectors:" + c.getParameter(c.MAX_FRAGMENT_UNIFORM_VECTORS));b.push("webgl max render buffer size:" + c.getParameter(c.MAX_RENDERBUFFER_SIZE));b.push("webgl max texture image units:" + c.getParameter(c.MAX_TEXTURE_IMAGE_UNITS));b.push("webgl max texture size:" + c.getParameter(c.MAX_TEXTURE_SIZE));b.push("webgl max varying vectors:" + c.getParameter(c.MAX_VARYING_VECTORS));b.push("webgl max vertex attribs:" + c.getParameter(c.MAX_VERTEX_ATTRIBS));b.push("webgl max vertex texture image units:" + c.getParameter(c.MAX_VERTEX_TEXTURE_IMAGE_UNITS));b.push("webgl max vertex uniform vectors:" + c.getParameter(c.MAX_VERTEX_UNIFORM_VECTORS));b.push("webgl max viewport dims:" + a(c.getParameter(c.MAX_VIEWPORT_DIMS)));b.push("webgl red bits:" + c.getParameter(c.RED_BITS));b.push("webgl renderer:" + c.getParameter(c.RENDERER));b.push("webgl shading language version:" + c.getParameter(c.SHADING_LANGUAGE_VERSION));b.push("webgl stencil bits:" + c.getParameter(c.STENCIL_BITS));b.push("webgl vendor:" + c.getParameter(c.VENDOR));b.push("webgl version:" + c.getParameter(c.VERSION));try {
        var g = c.getExtension("WEBGL_debug_renderer_info");g && (b.push("webgl unmasked vendor:" + c.getParameter(g.UNMASKED_VENDOR_WEBGL)), b.push("webgl unmasked renderer:" + c.getParameter(g.UNMASKED_RENDERER_WEBGL)));
      } catch (n) {}
      if (!c.getShaderPrecisionFormat) {
        return b.join("~");
      }
      var l = this;l.each(["FLOAT", "INT"], function (a) {
        l.each(["VERTEX", "FRAGMENT"], function (d) {
          l.each(["HIGH", "MEDIUM", "LOW"], function (e) {
            l.each(["precision", "rangeMin", "rangeMax"], function (f) {
              var g = c.getShaderPrecisionFormat(c[d + "_SHADER"], c[e + "_" + a])[f];"precision" !== f && (f = "precision " + f);f = ["webgl ", d.toLowerCase(), " shader ", e.toLowerCase(), " ", a.toLowerCase(), " ", f, ":", g];b.push(f.join(""));
            });
          });
        });
      });return b.join("~");
    }, getWebglVendorAndRenderer: function getWebglVendorAndRenderer() {
      try {
        var a = this.getWebglCanvas(),
            c = a.getExtension("WEBGL_debug_renderer_info");return a.getParameter(c.UNMASKED_VENDOR_WEBGL) + "~" + a.getParameter(c.UNMASKED_RENDERER_WEBGL);
      } catch (b) {
        return null;
      }
    }, getAdBlock: function getAdBlock() {
      var a = document.createElement("div");a.innerHTML = "&nbsp;";a.className = "adsbox";var c = !1;try {
        document.body.appendChild(a), c = 0 === document.getElementsByClassName("adsbox")[0].offsetHeight, document.body.removeChild(a);
      } catch (b) {
        c = !1;
      }
      return c;
    }, getHasLiedLanguages: function getHasLiedLanguages() {
      if ("undefined" !== typeof navigator.languages) {
        try {
          if (navigator.languages[0].substr(0, 2) !== navigator.language.substr(0, 2)) {
            return !0;
          }
        } catch (a) {
          return !0;
        }
      }
      return !1;
    }, getHasLiedResolution: function getHasLiedResolution() {
      return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight ? !0 : !1;
    }, getHasLiedOs: function getHasLiedOs() {
      var a = navigator.userAgent.toLowerCase(),
          c = navigator.oscpu,
          b = navigator.platform.toLowerCase();a = 0 <= a.indexOf("windows phone") ? "Windows Phone" : 0 <= a.indexOf("win") ? "Windows" : 0 <= a.indexOf("android") ? "Android" : 0 <= a.indexOf("linux") ? "Linux" : 0 <= a.indexOf("iphone") || 0 <= a.indexOf("ipad") ? "iOS" : 0 <= a.indexOf("mac") ? "Mac" : "Other";return ("ontouchstart" in window || 0 < navigator.maxTouchPoints || 0 < navigator.msMaxTouchPoints) && "Windows Phone" !== a && "Android" !== a && "iOS" !== a && "Other" !== a || "undefined" !== typeof c && (c = c.toLowerCase(), 0 <= c.indexOf("win") && "Windows" !== a && "Windows Phone" !== a || 0 <= c.indexOf("linux") && "Linux" !== a && "Android" !== a || 0 <= c.indexOf("mac") && "Mac" !== a && "iOS" !== a || (-1 === c.indexOf("win") && -1 === c.indexOf("linux") && -1 === c.indexOf("mac")) !== ("Other" === a)) ? !0 : 0 <= b.indexOf("win") && "Windows" !== a && "Windows Phone" !== a || (0 <= b.indexOf("linux") || 0 <= b.indexOf("android") || 0 <= b.indexOf("pike")) && "Linux" !== a && "Android" !== a || (0 <= b.indexOf("mac") || 0 <= b.indexOf("ipad") || 0 <= b.indexOf("ipod") || 0 <= b.indexOf("iphone")) && "Mac" !== a && "iOS" !== a || (-1 === b.indexOf("win") && -1 === b.indexOf("linux") && -1 === b.indexOf("mac")) !== ("Other" === a) ? !0 : "undefined" === typeof navigator.plugins && "Windows" !== a && "Windows Phone" !== a ? !0 : !1;
    }, getHasLiedBrowser: function getHasLiedBrowser() {
      var a = navigator.userAgent.toLowerCase(),
          c = navigator.productSub;a = 0 <= a.indexOf("firefox") ? "Firefox" : 0 <= a.indexOf("opera") || 0 <= a.indexOf("opr") ? "Opera" : 0 <= a.indexOf("chrome") ? "Chrome" : 0 <= a.indexOf("safari") ? "Safari" : 0 <= a.indexOf("trident") ? "Internet Explorer" : "Other";if (("Chrome" === a || "Safari" === a || "Opera" === a) && "20030107" !== c) {
        return !0;
      }
      c = eval.toString().length;if (37 === c && "Safari" !== a && "Firefox" !== a && "Other" !== a || 39 === c && "Internet Explorer" !== a && "Other" !== a || 33 === c && "Chrome" !== a && "Opera" !== a && "Other" !== a) {
        return !0;
      }
      try {
        throw "a";
      } catch (h) {
        try {
          h.toSource();var b = !0;
        } catch (d) {
          b = !1;
        }
      }
      return b && "Firefox" !== a && "Other" !== a ? !0 : !1;
    }, isCanvasSupported: function isCanvasSupported() {
      var a = document.createElement("canvas");return !(!a.getContext || !a.getContext("2d"));
    }, isWebGlSupported: function isWebGlSupported() {
      if (!this.isCanvasSupported()) {
        return !1;
      }
      var a = this.getWebglCanvas();return !!window.WebGLRenderingContext && !!a;
    }, isIE: function isIE() {
      return "Microsoft Internet Explorer" === navigator.appName || "Netscape" === navigator.appName && /Trident/.test(navigator.userAgent) ? !0 : !1;
    }, hasSwfObjectLoaded: function hasSwfObjectLoaded() {
      return "undefined" !== typeof window.swfobject;
    }, hasMinFlashInstalled: function hasMinFlashInstalled() {
      return window.swfobject.hasFlashPlayerVersion("9.0.0");
    }, addFlashDivNode: function addFlashDivNode() {
      var a = document.createElement("div");a.setAttribute("id", this.options.swfContainerId);document.body.appendChild(a);
    }, loadSwfAndDetectFonts: function loadSwfAndDetectFonts(a) {
      window.___fp_swf_loaded = function (b) {
        a(b);
      };var c = this.options.swfContainerId;this.addFlashDivNode();window.swfobject.embedSWF(this.options.swfPath, c, "1", "1", "9.0.0", !1, { onReady: "___fp_swf_loaded" }, { allowScriptAccess: "always", menu: "false" }, {});
    }, getWebglCanvas: function getWebglCanvas() {
      var a = document.createElement("canvas"),
          c = null;try {
        c = a.getContext("webgl") || a.getContext("experimental-webgl");
      } catch (b) {}
      c || (c = null);return c;
    }, each: function each(a, c, b) {
      if (null !== a) {
        if (this.nativeForEach && a.forEach === this.nativeForEach) {
          a.forEach(c, b);
        } else {
          if (a.length === +a.length) {
            for (var h = 0, d = a.length; h < d && c.call(b, a[h], h, a) !== {}; h++) {}
          } else {
            for (h in a) {
              if (a.hasOwnProperty(h) && c.call(b, a[h], h, a) === {}) {
                break;
              }
            }
          }
        }
      }
    }, map: function map(a, c, b) {
      var h = [];if (null == a) {
        return h;
      }
      if (this.nativeMap && a.map === this.nativeMap) {
        return a.map(c, b);
      }
      this.each(a, function (a, f, e) {
        h[h.length] = c.call(b, a, f, e);
      });return h;
    }, x64Add: function x64Add(a, c) {
      a = [a[0] >>> 16, a[0] & 65535, a[1] >>> 16, a[1] & 65535];c = [c[0] >>> 16, c[0] & 65535, c[1] >>> 16, c[1] & 65535];var b = [0, 0, 0, 0];b[3] += a[3] + c[3];b[2] += b[3] >>> 16;b[3] &= 65535;b[2] += a[2] + c[2];b[1] += b[2] >>> 16;b[2] &= 65535;b[1] += a[1] + c[1];b[0] += b[1] >>> 16;b[1] &= 65535;b[0] += a[0] + c[0];b[0] &= 65535;return [b[0] << 16 | b[1], b[2] << 16 | b[3]];
    }, x64Multiply: function x64Multiply(a, c) {
      a = [a[0] >>> 16, a[0] & 65535, a[1] >>> 16, a[1] & 65535];c = [c[0] >>> 16, c[0] & 65535, c[1] >>> 16, c[1] & 65535];var b = [0, 0, 0, 0];b[3] += a[3] * c[3];b[2] += b[3] >>> 16;b[3] &= 65535;b[2] += a[2] * c[3];b[1] += b[2] >>> 16;b[2] &= 65535;b[2] += a[3] * c[2];b[1] += b[2] >>> 16;b[2] &= 65535;b[1] += a[1] * c[3];b[0] += b[1] >>> 16;b[1] &= 65535;b[1] += a[2] * c[2];b[0] += b[1] >>> 16;b[1] &= 65535;b[1] += a[3] * c[1];b[0] += b[1] >>> 16;b[1] &= 65535;b[0] += a[0] * c[3] + a[1] * c[2] + a[2] * c[1] + a[3] * c[0];b[0] &= 65535;return [b[0] << 16 | b[1], b[2] << 16 | b[3]];
    }, x64Rotl: function x64Rotl(a, c) {
      c %= 64;if (32 === c) {
        return [a[1], a[0]];
      }
      if (32 > c) {
        return [a[0] << c | a[1] >>> 32 - c, a[1] << c | a[0] >>> 32 - c];
      }
      c -= 32;return [a[1] << c | a[0] >>> 32 - c, a[0] << c | a[1] >>> 32 - c];
    }, x64LeftShift: function x64LeftShift(a, c) {
      c %= 64;return 0 === c ? a : 32 > c ? [a[0] << c | a[1] >>> 32 - c, a[1] << c] : [a[1] << c - 32, 0];
    }, x64Xor: function x64Xor(a, c) {
      return [a[0] ^ c[0], a[1] ^ c[1]];
    }, x64Fmix: function x64Fmix(a) {
      a = this.x64Xor(a, [0, a[0] >>> 1]);a = this.x64Multiply(a, [4283543511, 3981806797]);a = this.x64Xor(a, [0, a[0] >>> 1]);a = this.x64Multiply(a, [3301882366, 444984403]);return a = this.x64Xor(a, [0, a[0] >>> 1]);
    }, x64hash128: function x64hash128(a, c) {
      a = a || "";c = c || 0;for (var b = a.length % 16, h = a.length - b, d = [0, c], f = [0, c], e, g, l = [2277735313, 289559509], n = [1291169091, 658871167], k = 0; k < h; k += 16) {
        e = [a.charCodeAt(k + 4) & 255 | (a.charCodeAt(k + 5) & 255) << 8 | (a.charCodeAt(k + 6) & 255) << 16 | (a.charCodeAt(k + 7) & 255) << 24, a.charCodeAt(k) & 255 | (a.charCodeAt(k + 1) & 255) << 8 | (a.charCodeAt(k + 2) & 255) << 16 | (a.charCodeAt(k + 3) & 255) << 24], g = [a.charCodeAt(k + 12) & 255 | (a.charCodeAt(k + 13) & 255) << 8 | (a.charCodeAt(k + 14) & 255) << 16 | (a.charCodeAt(k + 15) & 255) << 24, a.charCodeAt(k + 8) & 255 | (a.charCodeAt(k + 9) & 255) << 8 | (a.charCodeAt(k + 10) & 255) << 16 | (a.charCodeAt(k + 11) & 255) << 24], e = this.x64Multiply(e, l), e = this.x64Rotl(e, 31), e = this.x64Multiply(e, n), d = this.x64Xor(d, e), d = this.x64Rotl(d, 27), d = this.x64Add(d, f), d = this.x64Add(this.x64Multiply(d, [0, 5]), [0, 1390208809]), g = this.x64Multiply(g, n), g = this.x64Rotl(g, 33), g = this.x64Multiply(g, l), f = this.x64Xor(f, g), f = this.x64Rotl(f, 31), f = this.x64Add(f, d), f = this.x64Add(this.x64Multiply(f, [0, 5]), [0, 944331445]);
      }
      e = [0, 0];g = [0, 0];switch (b) {case 15:
          g = this.x64Xor(g, this.x64LeftShift([0, a.charCodeAt(k + 14)], 48));case 14:
          g = this.x64Xor(g, this.x64LeftShift([0, a.charCodeAt(k + 13)], 40));case 13:
          g = this.x64Xor(g, this.x64LeftShift([0, a.charCodeAt(k + 12)], 32));case 12:
          g = this.x64Xor(g, this.x64LeftShift([0, a.charCodeAt(k + 11)], 24));case 11:
          g = this.x64Xor(g, this.x64LeftShift([0, a.charCodeAt(k + 10)], 16));case 10:
          g = this.x64Xor(g, this.x64LeftShift([0, a.charCodeAt(k + 9)], 8));case 9:
          g = this.x64Xor(g, [0, a.charCodeAt(k + 8)]), g = this.x64Multiply(g, n), g = this.x64Rotl(g, 33), g = this.x64Multiply(g, l), f = this.x64Xor(f, g);case 8:
          e = this.x64Xor(e, this.x64LeftShift([0, a.charCodeAt(k + 7)], 56));case 7:
          e = this.x64Xor(e, this.x64LeftShift([0, a.charCodeAt(k + 6)], 48));case 6:
          e = this.x64Xor(e, this.x64LeftShift([0, a.charCodeAt(k + 5)], 40));case 5:
          e = this.x64Xor(e, this.x64LeftShift([0, a.charCodeAt(k + 4)], 32));case 4:
          e = this.x64Xor(e, this.x64LeftShift([0, a.charCodeAt(k + 3)], 24));case 3:
          e = this.x64Xor(e, this.x64LeftShift([0, a.charCodeAt(k + 2)], 16));case 2:
          e = this.x64Xor(e, this.x64LeftShift([0, a.charCodeAt(k + 1)], 8));case 1:
          e = this.x64Xor(e, [0, a.charCodeAt(k)]), e = this.x64Multiply(e, l), e = this.x64Rotl(e, 31), e = this.x64Multiply(e, n), d = this.x64Xor(d, e);}
      d = this.x64Xor(d, [0, a.length]);f = this.x64Xor(f, [0, a.length]);d = this.x64Add(d, f);f = this.x64Add(f, d);d = this.x64Fmix(d);f = this.x64Fmix(f);d = this.x64Add(d, f);f = this.x64Add(f, d);return ("00000000" + (d[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (d[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (f[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (f[1] >>> 0).toString(16)).slice(-8);
    } };p.VERSION = "1.8.0";return p;
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b26f504_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(270);
function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b26f504_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(258);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7f756d36", content, true, {});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".home__donate h2{color:#fff}", ""]);

// exports


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectValue_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4f5ab4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectValue_vue__ = __webpack_require__(260);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectValue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4f5ab4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectValue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.validateForm.apply(null, arguments)}}},[_c('fieldset',{staticClass:"of-radios-and-checks"},[_c('h4',[_vm._v("Escolha o valor")]),_vm._v(" "),_vm._l((_vm.pledges),function(pledge){return _c('div',{key:pledge,staticClass:"input-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],attrs:{"id":("amount_" + pledge),"type":"radio","name":"amount"},domProps:{"value":pledge,"checked":_vm._q(_vm.amount,pledge)},on:{"change":[function($event){_vm.amount=pledge},_vm.validateForm]}}),_vm._v(" "),_c('label',{staticClass:"bigger",attrs:{"for":("amount_" + pledge)}},[_vm._v("R$ "+_vm._s(_vm._f("formatBRL")(pledge)))])])}),_vm._v(" "),_c('div',{staticClass:"input-wrapper input-wrapper--full-width",attrs:{"id":"outro-valor"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amount),expression:"amount"}],attrs:{"id":"amount_other","type":"radio","name":"amount","value":"other"},domProps:{"checked":_vm._q(_vm.amount,"other")},on:{"change":function($event){_vm.amount="other"}}}),_vm._v(" "),_c('label',{attrs:{"for":"amount_other"}},[_vm._v("outro valor")])]),_vm._v(" "),(_vm.amount === 'other')?_c('div',{staticClass:"input-wrapper has-real-value"},[_c('label',{attrs:{"for":"other"}},[_vm._v("R$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.other),expression:"other"},{name:"mask",rawName:"v-mask",value:('########'),expression:"'########'"}],ref:"otherAmountField",attrs:{"type":"tel","name":"other","pattern":"[0-9]*","disabled":_vm.amount === 'other' ? false : true},domProps:{"value":(_vm.other)},on:{"input":function($event){if($event.target.composing){ return; }_vm.other=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"real-value"},[_vm._v(_vm._s(_vm.formatedOther))]),_vm._v(" "),_c('button',{attrs:{"type":"button","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.validateForm.apply(null, arguments)}}},[_vm._v("\n          OK\n        ")])]):_vm._e()],2),_vm._v(" "),_c('fieldset',{staticClass:"checkbox-custom"},[_c('div',{staticClass:"input-wrapper"},[_c('label',{attrs:{"for":"maxdonation"}},[_c('p',[_vm._v("\n            Declaro que minhas doações não ultrapassam 10% dos meus rendimentos brutos do ano anterior, a origem do dinheiro não é estrangeira, não sou concessionário ou permissionário de serviço público.\n          ")]),_vm._v(" "),_c('p',[_vm._v("Declaro estar ciente, que ao realizar uma doação, por conta da legislação eleitoral, os seus dados (nome completo, CPF, valor individual de cada doação, forma de pagamento, data das doações) serão publicados de forma pública no site do candidato, na aba transparência, e concordo com os "),_c('a',{attrs:{"href":_vm.contract,"target":"_blank"}},[_vm._v("termos de doação")]),_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"btn-accept-terms-of-use donation-nav donation-nav--forward"},[_vm._v("Aceitar e continuar")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxdonation),expression:"maxdonation"}],ref:"maxdonation",attrs:{"id":"maxdonation","type":"checkbox","name":"maxdonation"},domProps:{"checked":Array.isArray(_vm.maxdonation)?_vm._i(_vm.maxdonation,null)>-1:(_vm.maxdonation)},on:{"change":[function($event){var $$a=_vm.maxdonation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.maxdonation=$$a.concat([$$v]))}else{$$i>-1&&(_vm.maxdonation=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.maxdonation=$$c}},_vm.checkAmount]}})])]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorMessage),expression:"errorMessage"}],ref:"errorMessageEl",staticClass:"error",attrs:{"tabindex":"-1"}},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('form',{attrs:{"aria-busy":_vm.loading ? 'true' : 'false',"data-busy-message":_vm.dataBusyMessage},on:{"submit":function($event){$event.preventDefault();return _vm.validateForm.apply(null, arguments)}}},[(!_vm.isTicket)?[_c('div',{staticClass:"candidate-amount-select"},[(_vm.amount)?_c('h3',[_vm._v("\n            Valor escolhido: "),_c('strong',[_vm._v("R$ "+_vm._s(_vm._f("formatBRL")(_vm.amount))+",00")])]):_vm._e()]),_vm._v(" "),(_vm.allowedPaymentMethods.length > 1)?_c('h4',[_vm._v("\n          Escolha forma de pagamento\n        ")]):_vm._e(),_vm._v(" "),_c('div',{class:("input-wrapper half\n          " + (_vm.validation.errors.payment_method ? 'has-error' : ''))},[_c('ul',{staticClass:"payment-choices"},[(_vm.isPaymentMethodAllowed('credit_card'))?_c('li',{staticClass:"payment-type"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_method),expression:"payment_method"},{name:"focus",rawName:"v-focus"}],attrs:{"id":"credit_card","name":"payment_method","value":"credit_card","type":"radio"},domProps:{"checked":_vm._q(_vm.payment_method,"credit_card")},on:{"change":function($event){_vm.payment_method="credit_card"}}}),_vm._v(" "),_c('label',{attrs:{"for":"credit_card"}},[_vm._v(_vm._s(_vm._f("translate")('creditCard')))])]):_vm._e(),_vm._v(" "),(_vm.isPaymentMethodAllowed('boleto'))?_c('li',{staticClass:"payment-type"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment_method),expression:"payment_method"}],attrs:{"id":"boleto","name":"payment_method","value":"boleto","type":"radio"},domProps:{"checked":_vm._q(_vm.payment_method,"boleto")},on:{"change":function($event){_vm.payment_method="boleto"}}}),_vm._v(" "),_c('label',{attrs:{"for":"boleto"}},[_vm._v(_vm._s(_vm._f("translate")('boleto')))])]):_vm._e()])])]:_vm._e(),_vm._v(" "),_c('fieldset',[_c('h4',[_vm._v("Informe seus dados pessoais")]),_vm._v(" "),_c('div',{class:("input-wrapper half\n\t\t\t\t\t" + (_vm.validation.errors.name ? 'has-error' : ''))},[_c('label',{attrs:{"for":"name"}},[_vm._v("Primeiro nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"focus",rawName:"v-focus",value:(_vm.isTicket),expression:"isTicket"}],attrs:{"type":"text","name":"name","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.name)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.name)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper half\n\t\t\t\t\t" + (_vm.validation.errors.surname ? 'has-error' : ''))},[_c('label',{attrs:{"for":"surname"}},[_vm._v("Sobrenome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.surname),expression:"surname"}],attrs:{"type":"text","name":"surname","required":""},domProps:{"value":(_vm.surname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.surname=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.surname)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.surname)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.cpf ? 'has-error' : ''))},[_c('label',{attrs:{"for":"cpf"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cpf),expression:"cpf"},{name:"mask",rawName:"v-mask",value:('###.###.###-##'),expression:"'###.###.###-##'"}],attrs:{"type":"tel","name":"cpf","required":""},domProps:{"value":(_vm.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cpf=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.cpf)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.cpf)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.email ? 'has-error' : ''))},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"email","name":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.email)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.email)+"\n          ")]):_vm._e()])]),_vm._v(" "),(!_vm.isTicket)?[(_vm.candidateAmount)?_c('div',{staticClass:"candidate-amount"},[_c('p',[_vm._v(_vm._s(_vm._f("translate")('donationValue'))+" "+_vm._s(_vm._f("translate")('currencyReal'))+_vm._s(_vm._f("formatBRLDec")(_vm.candidateAmount)))])]):_vm._e(),_vm._v(" "),(_vm.payment_method === 'credit_card')?_c('div',[_c('p',{staticClass:"form__disclaimer"},[_vm._v("\n            Taxa de "+_vm._s(_vm.creditCard)+" via cartão de crédito. Esse valor é destinado a taxas de operação financeira, sistemas de controle anti-fraude, impostos e infraestrutura.\n          ")])]):_vm._e(),_vm._v(" "),(_vm.payment_method === 'boleto')?_c('div',[_c('p',{staticClass:"form__disclaimer"},[_vm._v("\n            Taxa de "+_vm._s(_vm.paymentSlip)+" via boleto. Esse valor é destinado a taxas de operação financeira, sistemas de controle anti-fraude, impostos e infraestrutura.\n          ")])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.errorMessage != '')?_c('p',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.validation.errors.payment_method)?_c('div',{staticClass:"error"},[_vm._v("\n        • "+_vm._s(_vm._f("translate")('paymentMethodError'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"donation-nav donation-nav--rewind",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}},[_vm._v("voltar")]),_vm._v(" "),_c('button',{staticClass:"donation-nav donation-nav--forward",attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("\n        Continuar\n      ")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardData_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13de51b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardData_vue__ = __webpack_require__(263);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13de51b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h4',[_vm._v("Obrigado, agora informe os dados de pagamento")]),_vm._v(" "),_c('form',{attrs:{"aria-busy":_vm.loading ? 'true' : 'false',"data-busy-message":_vm.dataBusyMessage},on:{"submit":function($event){$event.preventDefault();return _vm.validateForm.apply(null, arguments)}}},[_c('fieldset',[_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.name ? 'has-error' : ''))},[_c('label',{attrs:{"for":"number"}},[_vm._v("Nome impresso no cartão de crédito")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"focus",rawName:"v-focus"}],attrs:{"type":"text","name":"number","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.name)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.name)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.name ? 'has-error' : ''))},[_c('label',{attrs:{"for":"number"}},[_vm._v("CPF")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cpf),expression:"cpf"},{name:"mask",rawName:"v-mask",value:('###.###.###-##'),expression:"'###.###.###-##'"}],attrs:{"type":"tel","name":"number","required":""},domProps:{"value":(_vm.cpf)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cpf=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.cpf)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.cpf)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.number ? 'has-error' : ''))},[_c('label',{attrs:{"for":"number"}},[_vm._v("Número do cartão de crédito")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"},{name:"mask",rawName:"v-mask",value:('#### #### #### ####'),expression:"'#### #### #### ####'"}],attrs:{"type":"tel","name":"number","required":""},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.number)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.number)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.validity_month ? 'has-error' : ''))},[_c('label',{attrs:{"for":"validity_month"}},[_vm._v("Mês")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.validity_month),expression:"validity_month"},{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"}],attrs:{"type":"tel","name":"validity_month","placeholder":"MM","required":""},domProps:{"value":(_vm.validity_month)},on:{"input":function($event){if($event.target.composing){ return; }_vm.validity_month=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.validity_month)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.validity_month)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.validity_year ? 'has-error' : ''))},[_c('label',{attrs:{"for":"validity_year"}},[_vm._v("Ano")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.validity_year),expression:"validity_year"},{name:"mask",rawName:"v-mask",value:('####'),expression:"'####'"}],attrs:{"type":"tel","name":"validity_year","placeholder":"AAAA","required":""},domProps:{"value":(_vm.validity_year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.validity_year=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.validity_year)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.validity_year)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{class:("input-wrapper\n\t\t\t\t\t" + (_vm.validation.errors.csc ? 'has-error' : ''))},[_c('label',{attrs:{"for":"csc"}},[_vm._v("Cód. Segurança")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.csc),expression:"csc"}],attrs:{"type":"tel","name":"csc","maxlength":"4","required":""},domProps:{"value":(_vm.csc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.csc=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.csc)?_c('div',{staticClass:"error"},[_vm._v("\n            "+_vm._s(_vm.validation.errors.csc)+"\n          ")]):_vm._e()])]),_vm._v(" "),(_vm.errorMessage != '')?_c('p',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"form__disclaimer"},[_vm._v("\n        Será enviado um recibo em seu e-mail com todos os dados sobre a doação.\n      ")]),_vm._v(" "),_c('p',{staticClass:"form__disclaimer"},[_vm._v("\n        Não armazenamos seus dados de cartão de crédito.\n      ")]),_vm._v(" "),_c('a',{staticClass:"donation-nav donation-nav--rewind",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}},[_vm._v("voltar")]),_vm._v(" "),_c('button',{staticClass:"donation-nav donation-nav--forward bigger",attrs:{"type":"submit","disabled":_vm.loading}},[_vm._v("\n        doar!\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"final-message"},[_vm._l((_vm.messages),function(message,index){return (message.type == 'msg')?_c('div',{key:index,staticClass:"input-wrapper",domProps:{"innerHTML":_vm._s(message.text)}}):_vm._e()}),_vm._v(" "),_vm._l((_vm.messages),function(message,index){return (message.type == 'link')?_c('div',{key:index,staticClass:"input-wrapper"},[_c('a',{staticClass:"donation-nav donation-nav--block",attrs:{"target":"_blank","href":message.href}},[_vm._v(_vm._s(message.text)+" ")])]):_vm._e()}),_vm._v(" "),_c('ul',{staticClass:"wrap-share-buttons"},[_c('li',[_c('a',{staticClass:"twitter",attrs:{"target":"_blank","href":'https://twitter.com/intent/tweet?hashtags=VotoLegal&twitter&text=Eu%20apoiei%20'+ _vm.candidate.popular_name +',%20apoie%20você%20também!%20https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ _vm.candidate.username +''}})]),_vm._v(" "),_c('li',[_c('a',{staticClass:"fb-xfbml-parse-ignore facebook",attrs:{"target":"_blank","href":'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ _vm.candidate.username +'&src=sdkpreparse'}})])]),_vm._v(" "),_c('a',{staticClass:"donation-nav donation-nav--rewind",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}},[_vm._v("deseja doar novamente?")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"aria-busy":_vm.loading ? 'true' : 'false',"data-busy-message":_vm.dataBusyMessage},on:{"submit":function($event){$event.preventDefault();return _vm.validateForm.apply(null, arguments)}}},[_c('fieldset',[_c('div',{staticClass:"input-wrapper",class:{'has-error': _vm.validation.errors.birthdate}},[_c('label',{attrs:{"for":"birthdate"}},[_vm._v(_vm._s(_vm._f("translate")('birthdate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.birthdate),expression:"birthdate"},{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"},{name:"focus",rawName:"v-focus"}],attrs:{"type":"tel","name":"birthdate","required":""},domProps:{"value":(_vm.birthdate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.birthdate=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.birthdate)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.birthdate)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{ 'has-error' : _vm.validation.errors.phone }},[_c('label',{attrs:{"for":"phone"}},[_vm._v(_vm._s(_vm._f("translate")('phone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"},{name:"mask",rawName:"v-mask",value:(['(##) ####-####', '(##) #####-####']),expression:"['(##) ####-####', '(##) #####-####']"}],attrs:{"type":"tel","name":"phone","placeholder":"(00) 00000-0000","minlength":"14","required":_vm.paymentData.payment_method !== 'credit_card'},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.phone)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.phone)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{'has-error' : _vm.validation.errors.zip_code }},[_c('label',{attrs:{"for":"zip_code"}},[_vm._v(_vm._s(_vm._f("translate")('cep')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zip_code),expression:"zip_code"},{name:"mask",rawName:"v-mask",value:('#####-###'),expression:"'#####-###'"}],ref:"zipCode",attrs:{"type":"tel","name":"zipcode","minlength":"9","required":""},domProps:{"value":(_vm.zip_code)},on:{"change":function($event){return _vm.searchAddress($event)},"input":function($event){if($event.target.composing){ return; }_vm.zip_code=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.zip_code)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.zip_code)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{'has-error' : _vm.validation.errors.street }},[_c('label',{attrs:{"for":"street"}},[_vm._v(_vm._s(_vm._f("translate")('street')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.street),expression:"street"}],ref:"street",attrs:{"type":"text","name":"street","disabled":true,"required":""},domProps:{"value":(_vm.street)},on:{"input":function($event){if($event.target.composing){ return; }_vm.street=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.street)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.street)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{'has-error' : _vm.validation.errors.number }},[_c('label',{attrs:{"for":"number"}},[_vm._v(_vm._s(_vm._f("translate")('number')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],attrs:{"type":"number","name":"number","placeholder":"apenas números ou deixar vazio","required":!_vm.isTicket},domProps:{"value":(_vm.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.number=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.number)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.number)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{'has-error' : _vm.validation.errors.complement }},[_c('label',{attrs:{"for":"complement"}},[_vm._v(_vm._s(_vm._f("translate")('complement')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.complement),expression:"complement"}],attrs:{"type":"text","name":"complement","placeholder":"Casa Fundos, apto. 1234","autocomplete":"nope"},domProps:{"value":(_vm.complement)},on:{"input":function($event){if($event.target.composing){ return; }_vm.complement=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.complement)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.complement)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{'has-error' : _vm.validation.errors.district }},[_c('label',{attrs:{"for":"district"}},[_vm._v(_vm._s(_vm._f("translate")('district')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.district),expression:"district"}],ref:"district",attrs:{"type":"text","name":"district","disabled":true,"required":""},domProps:{"value":(_vm.district)},on:{"input":function($event){if($event.target.composing){ return; }_vm.district=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.district)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.district)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{'has-error' : _vm.validation.errors.city }},[_c('label',{attrs:{"for":"city"}},[_vm._v(_vm._s(_vm._f("translate")('city')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.city),expression:"city"}],ref:"city",attrs:{"type":"text","name":"city","disabled":true,"required":""},domProps:{"value":(_vm.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.city=$event.target.value}}}),_vm._v(" "),(_vm.validation.errors.city)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.city)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-wrapper",class:{'has-error' : _vm.validation.errors.state }},[_c('label',{attrs:{"for":"state"}},[_vm._v("Estado")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.state),expression:"state"}],ref:"state",attrs:{"type":"text","name":"state","disabled":true,"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.state=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("\n          Selecionar\n        ")]),_vm._v(" "),_vm._l((_vm.states),function(state,key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v("\n          "+_vm._s(state)+"\n        ")])})],2),_vm._v(" "),(_vm.validation.errors.state)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.validation.errors.state)+"\n      ")]):_vm._e()])]),_vm._v(" "),(_vm.errorMessage)?_c('p',{staticClass:"error"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"donation-nav donation-nav--rewind",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}},[_vm._v("voltar")]),_vm._v(" "),_c('button',{staticClass:"donation-nav donation-nav--forward",attrs:{"type":"submit","disabled":_vm.loading}},[(_vm.isTicket)?[_vm._v("\n      Concluir\n    ")]:[_vm._v("\n      Continuar\n    ")]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_certFaceVerify_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2385b931_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_certFaceVerify_vue__ = __webpack_require__(267);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_certFaceVerify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2385b931_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_certFaceVerify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"certiface-verify"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.messages[0].text)}}),_vm._v(" "),_c('a',{staticClass:"donation-nav donation-nav--forward",attrs:{"href":_vm.messages[1].href}},[_vm._v(_vm._s(_vm.messages[1].text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_printBoleto_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fe38a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_printBoleto_vue__ = __webpack_require__(269);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_printBoleto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71fe38a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_printBoleto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages)?_c('section',{staticClass:"certiface-verify"},[_vm._l((_vm.messages),function(message,index){return (message.type == 'msg')?_c('div',{key:index,staticClass:"input-wrapper",domProps:{"innerHTML":_vm._s(message.text)}}):_vm._e()}),_vm._v(" "),_vm._l((_vm.messages),function(message,index){return (message.type == 'link')?_c('div',{key:index,staticClass:"input-wrapper"},[_c('a',{staticClass:"donation-nav donation-nav--rewind",attrs:{"href":'/'+ _vm.candidate.username +'#doar'}},[_vm._v("voltar")]),_vm._v(" "),_c('a',{staticClass:"donation-nav donation-nav--block",attrs:{"target":"_blank","href":message.href}},[_vm._v(_vm._s(message.text)+" ")])]):_vm._e()})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"donation-form",attrs:{"aria-busy":Object.keys(_vm.candidate).length === 0 ? 'true' : 'false',"data-busy-message":_vm.dataBusyMessage}},[(!_vm.allowedPaymentMethods.length)?_c('h2',[_vm._v("\n    "+_vm._s(_vm._f("translate")('disabledDonations'))+"\n  ")]):(_vm.paymentStep === 'selectValue')?[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('donationPanel')))]),_vm._v(" "),_c('selectValue')]:(_vm.paymentStep === 'finalMessage')?[_c('finalMessage')]:[(_vm.paymentStep === 'userData')?_c('userData'):_vm._e(),_vm._v(" "),(_vm.paymentStep === 'boleto')?_c('addressData'):_vm._e(),_vm._v(" "),(_vm.paymentStep === 'certFaceVerify')?_c('certFaceVerify'):_vm._e(),_vm._v(" "),(_vm.paymentStep === 'printBoleto')?_c('printBoleto',{attrs:{"aria-busy":_vm.loading ? 'true' : 'false'}}):_vm._e(),_vm._v(" "),(_vm.paymentStep === 'cardData')?_c('cardData'):_vm._e(),_vm._v(" "),(_vm.certifaceError)?_c('a',{staticClass:"donation-nav donation-nav--block",attrs:{"href":'/'+ _vm.candidate.username +'#doar'}},[_vm._v("\n      Tentar Novamente\n    ")]):_vm._e()]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7ceec2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_vue__ = __webpack_require__(274);
function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b7ceec2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(273);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("76decf96", content, true, {});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".home__donate h2{color:#fff}", ""]);

// exports


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-form",attrs:{"aria-busy":Object.keys(_vm.candidate).length === 0 ? 'true' : 'false'}},[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('ticketPanel')))]),_vm._v(" "),(_vm.ticketStep === 'intro')?_c('section',{staticClass:"content"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.SET_TICKET_STEP({step: 'userData'})}}},[_c('p',[_vm._v("\n        clique no botão abaixo para utilizar o vale eleitoral do "),_c('strong',[_vm._v("\n          "+_vm._s(_vm.candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
            'partido' : '')+" "+_vm._s(_vm.candidate.party.name)+"\n        ")]),_vm._v(".\n      ")]),_vm._v(" "),_c('button',{attrs:{"type":"submit"}},[_vm._v("\n        "+_vm._s(_vm._f("translate")('submitTicket'))+"\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.ticketStep === 'userData')?[_c('userData',{attrs:{"is-ticket":true}}),_vm._v(" "),_c('p',{staticClass:"form__disclaimer"},[_vm._v("\n      Todos dados serão utilizados para que\n      "),_c('strong',[_vm._v("\n        "+_vm._s(_vm.candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
          'Partido' : '')+" "+_vm._s(_vm.candidate.party.name)+"\n      ")]),_vm._v("\n      possa enviar informativos.\n    ")])]:_vm._e(),_vm._v(" "),(_vm.ticketStep === 'addressData')?_c('addressData',{attrs:{"is-ticket":true}}):_vm._e(),_vm._v(" "),(_vm.ticketStep === 'finalMessage')?[_c('p',[_vm._v("\n      Obrigado!\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      O seu vale foi computado e quando a campanha começar, vamos\n      contabilizar todos os vales registrados e dividir de forma\n      proporcional entre todos os candidaturas do "+_vm._s(_vm.candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
          'Partido' : '')+" "+_vm._s(_vm.candidate.party.name)+" ("+_vm._s(_vm.candidate.address_city)+").\n    ")]),_vm._v(" "),_vm._m(0)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      Além deste vale, você também pode "),_c('a',{attrs:{"href":"#doar"}},[_vm._v("doar")]),_vm._v("\n      qualquer quantia financeira de pessoa física para fortalecer ainda\n      mais as candidaturas que te representam!\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__(79);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f64e30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f64e30_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pagination-nav"},[_c('ul',{class:_vm.classNames},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.firstPage()}}},[_vm._v("«")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.backPage()}}},[_vm._v("«")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.nextPage()}}},[_vm._v("»")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.lastPage()}}},[_vm._v("»")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

(function(t,e){ true?module.exports=e():"function"===typeof define&&define.amd?define([],e):"object"===typeof exports?exports["AnimatedNumber"]=e():t["AnimatedNumber"]=e()})("undefined"!==typeof self?self:this,function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:r})},n.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="./",n(n.s=0)}({0:function(t,e,n){t.exports=n("vgs7")},A5qe:function(t,e,n){(function(n){var r,o,a,i={scope:{}};i.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(t,e,n){if(n.get||n.set)throw new TypeError("ES3 does not support getters and setters.");t!=Array.prototype&&t!=Object.prototype&&(t[e]=n.value)},i.getGlobal=function(t){return"undefined"!=typeof window&&window===t?t:"undefined"!=typeof n&&null!=n?n:t},i.global=i.getGlobal(this),i.SYMBOL_PREFIX="jscomp_symbol_",i.initSymbol=function(){i.initSymbol=function(){},i.global.Symbol||(i.global.Symbol=i.Symbol)},i.symbolCounter_=0,i.Symbol=function(t){return i.SYMBOL_PREFIX+(t||"")+i.symbolCounter_++},i.initSymbolIterator=function(){i.initSymbol();var t=i.global.Symbol.iterator;t||(t=i.global.Symbol.iterator=i.global.Symbol("iterator")),"function"!=typeof Array.prototype[t]&&i.defineProperty(Array.prototype,t,{configurable:!0,writable:!0,value:function(){return i.arrayIterator(this)}}),i.initSymbolIterator=function(){}},i.arrayIterator=function(t){var e=0;return i.iteratorPrototype(function(){return e<t.length?{done:!1,value:t[e++]}:{done:!0}})},i.iteratorPrototype=function(t){return i.initSymbolIterator(),t={next:t},t[i.global.Symbol.iterator]=function(){return this},t},i.array=i.array||{},i.iteratorFromArray=function(t,e){i.initSymbolIterator(),t instanceof String&&(t+="");var n=0,r={next:function(){if(n<t.length){var o=n++;return{value:e(o,t[o]),done:!1}}return r.next=function(){return{done:!0,value:void 0}},r.next()}};return r[Symbol.iterator]=function(){return r},r},i.polyfill=function(t,e,n,r){if(e){for(n=i.global,t=t.split("."),r=0;r<t.length-1;r++){var o=t[r];o in n||(n[o]={}),n=n[o]}t=t[t.length-1],r=n[t],e=e(r),e!=r&&null!=e&&i.defineProperty(n,t,{configurable:!0,writable:!0,value:e})}},i.polyfill("Array.prototype.keys",function(t){return t||function(){return i.iteratorFromArray(this,function(t){return t})}},"es6-impl","es3");var u=this;(function(n,i){o=[],r=i,a="function"===typeof r?r.apply(e,o):r,void 0===a||(t.exports=a)})(0,function(){function t(t){if(!L.col(t))try{return document.querySelectorAll(t)}catch(t){}}function e(t,e){for(var n=t.length,r=2<=arguments.length?arguments[1]:void 0,o=[],a=0;a<n;a++)if(a in t){var i=t[a];e.call(r,i,a,t)&&o.push(i)}return o}function n(t){return t.reduce(function(t,e){return t.concat(L.arr(e)?n(e):e)},[])}function r(e){return L.arr(e)?e:(L.str(e)&&(e=t(e)||e),e instanceof NodeList||e instanceof HTMLCollection?[].slice.call(e):[e])}function o(t,e){return t.some(function(t){return t===e})}function a(t){var e,n={};for(e in t)n[e]=t[e];return n}function i(t,e){var n,r=a(t);for(n in t)r[n]=e.hasOwnProperty(n)?e[n]:t[n];return r}function s(t,e){var n,r=a(t);for(n in e)r[n]=L.und(t[n])?e[n]:t[n];return r}function f(t){t=t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(t,e,n,r){return e+e+n+n+r+r});var e=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);t=parseInt(e[1],16);var n=parseInt(e[2],16);e=parseInt(e[3],16);return"rgba("+t+","+n+","+e+",1)"}function c(t){function e(t,e,n){return 0>n&&(n+=1),1<n&&--n,n<1/6?t+6*(e-t)*n:.5>n?e:n<2/3?t+(e-t)*(2/3-n)*6:t}var n=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t)||/hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t);t=parseInt(n[1])/360;var r=parseInt(n[2])/100,o=parseInt(n[3])/100;n=n[4]||1;if(0==r)o=r=t=o;else{var a=.5>o?o*(1+r):o+r-o*r,i=2*o-a;o=e(i,a,t+1/3),r=e(i,a,t);t=e(i,a,t-1/3)}return"rgba("+255*o+","+255*r+","+255*t+","+n+")"}function l(t){if(t=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t))return t[2]}function d(t){return-1<t.indexOf("translate")||"perspective"===t?"px":-1<t.indexOf("rotate")||-1<t.indexOf("skew")?"deg":void 0}function p(t,e){return L.fnc(t)?t(e.target,e.id,e.total):t}function m(t,e){if(e in t.style)return getComputedStyle(t).getPropertyValue(e.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function y(t,e){return L.dom(t)&&o($,e)?"transform":L.dom(t)&&(t.getAttribute(e)||L.svg(t)&&t[e])?"attribute":L.dom(t)&&"transform"!==e&&m(t,e)?"css":null!=t[e]?"object":void 0}function g(t,n){var r=d(n);r=-1<n.indexOf("scale")?1:0+r;if(t=t.style.transform,!t)return r;for(var o=[],a=[],i=[],u=/(\w+)\((.+?)\)/g;o=u.exec(t);)a.push(o[1]),i.push(o[2]);return t=e(i,function(t,e){return a[e]===n}),t.length?t[0]:r}function h(t,e){switch(y(t,e)){case"transform":return g(t,e);case"css":return m(t,e);case"attribute":return t.getAttribute(e)}return t[e]||0}function v(t,e){var n=/^(\*=|\+=|-=)/.exec(t);if(!n)return t;var r=l(t)||0;switch(e=parseFloat(e),t=parseFloat(t.replace(n[0],"")),n[0][0]){case"+":return e+t+r;case"-":return e-t+r;case"*":return e*t+r}}function b(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))}function x(t){t=t.points;for(var e,n=0,r=0;r<t.numberOfItems;r++){var o=t.getItem(r);0<r&&(n+=b(e,o)),e=o}return n}function w(t){if(t.getTotalLength)return t.getTotalLength();switch(t.tagName.toLowerCase()){case"circle":return 2*Math.PI*t.getAttribute("r");case"rect":return 2*t.getAttribute("width")+2*t.getAttribute("height");case"line":return b({x:t.getAttribute("x1"),y:t.getAttribute("y1")},{x:t.getAttribute("x2"),y:t.getAttribute("y2")});case"polyline":return x(t);case"polygon":var e=t.points;return x(t)+b(e.getItem(e.numberOfItems-1),e.getItem(0))}}function S(t,e){function n(n){return n=void 0===n?0:n,t.el.getPointAtLength(1<=e+n?e+n:0)}var r=n(),o=n(-1),a=n(1);switch(t.property){case"x":return r.x;case"y":return r.y;case"angle":return 180*Math.atan2(a.y-o.y,a.x-o.x)/Math.PI}}function _(t,e){var n,r=/-?\d*\.?\d+/g;if(n=L.pth(t)?t.totalLength:t,L.col(n))if(L.rgb(n)){var o=/rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n);n=o?"rgba("+o[1]+",1)":n}else n=L.hex(n)?f(n):L.hsl(n)?c(n):void 0;else o=(o=l(n))?n.substr(0,n.length-o.length):n,n=e&&!/\s/g.test(n)?o+e:o;return n+="",{original:n,numbers:n.match(r)?n.match(r).map(Number):[0],strings:L.str(t)||e?n.split(r):[]}}function A(t){return t=t?n(L.arr(t)?t.map(r):r(t)):[],e(t,function(t,e,n){return n.indexOf(t)===e})}function O(t){var e=A(t);return e.map(function(t,n){return{target:t,id:n,total:e.length}})}function M(t,e){var n=a(e);if(L.arr(t)){var o=t.length;2!==o||L.obj(t[0])?L.fnc(e.duration)||(n.duration=e.duration/o):t={value:t}}return r(t).map(function(t,n){return n=n?0:e.delay,t=L.obj(t)&&!L.pth(t)?t:{value:t},L.und(t.delay)&&(t.delay=n),t}).map(function(t){return s(t,n)})}function I(t,e){var n,r={};for(n in t){var o=p(t[n],e);L.arr(o)&&(o=o.map(function(t){return p(t,e)}),1===o.length&&(o=o[0])),r[n]=o}return r.duration=parseFloat(r.duration),r.delay=parseFloat(r.delay),r}function P(t){return L.arr(t)?R.apply(this,t):X[t]}function j(t,e){var n;return t.tweens.map(function(r){r=I(r,e);var o=r.value,a=h(e.target,t.name),i=n?n.to.original:a,u=(i=L.arr(o)?o[0]:i,v(L.arr(o)?o[1]:o,i));a=l(u)||l(i)||l(a);return r.from=_(i,a),r.to=_(u,a),r.start=n?n.end:t.offset,r.end=r.start+r.delay+r.duration,r.easing=P(r.easing),r.elasticity=(1e3-Math.min(Math.max(r.elasticity,1),999))/1e3,r.isPath=L.pth(o),r.isColor=L.col(r.from.original),r.isColor&&(r.round=1),n=r})}function F(t,r){return e(n(t.map(function(t){return r.map(function(e){var n=y(t.target,e.name);if(n){var r=j(e,t);e={type:n,property:e.name,animatable:t,tweens:r,duration:r[r.length-1].end,delay:r[0].delay}}else e=void 0;return e})})),function(t){return!L.und(t)})}function C(t,e,n,r){var o="delay"===t;return e.length?(o?Math.min:Math.max).apply(Math,e.map(function(e){return e[t]})):o?r.delay:n.offset+r.delay+r.duration}function k(t){var e,n=i(T,t),r=i(V,t),o=O(t.targets),a=[],u=s(n,r);for(e in t)u.hasOwnProperty(e)||"targets"===e||a.push({name:e,offset:u.offset,tweens:M(t[e],r)});return t=F(o,a),s(n,{children:[],animatables:o,animations:t,duration:C("duration",t,n,r),delay:C("delay",t,n,r)})}function E(t){function n(){return window.Promise&&new Promise(function(t){return l=t})}function r(t){return p.reversed?p.duration-t:t}function o(t){for(var n=0,r={},o=p.animations,a=o.length;n<a;){var i=o[n],u=i.animatable,s=i.tweens,f=s.length-1,c=s[f];f&&(c=e(s,function(e){return t<e.end})[0]||c);s=Math.min(Math.max(t-c.start-c.delay,0),c.duration)/c.duration;for(var l=isNaN(s)?1:c.easing(s,c.elasticity),d=(s=c.to.strings,c.round),y=(f=[],void 0),g=(y=c.to.numbers.length,0);g<y;g++){var h=void 0,v=(h=c.to.numbers[g],c.from.numbers[g]);h=c.isPath?S(c.value,l*h):v+l*(h-v);d&&(c.isColor&&2<g||(h=Math.round(h*d)/d)),f.push(h)}if(c=s.length)for(y=s[0],l=0;l<c;l++)d=s[l+1],g=f[l],isNaN(g)||(y=d?y+(g+d):y+(g+" "));else y=f[0];q[i.type](u.target,i.property,y,r,u.id),i.currentValue=y,n++}if(n=Object.keys(r).length)for(o=0;o<n;o++)N||(N=m(document.body,"transform")?"transform":"-webkit-transform"),p.animatables[o].target.style[N]=r[o].join(" ");p.currentTime=t,p.progress=t/p.duration*100}function a(t){p[t]&&p[t](p)}function i(){p.remaining&&!0!==p.remaining&&p.remaining--}function u(t){var e=p.duration,u=p.offset,m=u+p.delay,y=p.currentTime,g=p.reversed,h=r(t);if(p.children.length){var v=p.children,b=v.length;if(h>=p.currentTime)for(var x=0;x<b;x++)v[x].seek(h);else for(;b--;)v[b].seek(h)}(h>=m||!e)&&(p.began||(p.began=!0,a("begin")),a("run")),h>u&&h<e?o(h):(h<=u&&0!==y&&(o(0),g&&i()),(h>=e&&y!==e||!e)&&(o(e),g||i())),a("update"),t>=e&&(p.remaining?(f=s,"alternate"===p.direction&&(p.reversed=!p.reversed)):(p.pause(),p.completed||(p.completed=!0,a("complete"),"Promise"in window&&(l(),d=n()))),c=0)}t=void 0===t?{}:t;var s,f,c=0,l=null,d=n(),p=k(t);return p.reset=function(){var t=p.direction,e=p.loop;for(p.currentTime=0,p.progress=0,p.paused=!0,p.began=!1,p.completed=!1,p.reversed="reverse"===t,p.remaining="alternate"===t&&1===e?2:e,o(0),t=p.children.length;t--;)p.children[t].reset()},p.tick=function(t){s=t,f||(f=s),u((c+s-f)*E.speed)},p.seek=function(t){u(r(t))},p.pause=function(){var t=Y.indexOf(p);-1<t&&Y.splice(t,1),p.paused=!0},p.play=function(){p.paused&&(p.paused=!1,f=0,c=r(p.currentTime),Y.push(p),Z||B())},p.reverse=function(){p.reversed=!p.reversed,f=0,c=r(p.currentTime)},p.restart=function(){p.pause(),p.reset(),p.play()},p.finished=d,p.reset(),p.autoplay&&p.play(),p}var N,T={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},V={duration:1e3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},$="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),L={arr:function(t){return Array.isArray(t)},obj:function(t){return-1<Object.prototype.toString.call(t).indexOf("Object")},pth:function(t){return L.obj(t)&&t.hasOwnProperty("totalLength")},svg:function(t){return t instanceof SVGElement},dom:function(t){return t.nodeType||L.svg(t)},str:function(t){return"string"===typeof t},fnc:function(t){return"function"===typeof t},und:function(t){return"undefined"===typeof t},hex:function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)},rgb:function(t){return/^rgb/.test(t)},hsl:function(t){return/^hsl/.test(t)},col:function(t){return L.hex(t)||L.rgb(t)||L.hsl(t)}},R=function(){function t(t,e,n){return(((1-3*n+3*e)*t+(3*n-6*e))*t+3*e)*t}return function(e,n,r,o){if(0<=e&&1>=e&&0<=r&&1>=r){var a=new Float32Array(11);if(e!==n||r!==o)for(var i=0;11>i;++i)a[i]=t(.1*i,e,r);return function(i){if(e===n&&r===o)return i;if(0===i)return 0;if(1===i)return 1;for(var u=0,s=1;10!==s&&a[s]<=i;++s)u+=.1;--s;s=u+(i-a[s])/(a[s+1]-a[s])*.1;var f=3*(1-3*r+3*e)*s*s+2*(3*r-6*e)*s+3*e;if(.001<=f){for(u=0;4>u;++u){if(f=3*(1-3*r+3*e)*s*s+2*(3*r-6*e)*s+3*e,0===f)break;var c=t(s,e,r)-i;s=s-c/f}i=s}else if(0===f)i=s;else{s=u,u=u+.1;var l=0;do{c=s+(u-s)/2,f=t(c,e,r)-i,0<f?u=c:s=c}while(1e-7<Math.abs(f)&&10>++l);i=c}return t(i,n,o)}}}}(),X=function(){function t(t,e){return 0===t||1===t?t:-Math.pow(2,10*(t-1))*Math.sin(2*(t-1-e/(2*Math.PI)*Math.asin(1))*Math.PI/e)}var e,n="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),r={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,.335],[.6,-.28,.735,.045],t],Out:[[.25,.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(e,n){return 1-t(1-e,n)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(e,n){return.5>e?t(2*e,n)/2:1-t(-2*e+2,n)/2}]},o={linear:R(.25,.25,.75,.75)},a={};for(e in r)a.type=e,r[a.type].forEach(function(t){return function(e,r){o["ease"+t.type+n[r]]=L.fnc(e)?e:R.apply(u,e)}}(a)),a={type:a.type};return o}(),q={css:function(t,e,n){return t.style[e]=n},attribute:function(t,e,n){return t.setAttribute(e,n)},object:function(t,e,n){return t[e]=n},transform:function(t,e,n,r,o){r[o]||(r[o]=[]),r[o].push(e+"("+n+")")}},Y=[],Z=0,B=function(){function t(){Z=requestAnimationFrame(e)}function e(e){var n=Y.length;if(n){for(var r=0;r<n;)Y[r]&&Y[r].tick(e),r++;t()}else cancelAnimationFrame(Z),Z=0}return t}();return E.version="2.2.0",E.speed=1,E.running=Y,E.remove=function(t){t=A(t);for(var e=Y.length;e--;)for(var n=Y[e],r=n.animations,a=r.length;a--;)o(t,r[a].animatable.target)&&(r.splice(a,1),r.length||n.pause())},E.getValue=h,E.path=function(e,n){var r=L.str(e)?t(e)[0]:e,o=n||100;return function(t){return{el:r,property:t,totalLength:w(r)*(o/100)}}},E.setDashoffset=function(t){var e=w(t);return t.setAttribute("stroke-dasharray",e),e},E.bezier=R,E.easings=X,E.timeline=function(t){var e=E(t);return e.pause(),e.duration=0,e.add=function(n){return e.children.forEach(function(t){t.began=!0,t.completed=!0}),r(n).forEach(function(n){var r=s(n,i(V,t||{}));r.targets=r.targets||t.targets,n=e.duration;var o=r.offset;r.autoplay=!1,r.direction=e.direction,r.offset=L.und(o)?n:v(o,n),e.began=!0,e.completed=!0,e.seek(r.offset),r=E(r),r.began=!0,r.completed=!0,r.duration>n&&(e.duration=r.duration),e.children.push(r)}),e.seek(0),e.reset(),e.autoplay&&e.restart(),e},e},E.random=function(t,e){return Math.floor(Math.random()*(e-t+1))+t},E})}).call(e,n("DuR2"))},DuR2:function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"===typeof window&&(n=window)}t.exports=n},vgs7:function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n("A5qe"),o=n.n(r),a={props:{value:{type:[Number,String],default:"0",required:!0},formatValue:{type:Function,default:function(t){return t}},easing:{type:String,default:"linear"},duration:{type:Number,default:1e3},update:Function,begin:Function,complete:Function,run:Function,delay:{type:Number,default:0},round:{default:null}},data:function(){return{animatedValue:0}},mounted:function(){this.animateValue(this.value)},watch:{value:function(t){this.animateValue(t)}},methods:{animateValue:function(t){var e=this.begin,n=this.easing,r=this.duration,a=this.complete,i=this.update,u=this.run,s=this.delay,f=this.round;o()({targets:this,animatedValue:t,duration:r,easing:n,update:i,begin:e,complete:a,run:u,delay:s,round:f})}}},i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("span",[t._v(t._s(t.formatValue(Number(t.animatedValue))))])},u=[];function s(t,e,n,r,o,a,i,u){t=t||{};var s=typeof t.default;"object"!==s&&"function"!==s||(t=t.default);var f,c="function"===typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=n,c._compiled=!0),r&&(c.functional=!0),a&&(c._scopeId=a),i?(f=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"===typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),o&&o.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(i)},c._ssrRegister=f):o&&(f=u?function(){o.call(this,this.$root.$options.shadowRoot)}:o),f)if(c.functional){c._injectStyles=f;var l=c.render;c.render=function(t,e){return f.call(e),l(t,e)}}else{var d=c.beforeCreate;c.beforeCreate=d?[].concat(d,f):[f]}return{exports:t,options:c}}var f=!1,c=null,l=null,d=null,p=s(a,i,u,f,c,l,d),m=p.exports;e["default"]=m}})["default"]});
//# sourceMappingURL=AnimatedNumber.umd.min.js.map

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('main',{ref:"candidateRoot",class:_vm.candidate.color,attrs:{"id":_vm.$route.name}},[_c('header',{staticClass:"site-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"site-label"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.candidate.popular_name)+"\n          ")]),_vm._v(" "),_c('h2',[(_vm.candidate.campaign_donation_type === 'campaign')?[_vm._v("\n              Candidato(a)\n            ")]:[_vm._v("\n              Pré-candidato(a)\n            ")],_vm._v("\n            a "+_vm._s(_vm.offices[_vm.candidate.office_id])+"\n          ")],2),_vm._v(" "),_c('ul',{staticClass:"wrap-social-candidate"},[(_vm.candidate.facebook_url)?_c('li',[_c('a',{staticClass:"facebook",attrs:{"href":_vm.candidate.facebook_url,"target":"_blank"}})]):_vm._e(),_vm._v(" "),(_vm.candidate.twitter_url)?_c('li',[_c('a',{staticClass:"twitter",attrs:{"href":_vm.candidate.twitter_url,"target":"_blank"}})]):_vm._e(),_vm._v(" "),(_vm.candidate.instagram_url)?_c('li',[_c('a',{staticClass:"instagram",attrs:{"href":_vm.candidate.instagram_url,"target":"_blank"}})]):_vm._e(),_vm._v(" "),(_vm.candidate.whatsapp_number)?_c('li',[_c('a',{staticClass:"whatsapp",attrs:{"href":("https://api.whatsapp.com/send?phone=" + (_vm.candidate.whatsapp_number)),"target":"_blank"}})]):_vm._e(),_vm._v(" "),(_vm.candidate.youtube_url)?_c('li',[_c('a',{staticClass:"youtube",attrs:{"href":_vm.candidate.youtube_url,"target":"_blank"}})]):_vm._e(),_vm._v(" "),(_vm.candidate.website_url)?_c('li',[_c('a',{staticClass:"website",attrs:{"href":_vm.candidate.website_url,"target":"_blank"}})]):_vm._e(),_vm._v(" "),(_vm.candidate.public_email)?_c('li',[_c('a',{staticClass:"email",attrs:{"href":("mailto:" + (_vm.candidate.public_email))}})]):_vm._e()])])])]),_vm._v(" "),_c('article',{attrs:{"role":"main"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"candidate-wrap"},[_c('header',{attrs:{"id":"intro"}},[_c('figure',[_c('div',{staticClass:"embed-container"},[(_vm.videoId)?_c('iframe',{attrs:{"width":"560","height":"315","src":("https://www.youtube-nocookie.com/embed/" + _vm.videoId),"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}}):_vm._e()])]),_vm._v(" "),_c('dl',{staticClass:"intro__meta"},[_c('div',{staticClass:"intro__meta-item"},[_c('dt',[_vm._v(_vm._s(_vm._f("translate")('party')))]),_vm._v(" "),(_vm.candidate.party)?_c('dd',[_c('abbr',{attrs:{"title":_vm.candidate.party.name}},[_vm._v("\n                    "+_vm._s(_vm.candidate.party.acronym)+"\n                  ")])]):_vm._e()]),_vm._v(" "),(_vm.candidate.number)?_c('div',{staticClass:"intro__meta-item"},[_c('dt',[_vm._v(_vm._s(_vm._f("translate")('number')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.candidate.number))])]):_vm._e(),_vm._v(" "),(_vm.candidate.address_state_name)?_c('div',{staticClass:"intro__meta-item"},[_c('dt',[_vm._v(_vm._s(_vm._f("translate")('runingon')))]),_vm._v(" "),_c('dd',[_c('span',{staticClass:"locality"},[_vm._v(_vm._s(_vm.candidate.address_city))]),_vm._v("\n                  -\n                  "),_c('span',{staticClass:"region"},[_vm._v(_vm._s(_vm.candidate.address_state_name))])])]):_vm._e(),_vm._v(" "),(_vm.candidate.political_movement_name)?_c('div',{staticClass:"intro__meta-item"},[_c('dt',[_vm._v(_vm._s(_vm._f("translate")('politicalMovement')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.candidate.political_movement_name))])]):_vm._e()])]),_vm._v(" "),_c('section',{attrs:{"id":"campaign-progress"}},[_c('dl',{staticClass:"campaign-progress__meta"},[_c('div',{staticClass:"campaign-progress__meta-item campaign-progress__meta-item--expected"},[_c('dd',[(_vm.donationSources.length > 1)?_c('div',{attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuenow":_vm.totalAmount,"aria-valuemax":_vm.goal}},[_vm._l((_vm.donationSources),function(source,i){return [(source.total_donated)?_c('div',{key:i,style:(_vm.progressBarStyle(source)),attrs:{"title":((_vm.porcentage(source.total_donated)) + "% via " + (source.name))}},[_vm._v("\n                        "+_vm._s(_vm.porcentage(source.total_donated))+"\n                      ")]):_vm._e()]})],2):_c('progress',{attrs:{"max":_vm.goal},domProps:{"value":_vm.totalAmount}},[_c('div',{attrs:{"role":"progressbar","aria-valuenow":_vm.totalAmount,"aria-valuemax":_vm.goal}},[_c('div',{style:({width: ((_vm.porcentage(_vm.totalAmount)) + "%")})},[_vm._v("\n                        "+_vm._s(_vm.porcentage(_vm.totalAmount))+"\n                      ")])])])]),_vm._v(" "),_c('dt',[_c('span',{staticClass:"campaign-progress__meta-currency"},[_vm._v("\n                    "+_vm._s(_vm._f("translate")('currencyReal'))+"\n                  ")]),_vm._v(" "),(_vm.totalAmount)?_c('span',[_c('animated-number',{attrs:{"value":_vm.totalAmount,"format-value":_vm.FormatFixedBRL,"duration":1000}})],1):_vm._e(),_vm._v(" "),('capturedMoney')?_c('span',{staticClass:"campaign-progress__meta-captured"},[_vm._v("\n                    "+_vm._s(_vm._f("translate")('capturedMoney'))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('dd',[_vm._v("\n                  "+_vm._s(_vm._f("lowerCase")(_vm._f("translate")('gotFromTheExpected')))+"\t"+_vm._s(_vm._f("translate")('currencyReal'))+"\n                  "),(_vm.goal)?_c('strong',{staticClass:"campaign-progress__expected-value"},[_vm._v("\n                    "+_vm._s(_vm._f("formatBRL")(_vm.goal))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('dd',[(_vm.donationSources.length > 1)?_c('div',{staticClass:"donations-sources"},[_c('ul',_vm._l((_vm.donationSources),function(source,i){return _c('li',{key:i},[_c('strong',{staticClass:"donations-sources__amount"},[_vm._v("\n                          R$ "+_vm._s(_vm._f("formatBRL")(source.total_donated))+"\n                        ")]),_vm._v(" /\n                        "),_c('em',{staticClass:"donations-sources__donations"},[_vm._v("\n                          "+_vm._s(source.people_donated)+"\n                        ")]),_vm._v("\n                        doações via "+_vm._s(source.name)+"\n                      ")])}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"campaign-progress__meta-item"},[_c('dt',[_vm._v(_vm._s(_vm.totalDonors))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("lowerCase")(_vm._f("translate")('doners'))))])]),_vm._v(" "),(_vm.candidate.ramaining_days)?_c('div',{staticClass:"campaign-progress__meta-item"},[_c('dt',[_vm._v(_vm._s(_vm.candidate.ramaining_days))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("lowerCase")(_vm._f("translate")('remainingDays'))))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"candidate-content"},[_c('section',{attrs:{"id":"doar"}},[_c('Payment')],1),_vm._v(" "),(_vm.candidate.rede_ticket)?_c('section',{attrs:{"id":"votar"}},[_c('Ticket')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"entry-contents"},[(_vm.candidate.summary)?_c('section',{staticClass:"candidate-summary"},[_c('p',[_vm._v(_vm._s(_vm.candidate.summary))])]):_vm._e(),_vm._v(" "),(!_vm.isCrawler)?_c('nav',{staticClass:"entry-content__nav"},[_c('ul',[(_vm.getMergeCandidate.projects.length)?_c('li',{class:("" + (_vm.activeSection === 'projetos' ? 'active-nav-item' : ''))},[_c('a',{attrs:{"href":"#projetos"},on:{"click":function($event){$event.preventDefault();return _vm.changeSection('projetos')}}},[_vm._v(_vm._s(_vm._f("translate")('mainProjects')))])]):_vm._e(),_vm._v(" "),(_vm.candidate.biography)?_c('li',{class:("" + (_vm.activeSection === 'sobre' ? 'active-nav-item' : ''))},[_c('a',{attrs:{"href":"#sobre"},on:{"click":function($event){$event.preventDefault();return _vm.changeSection('sobre')}}},[_vm._v("\n                    "+_vm._s(_vm._f("translate")('aboutMe'))+"\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.donations && _vm.candidate.party)?_c('li',{class:("" + (_vm.activeSection === 'doacoes' ? 'active-nav-item' : ''))},[_c('a',{attrs:{"href":"#doacoes"},on:{"click":function($event){$event.preventDefault();return _vm.changeSection('doacoes')},"~click":function($event){$event.preventDefault();return _vm.getDonationsList()}}},[_vm._v("\n                    "+_vm._s(_vm._f("translate")('donations'))+"\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.tickets && _vm.candidate.rede_ticket)?_c('li',{class:("" + (_vm.activeSection === 'vales' ? 'active-nav-item' : ''))},[_c('a',{attrs:{"href":"#vales"},on:{"click":function($event){$event.preventDefault();return _vm.changeSection('vales')},"~click":function($event){$event.preventDefault();return _vm.getTicketsList()}}},[_vm._v("\n                    "+_vm._s(_vm._f("translate")('ticket'))+"\n                  ")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.getMergeCandidate.projects.length)?_c('section',{class:("entry-content " + (_vm.activeSection === 'projetos' ? 'entry-content-active' : '')),attrs:{"id":"projetos"}},[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('mainProjects')))]),_vm._v(" "),_vm._l((_vm.getMergeCandidate.projects),function(projects){return _c('div',{key:projects.id},[_c('h3',[_vm._v(_vm._s(projects.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(projects.scope))])])})],2):_vm._e(),_vm._v(" "),_c('section',{class:("entry-content " + (_vm.activeSection === 'sobre' ? 'entry-content-active' : '')),attrs:{"id":"sobre"}},[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('aboutMe')))]),_vm._v(" "),_c('p',{staticClass:"candidate-biography"},[_vm._v("\n                "+_vm._s(_vm.candidate.biography)+"\n              ")]),_vm._v(" "),(_vm.candidate.cnpj)?_c('p',{staticClass:"candidate-cnpj"},[_vm._m(0),_vm._v("\n                "+_vm._s(_vm._f("formatCNPJ")(_vm.candidate.cnpj))+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.donations && _vm.candidate.party)?_c('section',{class:("entry-content " + (_vm.activeSection === 'doacoes' ? 'entry-content-active' : '')),attrs:{"id":"doacoes"}},[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('donations')))]),_vm._v(" "),_c('h4',[_vm._v("O que são os comprovantes?")]),_vm._v(" "),_c('p',[_vm._v("\n                O "),(_vm.candidate.campaign_donation_type === 'campaign')?[_vm._v("\n                  candidato(a)\n                ")]:[_vm._v("\n                  pré-candidato(a)\n                ")],_vm._v(" registra todas suas doações em um cartório cívico digital, para comprovar e manter a autenticidade da sua doação. *Essa rede de informações é vinculada à uma das mais seguras e confiáveis do mundo, que é a blockchain do DECRED. Esses números são a referência sobre as doações realizadas.\n              ")],2),_vm._v(" "),_c('h4',[_vm._v("Por que isso é importante?")]),_vm._v(" "),_c('p',[_vm._v("As doações eleitorais são muito importantes para construção de projetos políticos. Porém, é fundamental que as plataformas de financiamento coletivo, sociedade e o TSE tenham garantias que as informações ofereçam integridade e confiabilidade de maneira descentralizada para garantir controle social.")]),_vm._v(" "),_c('p',[_vm._v("\n                Por isso a "),(_vm.candidate.campaign_donation_type === 'campaign')?[_vm._v("\n                  candidatura\n                ")]:[_vm._v("\n                  pré-candidatura\n                ")],_vm._v(" da(o) "+_vm._s(_vm.candidate.popular_name)+", do "+_vm._s(_vm.candidate.party.name.toLowerCase().indexOf('partido') === -1 ? 'Partido' : '')+" "+_vm._s(_vm.candidate.party.name)+", está registrando todas suas doações financeiras, para comprovar a integridade e honestidade do processo de captação de recursos.\n              ")],2),_vm._v(" "),(_vm.donations.length > 0)?_c('table',{staticClass:"donations-table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.donations),function(donation){return _c('tr',{key:donation.id,class:{irregular: donation.is_irregular}},[_c('th',{attrs:{"title":"Nome"}},[_vm._v("\n                      "+_vm._s(_vm._f("titleCase")(donation.name))+"\n                    ")]),_vm._v(" "),_c('td',{attrs:{"title":"CPF"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$options.filters.formatCPF(donation.cpf))}})]),_vm._v(" "),_c('td',{attrs:{"title":"Data"}},[_vm._v("\n                      "+_vm._s(_vm._f("date")(donation.captured_at))+"\n                    ")]),_vm._v(" "),_c('td',{attrs:{"title":"Método"}},[_vm._v("\n                      "+_vm._s(donation.payment_method_human)+"\n                    ")]),_vm._v(" "),_c('td',{attrs:{"title":"Valor"}},[_vm._v("\n                      R$ "+_vm._s(_vm._f("formatBRL")(donation.amount))+"\n                    ")]),_vm._v(" "),(donation.digest)?_c('td',{attrs:{"title":"Recibo"}},[_c('a',{attrs:{"href":'/'+ _vm.candidate.username +'/recibo/' + donation.digest,"target":"_blank","title":"Registro na blockchain"}},[_c('i',{staticClass:"fa fa-link"})])]):(!donation.platform || donation.platform === 'votolegal' || donation.platform === '30217474000150')?_c('td',{attrs:{"title":"Recibo"}},[_vm._v("\n                      Processando\n                    ")]):(donation.platform)?_c('td',{attrs:{"title":"Recibo"}},[_vm._v("\n                      "+_vm._s(_vm.getPlatformName(donation.platform))+"\n                    ")]):_c('td',{attrs:{"title":"Recibo"}})])}),0),_vm._v(" "),_vm._m(2)]):_c('h3',[_vm._v("\n                Ainda não há doações\n              ")]),_vm._v(" "),(_vm.hasMoreDonations)?_c('button',{staticClass:"button--load-more",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.getDonationsList()}}},[_vm._v("\n                "+_vm._s(_vm._f("translate")('loadMore'))+"\n              ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.tickets && _vm.candidate.rede_ticket)?_c('section',{class:("entry-content " + (_vm.activeSection === 'vales' ? 'entry-content-active' : '')),attrs:{"id":"vales"}},[_c('h2',[_vm._v(_vm._s(_vm._f("translate")('ticket')))]),_vm._v(" "),_c('h4',[_vm._v("O que são os vales eleitorais?")]),_vm._v(" "),_c('p',[_vm._v("\n                Você sabe como os partidos políticos definem quais candidatos\n                irão ganhar mais dinheiros e quais menos? Aqui na Rede\n                Sustentabilidade da cidade de São Paulo a gente faz essa escolha\n                com você!\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                Para você participar da escolha de destinar parte do fundo\n                eleitoral para candidaturas do "+_vm._s(_vm.candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
                    'Partido' : '')+" "+_vm._s(_vm.candidate.party.name)+" ("+_vm._s(_vm.candidate.address_city)+"), basta acessar a página do seu\n                pré-candidato do VOTO LEGAL e clicar em \"vale eleitoral\" e\n                preencher com seus dados para confirmar sua escolha. Você só\n                pode destinar o vale para 1 pré-candidato ou pré-candidata e tem\n                até o dia 27 de setembro para fazer isso.\n              ")]),_vm._v(" "),_c('p',[_vm._v("\n                Aqui você pode acompanhar todos os vales registrados para a\n                pré-candidatura de "+_vm._s(_vm.candidate.popular_name)+", do "+_vm._s(_vm.candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
                    'Partido' : '')+" "+_vm._s(_vm.candidate.party.name)+".\n              ")]),_vm._v(" "),(_vm.tickets.length > 0)?_c('table',{staticClass:"tickets-table"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.tickets),function(ticket){return _c('tr',{key:ticket.id,class:{irregular: ticket.is_irregular}},[_c('th',{attrs:{"title":"Nome"}},[_vm._v("\n                      "+_vm._s(_vm._f("titleCase")(ticket.nome))+"\n                    ")]),_vm._v(" "),_c('td',{attrs:{"title":"Data"}},[_vm._v("\n                      "+_vm._s(_vm._f("date")(ticket.criado_em))+"\n                    ")])])}),0),_vm._v(" "),_vm._m(4)]):_c('h3',[_vm._v("\n                Ainda não há vales\n              ")]),_vm._v(" "),(_vm.hasMoreTickets)?_c('button',{staticClass:"button--load-more",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.getTicketsList()}}},[_vm._v("\n                "+_vm._s(_vm._f("translate")('loadMore'))+"\n              ")]):_vm._e()]):_vm._e()])])]),_vm._v(" "),(_vm.candidate.chat && _vm.candidate.chat.page_id)?_c('div',{staticClass:"fb-customerchat",attrs:{"attribution":"setup_tool","page_id":_vm.candidate.chat.page_id,"theme_color":_vm.colors[_vm.candidate.color],"logged_in_greeting":_vm.candidate.chat.logged_in_greeting ? _vm.candidate.chat.logged_in_greeting : 'Posso ajudar?',"logged_out_greeting":_vm.candidate.chat.logged_in_greeting ? _vm.candidate.chat.logged_in_greeting : 'Posso ajudar?'}}):_vm._e()]),_vm._v(" "),(_vm.candidate.whatsapp_number)?[_c('a',{staticStyle:{"position":"fixed","width":"60px","height":"60px","bottom":"40px","right":"40px","background-color":"#25d366","color":"#FFF","border-radius":"50px","text-align":"center","font-size":"30px","box-shadow":"1px 1px 2px #888","z-index":"1000","text-decoration":"none"},attrs:{"href":("https://api.whatsapp.com/send?phone=" + (_vm.candidate.whatsapp_number)),"target":"_blank"}},[_c('i',{staticClass:"fa fa-whatsapp",staticStyle:{"margin-top":"16px"}})]),_vm._v(" "),_c('link',{attrs:{"rel":"stylesheet","href":"https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"}})]:_vm._e()],2):_c('main',[_c('header',{staticClass:"site-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"site-label"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.errorMessage)+"\n          ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('abbr',{attrs:{"title":"Cadastro Nacional de Pessoa Jurídica"}},[_vm._v("CNPJ")]),_vm._v("\n                  da campanha:\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("CPF")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Método")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Recibo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("CPF")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Método")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Recibo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Data")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Data")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Receipt_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542432b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Receipt_vue__ = __webpack_require__(282);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Receipt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542432b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Receipt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(281);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4f81f8b0", content, true, {});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "*,:after,:before{background-repeat:no-repeat;box-sizing:inherit;tab-size:inherit}::selection{text-shadow:none;color:#fff;background-color:#14698c}[aria-busy=true]{cursor:progress}[aria-busy=true][aria-hidden=true]:before{content:none}[aria-busy=true][aria-hidden=true]:after{position:static;display:inline-block;width:0;overflow:hidden;vertical-align:bottom;background:none;content:\"\\2026\";opacity:.5;animation:ellipsis steps(4) .9s infinite}@keyframes ellipsis{to{width:1.25em}}main[aria-busy=true]{overflow:hidden}[aria-controls]{cursor:pointer}[aria-disabled]{cursor:default}[tabindex],a,area,button,input,label,select,summary,textarea{touch-action:manipulation}html{height:100%;padding:0;margin:0;overflow-y:scroll;font-size:100.01%;text-size-adjust:100%;background:#f1f1f1;box-sizing:border-box;tab-size:4}body{max-width:1400px;min-height:100%;margin:0;margin:auto;color:#333;background:#fff}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section{display:block}summary{display:list-item;list-style-type:none;cursor:pointer}summary::-webkit-details-marker{display:none}summary:focus{outline:5px auto -webkit-focus-ring-color}summary:before{padding-right:.5em;content:\"\\25B6\"}details[open]>summary:before{content:\"\\25BC\"}[hidden],template{display:none}[hidden][aria-hidden=false]{position:absolute;display:inherit;clip:rect(0,0,0,0)}[hidden][aria-hidden=false]:focus{clip:auto}hr{margin:calc(1.5em - 1px) 0 1.5em;clear:both;display:block;height:0;padding:0;overflow:visible;color:#999;border:0;border-top:1px solid #999;box-sizing:content-box}svg:not(:root){overflow:hidden}svg{fill:currentColor}a>svg{pointer-events:none}audio,canvas,iframe,progress,svg,video{display:inline-block;vertical-align:middle}audio:not([controls]){display:none;height:0}meter,progress{background-size:auto;appearance:none}iframe,img,object{font-size:83.3333%;color:currentColor;border-style:none}embed,img,object,video{max-width:100%}video>source{width:100%;height:auto}.ie:not(.ie6-8),object>img{position:relative;z-index:-1;font-size:1em;pointer-events:none}img{height:auto;max-width:100%;max-height:90vh;image-rendering:optimizeQuality;-ms-interpolation-mode:bicubic}[usemap]{color:#06c}li img,p img{vertical-align:middle}a>picture,a img{border:0}a{padding:0;margin:0;font-weight:700;font-size:100%;vertical-align:baseline;color:#333}a,a:active,a:focus,a:hover,a:link{text-decoration:underline}a:link{cursor:pointer;-webkit-tap-highlight-color:rgba(0,0,0,0)}a:visited:active,a:visited:focus,a:visited:hover{text-decoration:underline}a:focus,a:hover{color:#f63}a:focus{overflow:hidden;outline:none;outline-offset:2px}a:active,a:hover{outline-width:0}a:active{background-color:transparent}address{padding:0;margin:0;font-style:italic}*,:after,:before{line-height:inherit;text-decoration:inherit;vertical-align:inherit}body{font-weight:400;font-size:1em;line-height:1.875;font-family:Miriam Libre,sans-serif;color:#212121}caption,details>summary,h1,h2,h3,h4,h5,h6,legend{font-weight:600;font-family:Miriam Libre,sans-serif;font-feature-settings:\"case\" 1,\"cpsp\" 1,\"cswh\" 1,\"liga\" 1,\"locl\" 1,\"lnum\" 1,\"pnum\" 1,\"titl\" 1,\"zero\" 1;break-after:avoid;page-break-after:avoid}caption a,caption a:link,dt a,dt a:link,h1 a,h1 a:link,h2 a,h2 a:link,h3 a,h3 a:link,h4 a,h4 a:link,h5 a,h5 a:link,h6 a,h6 a:link,legend a,legend a:link{text-decoration:inherit;color:inherit}h1{font-size:3.05176rem;font-weight:100;text-transform:capitalize}h2{font-size:1.95312rem;font-weight:400}h3{font-size:1.5625rem}h3,h4{font-weight:700}h4{font-size:1.25rem}p{padding:0;margin:0}article p{orphans:3;widows:3}article fieldset>p:first-child,article h1+p,article h2+p,article h3+p,article h4+p,article h5+p,article h6+p,article legend+p{margin-top:0;text-indent:0}abbr[title],dfn[title]{text-decoration:none;cursor:help;border-bottom:1px dotted}@supports (text-decoration:dotted underline){abbr[title],dfn[title]{text-decoration:none;border-bottom:inherit}}abbr{letter-spacing:.1em}dfn{font-style:italic;font-size:1em}b,strong{font-weight:700;font-weight:inherit;font-weight:600}mark{color:#333;background:#d7ff5a}small{line-height:inherit}small,sub,sup{font-size:83.3333%}sub,sup{position:relative;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}time{font-style:italic}time[pubdate]{cursor:help}code,kbd,pre,samp,var{font-size:1em;font-family:Consolas,Liberation Mono,Menlo,Courier,monospace,monospace,monospace}pre{padding:0;margin:0;overflow:auto;word-wrap:break-word;white-space:pre;white-space:pre-wrap;white-space:pre-line}samp,var{font-style:italic}del,s{text-decoration:line-through}s{font-style:italic}del:before,ins:before{font-weight:700;text-decoration:none;content:\"[update] \"}del[datetime]:before,ins[datetime]:before{content:\"[update\\A0\\2192\\A0\" attr(datetime) \"] \"}del:after,ins:after{text-decoration:none;content:\" [/update] \"}ins{text-decoration:underline}ins:lang(pt):before{content:\" [inserido] \"}ins[datetime]:lang(pt):before{content:\" [inserido\\A0\\2192\\A0\" attr(datetime) \"] \"}ins:lang(pt):after{content:\" [/inserido] \"}del:lang(pt):before{content:\" [exclu\\ED  do] \"}del[datetime]:lang(pt):before{content:\" [exclu\\ED  do\\A0\\2192\\A0\" attr(datetime) \"] \"}del:lang(pt):after{content:\" [/exclu\\ED  do] \"}blockquote,q{font-style:italic;color:#575757}cite{font-style:italic;font-size:1em}blockquote footer:before{content:\"\\2014   \\A0\"}blockquote footer cite{font-style:italic}blockquote li,blockquote p,blockquote pre{font-size:1em}blockquote.verse{text-align:center}blockquote.verse p{display:inline-block;width:auto;margin-right:auto;margin-left:auto;text-align:left}embed,input[aria-busy=true],keygen[aria-busy=true],output[aria-busy=true],textarea[aria-busy=true]{background-image:url(" + escape(__webpack_require__(8)) + ");background-position:50% 50%;background-repeat:no-repeat;background-color:hsla(0,0%,7%,.8)}[aria-busy=true]:not(html),[aria-busy=true]>body{cursor:wait}:not(html)[aria-busy=true]:before,[aria-busy=true]>body:before{position:absolute;top:-.9375rem;right:-.9375rem;bottom:-.9375rem;left:-.9375rem;z-index:3000;padding:1.875rem;text-align:center;color:#fff;background-image:url(" + escape(__webpack_require__(8)) + ");background-position:50% 50%;background-repeat:no-repeat;background-color:hsla(0,0%,7%,.8);border-radius:20px;content:\"\"}:not(html)[aria-busy=true][data-busy-message]:before,[aria-busy=true]>body[data-busy-message]:before{padding-top:3.75rem;content:attr(data-busy-message)}[aria-busy=true]:not(html),[aria-busy=true]>body{position:relative}img{background-size:auto}img:after{content:none}embed{background-size:auto}embed:after{content:none}input[aria-busy=true],keygen[aria-busy=true],output[aria-busy=true],textarea[aria-busy=true]{background-size:auto}.grid:after,.grid:root:before{position:fixed;top:0;right:0;z-index:5000;font-size:1rem;pointer-events:none;content:\"breakpoint: phone\"}.grid:after{bottom:0;left:0;background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35));background-position:top;content:\"\"}@media screen and (min-width:30em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% + 1.25rem),transparent calc(33.33333% + 1.25rem),transparent calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% + .625rem),transparent calc(66.66667% + .625rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:48em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(25% - .46875rem),rgba(255,0,0,.35) calc(25% - .46875rem),rgba(255,0,0,.35) calc(25% + 1.40625rem),transparent calc(25% + 1.40625rem),transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(75% - 1.40625rem),rgba(255,0,0,.35) calc(75% - 1.40625rem),rgba(255,0,0,.35) calc(75% + .46875rem),transparent calc(75% + .46875rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:64em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(20% - .375rem),rgba(255,0,0,.35) calc(20% - .375rem),rgba(255,0,0,.35) calc(20% + 1.5rem),transparent calc(20% + 1.5rem),transparent calc(40% - .75rem),rgba(255,0,0,.35) calc(40% - .75rem),rgba(255,0,0,.35) calc(40% + 1.125rem),transparent calc(40% + 1.125rem),transparent calc(60% - 1.125rem),rgba(255,0,0,.35) calc(60% - 1.125rem),rgba(255,0,0,.35) calc(60% + .75rem),transparent calc(60% + .75rem),transparent calc(80% - 1.5rem),rgba(255,0,0,.35) calc(80% - 1.5rem),rgba(255,0,0,.35) calc(80% + .375rem),transparent calc(80% + .375rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:75em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(16.66667% - .3125rem),rgba(255,0,0,.35) calc(16.66667% - .3125rem),rgba(255,0,0,.35) calc(16.66667% + 1.5625rem),transparent calc(16.66667% + 1.5625rem),transparent calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% + 1.25rem),transparent calc(33.33333% + 1.25rem),transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% + .625rem),transparent calc(66.66667% + .625rem),transparent calc(83.33333% - 1.5625rem),rgba(255,0,0,.35) calc(83.33333% - 1.5625rem),rgba(255,0,0,.35) calc(83.33333% + .3125rem),transparent calc(83.33333% + .3125rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35));background-size:1400px 100%}}.grid:root:before{padding:1.875rem;background-color:red;opacity:.75}@media screen and (min-width:30em){.grid:root:before{content:\"breakpoint: phablet\"}}@media screen and (min-width:48em){.grid:root:before{content:\"breakpoint: tablet\"}}@media screen and (min-width:64em){.grid:root:before{content:\"breakpoint: desktop\"}}@media screen and (min-width:75em){.grid:root:before{content:\"breakpoint: wide\"}}ol,ul{margin:0 0 1.5rem;padding-left:1em;margin:0}ol{counter-reset:li}article li{position:relative;padding-left:0;margin:0;list-style:none}article li:last-child{margin-bottom:0}dl{margin:0 0 1rem}dd,dl,dt{padding:0}dd,dt{margin:0}dd{margin:0 0 1rem}dd:last-child{margin-bottom:0}menu ol,menu ul,nav ol,nav ul{padding:0;margin:0;list-style:none}menu li,nav li{padding:0;margin:0}menu li:before,nav li:before{content:none}menu a,nav a{display:block;overflow:hidden}menu a:link,nav a:link{text-decoration:underline}.current>a{pointer-events:none}[for=menu-controller]:before{font-size:2em;line-height:.75;font-family:sans-serif;vertical-align:middle;content:\" \\2261   \"}@media screen and (min-width:64em){[for=menu-controller]{display:none}}table,tbody,td,tfoot,th,thead,tr{background:red;padding:1em}.irregular td,.irregular th{text-decoration:line-through}tbody td,tbody th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}table,tbody,td,tfoot,th,thead,tr{width:auto;height:auto;font-size:1rem;vertical-align:top;background-color:transparent;border:0}@media screen and (max-width:74.99em){table,tbody,td,tfoot,th,thead,tr{display:block}}table{width:100%;max-width:100%;font-size:100%;font-family:inherit;font-feature-settings:\"kern\" 1,\"liga\" 1,\"calt\" 1,\"pnum\" 0,\"tnum\" 1,\"onum\" 0,\"lnum\" 1,\"dlig\" 0;border-collapse:collapse;empty-cells:show}@media screen and (max-width:74.99em){table{padding:0}}table li,table p{font-size:1rem}.blockchain-cell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media screen and (max-width:74.99em){tr{padding:0;padding-bottom:.46875em;padding-top:.46875em;margin:0 0 1.5rem}tr:last-child{margin-bottom:0}}th{font-weight:700;text-transform:capitalize}@media screen and (max-width:74.99em){th{text-transform:capitalize;padding-top:.46875em}}td{font-family:inherit}@media screen and (max-width:74.99em){td{padding-bottom:.46875em;padding-top:.46875em}}@media screen and (max-width:74.99em){td:empty,thead{display:none}}thead td,thead th{background-color:#f63;color:#fff;text-align:left;vertical-align:bottom}tbody,tfoot th:first-child,thead th:first-child{text-align:left}@media screen and (max-width:74.99em){tbody{padding:0}}tbody td,tbody th{text-align:left}tbody td{font-variant-numeric:lining-nums oldstyle-nums}@media screen and (max-width:74.99em){tbody td{text-align:left}tbody td[title]{text-align:right}tbody td[title]:before{float:left;font-style:italic;content:attr(title) \": \"}}tbody tr:nth-child(odd){background-color:#f1f1f1}td img{vertical-align:top}@media screen and (max-width:74.99em){tbody tr:nth-of-type(odd)>td,tbody tr:nth-of-type(odd)>th{background-color:transparent}}tfoot td,tfoot th{background-color:#f63;color:#fff;vertical-align:top;text-align:left}@media screen and (max-width:74.99em){tfoot td,tfoot th{display:none}}form{margin:0}fieldset{max-width:none;min-width:0;padding:0;border:0}fieldset>legend,legend{display:table;max-width:100%;padding:0;font-weight:bolder;white-space:normal;color:inherit;box-sizing:border-box}label{padding:0;margin:0;font-size:small;line-height:inherit}label *{font-size:1em}form br{clear:both}[role=button],[type=button],[type=email],[type=number],[type=password],[type=reset],[type=search],[type=submit],[type=tel],[type=text],[type=url],button,html [type=button],optgroup,textarea{display:inline-block;padding:1px;margin:0;overflow:visible;font-size:inherit;line-height:inherit;font-family:inherit;-webkit-font-smoothing:inherit;letter-spacing:inherit;text-align:inherit;text-transform:inherit;white-space:normal;vertical-align:top;color:inherit;border:1px solid #ddd;border-radius:20px;outline:none;box-sizing:border-box}:focus[role=button],:focus[type=button],:focus[type=email],:focus[type=number],:focus[type=password],:focus[type=reset],:focus[type=search],:focus[type=submit],:focus[type=tel],:focus[type=text],:focus[type=url],button:focus,optgroup:focus,textarea:focus{outline:none;outline-offset:0}:disabled,:readonly{color:#6b6b6b;background:#f0f0f0}:disabled{cursor:not-allowed}:readonly{cursor:default}:-moz-placeholder{color:#575757;opacity:1}:focus:-moz-placeholder{color:#8f8f8f}::-moz-placeholder{color:#575757;opacity:1}:focus::-moz-placeholder{color:#8f8f8f}::-webkit-input-placeholder{color:#575757;opacity:1}:focus::-webkit-input-placeholder{color:#8f8f8f}:-ms-input-placeholder{color:#575757;opacity:1}:focus:-ms-input-placeholder{color:#8f8f8f}::placeholder{color:#575757;opacity:1}:focus::placeholder{color:#8f8f8f}[type=color],[type=file],[type=image]{padding:0;vertical-align:middle;cursor:pointer;border:0}[type=image]{display:inline-block}[type=color]{background-color:#fff}::-webkit-color-swatch{border:0}::-moz-color-swatch{border:0}::-webkit-color-swatch-wrapper{padding:0}::-moz-color-swatch-wrapper{padding:0}[type=file]{height:2em;min-width:250px;padding:0!important;margin:0;font-family:inherit;text-align:start!important;white-space:nowrap;cursor:default;background-color:transparent;border-style:none!important;-webkit-box-align:baseline;-webkit-appearance:none;-moz-appearance:none;appearance:normal;-moz-binding:none}[type=file]>[type=text]{height:inherit;font-size:inherit;letter-spacing:inherit;color:inherit;background-color:inherit;border-color:inherit}[type=file]>[type=button]{height:inherit;padding:0;font-size:inherit;white-space:normal;-webkit-box-align:center;box-sizing:content-box;appearance:button}::-webkit-file-upload-button{font:inherit;cursor:pointer;background-color:#f63;border:1px solid #ddd;-webkit-appearance:button}::-webkit-file-upload-button:hover{background-color:#fff}:focus::-webkit-color-swatch,:focus::-webkit-file-upload-button{outline:none}::-ms-browse{border:1px solid #ddd}::-ms-browse:hover{background-color:#fff}:focus::-ms-browse{outline:none}:required,[required]{box-shadow:none}[type=checkbox]:-moz-focusring,[type=radio]:-moz-focusring,[type=range]:-moz-focusring{outline-width:0}.checkbox-custom{zoom:1\\9;color:#fff;padding-right:.9375rem}.checkbox-custom:after,.checkbox-custom:before{display:table;content:\"\";border-collapse:collapse}.checkbox-custom:after{clear:both}.checkbox-custom [type=checkbox]{position:relative;display:inline-block;opacity:1;width:auto;height:auto}.checkbox-custom .input-wrapper label{position:relative;color:#000;display:inline;line-height:0;font-weight:400}.checkbox-custom .input-wrapper label a{color:inherit}.of-radios-and-checks .input-wrapper{position:relative;display:block;width:33.33333%;float:left;padding-right:.1875rem;padding-left:.1875rem;margin-bottom:0;white-space:nowrap;list-style-type:none;overflow:hidden}.of-radios-and-checks .input-wrapper:before{content:none}@media (max-width:480px){.of-radios-and-checks .input-wrapper{width:50%}}.of-radios-and-checks .input-wrapper label{padding-left:0}.of-radios-and-checks .input-wrapper--full-width{width:100%}.of-radios-and-checks .has-real-value{background-color:#fff;border-radius:30px;color:#212121;float:none;margin-right:.1875rem;margin-left:.1875rem;padding-top:.75rem;padding-bottom:.75rem;position:relative;width:auto;padding-left:2.25rem}.has-real-value label{display:block;background-color:transparent;padding:0;margin-left:-1.25rem;font-size:1em}.has-real-value label:focus,.has-real-value label:hover{color:inherit;background-color:transparent}.has-real-value [type=tel]{color:inherit;position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:100%;color:transparent;background:transparent;margin:0;padding:0;border:none}.has-real-value .real-value{font-size:1em;display:block;min-height:30px;line-height:2em;padding-left:.46875rem}.has-real-value [type=button]{border:0;border-radius:50%;background-color:#999;color:#fff;padding-right:.80625rem;padding-left:.80625rem;position:absolute;top:.1875rem;right:.1875rem;z-index:2}.site-footer{text-align:center;font-size:.8rem;color:#fff;background-color:#f63}.donations-sources{padding-top:.9375rem;padding-bottom:.9375rem;font-weight:400;font-size:.8rem;line-height:1.875;color:rgba(33,33,33,.65)}.donations-sources *{font-size:inherit!important}.donations-sources ul{padding-left:0}.donations-sources li:before{display:inline-block;width:1em;height:1em;background-color:#f63;border:1px solid #fff;border-radius:50%;content:\"\"}.donations-sources li:nth-child(2):before{background-image:linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25))}.donations-sources li:nth-child(3):before{background-image:linear-gradient(rgba(0,0,0,.5),rgba(0,0,0,.5))}.donations-sources li:nth-child(4):before{background-image:linear-gradient(rgba(0,0,0,.75),rgba(0,0,0,.75))}.donations-sources li:nth-child(5):before,.donations-sources li:nth-child(6):before,.donations-sources li:nth-child(7):before,.donations-sources li:nth-child(8):before,.donations-sources li:nth-child(9):before,.donations-sources li:nth-child(10):before{background-image:linear-gradient(#000,#000)}.donations-sources em,.donations-sources strong{font-weight:400}.donations-sources details,.donations-sources details[open]{display:inline}.donations-sources summary{display:inline;font-weight:400;list-style-type:none;cursor:help}.donations-sources summary:before{content:none}.donations-sources summary:after{display:inline-block;width:1.875em;height:1.875em;margin-right:.5em;margin-left:.5em;line-height:1.875em;text-align:center;background-color:#000;border-width:1px;border-color:currentColor;border-radius:50%;content:\"?\";transition-duration:1s;transition-property:background-color}.donations-sources summary:focus,.donations-sources summary:hover{text-decoration:underline}.donations-sources summary:focus:after,.donations-sources summary:hover:after{text-decoration:none;background-color:#3298ff}.donations-sources [open] summary:before{content:none}.donations-sources [open] summary~*{overflow:hidden;animation:here-comes-the-detail .5s ease-in-out}@keyframes here-comes-the-detail{0%{opacity:0}to{opacity:1}}@media screen and (min-width:30em){.donations-sources [open] summary~:after{content:\"\\A0; \"}.donations-sources [open] summary+:before{content:\"(\\A0\"}.donations-sources [open] summary~:last-child:after{content:\"\\A0)\"}}.donations-sources details p{display:inline}.donations-sources details em{font-style:normal}.donations-sources__amount{font-size:1rem}figure{margin:1em 2.5rem;margin:0}figcaption{font-size:83.3333%;line-height:inherit}figcaption p,figcaption small{margin:0;font-size:1em}[role=button],[type=button],[type=reset],[type=submit],button,html [type=button]{width:auto;padding:.5em 1.2em;border-radius:1.25rem;font-weight:700;border:0;overflow:visible;text-indent:0;white-space:inherit;cursor:pointer;box-sizing:inherit;appearance:button}[role=button]::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border:0}:active[role=button],:active[type=button],:active[type=reset],:active[type=submit],:focus[role=button],:focus[type=button],:focus[type=reset],:focus[type=submit],:hover[role=button],:hover[type=button],:hover[type=reset],:hover[type=submit],button:active,button:focus,button:hover{background-color:#fff}[role=button]:focus,[role=button]:hover,[type=button]:focus,[type=button]:hover,button:focus,button:hover{background-color:#f63;color:#fff}[role=button]:active,[type=button]:active,button:active{background-color:#666;color:#fff}[type=submit]{background-color:#fff;color:#f63}[type=submit]:focus,[type=submit]:hover{background-color:#f63;color:#fff}[type=submit]:active{background-color:#f63}button:-moz-focusring,input:-moz-focusring{outline:1px dotted ButtonText}.button--load-more[class]{display:block;margin:1.875rem auto 3.75rem;background-color:#999;text-transform:lowercase}fieldset ol,fieldset ul{padding:0;margin:0}fieldset li{text-align:center;display:block;white-space:nowrap;list-style-type:none}fieldset li:before{content:none}li label{display:inline;padding:0 .5em}[type=checkbox],[type=radio]{width:auto;height:auto;padding:0;vertical-align:middle;cursor:pointer;box-sizing:border-box}[type=checkbox]:focus,[type=radio]:focus{outline-style:auto}li:hover>input,li:hover>label{color:#000}li :checked+label{font-weight:700}:disabled+label,[disabled]+label{cursor:default;color:#6b6b6b}.of-radios-and-checks [type=radio]:checked+label,.of-radios-and-checks [type=radio]:not(:checked)+label{font-size:1rem}@media screen and (min-width:75em){.of-radios-and-checks [type=radio]:checked+label,.of-radios-and-checks [type=radio]:not(:checked)+label{font-size:1.25rem}}[type=radio]:checked+label,[type=radio]:not(:checked)+label{position:relative;width:100%;margin-top:.25em;margin-bottom:.5em;padding-top:.25em;padding-bottom:.25em;border-radius:20px;text-align:center;display:block;white-space:nowrap;list-style-type:none;cursor:pointer;z-index:3;font-size:1rem;font-weight:700;outline:none}[type=radio]:checked+label .donation-form__currency-item,[type=radio]:not(:checked)+label .donation-form__currency-item{font-size:1rem}[type=radio]+label:hover,[type=radio]:checked+label{color:#fff}input[type=checkbox],input[type=radio]{position:absolute;height:100%;width:100%;opacity:0}[type=radio]:checked,[type=radio]:not(:checked){position:absolute;left:0;top:0;z-index:2}[type=radio]:checked+label:before,[type=radio]:not(:checked)+label:before{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;border-radius:20px;background:#fff;z-index:-1}[type=radio]:checked+label:hover:before,[type=radio]:not(:checked)+label:hover:before{content:\"\";background:#f63}[type=radio]:checked+label:after,[type=radio]:not(:checked)+label:after{content:\"\";position:absolute;width:100%;height:100%;border-radius:20px;background:#f63;left:0;top:0;-webkit-transition:all .2s ease;transition:all .2s ease;z-index:-1}[type=radio]:not(:checked)+label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0)}[type=radio]:checked+label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1)}[role=progressbar],progress{width:100%;height:5px;line-height:5px;border-radius:5px;color:#fff;overflow:hidden;border:0;background:#e0e0e0}[role=progressbar][value]::-moz-progress-bar,progress[value]::-moz-progress-bar{border-radius:5px;background:#f63;transition:width .5s}[role=progressbar][value]::-webkit-progress-value,progress[value]::-webkit-progress-value{border-radius:5px;background:#f63;transition:width .5s}[role=progressbar]>div,progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;border-radius:5px;background:#f63;transition:width .5s;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}[role=progressbar]>div:first-child,progress>div:first-child{border-radius:5px 0 0 5px}[role=progressbar]>div:last-child,progress>div:last-child{border-radius:0 5px 5px 0}[role=progressbar]::-webkit-progress-bar,progress::-webkit-progress-bar{background:#e0e0e0}option,select{width:auto;min-width:1.5em;cursor:pointer}select{text-indent:.01px;text-overflow:\"\";box-sizing:content-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}select::-ms-expand{display:none}.ie6-9:invalid,select{padding-right:1.5em;background-image:url(\"data:image/png;base64,R0lGODlhDwAUAIABAAAAAP///yH5BAEAAAEALAAAAAAPABQAAAIXjI+py+0Po5wH2HsXzmw//lHiSJZmUAAAOw==\");background-position:95% 50%}optgroup{font-weight:700}option{padding:0 .4em 0 .1em;margin:0}option:focus,option:hover{color:#000}select[multiple] option:checked{font-weight:700}[type=range]{display:block;width:100%;padding:0;vertical-align:middle;cursor:pointer;background:transparent;border:0;appearance:none}[type=range]::-webkit-slider-runnable-track{width:100%;background-color:#f63}[type=range]::-webkit-slider-runnable-track:focus{outline:none}[type=range]::-moz-range-track{background-color:#f63}[type=range]::-moz-range-track:focus{outline:none}[type=range]::-ms-track{width:100%;color:transparent;background:transparent;border-width:.6875rem 0;border-color:transparent}[type=range]::-ms-fill-lower{background-color:#f63}[type=range]::-ms-fill-lower:focus{outline:none}[type=range]::-ms-fill-upper{background-color:#f63}[type=range]::-ms-fill-upper:focus{outline:none}[type=range]::-webkit-slider-thumb{background-color:#fff;border:0;margin-top:-.6875rem;appearance:none}[type=range]::-moz-range-thumb{background-color:#fff;border:0;appearance:none}[type=range]::-ms-thumb{margin-top:0;appearance:none;background-color:#fff;border:0}[type=range]::-moz-focus-outer{border:0}[type=range]:-moz-focusring{outline:1px solid transparent;outline-offset:-1px}[type=email],[type=number],[type=password],[type=search],[type=tel],[type=text],[type=url],textarea{width:100%;height:3.125rem;padding-top:1.2em;padding-left:.2em;font-size:1rem;text-indent:.5ex;cursor:text;border-radius:6px;box-sizing:inherit;appearance:none}:invalid[type=email],:invalid[type=number],:invalid[type=password],:invalid[type=search],:invalid[type=tel],:invalid[type=text],:invalid[type=url],textarea:invalid{border-radius:6px;box-shadow:0}:disabled[type=email],:disabled[type=number],:disabled[type=password],:disabled[type=search],:disabled[type=tel],:disabled[type=text],:disabled[type=url],textarea:disabled{cursor:not-allowed;background-color:#bababa;border-radius:6px;box-shadow:0}:-moz-ui-invalid[type=email],:-moz-ui-invalid[type=number],:-moz-ui-invalid[type=password],:-moz-ui-invalid[type=search],:-moz-ui-invalid[type=tel],:-moz-ui-invalid[type=text],:-moz-ui-invalid[type=url],textarea:-moz-ui-invalid{border-radius:6px;box-shadow:0}:focus[type=email],:focus[type=number],:focus[type=password],:focus[type=search],:focus[type=tel],:focus[type=text],:focus[type=url],textarea:focus{outline:none}[type=number]{-moz-appearance:textfield}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto;margin:0;-webkit-appearance:none}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto;line-height:inherit;white-space:pre;vertical-align:top;cursor:text;resize:vertical}.embed-container{padding-bottom:56.25%;height:0;overflow:hidden;position:relative;border-top-left-radius:2em;border-bottom-left-radius:2em;border-top-right-radius:2em;border-bottom-right-radius:2em;margin-bottom:1.875em}@media (min-width:64em){.embed-container{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:2em;border-bottom-right-radius:0}}.embed-container iframe{position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:100%}#receipt{background:#f1f1f1}#receipt .container{padding-right:3rem;padding-left:3rem}#receipt a{overflow-wrap:break-word;word-wrap:break-word;-ms-word-break:break-all;word-break:break-all;word-break:break-word;-ms-hyphens:auto;-moz-hyphens:auto;-webkit-hyphens:auto;hyphens:auto}.receipts-header{background-color:#1d384d;flex-direction:column;flex-wrap:wrap;align-items:flex-start;max-width:45em;padding-top:7.5em;padding-bottom:7.5em;background-image:url(" + escape(__webpack_require__(7)) + ");background-repeat:no-repeat;background-position:center 2em}.receipt__avatar,.receipts-header{margin-right:auto;margin-left:auto}.receipt__avatar{display:block;object-fit:cover;border:5px solid #f1f1f1;background-color:#f1f1f1;max-height:180px;max-width:180px;border-radius:50%;margin-top:2em;object-position:center;position:relative}.receipts{background-color:#fff;max-width:45em;margin:-12.1875em auto 0;padding-top:11.25em;border-top-left-radius:50px;border-top-right-radius:50px;background-image:url(" + escape(__webpack_require__(20)) + ");background-repeat:no-repeat;background-position:90% 4em;background-size:100px 100px}@media screen and (min-width:48em){.receipts{padding-top:10.3125em;background-position:90% 3.5em;background-size:125px 125px;border-top-left-radius:90px;border-top-right-radius:90px}}.receipts h1{font-size:1.95312rem;text-transform:none}.receipts h1,.receipts h2{color:#1d384d;font-weight:600;margin-bottom:.5em}.receipts h2{font-size:1.25rem}.receipts li{font-size:1rem;list-style-type:disc;color:#676767}.receipts a,.receipts a:active,.receipts a:focus,.receipts a:hover{color:#01d022}.receipts h3{font-size:1.25rem}.receipts p{color:#676767;margin-bottom:1em;line-height:1.5}.receipts hr{border-radius:2px;border:4px solid #1d384d;margin-bottom:1em}.receipt-blockchain,.receipt-donation,.receipt-donation__blockchain,.receipt-donation__got,.receipt-greetings,.receipt-share{margin-bottom:3em}.receipt-donation__donator,.receipt-share a{margin-bottom:1em}.receipt-share a{margin-top:1em;text-align:center;display:block;padding:.5em 1.2em;border-radius:20px;background-color:#f63;text-decoration:none;width:16em}.receipt-share a:hover{color:#366666}.receipt-footer{background-color:#1d384d;padding-top:4em;padding-bottom:2em}.receipts .receipt-footer a{text-decoration:underline;color:#fff}.receipt-footer p{margin-top:2em;margin-bottom:2em;font-size:.8em;color:#fff;text-align:center}.receipts .wrap-logos{text-align:center}.receipts .wrap-logos li{list-style:none;float:none;font-size:19px}.receipts .wrap-votolegal a{margin:0;margin-right:auto;margin-left:auto;display:block;padding:0}.receipts .wrap-votolegal a.votolegal{background:url(" + escape(__webpack_require__(7)) + ");background-repeat:no-repeat;width:171px;height:49px}.receipts .wrap-share-buttons li{background-color:#1d384d;margin-top:1em}.error{margin-bottom:.9375rem;font-weight:700;font-size:.8rem;color:#ed1941}.form__disclaimer{clear:both;margin-top:3.75rem;margin-bottom:.46875rem;font-size:.8rem}.form__disclaimer:before{content:\"\\2022   \"}.donation-form h3{margin:0;margin-top:1.875em;margin-bottom:.46875em;font-size:1rem;text-align:center}.donation-form h3 strong{font-weight:700;font-size:1.25rem;color:#000}.btn-accept-terms-of-use{display:block;height:30px;text-align:center;padding:24px;font-size:18px;cursor:pointer;width:100%;margin-bottom:10px}#maxdonation{display:none}.input-wrapper{margin-top:.46875em;margin-bottom:.46875em}.input-wrapper label{position:absolute;display:block;padding-top:2px;padding-left:10px;font-weight:700}.payment-type{display:inline-block;min-width:10rem}@media (min-width:1020px) and (max-width:1200px){.payment-type{display:block}}#doar .payment-type label{padding-top:0;padding-bottom:0}.payment-choices{padding:0;text-align:center}.certiface-verify h3{margin-bottom:1em}.certiface-verify div{margin-bottom:.5em;text-align:center}.certiface-verify p{margin-bottom:1em}.certiface-verify .donation-nav--rewind{padding-top:.5rem;padding-bottom:.5rem}.certiface-verify .donation-nav--forward{float:right;padding:.5rem .8rem}.donation-nav.donation-nav--block{display:block;text-align:center}.donations-table{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;table-layout:fixed;margin-top:1.875em;margin-bottom:1.875em}.donations-table a{text-decoration:none}.donations-table thead th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media (max-width:64em){.donations-table thead th{font-size:.8rem}}@media screen and (max-width:74.99em){.donations-table thead th{width:auto}}.donations-table thead th:first-child{width:auto}.donations-table thead th:nth-child(2),.donations-table thead th:nth-child(3){width:18%}.donations-table thead th:nth-child(4),.donations-table thead th:nth-child(5),.donations-table thead th:nth-child(6){width:15%}.donations-table tbody td:first-child{width:auto}@media screen and (max-width:74.99em){.donations-table tbody td:first-child{width:auto}}.donations-table tbody td:nth-child(2){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(2){width:auto}}.donations-table tbody td:nth-child(3){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(3){width:auto}}.donations-table tbody td:nth-child(4){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(4){width:auto}}.donations-table tbody td:nth-child(5){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(5){width:auto}}.donations-table tbody td:nth-child(6){width:20%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(6){width:auto}}.entry-content__nav ul{margin-top:2.8125em;margin-bottom:2.8125em}.entry-content__nav li{display:inline-block;margin-right:1em;position:relative;font-weight:700;font-size:1rem;color:#333}.entry-content__nav a{color:#333}.active-nav-item a{color:#f63}.active-nav-item a:hover,.active-nav-item a:link{text-decoration:none}.active-nav-item a:before{background-color:#f63;position:absolute;width:10px;height:10px;border-bottom:1px solid #f63;border-radius:50%;left:50%;top:0;margin-top:-10px;content:\"\"}.donation-form__navigation{margin-top:1.875em;margin-bottom:1.875em}.donation-form__navigation ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed}.donation-form__navigation li{display:inline-block;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;font-weight:700;font-size:1rem}.donation-form--rewind a{color:#f63}.donation-form--rewind a:hover{color:#333}.donation-nav--rewind{float:left;padding-top:.5em}.donation-nav--rewind:before{content:\"< \"}.donation-nav--forward{float:right;background-color:#fff;border-radius:20px;text-align:center}.donation-nav--forward:hover{background-color:#f63;color:#fff}.donation-nav--forward.bigger{font-size:1.25rem}.donation-form__forward a{width:100%}.donation-form__forward a:link{text-decoration:none}.donation-form__forward a:hover{color:#fff}.donate-service__nav a:link{text-decoration:none}.nav-links__donation-service a{width:100%;margin-top:.2em;margin-bottom:.2em;padding-top:.25em;padding-bottom:.25em;border-radius:20px;text-align:center;display:block;white-space:nowrap;list-style-type:none;cursor:pointer;font-size:1rem;font-weight:700;outline:none;background:#fff;color:#f63}.nav-links__donation-service a:link:hover{background:#f63;color:#fff}.donate__nav ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-right:-.9375rem;margin-left:-.9375rem;margin-left:-1.875rem;margin-right:-1.875rem;margin-bottom:1em}.donate__nav li{display:inline-block;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;width:50%;position:relative;font-weight:700;font-size:1rem;color:#fff}.donate__nav a{padding:.5625rem .9375rem;text-align:center;color:#fff;background-color:#c5c5c5}.donate__nav a:link{text-decoration:none}.donate__nav__active a{background-color:#f1f1f1}.service-list a{border-radius:20px;margin-bottom:.46875rem;margin-top:.46875rem;padding:.5em 1em;font-weight:400;background:#fff;display:block;text-decoration:none}.service-list a:hover{color:#ed1941}.service-list .service-nav{margin-top:1.875rem;text-align:center;text-transform:uppercase;color:#ed1941;font-weight:700}.wrap-social-candidate{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;padding:0;margin-top:.5em;margin-right:-.46875rem;margin-left:-.46875rem}@media (min-width:48em){.wrap-social-candidate{position:absolute;right:0;bottom:0;margin-right:2rem}}.wrap-social-candidate li{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;position:relative;width:20px;height:20px;margin:1em .46875rem 0;border-radius:50%}.wrap-social-candidate li:first-child{margin-left:.2em}@media (min-width:48em){.wrap-social-candidate li:first-child{margin-left:.46875rem}.wrap-social-candidate li:last-child{margin-right:0}}.wrap-social-candidate a{position:absolute;top:50%;left:50%;width:36px;height:36px;transform:translate(-50%,-50%)}.wrap-social-candidate a.twitter{background:url(" + escape(__webpack_require__(21)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-social-candidate a.whatsapp{background:url(" + escape(__webpack_require__(22)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-social-candidate a.youtube{background:url(" + escape(__webpack_require__(23)) + ");background-position:50%;background-size:auto 14px;background-repeat:no-repeat}.wrap-social-candidate a.instagram{background:url(" + escape(__webpack_require__(24)) + ");background-position:50%;background-size:auto 14px;background-repeat:no-repeat}.wrap-social-candidate a.facebook{background:url(" + escape(__webpack_require__(25)) + ");background-position:50%;background-size:auto 16px;background-repeat:no-repeat}.wrap-social-candidate a.website{background:url(" + escape(__webpack_require__(26)) + ");background-position:50%;background-size:auto 13px;background-repeat:no-repeat}.wrap-social-candidate a.email{background:url(" + escape(__webpack_require__(27)) + ");background-position:50%;background-size:auto 16px;background-repeat:no-repeat}.wrap-share-buttons{padding:0;margin:0;text-align:center}.wrap-share-buttons li{position:relative;display:inline-block;width:36px;height:36px;margin:0 .1em;background-color:red;border-radius:50%}.wrap-share-buttons a{position:absolute;top:50%;left:50%;width:36px;height:36px;transform:translate(-50%,-50%)}.wrap-share-buttons a.twitter{background:url(" + escape(__webpack_require__(12)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-share-buttons a.mail{background:url(" + escape(__webpack_require__(13)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-share-buttons a.facebook{background:url(" + escape(__webpack_require__(14)) + ");background-position:50%;background-size:auto 18px;background-repeat:no-repeat}.donation-form__breadcrumbs ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-top:.9375em;margin-bottom:.9375em}.donation-form__breadcrumbs li{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;font-size:.8rem;position:relative;width:25px;height:25px;z-index:1;background-color:#bababa;border-radius:50%;margin-right:.5em}li.active-breadcrumbs{background-color:#666}.donation-form__breadcrumbs a{position:absolute;color:#fff;transform:translate(-50%,-50%);top:50%;left:50%}.donation-form__breadcrumbs a:link{text-decoration:none}#candidate.default #doar h2,#candidate.default .campaign-progress__meta-item--expected dd,#candidate.default .campaign-progress__meta__service .candidate-goals,#candidate.default .donate__nav__active a,#candidate.default .donation-nav,#candidate.default .entry-contents a,#candidate.default .input-wrapper a,#candidate.default .site-header h2{color:#f63}#candidate.default .donation-nav--rewind:hover{color:#333}#candidate.default .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.default .active-nav-item a:before,#candidate.default [type=radio]:checked+label:after,#candidate.default [type=radio]:not(:checked)+label:after,#candidate.default tfoot td,#candidate.default tfoot th,#candidate.default thead td,#candidate.default thead th{background-color:#f63}#candidate.default .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.default+#tfooter{background-color:#f63}#candidate.default+#tfooter .wrap-informations{color:#fff}#candidate.default+#tfooter .wrap-informations a{color:inherit}#candidate.default .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.default progress[value]::-moz-progress-bar{background:#f63}#candidate.default progress[value]::-webkit-progress-value{background:#f63}#candidate.default progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.default progress>div:first-child{border-radius:5px 0 0 5px}#candidate.default progress>div:last-child{border-radius:0 5px 5px 0}#candidate.default button{color:#f63}#candidate.default [type=radio]:checked+label:hover:before,#candidate.default [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.default [type=radio]:checked+label{color:#fff}#candidate.default [role=button]:active,#candidate.default [role=button]:focus,#candidate.default [role=button]:hover,#candidate.default [type=button]:active,#candidate.default [type=button]:focus,#candidate.default [type=button]:hover,#candidate.default button:active,#candidate.default button:focus,#candidate.default button:hover{color:#fff;background-color:#f63}#candidate.default [type=button]{color:#fff}#candidate.default .wrap-share-buttons li{background-color:#f63}#candidate.theme--default #doar h2,#candidate.theme--default .campaign-progress__meta-item--expected dd,#candidate.theme--default .campaign-progress__meta__service .candidate-goals,#candidate.theme--default .donate__nav__active a,#candidate.theme--default .donation-nav,#candidate.theme--default .entry-contents a,#candidate.theme--default .input-wrapper a,#candidate.theme--default .site-header h2{color:#f63}#candidate.theme--default .donation-nav--rewind:hover{color:#333}#candidate.theme--default .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.theme--default .active-nav-item a:before,#candidate.theme--default [type=radio]:checked+label:after,#candidate.theme--default [type=radio]:not(:checked)+label:after,#candidate.theme--default tfoot td,#candidate.theme--default tfoot th,#candidate.theme--default thead td,#candidate.theme--default thead th{background-color:#f63}#candidate.theme--default .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.theme--default+#tfooter{background-color:#f63}#candidate.theme--default+#tfooter .wrap-informations{color:#fff}#candidate.theme--default+#tfooter .wrap-informations a{color:inherit}#candidate.theme--default .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.theme--default progress[value]::-moz-progress-bar{background:#f63}#candidate.theme--default progress[value]::-webkit-progress-value{background:#f63}#candidate.theme--default progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--default progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--default progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--default button{color:#f63}#candidate.theme--default [type=radio]:checked+label:hover:before,#candidate.theme--default [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.theme--default [type=radio]:checked+label{color:#fff}#candidate.theme--default [role=button]:active,#candidate.theme--default [role=button]:focus,#candidate.theme--default [role=button]:hover,#candidate.theme--default [type=button]:active,#candidate.theme--default [type=button]:focus,#candidate.theme--default [type=button]:hover,#candidate.theme--default button:active,#candidate.theme--default button:focus,#candidate.theme--default button:hover{color:#fff;background-color:#f63}#candidate.theme--default [type=button]{color:#fff}#candidate.theme--default .wrap-share-buttons li{background-color:#f63}#candidate.theme--orange #doar h2,#candidate.theme--orange .campaign-progress__meta-item--expected dd,#candidate.theme--orange .campaign-progress__meta__service .candidate-goals,#candidate.theme--orange .donate__nav__active a,#candidate.theme--orange .donation-nav,#candidate.theme--orange .entry-contents a,#candidate.theme--orange .input-wrapper a,#candidate.theme--orange .site-header h2{color:#f63}#candidate.theme--orange .donation-nav--rewind:hover{color:#333}#candidate.theme--orange .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.theme--orange .active-nav-item a:before,#candidate.theme--orange [type=radio]:checked+label:after,#candidate.theme--orange [type=radio]:not(:checked)+label:after,#candidate.theme--orange tfoot td,#candidate.theme--orange tfoot th,#candidate.theme--orange thead td,#candidate.theme--orange thead th{background-color:#f63}#candidate.theme--orange .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.theme--orange+#tfooter{background-color:#f63}#candidate.theme--orange+#tfooter .wrap-informations{color:#fff}#candidate.theme--orange+#tfooter .wrap-informations a{color:inherit}#candidate.theme--orange .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.theme--orange progress[value]::-moz-progress-bar{background:#f63}#candidate.theme--orange progress[value]::-webkit-progress-value{background:#f63}#candidate.theme--orange progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--orange progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--orange progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--orange button{color:#f63}#candidate.theme--orange [type=radio]:checked+label:hover:before,#candidate.theme--orange [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.theme--orange [type=radio]:checked+label{color:#fff}#candidate.theme--orange [role=button]:active,#candidate.theme--orange [role=button]:focus,#candidate.theme--orange [role=button]:hover,#candidate.theme--orange [type=button]:active,#candidate.theme--orange [type=button]:focus,#candidate.theme--orange [type=button]:hover,#candidate.theme--orange button:active,#candidate.theme--orange button:focus,#candidate.theme--orange button:hover{color:#fff;background-color:#f63}#candidate.theme--orange [type=button]{color:#fff}#candidate.theme--orange .wrap-share-buttons li{background-color:#f63}#candidate.theme--red #doar h2,#candidate.theme--red .campaign-progress__meta-item--expected dd,#candidate.theme--red .campaign-progress__meta__service .candidate-goals,#candidate.theme--red .donate__nav__active a,#candidate.theme--red .donation-nav,#candidate.theme--red .entry-contents a,#candidate.theme--red .input-wrapper a,#candidate.theme--red .site-header h2{color:#ed1941}#candidate.theme--red .donation-nav--rewind:hover{color:#333}#candidate.theme--red .donation-nav--forward:hover{color:#fff;background-color:#ed1941}#candidate.theme--red .active-nav-item a:before,#candidate.theme--red [type=radio]:checked+label:after,#candidate.theme--red [type=radio]:not(:checked)+label:after,#candidate.theme--red tfoot td,#candidate.theme--red tfoot th,#candidate.theme--red thead td,#candidate.theme--red thead th{background-color:#ed1941}#candidate.theme--red .active-nav-item a:before{border-bottom:1px solid #ed1941}#candidate.theme--red+#tfooter{background-color:#ed1941}#candidate.theme--red+#tfooter .wrap-informations{color:#fff}#candidate.theme--red+#tfooter .wrap-informations a{color:inherit}#candidate.theme--red .site-header{background-image:url(" + escape(__webpack_require__(28)) + ")}#candidate.theme--red progress[value]::-moz-progress-bar{background:#ed1941}#candidate.theme--red progress[value]::-webkit-progress-value{background:#ed1941}#candidate.theme--red progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#ed1941;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--red progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--red progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--red button{color:#ed1941}#candidate.theme--red [type=radio]:checked+label:hover:before,#candidate.theme--red [type=radio]:not(:checked)+label:hover:before{background:#f93156;content:\"\"}#candidate.theme--red [type=radio]:checked+label{color:#fff}#candidate.theme--red [role=button]:active,#candidate.theme--red [role=button]:focus,#candidate.theme--red [role=button]:hover,#candidate.theme--red [type=button]:active,#candidate.theme--red [type=button]:focus,#candidate.theme--red [type=button]:hover,#candidate.theme--red button:active,#candidate.theme--red button:focus,#candidate.theme--red button:hover{color:#fff;background-color:#ed1941}#candidate.theme--red [type=button]{color:#fff}#candidate.theme--red .wrap-share-buttons li{background-color:#ed1941}#candidate.theme--blue #doar h2,#candidate.theme--blue .campaign-progress__meta-item--expected dd,#candidate.theme--blue .campaign-progress__meta__service .candidate-goals,#candidate.theme--blue .donate__nav__active a,#candidate.theme--blue .donation-nav,#candidate.theme--blue .entry-contents a,#candidate.theme--blue .input-wrapper a,#candidate.theme--blue .site-header h2{color:#0072bc}#candidate.theme--blue .donation-nav--rewind:hover{color:#333}#candidate.theme--blue .donation-nav--forward:hover{color:#fff;background-color:#0072bc}#candidate.theme--blue .active-nav-item a:before,#candidate.theme--blue [type=radio]:checked+label:after,#candidate.theme--blue [type=radio]:not(:checked)+label:after,#candidate.theme--blue tfoot td,#candidate.theme--blue tfoot th,#candidate.theme--blue thead td,#candidate.theme--blue thead th{background-color:#0072bc}#candidate.theme--blue .active-nav-item a:before{border-bottom:1px solid #0072bc}#candidate.theme--blue+#tfooter{background-color:#0072bc}#candidate.theme--blue+#tfooter .wrap-informations{color:#fff}#candidate.theme--blue+#tfooter .wrap-informations a{color:inherit}#candidate.theme--blue .site-header{background-image:url(" + escape(__webpack_require__(29)) + ")}#candidate.theme--blue progress[value]::-moz-progress-bar{background:#0072bc}#candidate.theme--blue progress[value]::-webkit-progress-value{background:#0072bc}#candidate.theme--blue progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#0072bc;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--blue progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--blue progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--blue button{color:#0072bc}#candidate.theme--blue [type=radio]:checked+label:hover:before,#candidate.theme--blue [type=radio]:not(:checked)+label:hover:before{background:#2b7fb8;content:\"\"}#candidate.theme--blue [type=radio]:checked+label{color:#fff}#candidate.theme--blue [role=button]:active,#candidate.theme--blue [role=button]:focus,#candidate.theme--blue [role=button]:hover,#candidate.theme--blue [type=button]:active,#candidate.theme--blue [type=button]:focus,#candidate.theme--blue [type=button]:hover,#candidate.theme--blue button:active,#candidate.theme--blue button:focus,#candidate.theme--blue button:hover{color:#fff;background-color:#0072bc}#candidate.theme--blue [type=button]{color:#fff}#candidate.theme--blue .wrap-share-buttons li{background-color:#0072bc}#candidate.theme--green #doar h2,#candidate.theme--green .campaign-progress__meta-item--expected dd,#candidate.theme--green .campaign-progress__meta__service .candidate-goals,#candidate.theme--green .donate__nav__active a,#candidate.theme--green .donation-nav,#candidate.theme--green .entry-contents a,#candidate.theme--green .input-wrapper a,#candidate.theme--green .site-header h2{color:#396}#candidate.theme--green .donation-nav--rewind:hover{color:#333}#candidate.theme--green .donation-nav--forward:hover{color:#fff;background-color:#396}#candidate.theme--green .active-nav-item a:before,#candidate.theme--green [type=radio]:checked+label:after,#candidate.theme--green [type=radio]:not(:checked)+label:after,#candidate.theme--green tfoot td,#candidate.theme--green tfoot th,#candidate.theme--green thead td,#candidate.theme--green thead th{background-color:#396}#candidate.theme--green .active-nav-item a:before{border-bottom:1px solid #396}#candidate.theme--green+#tfooter{background-color:#396}#candidate.theme--green+#tfooter .wrap-informations{color:#fff}#candidate.theme--green+#tfooter .wrap-informations a{color:inherit}#candidate.theme--green .site-header{background-image:url(" + escape(__webpack_require__(30)) + ")}#candidate.theme--green progress[value]::-moz-progress-bar{background:#396}#candidate.theme--green progress[value]::-webkit-progress-value{background:#396}#candidate.theme--green progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#396;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--green progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--green progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--green button{color:#396}#candidate.theme--green [type=radio]:checked+label:hover:before,#candidate.theme--green [type=radio]:not(:checked)+label:hover:before{background:#62a282;content:\"\"}#candidate.theme--green [type=radio]:checked+label{color:#fff}#candidate.theme--green [role=button]:active,#candidate.theme--green [role=button]:focus,#candidate.theme--green [role=button]:hover,#candidate.theme--green [type=button]:active,#candidate.theme--green [type=button]:focus,#candidate.theme--green [type=button]:hover,#candidate.theme--green button:active,#candidate.theme--green button:focus,#candidate.theme--green button:hover{color:#fff;background-color:#396}#candidate.theme--green [type=button]{color:#fff}#candidate.theme--green .wrap-share-buttons li{background-color:#396}.site-header{background-size:70% auto}@media (min-width:20em){.site-header{background-position:center -50px}}@media (min-width:30em){.site-header{background-position:center -100px}}@media (min-width:48em){.site-header{background-position:center 650%;background-size:auto}}.site-header .container{padding-top:10rem;background-image:url(" + escape(__webpack_require__(31)) + ");background-position:1em 30%;background-repeat:no-repeat}@media (min-width:30em){.site-header .container{padding-top:12.5rem}}@media (min-width:64em){.site-header .container{padding-top:12.5rem;background-image:url(" + escape(__webpack_require__(32)) + ");background-position:2em 25%}}#candidate .site-header h2{font-weight:700;font-size:1.5625rem;text-transform:uppercase}#candidate #intro{margin-top:1.875em}.candidate-wrap{position:relative}@media screen and (min-width:64em){.candidate-wrap{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-right:-.9375rem;margin-left:-.9375rem}}@media screen and (min-width:64em){#intro{width:70%}}@media screen and (min-width:64em){#campaign-progress,#intro{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;padding-right:.9375rem;padding-left:.9375rem}#campaign-progress{width:30%}}.intro__meta{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;overflow:hidden}@media screen and (min-width:64em){.intro__meta{border-bottom:1px solid #e5e7ea}}.intro__meta-item{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;max-width:100%;margin-right:2em;margin-bottom:.9375em;line-height:1.3}.intro__meta-item .intro__meta-item:last-child{margin-bottom:0}@media screen and (min-width:48em){.intro__meta-item{margin-bottom:0}}@media screen and (min-width:64em){.intro__meta-item{padding-bottom:.9375em}}.intro__meta-item dt{font-weight:700;font-size:.8rem;text-transform:uppercase;color:#999}.intro__meta-item dd{display:flex;max-width:100%;font-size:1.5625rem}@media screen and (min-width:75em){.intro__meta-item dd{font-size:1.95312rem}}.intro__meta-item .locality,.intro__meta-item .region{display:table-cell}.intro__meta-item .locality{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#campaign-progress{margin-top:.9375em;margin-bottom:1.875em;line-height:1.3}@media screen and (min-width:64em){#campaign-progress{margin-top:1.875em;margin-bottom:1.875em}}.campaign-progress__meta-item dt{font-size:1.95312rem}.campaign-progress__meta-item dd{font-weight:700;font-size:1rem;color:#999}.campaign-progress__meta-currency{font-size:1.5625rem}@media screen and (min-width:75em){.campaign-progress__meta-currency{display:block}}.campaign-progress__donated{font-weight:700}.campaign-progress__meta-captured{font-weight:700;font-size:1rem;color:#999}dt .campaign-progress__value-minor{font-weight:700;font-size:1.25rem}dd .campaign-progress__value-minor{font-weight:700;font-size:1rem}.campaign-progress__meta-item{margin-bottom:1.5em}.campaign-progress__meta-item--expected dt{font-size:2.44141rem}.campaign-progress__meta-item--expected dd{font-size:1.25rem;color:#f63}.campaign-progress__meta-item--expected dd:first-child{margin-bottom:0}@media (min-width:75em){.campaign-progress__meta__service{margin-top:2.8125em}}.campaign-progress__meta__service dt{font-size:1.95312rem}.campaign-progress__meta__service dd{margin-bottom:0;font-weight:700;font-size:1rem;color:#999}.campaign-progress__meta__service .candidate-goals{font-size:1.25rem;color:#f63}.candidate-content{position:relative;width:100%;padding-bottom:3.75rem}@media (max-width:768px){.candidate-content{padding-bottom:1.875rem}}#doar,[id=votar]{position:relative;float:none;display:table;z-index:10;width:100%;max-width:none;padding:1.875rem;margin-bottom:1.875em;overflow:hidden;color:#666;background-color:#f1f1f1;border-radius:1.875rem}@media (min-width:64em){#doar,[id=votar]{position:relative;float:right;clear:right;max-width:36%;margin-top:-10%}}#doar h2,[id=votar] h2{font-weight:700;font-size:1.5625rem;text-align:center;color:#f63}#doar h4,[id=votar] h4{font-weight:700;font-size:.9em;text-align:left}@media (min-width:64em){[id=votar]{margin-top:1.875rem}}#doar section,[id=votar] section{margin-top:.9375em;margin-bottom:.9375em}[id=votar] p{margin-bottom:1.875em}#doar__valores legend{font-size:1.25rem}.donation-panel-title{padding-bottom:.46875em;border-bottom:1px solid #e5e7ea}.payment-confirmation-message{font-weight:700;font-size:1rem;text-align:center;text-transform:uppercase}.final-message{text-align:center}.payment-final-message{font-weight:700;color:#333}.donation-form__chosen-value,.payment-final-message{margin-bottom:.9375em;font-size:1.25rem;text-align:center}.donation-form__currency-value{font-weight:700;font-size:1rem}.donation-form__navigation li{padding:0}.entry-contents{position:relative;width:100%;margin-top:.9375em;margin-bottom:9.375em}@media (max-width:1024px){.entry-contents{float:none;max-width:none}}@media screen and (min-width:64em){.entry-contents h3,.entry-contents h4,.entry-contents p{max-width:63%}}.candidate-summary{margin-bottom:3.75em}.candidate-summary p{white-space:pre-line}.entry-contents section h2,.entry-contents section h4{margin-bottom:.9375em}.entry-contents section p{margin-bottom:1.875em}.entry-content{display:none}.candidate-cnpj{font-size:.8rem}.candidate-biography{white-space:pre-line}.entry-content-active{display:block}.candidate-amount-select{margin-bottom:.9375em;text-align:center}.candidate-amount p{margin-bottom:.9375em;font-weight:700;font-size:.9em}@media print{*{text-shadow:none!important;color:#000!important;background:transparent!important}body{font:12pt/1.33333 Palatino Linotype,Palatino,Times New Roman,Times,serif;color:#000;background:#fff none}a,a:link,a:visited{font-weight:700;text-decoration:underline;color:#444!important;background:transparent}a[href]:after{font-style:italic;word-wrap:break-word;white-space:pre-wrap;color:#333;content:\" (\" attr(href) \") \"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}abbr[title]:after{font-style:italic;content:\" (\" attr(title) \")\"}blockquote,pre{page-break-inside:avoid;border:1px solid #999}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important;vertical-align:bottom}@page{margin:.5cm}h2,h3,p{orphans:3;widows:3}caption,h1,h2,h3,h4,h5,h6,legend{page-break-after:avoid;page-break-inside:never}[role=main]{float:none!important;width:auto;padding:0;margin:0 5%;border:0}.access,.secondary,nav{display:none}}", ""]);

// exports


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":_vm.$route.name}},[_c('header',{staticClass:"receipts-header"},[_c('img',{staticClass:"receipt__avatar",attrs:{"src":_vm.receipt.candidate.avatar,"alt":_vm.receipt.candidate.popular_name}})]),_vm._v(" "),_c('article',{staticClass:"receipts",attrs:{"aria-busy":_vm.receipt.lenght > 1 ? 'true' : 'false'}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"receipt-greetings"},[_c('h1',[_vm._v("\n            Recibo\n        ")]),_vm._v(" "),(_vm.receipt.candidate.colective_name)?_c('p',[_vm._v("\n            Essa doação foi relizada para "+_vm._s(_vm.receipt.candidate.colective_name)+", representado(a) por "),_c('strong',[_vm._v(_vm._s(_vm.receipt.candidate.popular_name))]),_vm._v(",\n            "),(_vm.receipt.candidate.campaign_donation_type === 'campaign')?[_vm._v("\n              candidato(a)\n            ")]:[_vm._v("\n              pré-candidato(a)\n            ")],_vm._v("\n            a "+_vm._s(_vm.receipt.candidate.office.name)+", pelo "),_c('abbr',{attrs:{"title":_vm.receipt.candidate.party.name}},[_vm._v(_vm._s(_vm.receipt.candidate.party.acronym))]),_vm._v(".\n        ")],2):_c('p',[_vm._v("\n          Essa doação foi realizada para "),_c('strong',[_vm._v(_vm._s(_vm.receipt.candidate.popular_name))]),_vm._v(",\n          "),(_vm.receipt.candidate.campaign_donation_type === 'campaign')?[_vm._v("\n            candidato(a)\n          ")]:[_vm._v("\n            pré-candidato(a)\n          ")],_vm._v("\n          a "+_vm._s(_vm.receipt.candidate.office.name)+", pelo "),_c('abbr',{attrs:{"title":_vm.receipt.candidate.party.name}},[_vm._v(_vm._s(_vm.receipt.candidate.party.acronym))]),_vm._v(".\n        ")],2),_vm._v(" "),_c('p',[_vm._v("\n          As doações eleitorais são muito importantes para construção de projetos políticos, porém é fundamental que as plataformas de financiamento coletivo, sociedade e o próprio TSE tenham garantias de que as informações ofereçam integridade e confiabilidade de maneira descentralizada para garantir controle social.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Por isso, "),_c('strong',[_vm._v(_vm._s(_vm.receipt.candidate.popular_name))]),_vm._v(" está registrando todas suas doações financeiras para comprovar a integridade e honestidade no seu processo de captação de recursos.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"receipt-donation"},[_c('h2',[_vm._v("Informações de doação")]),_vm._v(" "),_c('div',{staticClass:"receipt-donation__candidate"},[_c('ul',[(_vm.receipt.candidate.popular_name)?_c('li',[(_vm.receipt.candidate.campaign_donation_type === 'campaign')?[_vm._v("\n                candidato(a)\n              ")]:[_vm._v("\n                pré-candidato(a)\n              ")],_vm._v("\n              "+_vm._s(_vm.receipt.candidate.popular_name)+"\n            ")],2):_vm._e(),_vm._v(" "),(_vm.receipt.candidate.cnpj)?_c('li',[_vm._v("CNPJ: "+_vm._s(_vm._f("formatCNPJ")(_vm.receipt.candidate.cnpj)))]):_vm._e(),_vm._v(" "),(_vm.receipt.candidate.cpf)?_c('li',[_vm._v("CPF: "+_vm._s(_vm._f("formatCPF")(_vm.receipt.candidate.cpf)))]):_vm._e(),_vm._v(" "),(_vm.receipt.candidate.party.name)?_c('li',[_vm._v("Partido: "),_c('abbr',{attrs:{"title":_vm.receipt.candidate.party.name}},[_vm._v(_vm._s(_vm.receipt.candidate.party.acronym))])]):_vm._e(),_vm._v(" "),(_vm.receipt.candidate.office.name)?_c('li',[_vm._v("Cargo: "+_vm._s(_vm.receipt.candidate.office.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"receipt-donation__donator"},[_c('ul',[(_vm.receipt.is_irregular)?_c('li',[_c('strong',[_vm._v("Irregular / em análise:")]),_vm._v(" "+_vm._s(_vm.receipt.irregular_reason))]):_vm._e(),_vm._v(" "),(_vm.receipt.donor_name)?_c('li',[_vm._v("Nome do doador: "+_vm._s(_vm._f("titleCase")(_vm.receipt.donor_name)))]):_vm._e(),_vm._v(" "),(_vm.receipt.name_receita)?_c('li',[_vm._v("Nome na Receita Federal: "+_vm._s(_vm._f("titleCase")(_vm.receipt.name_receita)))]):_vm._e(),_vm._v(" "),(_vm.receipt.donor_cpf)?_c('li',[_vm._v("CPF do doador: "+_vm._s(_vm._f("formatCPF")(_vm.receipt.donor_cpf)))]):_vm._e(),_vm._v(" "),(_vm.receipt.cpf_receita)?_c('li',[_vm._v("CPF corrigido: "+_vm._s(_vm._f("formatCPF")(_vm.receipt.cpf_receita)))]):_vm._e(),_vm._v(" "),(_vm.receipt.captured_at_human)?_c('li',[_vm._v("Data: "+_vm._s(_vm._f("date")(_vm.receipt.captured_at_human)))]):_vm._e(),_vm._v(" "),(_vm.receipt.amount)?_c('li',[_vm._v("Valor: R$"+_vm._s(_vm._f("formatBRL")(_vm.receipt.amount)))]):_vm._e(),_vm._v(" "),(_vm.receipt.payment_method_human)?_c('li',[_vm._v("Forma de pagamento: "+_vm._s(_vm.receipt.payment_method_human))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"receipt-donation__blockchain"},[_c('h2',[_vm._v("Informações sobre o registro na blockchain")]),_vm._v(" "),_c('p',[_vm._v("\n          Para que sua doação tenha garantias, usamos o Blockchain, uma ferramenta que garantirá que todo histórico de doações ficará online e ninguém poderá alterá-lo, de maneira descentralizada.\n        ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Comprovante decred:")]),_vm._v(" "),(_vm.receipt.decred_transaction_url)?_c('a',{attrs:{"href":_vm.receipt.decred_transaction_url}},[_vm._v(_vm._s(_vm.receipt.decred_transaction_url))]):_c('em',[_vm._v("em processamento")])])]),_vm._v(" "),(_vm.receipt.git_url)?_c('div',{staticClass:"receipt-donation__got"},[_c('h2',[_vm._v("Informações sobre o código utilizado para essa doação")]),_vm._v(" "),_c('p',[_vm._v("\n          Para transparência eleitoral, além dos dados de doação, também é fundamental que a tecnologia utilizado para processar essa doação seja aberto. Por isso, nosso código fonte é aberto e também registramos a versão utilizada por nossos servidores junto com os dados de doação na blockchain.\n        ")]),_c('p',[_c('strong',[_vm._v("Versão do site:")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.receipt.git_url}},[_vm._v(_vm._s(_vm.receipt.git_url))])])]):_vm._e(),_vm._v(" "),(_vm.receipt.git_url)?_c('div',{staticClass:"receipt-donation__got"},[_c('h2',[_vm._v("Compartilhe")]),_vm._v(" "),_c('p',[_vm._v("\n          Faça parte desse movimento contra a corrupção eleitoral e fortaleça a nossa rede.\n        ")]),_c('p',[_c('ul',{staticClass:"wrap-share-buttons"},[_c('li',[_c('a',{staticClass:"twitter",attrs:{"target":"_blank","href":'https://twitter.com/intent/tweet?hashtags=VotoLegal&twitter&text=Eu%20apoiei%20'+ _vm.receipt.candidate.popular_name +',%20apoie%20você%20também!%20https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ _vm.receipt.candidate.username +''}})]),_vm._v(" "),_c('li',[_c('a',{staticClass:"fb-xfbml-parse-ignore facebook",attrs:{"target":"_blank","href":'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ _vm.receipt.candidate.username +'&src=sdkpreparse'}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"receipt-footer"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_c('strong',[_vm._v("© 2016-2018 "),_c('a',{attrs:{"href":"https://votolegal.com.br","target":"_blank"}},[_vm._v("Voto Legal")]),_vm._v(" • Uma iniciativa "),_c('a',{attrs:{"href":"http://appcivico.com","target":"_blank"}},[_vm._v("AppCívico")]),_vm._v(" - Tecnologias Cívicas • "),_c('a',{attrs:{"href":_vm.contract,"target":"_blank"}},[_vm._v("Contrato")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-logos"},[_c('ul',{staticClass:"wrap-votolegal"},[_c('li',[_c('a',{staticClass:"votolegal",attrs:{"href":"/"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"https://votolegal.com.br","target":"_blank"}},[_vm._v("Voto Legal")]),_vm._v(" é uma plataforma de software livre.\n          Todas as doações são registradas na blockchain da Decred com objetivo de garantir a autenticidade das transações, promovendo a confiabilidade no processo de doação eleitoral.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deposit_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6599ad75_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deposit_vue__ = __webpack_require__(286);
function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deposit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6599ad75_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deposit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(285);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7945c380", content, true, {});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(3);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "*,:after,:before{background-repeat:no-repeat;box-sizing:inherit;tab-size:inherit}::selection{text-shadow:none;color:#fff;background-color:#14698c}[aria-busy=true]{cursor:progress}[aria-busy=true][aria-hidden=true]:before{content:none}[aria-busy=true][aria-hidden=true]:after{position:static;display:inline-block;width:0;overflow:hidden;vertical-align:bottom;background:none;content:\"\\2026\";opacity:.5;animation:ellipsis steps(4) .9s infinite}@keyframes ellipsis{to{width:1.25em}}main[aria-busy=true]{overflow:hidden}[aria-controls]{cursor:pointer}[aria-disabled]{cursor:default}[tabindex],a,area,button,input,label,select,summary,textarea{touch-action:manipulation}html{height:100%;padding:0;margin:0;overflow-y:scroll;font-size:100.01%;text-size-adjust:100%;background:#f1f1f1;box-sizing:border-box;tab-size:4}body{max-width:1400px;min-height:100%;margin:0;margin:auto;color:#333;background:#fff}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section{display:block}summary{display:list-item;list-style-type:none;cursor:pointer}summary::-webkit-details-marker{display:none}summary:focus{outline:5px auto -webkit-focus-ring-color}summary:before{padding-right:.5em;content:\"\\25B6\"}details[open]>summary:before{content:\"\\25BC\"}[hidden],template{display:none}[hidden][aria-hidden=false]{position:absolute;display:inherit;clip:rect(0,0,0,0)}[hidden][aria-hidden=false]:focus{clip:auto}hr{margin:calc(1.5em - 1px) 0 1.5em;clear:both;display:block;height:0;padding:0;overflow:visible;color:#999;border:0;border-top:1px solid #999;box-sizing:content-box}svg:not(:root){overflow:hidden}svg{fill:currentColor}a>svg{pointer-events:none}audio,canvas,iframe,progress,svg,video{display:inline-block;vertical-align:middle}audio:not([controls]){display:none;height:0}meter,progress{background-size:auto;appearance:none}iframe,img,object{font-size:83.3333%;color:currentColor;border-style:none}embed,img,object,video{max-width:100%}video>source{width:100%;height:auto}.ie:not(.ie6-8),object>img{position:relative;z-index:-1;font-size:1em;pointer-events:none}img{height:auto;max-width:100%;max-height:90vh;image-rendering:optimizeQuality;-ms-interpolation-mode:bicubic}[usemap]{color:#06c}li img,p img{vertical-align:middle}a>picture,a img{border:0}a{padding:0;margin:0;font-weight:700;font-size:100%;vertical-align:baseline;color:#333}a,a:active,a:focus,a:hover,a:link{text-decoration:underline}a:link{cursor:pointer;-webkit-tap-highlight-color:rgba(0,0,0,0)}a:visited:active,a:visited:focus,a:visited:hover{text-decoration:underline}a:focus,a:hover{color:#f63}a:focus{overflow:hidden;outline:none;outline-offset:2px}a:active,a:hover{outline-width:0}a:active{background-color:transparent}address{padding:0;margin:0;font-style:italic}*,:after,:before{line-height:inherit;text-decoration:inherit;vertical-align:inherit}body{font-weight:400;font-size:1em;line-height:1.875;font-family:Miriam Libre,sans-serif;color:#212121}caption,details>summary,h1,h2,h3,h4,h5,h6,legend{font-weight:600;font-family:Miriam Libre,sans-serif;font-feature-settings:\"case\" 1,\"cpsp\" 1,\"cswh\" 1,\"liga\" 1,\"locl\" 1,\"lnum\" 1,\"pnum\" 1,\"titl\" 1,\"zero\" 1;break-after:avoid;page-break-after:avoid}caption a,caption a:link,dt a,dt a:link,h1 a,h1 a:link,h2 a,h2 a:link,h3 a,h3 a:link,h4 a,h4 a:link,h5 a,h5 a:link,h6 a,h6 a:link,legend a,legend a:link{text-decoration:inherit;color:inherit}h1{font-size:3.05176rem;font-weight:100;text-transform:capitalize}h2{font-size:1.95312rem;font-weight:400}h3{font-size:1.5625rem}h3,h4{font-weight:700}h4{font-size:1.25rem}p{padding:0;margin:0}article p{orphans:3;widows:3}article fieldset>p:first-child,article h1+p,article h2+p,article h3+p,article h4+p,article h5+p,article h6+p,article legend+p{margin-top:0;text-indent:0}abbr[title],dfn[title]{text-decoration:none;cursor:help;border-bottom:1px dotted}@supports (text-decoration:dotted underline){abbr[title],dfn[title]{text-decoration:none;border-bottom:inherit}}abbr{letter-spacing:.1em}dfn{font-style:italic;font-size:1em}b,strong{font-weight:700;font-weight:inherit;font-weight:600}mark{color:#333;background:#d7ff5a}small{line-height:inherit}small,sub,sup{font-size:83.3333%}sub,sup{position:relative;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}time{font-style:italic}time[pubdate]{cursor:help}code,kbd,pre,samp,var{font-size:1em;font-family:Consolas,Liberation Mono,Menlo,Courier,monospace,monospace,monospace}pre{padding:0;margin:0;overflow:auto;word-wrap:break-word;white-space:pre;white-space:pre-wrap;white-space:pre-line}samp,var{font-style:italic}del,s{text-decoration:line-through}s{font-style:italic}del:before,ins:before{font-weight:700;text-decoration:none;content:\"[update] \"}del[datetime]:before,ins[datetime]:before{content:\"[update\\A0\\2192\\A0\" attr(datetime) \"] \"}del:after,ins:after{text-decoration:none;content:\" [/update] \"}ins{text-decoration:underline}ins:lang(pt):before{content:\" [inserido] \"}ins[datetime]:lang(pt):before{content:\" [inserido\\A0\\2192\\A0\" attr(datetime) \"] \"}ins:lang(pt):after{content:\" [/inserido] \"}del:lang(pt):before{content:\" [exclu\\ED  do] \"}del[datetime]:lang(pt):before{content:\" [exclu\\ED  do\\A0\\2192\\A0\" attr(datetime) \"] \"}del:lang(pt):after{content:\" [/exclu\\ED  do] \"}blockquote,q{font-style:italic;color:#575757}cite{font-style:italic;font-size:1em}blockquote footer:before{content:\"\\2014   \\A0\"}blockquote footer cite{font-style:italic}blockquote li,blockquote p,blockquote pre{font-size:1em}blockquote.verse{text-align:center}blockquote.verse p{display:inline-block;width:auto;margin-right:auto;margin-left:auto;text-align:left}embed,input[aria-busy=true],keygen[aria-busy=true],output[aria-busy=true],textarea[aria-busy=true]{background-image:url(" + escape(__webpack_require__(8)) + ");background-position:50% 50%;background-repeat:no-repeat;background-color:hsla(0,0%,7%,.8)}[aria-busy=true]:not(html),[aria-busy=true]>body{cursor:wait}:not(html)[aria-busy=true]:before,[aria-busy=true]>body:before{position:absolute;top:-.9375rem;right:-.9375rem;bottom:-.9375rem;left:-.9375rem;z-index:3000;padding:1.875rem;text-align:center;color:#fff;background-image:url(" + escape(__webpack_require__(8)) + ");background-position:50% 50%;background-repeat:no-repeat;background-color:hsla(0,0%,7%,.8);border-radius:20px;content:\"\"}:not(html)[aria-busy=true][data-busy-message]:before,[aria-busy=true]>body[data-busy-message]:before{padding-top:3.75rem;content:attr(data-busy-message)}[aria-busy=true]:not(html),[aria-busy=true]>body{position:relative}img{background-size:auto}img:after{content:none}embed{background-size:auto}embed:after{content:none}input[aria-busy=true],keygen[aria-busy=true],output[aria-busy=true],textarea[aria-busy=true]{background-size:auto}.grid:after,.grid:root:before{position:fixed;top:0;right:0;z-index:5000;font-size:1rem;pointer-events:none;content:\"breakpoint: phone\"}.grid:after{bottom:0;left:0;background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35));background-position:top;content:\"\"}@media screen and (min-width:30em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% + 1.25rem),transparent calc(33.33333% + 1.25rem),transparent calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% + .625rem),transparent calc(66.66667% + .625rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:48em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(25% - .46875rem),rgba(255,0,0,.35) calc(25% - .46875rem),rgba(255,0,0,.35) calc(25% + 1.40625rem),transparent calc(25% + 1.40625rem),transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(75% - 1.40625rem),rgba(255,0,0,.35) calc(75% - 1.40625rem),rgba(255,0,0,.35) calc(75% + .46875rem),transparent calc(75% + .46875rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:64em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(20% - .375rem),rgba(255,0,0,.35) calc(20% - .375rem),rgba(255,0,0,.35) calc(20% + 1.5rem),transparent calc(20% + 1.5rem),transparent calc(40% - .75rem),rgba(255,0,0,.35) calc(40% - .75rem),rgba(255,0,0,.35) calc(40% + 1.125rem),transparent calc(40% + 1.125rem),transparent calc(60% - 1.125rem),rgba(255,0,0,.35) calc(60% - 1.125rem),rgba(255,0,0,.35) calc(60% + .75rem),transparent calc(60% + .75rem),transparent calc(80% - 1.5rem),rgba(255,0,0,.35) calc(80% - 1.5rem),rgba(255,0,0,.35) calc(80% + .375rem),transparent calc(80% + .375rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35))}}@media screen and (min-width:75em){.grid:after{background-image:linear-gradient(90deg,rgba(255,0,0,.35) 0,rgba(255,0,0,.35) 1.875rem,transparent 0,transparent calc(16.66667% - .3125rem),rgba(255,0,0,.35) calc(16.66667% - .3125rem),rgba(255,0,0,.35) calc(16.66667% + 1.5625rem),transparent calc(16.66667% + 1.5625rem),transparent calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% - .625rem),rgba(255,0,0,.35) calc(33.33333% + 1.25rem),transparent calc(33.33333% + 1.25rem),transparent calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% - .9375rem),rgba(255,0,0,.35) calc(50% + .9375rem),transparent calc(50% + .9375rem),transparent calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% - 1.25rem),rgba(255,0,0,.35) calc(66.66667% + .625rem),transparent calc(66.66667% + .625rem),transparent calc(83.33333% - 1.5625rem),rgba(255,0,0,.35) calc(83.33333% - 1.5625rem),rgba(255,0,0,.35) calc(83.33333% + .3125rem),transparent calc(83.33333% + .3125rem),transparent calc(100% - 1.875rem),rgba(255,0,0,.35) calc(100% - 1.875rem),rgba(255,0,0,.35));background-size:1400px 100%}}.grid:root:before{padding:1.875rem;background-color:red;opacity:.75}@media screen and (min-width:30em){.grid:root:before{content:\"breakpoint: phablet\"}}@media screen and (min-width:48em){.grid:root:before{content:\"breakpoint: tablet\"}}@media screen and (min-width:64em){.grid:root:before{content:\"breakpoint: desktop\"}}@media screen and (min-width:75em){.grid:root:before{content:\"breakpoint: wide\"}}ol,ul{margin:0 0 1.5rem;padding-left:1em;margin:0}ol{counter-reset:li}article li{position:relative;padding-left:0;margin:0;list-style:none}article li:last-child{margin-bottom:0}dl{margin:0 0 1rem}dd,dl,dt{padding:0}dd,dt{margin:0}dd{margin:0 0 1rem}dd:last-child{margin-bottom:0}menu ol,menu ul,nav ol,nav ul{padding:0;margin:0;list-style:none}menu li,nav li{padding:0;margin:0}menu li:before,nav li:before{content:none}menu a,nav a{display:block;overflow:hidden}menu a:link,nav a:link{text-decoration:underline}.current>a{pointer-events:none}[for=menu-controller]:before{font-size:2em;line-height:.75;font-family:sans-serif;vertical-align:middle;content:\" \\2261   \"}@media screen and (min-width:64em){[for=menu-controller]{display:none}}table,tbody,td,tfoot,th,thead,tr{background:red;padding:1em}.irregular td,.irregular th{text-decoration:line-through}tbody td,tbody th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}table,tbody,td,tfoot,th,thead,tr{width:auto;height:auto;font-size:1rem;vertical-align:top;background-color:transparent;border:0}@media screen and (max-width:74.99em){table,tbody,td,tfoot,th,thead,tr{display:block}}table{width:100%;max-width:100%;font-size:100%;font-family:inherit;font-feature-settings:\"kern\" 1,\"liga\" 1,\"calt\" 1,\"pnum\" 0,\"tnum\" 1,\"onum\" 0,\"lnum\" 1,\"dlig\" 0;border-collapse:collapse;empty-cells:show}@media screen and (max-width:74.99em){table{padding:0}}table li,table p{font-size:1rem}.blockchain-cell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media screen and (max-width:74.99em){tr{padding:0;padding-bottom:.46875em;padding-top:.46875em;margin:0 0 1.5rem}tr:last-child{margin-bottom:0}}th{font-weight:700;text-transform:capitalize}@media screen and (max-width:74.99em){th{text-transform:capitalize;padding-top:.46875em}}td{font-family:inherit}@media screen and (max-width:74.99em){td{padding-bottom:.46875em;padding-top:.46875em}}@media screen and (max-width:74.99em){td:empty,thead{display:none}}thead td,thead th{background-color:#f63;color:#fff;text-align:left;vertical-align:bottom}tbody,tfoot th:first-child,thead th:first-child{text-align:left}@media screen and (max-width:74.99em){tbody{padding:0}}tbody td,tbody th{text-align:left}tbody td{font-variant-numeric:lining-nums oldstyle-nums}@media screen and (max-width:74.99em){tbody td{text-align:left}tbody td[title]{text-align:right}tbody td[title]:before{float:left;font-style:italic;content:attr(title) \": \"}}tbody tr:nth-child(odd){background-color:#f1f1f1}td img{vertical-align:top}@media screen and (max-width:74.99em){tbody tr:nth-of-type(odd)>td,tbody tr:nth-of-type(odd)>th{background-color:transparent}}tfoot td,tfoot th{background-color:#f63;color:#fff;vertical-align:top;text-align:left}@media screen and (max-width:74.99em){tfoot td,tfoot th{display:none}}form{margin:0}fieldset{max-width:none;min-width:0;padding:0;border:0}fieldset>legend,legend{display:table;max-width:100%;padding:0;font-weight:bolder;white-space:normal;color:inherit;box-sizing:border-box}label{padding:0;margin:0;font-size:small;line-height:inherit}label *{font-size:1em}form br{clear:both}[role=button],[type=button],[type=email],[type=number],[type=password],[type=reset],[type=search],[type=submit],[type=tel],[type=text],[type=url],button,html [type=button],optgroup,textarea{display:inline-block;padding:1px;margin:0;overflow:visible;font-size:inherit;line-height:inherit;font-family:inherit;-webkit-font-smoothing:inherit;letter-spacing:inherit;text-align:inherit;text-transform:inherit;white-space:normal;vertical-align:top;color:inherit;border:1px solid #ddd;border-radius:20px;outline:none;box-sizing:border-box}:focus[role=button],:focus[type=button],:focus[type=email],:focus[type=number],:focus[type=password],:focus[type=reset],:focus[type=search],:focus[type=submit],:focus[type=tel],:focus[type=text],:focus[type=url],button:focus,optgroup:focus,textarea:focus{outline:none;outline-offset:0}:disabled,:readonly{color:#6b6b6b;background:#f0f0f0}:disabled{cursor:not-allowed}:readonly{cursor:default}:-moz-placeholder{color:#575757;opacity:1}:focus:-moz-placeholder{color:#8f8f8f}::-moz-placeholder{color:#575757;opacity:1}:focus::-moz-placeholder{color:#8f8f8f}::-webkit-input-placeholder{color:#575757;opacity:1}:focus::-webkit-input-placeholder{color:#8f8f8f}:-ms-input-placeholder{color:#575757;opacity:1}:focus:-ms-input-placeholder{color:#8f8f8f}::placeholder{color:#575757;opacity:1}:focus::placeholder{color:#8f8f8f}[type=color],[type=file],[type=image]{padding:0;vertical-align:middle;cursor:pointer;border:0}[type=image]{display:inline-block}[type=color]{background-color:#fff}::-webkit-color-swatch{border:0}::-moz-color-swatch{border:0}::-webkit-color-swatch-wrapper{padding:0}::-moz-color-swatch-wrapper{padding:0}[type=file]{height:2em;min-width:250px;padding:0!important;margin:0;font-family:inherit;text-align:start!important;white-space:nowrap;cursor:default;background-color:transparent;border-style:none!important;-webkit-box-align:baseline;-webkit-appearance:none;-moz-appearance:none;appearance:normal;-moz-binding:none}[type=file]>[type=text]{height:inherit;font-size:inherit;letter-spacing:inherit;color:inherit;background-color:inherit;border-color:inherit}[type=file]>[type=button]{height:inherit;padding:0;font-size:inherit;white-space:normal;-webkit-box-align:center;box-sizing:content-box;appearance:button}::-webkit-file-upload-button{font:inherit;cursor:pointer;background-color:#f63;border:1px solid #ddd;-webkit-appearance:button}::-webkit-file-upload-button:hover{background-color:#fff}:focus::-webkit-color-swatch,:focus::-webkit-file-upload-button{outline:none}::-ms-browse{border:1px solid #ddd}::-ms-browse:hover{background-color:#fff}:focus::-ms-browse{outline:none}:required,[required]{box-shadow:none}[type=checkbox]:-moz-focusring,[type=radio]:-moz-focusring,[type=range]:-moz-focusring{outline-width:0}.checkbox-custom{zoom:1\\9;color:#fff;padding-right:.9375rem}.checkbox-custom:after,.checkbox-custom:before{display:table;content:\"\";border-collapse:collapse}.checkbox-custom:after{clear:both}.checkbox-custom [type=checkbox]{position:relative;display:inline-block;opacity:1;width:auto;height:auto}.checkbox-custom .input-wrapper label{position:relative;color:#000;display:inline;line-height:0;font-weight:400}.checkbox-custom .input-wrapper label a{color:inherit}.of-radios-and-checks .input-wrapper{position:relative;display:block;width:33.33333%;float:left;padding-right:.1875rem;padding-left:.1875rem;margin-bottom:0;white-space:nowrap;list-style-type:none;overflow:hidden}.of-radios-and-checks .input-wrapper:before{content:none}@media (max-width:480px){.of-radios-and-checks .input-wrapper{width:50%}}.of-radios-and-checks .input-wrapper label{padding-left:0}.of-radios-and-checks .input-wrapper--full-width{width:100%}.of-radios-and-checks .has-real-value{background-color:#fff;border-radius:30px;color:#212121;float:none;margin-right:.1875rem;margin-left:.1875rem;padding-top:.75rem;padding-bottom:.75rem;position:relative;width:auto;padding-left:2.25rem}.has-real-value label{display:block;background-color:transparent;padding:0;margin-left:-1.25rem;font-size:1em}.has-real-value label:focus,.has-real-value label:hover{color:inherit;background-color:transparent}.has-real-value [type=tel]{color:inherit;position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:100%;color:transparent;background:transparent;margin:0;padding:0;border:none}.has-real-value .real-value{font-size:1em;display:block;min-height:30px;line-height:2em;padding-left:.46875rem}.has-real-value [type=button]{border:0;border-radius:50%;background-color:#999;color:#fff;padding-right:.80625rem;padding-left:.80625rem;position:absolute;top:.1875rem;right:.1875rem;z-index:2}.site-footer{text-align:center;font-size:.8rem;color:#fff;background-color:#f63}.donations-sources{padding-top:.9375rem;padding-bottom:.9375rem;font-weight:400;font-size:.8rem;line-height:1.875;color:rgba(33,33,33,.65)}.donations-sources *{font-size:inherit!important}.donations-sources ul{padding-left:0}.donations-sources li:before{display:inline-block;width:1em;height:1em;background-color:#f63;border:1px solid #fff;border-radius:50%;content:\"\"}.donations-sources li:nth-child(2):before{background-image:linear-gradient(rgba(0,0,0,.25),rgba(0,0,0,.25))}.donations-sources li:nth-child(3):before{background-image:linear-gradient(rgba(0,0,0,.5),rgba(0,0,0,.5))}.donations-sources li:nth-child(4):before{background-image:linear-gradient(rgba(0,0,0,.75),rgba(0,0,0,.75))}.donations-sources li:nth-child(5):before,.donations-sources li:nth-child(6):before,.donations-sources li:nth-child(7):before,.donations-sources li:nth-child(8):before,.donations-sources li:nth-child(9):before,.donations-sources li:nth-child(10):before{background-image:linear-gradient(#000,#000)}.donations-sources em,.donations-sources strong{font-weight:400}.donations-sources details,.donations-sources details[open]{display:inline}.donations-sources summary{display:inline;font-weight:400;list-style-type:none;cursor:help}.donations-sources summary:before{content:none}.donations-sources summary:after{display:inline-block;width:1.875em;height:1.875em;margin-right:.5em;margin-left:.5em;line-height:1.875em;text-align:center;background-color:#000;border-width:1px;border-color:currentColor;border-radius:50%;content:\"?\";transition-duration:1s;transition-property:background-color}.donations-sources summary:focus,.donations-sources summary:hover{text-decoration:underline}.donations-sources summary:focus:after,.donations-sources summary:hover:after{text-decoration:none;background-color:#3298ff}.donations-sources [open] summary:before{content:none}.donations-sources [open] summary~*{overflow:hidden;animation:here-comes-the-detail .5s ease-in-out}@keyframes here-comes-the-detail{0%{opacity:0}to{opacity:1}}@media screen and (min-width:30em){.donations-sources [open] summary~:after{content:\"\\A0; \"}.donations-sources [open] summary+:before{content:\"(\\A0\"}.donations-sources [open] summary~:last-child:after{content:\"\\A0)\"}}.donations-sources details p{display:inline}.donations-sources details em{font-style:normal}.donations-sources__amount{font-size:1rem}figure{margin:1em 2.5rem;margin:0}figcaption{font-size:83.3333%;line-height:inherit}figcaption p,figcaption small{margin:0;font-size:1em}[role=button],[type=button],[type=reset],[type=submit],button,html [type=button]{width:auto;padding:.5em 1.2em;border-radius:1.25rem;font-weight:700;border:0;overflow:visible;text-indent:0;white-space:inherit;cursor:pointer;box-sizing:inherit;appearance:button}[role=button]::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border:0}:active[role=button],:active[type=button],:active[type=reset],:active[type=submit],:focus[role=button],:focus[type=button],:focus[type=reset],:focus[type=submit],:hover[role=button],:hover[type=button],:hover[type=reset],:hover[type=submit],button:active,button:focus,button:hover{background-color:#fff}[role=button]:focus,[role=button]:hover,[type=button]:focus,[type=button]:hover,button:focus,button:hover{background-color:#f63;color:#fff}[role=button]:active,[type=button]:active,button:active{background-color:#666;color:#fff}[type=submit]{background-color:#fff;color:#f63}[type=submit]:focus,[type=submit]:hover{background-color:#f63;color:#fff}[type=submit]:active{background-color:#f63}button:-moz-focusring,input:-moz-focusring{outline:1px dotted ButtonText}.button--load-more[class]{display:block;margin:1.875rem auto 3.75rem;background-color:#999;text-transform:lowercase}fieldset ol,fieldset ul{padding:0;margin:0}fieldset li{text-align:center;display:block;white-space:nowrap;list-style-type:none}fieldset li:before{content:none}li label{display:inline;padding:0 .5em}[type=checkbox],[type=radio]{width:auto;height:auto;padding:0;vertical-align:middle;cursor:pointer;box-sizing:border-box}[type=checkbox]:focus,[type=radio]:focus{outline-style:auto}li:hover>input,li:hover>label{color:#000}li :checked+label{font-weight:700}:disabled+label,[disabled]+label{cursor:default;color:#6b6b6b}.of-radios-and-checks [type=radio]:checked+label,.of-radios-and-checks [type=radio]:not(:checked)+label{font-size:1rem}@media screen and (min-width:75em){.of-radios-and-checks [type=radio]:checked+label,.of-radios-and-checks [type=radio]:not(:checked)+label{font-size:1.25rem}}[type=radio]:checked+label,[type=radio]:not(:checked)+label{position:relative;width:100%;margin-top:.25em;margin-bottom:.5em;padding-top:.25em;padding-bottom:.25em;border-radius:20px;text-align:center;display:block;white-space:nowrap;list-style-type:none;cursor:pointer;z-index:3;font-size:1rem;font-weight:700;outline:none}[type=radio]:checked+label .donation-form__currency-item,[type=radio]:not(:checked)+label .donation-form__currency-item{font-size:1rem}[type=radio]+label:hover,[type=radio]:checked+label{color:#fff}input[type=checkbox],input[type=radio]{position:absolute;height:100%;width:100%;opacity:0}[type=radio]:checked,[type=radio]:not(:checked){position:absolute;left:0;top:0;z-index:2}[type=radio]:checked+label:before,[type=radio]:not(:checked)+label:before{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;border-radius:20px;background:#fff;z-index:-1}[type=radio]:checked+label:hover:before,[type=radio]:not(:checked)+label:hover:before{content:\"\";background:#f63}[type=radio]:checked+label:after,[type=radio]:not(:checked)+label:after{content:\"\";position:absolute;width:100%;height:100%;border-radius:20px;background:#f63;left:0;top:0;-webkit-transition:all .2s ease;transition:all .2s ease;z-index:-1}[type=radio]:not(:checked)+label:after{opacity:0;-webkit-transform:scale(0);transform:scale(0)}[type=radio]:checked+label:after{opacity:1;-webkit-transform:scale(1);transform:scale(1)}[role=progressbar],progress{width:100%;height:5px;line-height:5px;border-radius:5px;color:#fff;overflow:hidden;border:0;background:#e0e0e0}[role=progressbar][value]::-moz-progress-bar,progress[value]::-moz-progress-bar{border-radius:5px;background:#f63;transition:width .5s}[role=progressbar][value]::-webkit-progress-value,progress[value]::-webkit-progress-value{border-radius:5px;background:#f63;transition:width .5s}[role=progressbar]>div,progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;border-radius:5px;background:#f63;transition:width .5s;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}[role=progressbar]>div:first-child,progress>div:first-child{border-radius:5px 0 0 5px}[role=progressbar]>div:last-child,progress>div:last-child{border-radius:0 5px 5px 0}[role=progressbar]::-webkit-progress-bar,progress::-webkit-progress-bar{background:#e0e0e0}option,select{width:auto;min-width:1.5em;cursor:pointer}select{text-indent:.01px;text-overflow:\"\";box-sizing:content-box;-webkit-appearance:none;-moz-appearance:none;appearance:none}select::-ms-expand{display:none}.ie6-9:invalid,select{padding-right:1.5em;background-image:url(\"data:image/png;base64,R0lGODlhDwAUAIABAAAAAP///yH5BAEAAAEALAAAAAAPABQAAAIXjI+py+0Po5wH2HsXzmw//lHiSJZmUAAAOw==\");background-position:95% 50%}optgroup{font-weight:700}option{padding:0 .4em 0 .1em;margin:0}option:focus,option:hover{color:#000}select[multiple] option:checked{font-weight:700}[type=range]{display:block;width:100%;padding:0;vertical-align:middle;cursor:pointer;background:transparent;border:0;appearance:none}[type=range]::-webkit-slider-runnable-track{width:100%;background-color:#f63}[type=range]::-webkit-slider-runnable-track:focus{outline:none}[type=range]::-moz-range-track{background-color:#f63}[type=range]::-moz-range-track:focus{outline:none}[type=range]::-ms-track{width:100%;color:transparent;background:transparent;border-width:.6875rem 0;border-color:transparent}[type=range]::-ms-fill-lower{background-color:#f63}[type=range]::-ms-fill-lower:focus{outline:none}[type=range]::-ms-fill-upper{background-color:#f63}[type=range]::-ms-fill-upper:focus{outline:none}[type=range]::-webkit-slider-thumb{background-color:#fff;border:0;margin-top:-.6875rem;appearance:none}[type=range]::-moz-range-thumb{background-color:#fff;border:0;appearance:none}[type=range]::-ms-thumb{margin-top:0;appearance:none;background-color:#fff;border:0}[type=range]::-moz-focus-outer{border:0}[type=range]:-moz-focusring{outline:1px solid transparent;outline-offset:-1px}[type=email],[type=number],[type=password],[type=search],[type=tel],[type=text],[type=url],textarea{width:100%;height:3.125rem;padding-top:1.2em;padding-left:.2em;font-size:1rem;text-indent:.5ex;cursor:text;border-radius:6px;box-sizing:inherit;appearance:none}:invalid[type=email],:invalid[type=number],:invalid[type=password],:invalid[type=search],:invalid[type=tel],:invalid[type=text],:invalid[type=url],textarea:invalid{border-radius:6px;box-shadow:0}:disabled[type=email],:disabled[type=number],:disabled[type=password],:disabled[type=search],:disabled[type=tel],:disabled[type=text],:disabled[type=url],textarea:disabled{cursor:not-allowed;background-color:#bababa;border-radius:6px;box-shadow:0}:-moz-ui-invalid[type=email],:-moz-ui-invalid[type=number],:-moz-ui-invalid[type=password],:-moz-ui-invalid[type=search],:-moz-ui-invalid[type=tel],:-moz-ui-invalid[type=text],:-moz-ui-invalid[type=url],textarea:-moz-ui-invalid{border-radius:6px;box-shadow:0}:focus[type=email],:focus[type=number],:focus[type=password],:focus[type=search],:focus[type=tel],:focus[type=text],:focus[type=url],textarea:focus{outline:none}[type=number]{-moz-appearance:textfield}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto;margin:0;-webkit-appearance:none}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto;line-height:inherit;white-space:pre;vertical-align:top;cursor:text;resize:vertical}.embed-container{padding-bottom:56.25%;height:0;overflow:hidden;position:relative;border-top-left-radius:2em;border-bottom-left-radius:2em;border-top-right-radius:2em;border-bottom-right-radius:2em;margin-bottom:1.875em}@media (min-width:64em){.embed-container{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:2em;border-bottom-right-radius:0}}.embed-container iframe{position:absolute;top:0;right:0;left:0;bottom:0;width:100%;height:100%}#receipt{background:#f1f1f1}#receipt .container{padding-right:3rem;padding-left:3rem}#receipt a{overflow-wrap:break-word;word-wrap:break-word;-ms-word-break:break-all;word-break:break-all;word-break:break-word;-ms-hyphens:auto;-moz-hyphens:auto;-webkit-hyphens:auto;hyphens:auto}.receipts-header{background-color:#1d384d;flex-direction:column;flex-wrap:wrap;align-items:flex-start;max-width:45em;padding-top:7.5em;padding-bottom:7.5em;background-image:url(" + escape(__webpack_require__(7)) + ");background-repeat:no-repeat;background-position:center 2em}.receipt__avatar,.receipts-header{margin-right:auto;margin-left:auto}.receipt__avatar{display:block;object-fit:cover;border:5px solid #f1f1f1;background-color:#f1f1f1;max-height:180px;max-width:180px;border-radius:50%;margin-top:2em;object-position:center;position:relative}.receipts{background-color:#fff;max-width:45em;margin:-12.1875em auto 0;padding-top:11.25em;border-top-left-radius:50px;border-top-right-radius:50px;background-image:url(" + escape(__webpack_require__(20)) + ");background-repeat:no-repeat;background-position:90% 4em;background-size:100px 100px}@media screen and (min-width:48em){.receipts{padding-top:10.3125em;background-position:90% 3.5em;background-size:125px 125px;border-top-left-radius:90px;border-top-right-radius:90px}}.receipts h1{font-size:1.95312rem;text-transform:none}.receipts h1,.receipts h2{color:#1d384d;font-weight:600;margin-bottom:.5em}.receipts h2{font-size:1.25rem}.receipts li{font-size:1rem;list-style-type:disc;color:#676767}.receipts a,.receipts a:active,.receipts a:focus,.receipts a:hover{color:#01d022}.receipts h3{font-size:1.25rem}.receipts p{color:#676767;margin-bottom:1em;line-height:1.5}.receipts hr{border-radius:2px;border:4px solid #1d384d;margin-bottom:1em}.receipt-blockchain,.receipt-donation,.receipt-donation__blockchain,.receipt-donation__got,.receipt-greetings,.receipt-share{margin-bottom:3em}.receipt-donation__donator,.receipt-share a{margin-bottom:1em}.receipt-share a{margin-top:1em;text-align:center;display:block;padding:.5em 1.2em;border-radius:20px;background-color:#f63;text-decoration:none;width:16em}.receipt-share a:hover{color:#366666}.receipt-footer{background-color:#1d384d;padding-top:4em;padding-bottom:2em}.receipts .receipt-footer a{text-decoration:underline;color:#fff}.receipt-footer p{margin-top:2em;margin-bottom:2em;font-size:.8em;color:#fff;text-align:center}.receipts .wrap-logos{text-align:center}.receipts .wrap-logos li{list-style:none;float:none;font-size:19px}.receipts .wrap-votolegal a{margin:0;margin-right:auto;margin-left:auto;display:block;padding:0}.receipts .wrap-votolegal a.votolegal{background:url(" + escape(__webpack_require__(7)) + ");background-repeat:no-repeat;width:171px;height:49px}.receipts .wrap-share-buttons li{background-color:#1d384d;margin-top:1em}.error{margin-bottom:.9375rem;font-weight:700;font-size:.8rem;color:#ed1941}.form__disclaimer{clear:both;margin-top:3.75rem;margin-bottom:.46875rem;font-size:.8rem}.form__disclaimer:before{content:\"\\2022   \"}.donation-form h3{margin:0;margin-top:1.875em;margin-bottom:.46875em;font-size:1rem;text-align:center}.donation-form h3 strong{font-weight:700;font-size:1.25rem;color:#000}.btn-accept-terms-of-use{display:block;height:30px;text-align:center;padding:24px;font-size:18px;cursor:pointer;width:100%;margin-bottom:10px}#maxdonation{display:none}.input-wrapper{margin-top:.46875em;margin-bottom:.46875em}.input-wrapper label{position:absolute;display:block;padding-top:2px;padding-left:10px;font-weight:700}.payment-type{display:inline-block;min-width:10rem}@media (min-width:1020px) and (max-width:1200px){.payment-type{display:block}}#doar .payment-type label{padding-top:0;padding-bottom:0}.payment-choices{padding:0;text-align:center}.certiface-verify h3{margin-bottom:1em}.certiface-verify div{margin-bottom:.5em;text-align:center}.certiface-verify p{margin-bottom:1em}.certiface-verify .donation-nav--rewind{padding-top:.5rem;padding-bottom:.5rem}.certiface-verify .donation-nav--forward{float:right;padding:.5rem .8rem}.donation-nav.donation-nav--block{display:block;text-align:center}.donations-table{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;table-layout:fixed;margin-top:1.875em;margin-bottom:1.875em}.donations-table a{text-decoration:none}.donations-table thead th{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media (max-width:64em){.donations-table thead th{font-size:.8rem}}@media screen and (max-width:74.99em){.donations-table thead th{width:auto}}.donations-table thead th:first-child{width:auto}.donations-table thead th:nth-child(2),.donations-table thead th:nth-child(3){width:18%}.donations-table thead th:nth-child(4),.donations-table thead th:nth-child(5),.donations-table thead th:nth-child(6){width:15%}.donations-table tbody td:first-child{width:auto}@media screen and (max-width:74.99em){.donations-table tbody td:first-child{width:auto}}.donations-table tbody td:nth-child(2){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(2){width:auto}}.donations-table tbody td:nth-child(3){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(3){width:auto}}.donations-table tbody td:nth-child(4){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(4){width:auto}}.donations-table tbody td:nth-child(5){width:15%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(5){width:auto}}.donations-table tbody td:nth-child(6){width:20%}@media screen and (max-width:74.99em){.donations-table tbody td:nth-child(6){width:auto}}.entry-content__nav ul{margin-top:2.8125em;margin-bottom:2.8125em}.entry-content__nav li{display:inline-block;margin-right:1em;position:relative;font-weight:700;font-size:1rem;color:#333}.entry-content__nav a{color:#333}.active-nav-item a{color:#f63}.active-nav-item a:hover,.active-nav-item a:link{text-decoration:none}.active-nav-item a:before{background-color:#f63;position:absolute;width:10px;height:10px;border-bottom:1px solid #f63;border-radius:50%;left:50%;top:0;margin-top:-10px;content:\"\"}.donation-form__navigation{margin-top:1.875em;margin-bottom:1.875em}.donation-form__navigation ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed}.donation-form__navigation li{display:inline-block;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;font-weight:700;font-size:1rem}.donation-form--rewind a{color:#f63}.donation-form--rewind a:hover{color:#333}.donation-nav--rewind{float:left;padding-top:.5em}.donation-nav--rewind:before{content:\"< \"}.donation-nav--forward{float:right;background-color:#fff;border-radius:20px;text-align:center}.donation-nav--forward:hover{background-color:#f63;color:#fff}.donation-nav--forward.bigger{font-size:1.25rem}.donation-form__forward a{width:100%}.donation-form__forward a:link{text-decoration:none}.donation-form__forward a:hover{color:#fff}.donate-service__nav a:link{text-decoration:none}.nav-links__donation-service a{width:100%;margin-top:.2em;margin-bottom:.2em;padding-top:.25em;padding-bottom:.25em;border-radius:20px;text-align:center;display:block;white-space:nowrap;list-style-type:none;cursor:pointer;font-size:1rem;font-weight:700;outline:none;background:#fff;color:#f63}.nav-links__donation-service a:link:hover{background:#f63;color:#fff}.donate__nav ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-right:-.9375rem;margin-left:-.9375rem;margin-left:-1.875rem;margin-right:-1.875rem;margin-bottom:1em}.donate__nav li{display:inline-block;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;width:50%;position:relative;font-weight:700;font-size:1rem;color:#fff}.donate__nav a{padding:.5625rem .9375rem;text-align:center;color:#fff;background-color:#c5c5c5}.donate__nav a:link{text-decoration:none}.donate__nav__active a{background-color:#f1f1f1}.service-list a{border-radius:20px;margin-bottom:.46875rem;margin-top:.46875rem;padding:.5em 1em;font-weight:400;background:#fff;display:block;text-decoration:none}.service-list a:hover{color:#ed1941}.service-list .service-nav{margin-top:1.875rem;text-align:center;text-transform:uppercase;color:#ed1941;font-weight:700}.wrap-social-candidate{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;padding:0;margin-top:.5em;margin-right:-.46875rem;margin-left:-.46875rem}@media (min-width:48em){.wrap-social-candidate{position:absolute;right:0;bottom:0;margin-right:2rem}}.wrap-social-candidate li{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;position:relative;width:20px;height:20px;margin:1em .46875rem 0;border-radius:50%}.wrap-social-candidate li:first-child{margin-left:.2em}@media (min-width:48em){.wrap-social-candidate li:first-child{margin-left:.46875rem}.wrap-social-candidate li:last-child{margin-right:0}}.wrap-social-candidate a{position:absolute;top:50%;left:50%;width:36px;height:36px;transform:translate(-50%,-50%)}.wrap-social-candidate a.twitter{background:url(" + escape(__webpack_require__(21)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-social-candidate a.whatsapp{background:url(" + escape(__webpack_require__(22)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-social-candidate a.youtube{background:url(" + escape(__webpack_require__(23)) + ");background-position:50%;background-size:auto 14px;background-repeat:no-repeat}.wrap-social-candidate a.instagram{background:url(" + escape(__webpack_require__(24)) + ");background-position:50%;background-size:auto 14px;background-repeat:no-repeat}.wrap-social-candidate a.facebook{background:url(" + escape(__webpack_require__(25)) + ");background-position:50%;background-size:auto 16px;background-repeat:no-repeat}.wrap-social-candidate a.website{background:url(" + escape(__webpack_require__(26)) + ");background-position:50%;background-size:auto 13px;background-repeat:no-repeat}.wrap-social-candidate a.email{background:url(" + escape(__webpack_require__(27)) + ");background-position:50%;background-size:auto 16px;background-repeat:no-repeat}.wrap-share-buttons{padding:0;margin:0;text-align:center}.wrap-share-buttons li{position:relative;display:inline-block;width:36px;height:36px;margin:0 .1em;background-color:red;border-radius:50%}.wrap-share-buttons a{position:absolute;top:50%;left:50%;width:36px;height:36px;transform:translate(-50%,-50%)}.wrap-share-buttons a.twitter{background:url(" + escape(__webpack_require__(12)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-share-buttons a.mail{background:url(" + escape(__webpack_require__(13)) + ");background-position:50%;background-size:auto 15px;background-repeat:no-repeat}.wrap-share-buttons a.facebook{background:url(" + escape(__webpack_require__(14)) + ");background-position:50%;background-size:auto 18px;background-repeat:no-repeat}.donation-form__breadcrumbs ul{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-top:.9375em;margin-bottom:.9375em}.donation-form__breadcrumbs li{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;font-size:.8rem;position:relative;width:25px;height:25px;z-index:1;background-color:#bababa;border-radius:50%;margin-right:.5em}li.active-breadcrumbs{background-color:#666}.donation-form__breadcrumbs a{position:absolute;color:#fff;transform:translate(-50%,-50%);top:50%;left:50%}.donation-form__breadcrumbs a:link{text-decoration:none}#candidate.default #doar h2,#candidate.default .campaign-progress__meta-item--expected dd,#candidate.default .campaign-progress__meta__service .candidate-goals,#candidate.default .donate__nav__active a,#candidate.default .donation-nav,#candidate.default .entry-contents a,#candidate.default .input-wrapper a,#candidate.default .site-header h2{color:#f63}#candidate.default .donation-nav--rewind:hover{color:#333}#candidate.default .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.default .active-nav-item a:before,#candidate.default [type=radio]:checked+label:after,#candidate.default [type=radio]:not(:checked)+label:after,#candidate.default tfoot td,#candidate.default tfoot th,#candidate.default thead td,#candidate.default thead th{background-color:#f63}#candidate.default .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.default+#tfooter{background-color:#f63}#candidate.default+#tfooter .wrap-informations{color:#fff}#candidate.default+#tfooter .wrap-informations a{color:inherit}#candidate.default .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.default progress[value]::-moz-progress-bar{background:#f63}#candidate.default progress[value]::-webkit-progress-value{background:#f63}#candidate.default progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.default progress>div:first-child{border-radius:5px 0 0 5px}#candidate.default progress>div:last-child{border-radius:0 5px 5px 0}#candidate.default button{color:#f63}#candidate.default [type=radio]:checked+label:hover:before,#candidate.default [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.default [type=radio]:checked+label{color:#fff}#candidate.default [role=button]:active,#candidate.default [role=button]:focus,#candidate.default [role=button]:hover,#candidate.default [type=button]:active,#candidate.default [type=button]:focus,#candidate.default [type=button]:hover,#candidate.default button:active,#candidate.default button:focus,#candidate.default button:hover{color:#fff;background-color:#f63}#candidate.default [type=button]{color:#fff}#candidate.default .wrap-share-buttons li{background-color:#f63}#candidate.theme--default #doar h2,#candidate.theme--default .campaign-progress__meta-item--expected dd,#candidate.theme--default .campaign-progress__meta__service .candidate-goals,#candidate.theme--default .donate__nav__active a,#candidate.theme--default .donation-nav,#candidate.theme--default .entry-contents a,#candidate.theme--default .input-wrapper a,#candidate.theme--default .site-header h2{color:#f63}#candidate.theme--default .donation-nav--rewind:hover{color:#333}#candidate.theme--default .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.theme--default .active-nav-item a:before,#candidate.theme--default [type=radio]:checked+label:after,#candidate.theme--default [type=radio]:not(:checked)+label:after,#candidate.theme--default tfoot td,#candidate.theme--default tfoot th,#candidate.theme--default thead td,#candidate.theme--default thead th{background-color:#f63}#candidate.theme--default .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.theme--default+#tfooter{background-color:#f63}#candidate.theme--default+#tfooter .wrap-informations{color:#fff}#candidate.theme--default+#tfooter .wrap-informations a{color:inherit}#candidate.theme--default .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.theme--default progress[value]::-moz-progress-bar{background:#f63}#candidate.theme--default progress[value]::-webkit-progress-value{background:#f63}#candidate.theme--default progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--default progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--default progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--default button{color:#f63}#candidate.theme--default [type=radio]:checked+label:hover:before,#candidate.theme--default [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.theme--default [type=radio]:checked+label{color:#fff}#candidate.theme--default [role=button]:active,#candidate.theme--default [role=button]:focus,#candidate.theme--default [role=button]:hover,#candidate.theme--default [type=button]:active,#candidate.theme--default [type=button]:focus,#candidate.theme--default [type=button]:hover,#candidate.theme--default button:active,#candidate.theme--default button:focus,#candidate.theme--default button:hover{color:#fff;background-color:#f63}#candidate.theme--default [type=button]{color:#fff}#candidate.theme--default .wrap-share-buttons li{background-color:#f63}#candidate.theme--orange #doar h2,#candidate.theme--orange .campaign-progress__meta-item--expected dd,#candidate.theme--orange .campaign-progress__meta__service .candidate-goals,#candidate.theme--orange .donate__nav__active a,#candidate.theme--orange .donation-nav,#candidate.theme--orange .entry-contents a,#candidate.theme--orange .input-wrapper a,#candidate.theme--orange .site-header h2{color:#f63}#candidate.theme--orange .donation-nav--rewind:hover{color:#333}#candidate.theme--orange .donation-nav--forward:hover{color:#fff;background-color:#f63}#candidate.theme--orange .active-nav-item a:before,#candidate.theme--orange [type=radio]:checked+label:after,#candidate.theme--orange [type=radio]:not(:checked)+label:after,#candidate.theme--orange tfoot td,#candidate.theme--orange tfoot th,#candidate.theme--orange thead td,#candidate.theme--orange thead th{background-color:#f63}#candidate.theme--orange .active-nav-item a:before{border-bottom:1px solid #f63}#candidate.theme--orange+#tfooter{background-color:#f63}#candidate.theme--orange+#tfooter .wrap-informations{color:#fff}#candidate.theme--orange+#tfooter .wrap-informations a{color:inherit}#candidate.theme--orange .site-header{background-image:url(" + escape(__webpack_require__(5)) + ")}#candidate.theme--orange progress[value]::-moz-progress-bar{background:#f63}#candidate.theme--orange progress[value]::-webkit-progress-value{background:#f63}#candidate.theme--orange progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#f63;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--orange progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--orange progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--orange button{color:#f63}#candidate.theme--orange [type=radio]:checked+label:hover:before,#candidate.theme--orange [type=radio]:not(:checked)+label:hover:before{background:#fb7d54;content:\"\"}#candidate.theme--orange [type=radio]:checked+label{color:#fff}#candidate.theme--orange [role=button]:active,#candidate.theme--orange [role=button]:focus,#candidate.theme--orange [role=button]:hover,#candidate.theme--orange [type=button]:active,#candidate.theme--orange [type=button]:focus,#candidate.theme--orange [type=button]:hover,#candidate.theme--orange button:active,#candidate.theme--orange button:focus,#candidate.theme--orange button:hover{color:#fff;background-color:#f63}#candidate.theme--orange [type=button]{color:#fff}#candidate.theme--orange .wrap-share-buttons li{background-color:#f63}#candidate.theme--red #doar h2,#candidate.theme--red .campaign-progress__meta-item--expected dd,#candidate.theme--red .campaign-progress__meta__service .candidate-goals,#candidate.theme--red .donate__nav__active a,#candidate.theme--red .donation-nav,#candidate.theme--red .entry-contents a,#candidate.theme--red .input-wrapper a,#candidate.theme--red .site-header h2{color:#ed1941}#candidate.theme--red .donation-nav--rewind:hover{color:#333}#candidate.theme--red .donation-nav--forward:hover{color:#fff;background-color:#ed1941}#candidate.theme--red .active-nav-item a:before,#candidate.theme--red [type=radio]:checked+label:after,#candidate.theme--red [type=radio]:not(:checked)+label:after,#candidate.theme--red tfoot td,#candidate.theme--red tfoot th,#candidate.theme--red thead td,#candidate.theme--red thead th{background-color:#ed1941}#candidate.theme--red .active-nav-item a:before{border-bottom:1px solid #ed1941}#candidate.theme--red+#tfooter{background-color:#ed1941}#candidate.theme--red+#tfooter .wrap-informations{color:#fff}#candidate.theme--red+#tfooter .wrap-informations a{color:inherit}#candidate.theme--red .site-header{background-image:url(" + escape(__webpack_require__(28)) + ")}#candidate.theme--red progress[value]::-moz-progress-bar{background:#ed1941}#candidate.theme--red progress[value]::-webkit-progress-value{background:#ed1941}#candidate.theme--red progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#ed1941;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--red progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--red progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--red button{color:#ed1941}#candidate.theme--red [type=radio]:checked+label:hover:before,#candidate.theme--red [type=radio]:not(:checked)+label:hover:before{background:#f93156;content:\"\"}#candidate.theme--red [type=radio]:checked+label{color:#fff}#candidate.theme--red [role=button]:active,#candidate.theme--red [role=button]:focus,#candidate.theme--red [role=button]:hover,#candidate.theme--red [type=button]:active,#candidate.theme--red [type=button]:focus,#candidate.theme--red [type=button]:hover,#candidate.theme--red button:active,#candidate.theme--red button:focus,#candidate.theme--red button:hover{color:#fff;background-color:#ed1941}#candidate.theme--red [type=button]{color:#fff}#candidate.theme--red .wrap-share-buttons li{background-color:#ed1941}#candidate.theme--blue #doar h2,#candidate.theme--blue .campaign-progress__meta-item--expected dd,#candidate.theme--blue .campaign-progress__meta__service .candidate-goals,#candidate.theme--blue .donate__nav__active a,#candidate.theme--blue .donation-nav,#candidate.theme--blue .entry-contents a,#candidate.theme--blue .input-wrapper a,#candidate.theme--blue .site-header h2{color:#0072bc}#candidate.theme--blue .donation-nav--rewind:hover{color:#333}#candidate.theme--blue .donation-nav--forward:hover{color:#fff;background-color:#0072bc}#candidate.theme--blue .active-nav-item a:before,#candidate.theme--blue [type=radio]:checked+label:after,#candidate.theme--blue [type=radio]:not(:checked)+label:after,#candidate.theme--blue tfoot td,#candidate.theme--blue tfoot th,#candidate.theme--blue thead td,#candidate.theme--blue thead th{background-color:#0072bc}#candidate.theme--blue .active-nav-item a:before{border-bottom:1px solid #0072bc}#candidate.theme--blue+#tfooter{background-color:#0072bc}#candidate.theme--blue+#tfooter .wrap-informations{color:#fff}#candidate.theme--blue+#tfooter .wrap-informations a{color:inherit}#candidate.theme--blue .site-header{background-image:url(" + escape(__webpack_require__(29)) + ")}#candidate.theme--blue progress[value]::-moz-progress-bar{background:#0072bc}#candidate.theme--blue progress[value]::-webkit-progress-value{background:#0072bc}#candidate.theme--blue progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#0072bc;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--blue progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--blue progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--blue button{color:#0072bc}#candidate.theme--blue [type=radio]:checked+label:hover:before,#candidate.theme--blue [type=radio]:not(:checked)+label:hover:before{background:#2b7fb8;content:\"\"}#candidate.theme--blue [type=radio]:checked+label{color:#fff}#candidate.theme--blue [role=button]:active,#candidate.theme--blue [role=button]:focus,#candidate.theme--blue [role=button]:hover,#candidate.theme--blue [type=button]:active,#candidate.theme--blue [type=button]:focus,#candidate.theme--blue [type=button]:hover,#candidate.theme--blue button:active,#candidate.theme--blue button:focus,#candidate.theme--blue button:hover{color:#fff;background-color:#0072bc}#candidate.theme--blue [type=button]{color:#fff}#candidate.theme--blue .wrap-share-buttons li{background-color:#0072bc}#candidate.theme--green #doar h2,#candidate.theme--green .campaign-progress__meta-item--expected dd,#candidate.theme--green .campaign-progress__meta__service .candidate-goals,#candidate.theme--green .donate__nav__active a,#candidate.theme--green .donation-nav,#candidate.theme--green .entry-contents a,#candidate.theme--green .input-wrapper a,#candidate.theme--green .site-header h2{color:#396}#candidate.theme--green .donation-nav--rewind:hover{color:#333}#candidate.theme--green .donation-nav--forward:hover{color:#fff;background-color:#396}#candidate.theme--green .active-nav-item a:before,#candidate.theme--green [type=radio]:checked+label:after,#candidate.theme--green [type=radio]:not(:checked)+label:after,#candidate.theme--green tfoot td,#candidate.theme--green tfoot th,#candidate.theme--green thead td,#candidate.theme--green thead th{background-color:#396}#candidate.theme--green .active-nav-item a:before{border-bottom:1px solid #396}#candidate.theme--green+#tfooter{background-color:#396}#candidate.theme--green+#tfooter .wrap-informations{color:#fff}#candidate.theme--green+#tfooter .wrap-informations a{color:inherit}#candidate.theme--green .site-header{background-image:url(" + escape(__webpack_require__(30)) + ")}#candidate.theme--green progress[value]::-moz-progress-bar{background:#396}#candidate.theme--green progress[value]::-webkit-progress-value{background:#396}#candidate.theme--green progress>div{padding:0;overflow:hidden;text-indent:101%;white-space:nowrap;background:#396;display:block;float:left;height:100%;max-width:100%;line-height:inherit;border-radius:0}#candidate.theme--green progress>div:first-child{border-radius:5px 0 0 5px}#candidate.theme--green progress>div:last-child{border-radius:0 5px 5px 0}#candidate.theme--green button{color:#396}#candidate.theme--green [type=radio]:checked+label:hover:before,#candidate.theme--green [type=radio]:not(:checked)+label:hover:before{background:#62a282;content:\"\"}#candidate.theme--green [type=radio]:checked+label{color:#fff}#candidate.theme--green [role=button]:active,#candidate.theme--green [role=button]:focus,#candidate.theme--green [role=button]:hover,#candidate.theme--green [type=button]:active,#candidate.theme--green [type=button]:focus,#candidate.theme--green [type=button]:hover,#candidate.theme--green button:active,#candidate.theme--green button:focus,#candidate.theme--green button:hover{color:#fff;background-color:#396}#candidate.theme--green [type=button]{color:#fff}#candidate.theme--green .wrap-share-buttons li{background-color:#396}.site-header{background-size:70% auto}@media (min-width:20em){.site-header{background-position:center -50px}}@media (min-width:30em){.site-header{background-position:center -100px}}@media (min-width:48em){.site-header{background-position:center 650%;background-size:auto}}.site-header .container{padding-top:10rem;background-image:url(" + escape(__webpack_require__(31)) + ");background-position:1em 30%;background-repeat:no-repeat}@media (min-width:30em){.site-header .container{padding-top:12.5rem}}@media (min-width:64em){.site-header .container{padding-top:12.5rem;background-image:url(" + escape(__webpack_require__(32)) + ");background-position:2em 25%}}#candidate .site-header h2{font-weight:700;font-size:1.5625rem;text-transform:uppercase}#candidate #intro{margin-top:1.875em}.candidate-wrap{position:relative}@media screen and (min-width:64em){.candidate-wrap{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;margin-right:-.9375rem;margin-left:-.9375rem}}@media screen and (min-width:64em){#intro{width:70%}}@media screen and (min-width:64em){#campaign-progress,#intro{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;padding-right:.9375rem;padding-left:.9375rem}#campaign-progress{width:30%}}.intro__meta{font-size:0;font-family:FreeSans,Arimo,Droid Sans,Helvetica,Arial,sans-serif;letter-spacing:-.31em;letter-spacing:normal\\9;word-spacing:-.43em\\9;text-rendering:optimizespeed;overflow:hidden}@media screen and (min-width:64em){.intro__meta{border-bottom:1px solid #e5e7ea}}.intro__meta-item{display:inline-block;font-size:1rem;font-family:Miriam Libre,sans-serif;letter-spacing:normal;word-spacing:normal;text-rendering:auto;vertical-align:top;zoom:1;max-width:100%;margin-right:2em;margin-bottom:.9375em;line-height:1.3}.intro__meta-item .intro__meta-item:last-child{margin-bottom:0}@media screen and (min-width:48em){.intro__meta-item{margin-bottom:0}}@media screen and (min-width:64em){.intro__meta-item{padding-bottom:.9375em}}.intro__meta-item dt{font-weight:700;font-size:.8rem;text-transform:uppercase;color:#999}.intro__meta-item dd{display:flex;max-width:100%;font-size:1.5625rem}@media screen and (min-width:75em){.intro__meta-item dd{font-size:1.95312rem}}.intro__meta-item .locality,.intro__meta-item .region{display:table-cell}.intro__meta-item .locality{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#campaign-progress{margin-top:.9375em;margin-bottom:1.875em;line-height:1.3}@media screen and (min-width:64em){#campaign-progress{margin-top:1.875em;margin-bottom:1.875em}}.campaign-progress__meta-item dt{font-size:1.95312rem}.campaign-progress__meta-item dd{font-weight:700;font-size:1rem;color:#999}.campaign-progress__meta-currency{font-size:1.5625rem}@media screen and (min-width:75em){.campaign-progress__meta-currency{display:block}}.campaign-progress__donated{font-weight:700}.campaign-progress__meta-captured{font-weight:700;font-size:1rem;color:#999}dt .campaign-progress__value-minor{font-weight:700;font-size:1.25rem}dd .campaign-progress__value-minor{font-weight:700;font-size:1rem}.campaign-progress__meta-item{margin-bottom:1.5em}.campaign-progress__meta-item--expected dt{font-size:2.44141rem}.campaign-progress__meta-item--expected dd{font-size:1.25rem;color:#f63}.campaign-progress__meta-item--expected dd:first-child{margin-bottom:0}@media (min-width:75em){.campaign-progress__meta__service{margin-top:2.8125em}}.campaign-progress__meta__service dt{font-size:1.95312rem}.campaign-progress__meta__service dd{margin-bottom:0;font-weight:700;font-size:1rem;color:#999}.campaign-progress__meta__service .candidate-goals{font-size:1.25rem;color:#f63}.candidate-content{position:relative;width:100%;padding-bottom:3.75rem}@media (max-width:768px){.candidate-content{padding-bottom:1.875rem}}#doar,[id=votar]{position:relative;float:none;display:table;z-index:10;width:100%;max-width:none;padding:1.875rem;margin-bottom:1.875em;overflow:hidden;color:#666;background-color:#f1f1f1;border-radius:1.875rem}@media (min-width:64em){#doar,[id=votar]{position:relative;float:right;clear:right;max-width:36%;margin-top:-10%}}#doar h2,[id=votar] h2{font-weight:700;font-size:1.5625rem;text-align:center;color:#f63}#doar h4,[id=votar] h4{font-weight:700;font-size:.9em;text-align:left}@media (min-width:64em){[id=votar]{margin-top:1.875rem}}#doar section,[id=votar] section{margin-top:.9375em;margin-bottom:.9375em}[id=votar] p{margin-bottom:1.875em}#doar__valores legend{font-size:1.25rem}.donation-panel-title{padding-bottom:.46875em;border-bottom:1px solid #e5e7ea}.payment-confirmation-message{font-weight:700;font-size:1rem;text-align:center;text-transform:uppercase}.final-message{text-align:center}.payment-final-message{font-weight:700;color:#333}.donation-form__chosen-value,.payment-final-message{margin-bottom:.9375em;font-size:1.25rem;text-align:center}.donation-form__currency-value{font-weight:700;font-size:1rem}.donation-form__navigation li{padding:0}.entry-contents{position:relative;width:100%;margin-top:.9375em;margin-bottom:9.375em}@media (max-width:1024px){.entry-contents{float:none;max-width:none}}@media screen and (min-width:64em){.entry-contents h3,.entry-contents h4,.entry-contents p{max-width:63%}}.candidate-summary{margin-bottom:3.75em}.candidate-summary p{white-space:pre-line}.entry-contents section h2,.entry-contents section h4{margin-bottom:.9375em}.entry-contents section p{margin-bottom:1.875em}.entry-content{display:none}.candidate-cnpj{font-size:.8rem}.candidate-biography{white-space:pre-line}.entry-content-active{display:block}.candidate-amount-select{margin-bottom:.9375em;text-align:center}.candidate-amount p{margin-bottom:.9375em;font-weight:700;font-size:.9em}@media print{*{text-shadow:none!important;color:#000!important;background:transparent!important}body{font:12pt/1.33333 Palatino Linotype,Palatino,Times New Roman,Times,serif;color:#000;background:#fff none}a,a:link,a:visited{font-weight:700;text-decoration:underline;color:#444!important;background:transparent}a[href]:after{font-style:italic;word-wrap:break-word;white-space:pre-wrap;color:#333;content:\" (\" attr(href) \") \"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}abbr[title]:after{font-style:italic;content:\" (\" attr(title) \")\"}blockquote,pre{page-break-inside:avoid;border:1px solid #999}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important;vertical-align:bottom}@page{margin:.5cm}h2,h3,p{orphans:3;widows:3}caption,h1,h2,h3,h4,h5,h6,legend{page-break-after:avoid;page-break-inside:never}[role=main]{float:none!important;width:auto;padding:0;margin:0 5%;border:0}.access,.secondary,nav{display:none}}", ""]);

// exports


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":_vm.$route.name,"aria-busy":!_vm.donations.length}},[_c('header',{staticClass:"receipts-header"},[_c('img',{staticClass:"receipt__avatar",attrs:{"src":_vm.candidate.avatar,"alt":_vm.candidate.popular_name}})]),_vm._v(" "),_c('p',[_vm._v("\n    Doações referentes ao depósito "),_c('strong',[_vm._v(_vm._s(_vm.depositId))]),(_vm.deposit.created_at)?[_vm._v(" do dia "+_vm._s(_vm._f("date")(_vm.deposit.created_at)))]:_vm._e(),_vm._v(".\n  ")],2),_vm._v(" "),(_vm.donations.length)?[_c('table',{staticClass:"donations-table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.donations),function(donation){return _c('tr',{key:donation.id},[_c('th',{attrs:{"title":"Nome"}},[_vm._v(_vm._s(_vm._f("titleCase")(donation.donor_name)))]),_vm._v(" "),_c('td',{attrs:{"title":"CPF"}},[_vm._v(_vm._s(_vm._f("formatCPF")(donation.donor_cpf)))]),_vm._v(" "),_c('td',{attrs:{"title":"Data"}},[_vm._v(_vm._s(_vm._f("date")(donation.created_at)))]),_vm._v(" "),_c('td',{attrs:{"title":"Método"}},[_vm._v(_vm._s(_vm.paymentMethod(donation)))]),_vm._v(" "),_c('td',{attrs:{"title":"Valor"}},[_vm._v("R$ "+_vm._s(_vm._f("formatBRL")(donation.amount))+" ")]),_vm._v(" "),_c('td',{attrs:{"title":"Recibo"}},[_c('a',{attrs:{"href":donation.transaction_link}},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" Recibo")])])])}),0),_vm._v(" "),_vm._m(1)])]:[_c('h3',[_vm._v("Depósito inexistente")]),_vm._v(" "),_c('p',[_vm._v("Esse depósito não foi encontrado")])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("CPF")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Método")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Recibo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',[_c('tr',[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("CPF")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Método")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Recibo")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__address__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_development_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_development_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_development_js__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    address: __WEBPACK_IMPORTED_MODULE_3__address__["a" /* default */]
  },

  state: {
    offices: {},
    candidate: {},
    projects: [],
    donations: [],
    tickets: [],
    donationPlatforms: [],
    donationSources: [],
    hasMoreDonations: false,
    lastDonationMarker: '',
    lastTicketMarker: '',
    device: "",
    statusPaymentRequest: {},
    paymentError: "",
    paymentData: {},

    ticketStep: "intro",
    // from rede
    paymentStep: "selectValue",
    amount: 0,
    referral: '',
    token: "",
    donation: {},
    iugu: {},
    messages: [],
    username: {},
    candidateId: "",
    userData: {},
    receipt: {},
    deposit: {
      donations: [],
      candidate: {
        id: 0,
        avatar: '',
        popular_name: ''
      },
      meta: {
        created_at: ''
      }
    }
  },

  actions: {
    getOffices: function getOffices(_ref) {
      var commit = _ref.commit;

      return new Promise(function (resolve, reject) {

        var offices = [{ "name": "Prefeito(a)", "id": 10 }, { "name": "Vereador(a)", "id": 11 }, { "id": 12, "name": "Vice-prefeito(a)" }];
        commit('setOfficesList', offices), resolve(offices);
        /* axios
          .get(
            `${CONFIG_API.api}/api/office`
          )
          .then(response => {
            return (response.data.office);
          })
          .then(offices => {
            commit('setOfficesList', offices),
            resolve(offices);
          })
          .catch(err => {
            console.error('erro', err.response);
            reject(err.response);
          });*/
      });
    },

    getCandidate: function getCandidate(_ref2, candidateName) {
      var commit = _ref2.commit;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/public-api/candidate-summary/" + candidateName).then(function (response) {
          resolve(response.data.candidate);
          commit("getCandidateMutation", response.data.candidate);
          commit("getCandidateMutationProjects", response.data.candidate.projects);
          if (response.data.platforms) {
            commit('SET_SOURCES', response.data.platforms);
          }
        }).catch(function (err) {
          console.error('erro', err.response);
          reject(err.response);
        });
      });
    },

    getCandidateProjects: function getCandidateProjects(_ref3, candidate) {
      var commit = _ref3.commit;

      return new Promise(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api/candidate/" + candidate + "/projects").then(function (response) {
          resolve(response.data.projects);
          commit("getCandidateMutationProjects", response.data.projects);
        });
      });
    },

    getCandidateDonations: function getCandidateDonations(_ref4, candidate) {
      var commit = _ref4.commit,
          state = _ref4.state;

      return new Promise(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/public-api/candidate-donations/" + candidate + "/" + state.lastDonationMarker).then(function (response) {
          resolve(response.data.donations);
          commit("getCandidateMutationDonations", response.data);
        });
      });
    },

    getCandidateTickets: function getCandidateTickets(_ref5, candidate) {
      var commit = _ref5.commit,
          state = _ref5.state;

      return new Promise(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/public-api/candidate-tickets/" + candidate + "/" + state.lastTicketMarker).then(function (response) {
          resolve(response.data.tickets);
          commit("getCandidateMutationTickets", response.data);
        });
      });
    },

    postHiuguDevice: function postHiuguDevice(_ref6) {
      var commit = _ref6.commit;

      return new Promise(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api2/device-authentication").then(function (response) {
          resolve(response.data.device_authorization_token_id);
          commit("hiuguDevice", response.data.device_authorization_token_id);
        });
      });
    },

    GET_RECEIPT: function GET_RECEIPT(_ref7, payload) {
      var commit = _ref7.commit;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/public-api/candidate/" + payload.candidateId + "/donation/digest/" + payload.digest).then(function (response) {
          commit('SET_RECEIPT', {
            res: response.data
          });
          resolve();
        }, function (err) {
          reject(err.response);
        });
      });
    },
    GET_DEPOSIT: function GET_DEPOSIT(_ref8, payload) {
      var commit = _ref8.commit;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/public-api/candidate/" + payload.candidateId + "/deposit?deposit_id=" + payload.depositId).then(function (response) {
          commit('SET_DEPOSIT', {
            res: response.data
          });
          resolve();
        }, function (err) {
          reject(err.response);
        });
      });
    },


    // from rede
    CHANGE_PAYMENT_AMOUNT: function CHANGE_PAYMENT_AMOUNT(_ref9, data) {
      var commit = _ref9.commit;

      commit("SET_PAYMENT_STEP", { data: data });
      commit("SET_PAYMENT_AMOUNT", { data: data });
    },
    CHANGE_PAYMENT_STEP: function CHANGE_PAYMENT_STEP(_ref10, data) {
      var commit = _ref10.commit;

      commit("SET_PAYMENT_STEP", { data: data });
    },
    SAVE_USERNAME: function SAVE_USERNAME(_ref11, user) {
      var commit = _ref11.commit;

      commit("SET_USERNAME", { user: user });
    },
    ADD_TOKEN: function ADD_TOKEN(_ref12, data) {
      var commit = _ref12.commit;

      commit("SET_TOKEN", { token: data });
    },
    GET_TOKEN: function GET_TOKEN(_ref13, data) {
      var commit = _ref13.commit;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default()({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: __WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api2/device-authentication",
          data: data
        }).then(function (response) {
          var device_authorization_token_id = response.data.device_authorization_token_id;

          commit("SET_TOKEN", { token: device_authorization_token_id });
          resolve(response);
        }).catch(function (err) {
          console.error(err.response);
          reject(err.response);
        });
      });
    },
    SAVE_PAYMENT_DATA: function SAVE_PAYMENT_DATA(_ref14, data) {
      var commit = _ref14.commit;

      commit('SET_PAYMENT_DATA', { paymentData: data });
    },
    SEND_TICKET: function SEND_TICKET(_ref15, data) {
      var commit = _ref15.commit;

      return new Promise(function (resolve, reject) {
        var keys = {
          candidate_id: 'candidate_id',
          device_authorization_token_id: 'device_authorization_token_id',
          donation_fp: 'donation_fp',
          address_complement: 'complemento',
          address_district: 'bairro',
          address_house_number: 'numero',
          address_state: 'estado',
          address_street: 'endereco',
          address_zipcode: 'cep',
          address_city: 'cidade',
          birthdate: 'nascimento',
          cpf: 'cpf',
          email: 'email',
          name: 'nome',
          surname: 'sobrenome',
          phone: 'telefone'
        };

        var translatedAndCleanData = Object.keys(data).reduce(function (acc, cur) {
          if (keys[cur]) {
            acc[keys[cur]] = data[cur];
          }
          return acc;
        }, {});

        __WEBPACK_IMPORTED_MODULE_2_axios___default()({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: __WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api2/rede-ticket",
          data: translatedAndCleanData
        }).then(function (response) {
          if (response.data && response.data.ui && response.data.ui.messages) {
            commit("SET_MESSAGES", { messages: response.data.ui.messages });
          }

          resolve();
        }, function (err) {
          console.error(err.response);
          reject(err.response);
        });
      });
    },
    GET_DONATION: function GET_DONATION(_ref16, data) {
      var commit = _ref16.commit;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default()({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: __WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api2/donations",
          data: data
        }).then(function (response) {
          var _response$data = response.data,
              donation = _response$data.donation,
              ui = _response$data.ui;

          commit("SET_DONATION", { donation: donation });
          commit("SET_IUGU", { iugu: ui.messages[1] });
          commit("SET_MESSAGES", { messages: response.data.ui.messages });
          resolve();
        }, function (err) {
          console.error(err.response);
          reject(err.response);
        });
      });
    },
    START_DONATION: function START_DONATION(_ref17, payload) {
      var commit = _ref17.commit,
          state = _ref17.state;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default()({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: __WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api2/donations/" + state.donation.id + "?device_authorization_token_id=" + state.token + "&credit_card_token=" + payload.id + "&cc_hash=" + payload.cc_hash
        }).then(function (response) {
          var data = {
            step: "finalMessage"
          };
          commit("SET_MESSAGES", { messages: response.data.ui.messages });
          commit("SET_PAYMENT_STEP", { data: data });
          resolve(response);
        }, function (err) {
          console.error(err.response);
          reject(err.response);
        });
      });
    },
    START_DONATION_BOLETO: function START_DONATION_BOLETO(_ref18, payload) {
      var commit = _ref18.commit;

      var token = '';
      if (window.localStorage) {
        var tokenName = window.location.host === 'votolegal.com.br' || window.location.host === 'votolegal.com' ? 'prod_vlm_token' : 'dev_vlm_token';
        token = localStorage.getItem(tokenName);
      }

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default()({
          method: 'GET',
          headers: {
            "Content-Type": "application/json"
          },
          url: __WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api2/donations/" + payload.donationId + "?device_authorization_token_id=" + token
        }).then(function (response) {
          var data = {
            step: "printBoleto"
          };
          var _response$data2 = response.data,
              donation = _response$data2.donation,
              ui = _response$data2.ui;

          commit("SET_DONATION", { donation: donation });
          commit("SET_MESSAGES", {
            messages: ui
          });
          commit("SET_PAYMENT_STEP", {
            data: data
          });
          resolve(response);
        }, function (error) {
          commit("SET_MESSAGES", {
            messages: { messages: [{
                text: error.response.data[0].message
              }] } });
          console.error(error.response);
          reject(error.response);
        });
      });
    },
    GET_CANDIDATE_INFO: function GET_CANDIDATE_INFO(_ref19, id) {
      var commit = _ref19.commit;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api/candidate/" + id).then(function (response) {
          commit("SET_CANDIDATE", { res: response.data });
          if (response.data.platforms) {
            commit('SET_SOURCES', response.data.platforms);
          }
          resolve();
        }, function (err) {
          reject(err.response);
          console.error(err);
        });
      });
    },
    GET_DONATIONS: function GET_DONATIONS(_ref20, id) {
      var commit = _ref20.commit;

      return new Promise(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config_development_js___default.a.api + "/api/candidate/" + id + "/donate").then(function (response) {
          commit("SET_DONATIONS", { res: response.data });
          if (response.data.platforms) {
            commit('SET_PLATFORMS', response.data.platforms);
          }
          resolve();
        }, function (err) {
          reject(err.response);
          console.error(err);
        });
      });
    },
    SAVE_ADDRESS: function SAVE_ADDRESS(_ref21, payload) {
      var commit = _ref21.commit;

      commit('SET_ADDRESS', { userData: payload });
    },
    ADD_REFERRAL: function ADD_REFERRAL(_ref22, data) {
      var commit = _ref22.commit;

      commit('SET_REFERRAL', data);
    }
  },

  mutations: {
    setOfficesList: function setOfficesList(state, payload) {
      state.offices = payload.reduce(function (acc, cur) {
        acc[cur.id] = cur.name;
        return acc;
      }, {});
    },
    getCandidateMutation: function getCandidateMutation(state, payload) {
      state.candidate = payload;
      state.candidateId = payload.id;
    },
    getCandidateMutationProjects: function getCandidateMutationProjects(state, payload) {
      state.projects = payload;
    },
    getCandidateMutationDonations: function getCandidateMutationDonations(state, payload) {
      state.hasMoreDonations = payload.has_more || false;
      if (payload.donations.length) {
        state.lastDonationMarker = payload.donations[payload.donations.length - 1]._marker;
      }

      state.donations = state.donations.concat(payload.donations);
    },
    getCandidateMutationTickets: function getCandidateMutationTickets(state, payload) {
      state.hasMoreTickets = payload.has_more || false;
      if (payload.tickets.length) {
        state.lastTicketMarker = payload.tickets[payload.tickets.length - 1]._marker;
      }

      state.tickets = state.tickets.concat(payload.tickets);
    },
    SET_RECEIPT: function SET_RECEIPT(state, _ref23) {
      var res = _ref23.res;

      state.receipt = res.donation;
    },
    SET_DEPOSIT: function SET_DEPOSIT(state, _ref24) {
      var res = _ref24.res;

      state.deposit = res;
    },

    // from rede
    SET_PAYMENT_DATA: function SET_PAYMENT_DATA(state, _ref25) {
      var paymentData = _ref25.paymentData;

      state.paymentData = paymentData;
    },
    SET_PAYMENT_STEP: function SET_PAYMENT_STEP(state, _ref26) {
      var data = _ref26.data;

      state.paymentStep = data.step;
    },
    SET_TICKET_STEP: function SET_TICKET_STEP(state, _ref27) {
      var step = _ref27.step;

      state.ticketStep = step;
    },
    SET_PAYMENT_AMOUNT: function SET_PAYMENT_AMOUNT(state, _ref28) {
      var data = _ref28.data;

      state.amount = data.amount;
    },
    SET_TOKEN: function SET_TOKEN(state, _ref29) {
      var token = _ref29.token;

      state.token = token;
    },
    SET_USERNAME: function SET_USERNAME(state, _ref30) {
      var user = _ref30.user;

      state.username = user;
    },
    SET_DONATION: function SET_DONATION(state, _ref31) {
      var donation = _ref31.donation;

      state.donation = donation;
    },
    SET_IUGU: function SET_IUGU(state, _ref32) {
      var iugu = _ref32.iugu;

      state.iugu = iugu;
    },
    SET_MESSAGES: function SET_MESSAGES(state, _ref33) {
      var messages = _ref33.messages;

      state.messages = messages;
    },
    SET_CANDIDATE: function SET_CANDIDATE(state, _ref34) {
      var res = _ref34.res;

      state.candidate = res.candidate;
    },
    SET_PLATFORMS: function SET_PLATFORMS(state, platforms) {
      state.donationPlatforms = platforms.sort(function (a) {
        return ['voto legal', 'votolegal'].indexOf(a.name.toLowerCase()) !== -1 ? -1 : 1;
      });
    },
    SET_SOURCES: function SET_SOURCES(state, platforms) {
      var donationSources = platforms.reduce(function (allTypes, item) {
        var typeName = item.type.toLowerCase();
        if (typeName in allTypes) {
          allTypes[typeName].total_donated += item.total_donated;
          allTypes[typeName].people_donated += item.people_donated;
        } else {
          allTypes[typeName] = {
            name: item.type,
            total_donated: item.total_donated,
            people_donated: item.people_donated
          };
        }
        return allTypes;
      }, {});

      state.donationSources = Object.keys(donationSources).map(function (key) {
        return donationSources[key];
      });
    },
    SET_DONATIONS: function SET_DONATIONS(state, _ref35) {
      var res = _ref35.res;

      state.donations = res.donations;
    },
    SET_ADDRESS: function SET_ADDRESS(state, _ref36) {
      var userData = _ref36.userData;

      state.userData = userData;
    },
    SET_REFERRAL: function SET_REFERRAL(state, referral) {
      state.referral = referral;
    }
  },
  getters: {
    generateCandidateObject: function generateCandidateObject(state) {
      var candidateMerge = {
        candidate: state.candidate,
        projects: state.projects,
        tickets: state.tickets,
        donations: state.donations
      };
      return candidateMerge;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var state = {
	address: Object
};

var actions = {
	getAddress: function getAddress(_ref, cep) {
		var commit = _ref.commit,
		    rootState = _ref.rootState;

		return new Promise(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('//api2020vl.appcivico.com/api/cep?cep=' + cep, { timeout: 10000 }).then(function (response) {
				resolve(response.data);
				commit('getAddressMutation', response.data);
			}).catch(function (err) {
				reject(err);
			});
		});
	}
};

var mutations = {
	getAddressMutation: function getAddressMutation(state, payload) {
		state.address = payload;
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations,
	actions: actions
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__(290);





// The translation file could also be loaded from a separate json file
// I won't do this for now to prevent an extra ajax call
// import ptBr from '/ptBR.js';

var ptBr = {
	moneySeparator: ",",

	//donation info
	gotFromTheExpected: "Meta",
	currencyReal: "R$",
	donationValue: "Valor líquido da doação:",
	remainingDays: "dias restantes",
	capturedMoney: "arrecadados",
	doners: "Doações recebidas",
	viewDonors: "Veja quem são",
	daysRemaining: "Dias restantes",

	//form
	disabledDonations: "Doações desabilitadas",
	donationPanel: "Painel do Doador",
	ticketPanel: "Vale eleitoral",
	submitTicket: "Destinar Fundo Eleitoral",
	chooseDOnationValue: "Escolha o valor",
	otherValues: "Outro valor",
	forward: "Continuar",
	rewind: "Voltar",
	orService: "Ou doe serviços",
	donationService: "Participe!",
	informPersonalData: "Informe seus dados pessoais",
	chosenValue: "Valor escolhido:",
	creditCard: "Cartão de crédito",
	boleto: "Boleto bancário",
	fillName: "Nome completo",
	CPF: "Cpf",
	email: "Email",
	tel: "Telefone",
	birthDate: "Data de nascimento",
	informAddress: "Por favor, informe seu endereço",
	cep: "Cep",
	state: "Estado",
	city: "Cidade",
	street: "Endereço",
	neighborhood: "Bairro",

	//NUMBER: "Número",
	//"Complemento",
	informPaymentData: "Obrigado, agora informe os dados de pagamento",
	creditCardNumber: "Número do cartão",
	firstname: "Nome",
	lastname: "Sobrenome",
	fullName: "Nome completo",
	data: "Validade",
	ccv: "cod. Segurança",
	donate: "Doar!",

	//political info
	party: "Partido",
	runingon: "Concorre por",
	number: "Número",
	summaryCandidate: "Sobre",
	politicalMovement: "Movimento",

	//tabs
	mainProjects: "Projetos prioritários",
	aboutMe: "Sobre mim",
	donations: "Transparência",
	Name: "Nome do doador:",
	BlockchainAddress: "Endereço na Blockchain:",
	Type: "Tipo:",
	ticket: "Vale eleitoral",
	Value: "Valor doado:",
	expenses: "Despesas",

	//form adress
	district: 'Bairro',
	complement: 'Complemento',
	birthdate: 'Nascimento',
	phone: 'Telefone',

	loadMore: 'Carregar mais',

	//errors
	paymentMethodError: "Selecione uma forma de pagamento"

};

// initialize the vuex translations using the vuex module
var translations = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store();

// initialize the internationalization plugin on the vue instance
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, translations);

// add translations directly to the application
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].i18n.add("pt-BR", ptBr);

// set the start locale to use
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].i18n.set("pt-BR");

/* harmony default export */ __webpack_exports__["a"] = (translations);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/* vuex-i18n-store defines a vuex module to store locale translations. Make sure
** to also include the file vuex-i18n.js to enable easy access to localized
** strings in your vue components.
*/
// define a simple vuex module to handle locale translations
var i18nVuexModule = {
  namespaced: true,
  state: {
    locale: null,
    fallback: null,
    translations: {}
  },
  mutations: {
    // set the current locale
    SET_LOCALE: function SET_LOCALE(state, payload) {
      state.locale = payload.locale;
    },
    // add a new locale
    ADD_LOCALE: function ADD_LOCALE(state, payload) {
      // reduce the given translations to a single-depth tree
      var translations = flattenTranslations(payload.translations);

      if (state.translations.hasOwnProperty(payload.locale)) {
        // get the existing translations
        var existingTranslations = state.translations[payload.locale]; // merge the translations

        state.translations[payload.locale] = Object.assign({}, existingTranslations, translations);
      } else {
        // just set the locale if it does not yet exist
        state.translations[payload.locale] = translations;
      } // make sure to notify vue of changes (this might break with new vue versions)


      try {
        if (state.translations.__ob__) {
          state.translations.__ob__.dep.notify();
        }
      } catch (ex) {}
    },
    // replace existing locale information with new translations
    REPLACE_LOCALE: function REPLACE_LOCALE(state, payload) {
      // reduce the given translations to a single-depth tree
      var translations = flattenTranslations(payload.translations); // replace the translations entirely

      state.translations[payload.locale] = translations; // make sure to notify vue of changes (this might break with new vue versions)

      try {
        if (state.translations.__ob__) {
          state.translations.__ob__.dep.notify();
        }
      } catch (ex) {}
    },
    // remove a locale from the store
    REMOVE_LOCALE: function REMOVE_LOCALE(state, payload) {
      // check if the given locale is present in the state
      if (state.translations.hasOwnProperty(payload.locale)) {
        // check if the current locale is the given locale to remvoe
        if (state.locale === payload.locale) {
          // reset the current locale
          state.locale = null;
        } // create a copy of the translations object


        var translationCopy = Object.assign({}, state.translations); // remove the given locale

        delete translationCopy[payload.locale]; // set the state to the new object

        state.translations = translationCopy;
      }
    },
    SET_FALLBACK_LOCALE: function SET_FALLBACK_LOCALE(state, payload) {
      state.fallback = payload.locale;
    }
  },
  actions: {
    // set the current locale
    setLocale: function setLocale(context, payload) {
      context.commit({
        type: 'SET_LOCALE',
        locale: payload.locale
      });
    },
    // add or extend a locale with translations
    addLocale: function addLocale(context, payload) {
      context.commit({
        type: 'ADD_LOCALE',
        locale: payload.locale,
        translations: payload.translations
      });
    },
    // replace locale information
    replaceLocale: function replaceLocale(context, payload) {
      context.commit({
        type: 'REPLACE_LOCALE',
        locale: payload.locale,
        translations: payload.translations
      });
    },
    // remove the given locale translations
    removeLocale: function removeLocale(context, payload) {
      context.commit({
        type: 'REMOVE_LOCALE',
        locale: payload.locale,
        translations: payload.translations
      });
    },
    setFallbackLocale: function setFallbackLocale(context, payload) {
      context.commit({
        type: 'SET_FALLBACK_LOCALE',
        locale: payload.locale
      });
    }
  }
}; // flattenTranslations will convert object trees for translations into a
// single-depth object tree

var flattenTranslations = function flattenTranslations(translations) {
  var toReturn = {};

  for (var i in translations) {
    // check if the property is present
    if (!translations.hasOwnProperty(i)) {
      continue;
    } // get the type of the property


    var objType = _typeof(translations[i]); // allow unflattened array of strings


    if (isArray(translations[i])) {
      var count = translations[i].length;

      for (var index = 0; index < count; index++) {
        var itemType = _typeof(translations[i][index]);

        if (itemType !== 'string') {
          console.warn('i18n:', 'currently only arrays of strings are fully supported', translations[i]);
          break;
        }
      }

      toReturn[i] = translations[i];
    } else if (objType == 'object' && objType !== null) {
      var flatObject = flattenTranslations(translations[i]);

      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = translations[i];
    }
  }

  return toReturn;
}; // check if the given object is an array


function isArray(obj) {
  return !!obj && Array === obj.constructor;
}

var plurals = {
  getTranslationIndex: function getTranslationIndex(languageCode, n) {
    switch (languageCode) {
      case 'ay': // Aymará

      case 'bo': // Tibetan

      case 'cgg': // Chiga

      case 'dz': // Dzongkha

      case 'fa': // Persian

      case 'id': // Indonesian

      case 'ja': // Japanese

      case 'jbo': // Lojban

      case 'ka': // Georgian

      case 'kk': // Kazakh

      case 'km': // Khmer

      case 'ko': // Korean

      case 'ky': // Kyrgyz

      case 'lo': // Lao

      case 'ms': // Malay

      case 'my': // Burmese

      case 'sah': // Yakut

      case 'su': // Sundanese

      case 'th': // Thai

      case 'tt': // Tatar

      case 'ug': // Uyghur

      case 'vi': // Vietnamese

      case 'wo': // Wolof

      case 'zh':
        // Chinese
        // 1 form
        return 0;

      case 'is':
        // Icelandic
        // 2 forms
        return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;

      case 'jv':
        // Javanese
        // 2 forms
        return n !== 0 ? 1 : 0;

      case 'mk':
        // Macedonian
        // 2 forms
        return n === 1 || n % 10 === 1 ? 0 : 1;

      case 'ach': // Acholi

      case 'ak': // Akan

      case 'am': // Amharic

      case 'arn': // Mapudungun

      case 'br': // Breton

      case 'fil': // Filipino

      case 'fr': // French

      case 'gun': // Gun

      case 'ln': // Lingala

      case 'mfe': // Mauritian Creole

      case 'mg': // Malagasy

      case 'mi': // Maori

      case 'oc': // Occitan

      case 'pt_BR': // Brazilian Portuguese

      case 'tg': // Tajik

      case 'ti': // Tigrinya

      case 'tr': // Turkish

      case 'uz': // Uzbek

      case 'wa': // Walloon

      /* eslint-disable */

      /* Disable "Duplicate case label" because there are 2 forms of Chinese plurals */

      case 'zh':
        // Chinese

        /* eslint-enable */
        // 2 forms
        return n > 1 ? 1 : 0;

      case 'lv':
        // Latvian
        // 3 forms
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2;

      case 'lt':
        // Lithuanian
        // 3 forms
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'be': // Belarusian

      case 'bs': // Bosnian

      case 'hr': // Croatian

      case 'ru': // Russian

      case 'sr': // Serbian

      case 'uk':
        // Ukrainian
        // 3 forms
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'mnk':
        // Mandinka
        // 3 forms
        return n === 0 ? 0 : n === 1 ? 1 : 2;

      case 'ro':
        // Romanian
        // 3 forms
        return n === 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2;

      case 'pl':
        // Polish
        // 3 forms
        return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'cs': // Czech

      case 'sk':
        // Slovak
        // 3 forms
        return n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;

      case 'csb':
        // Kashubian
        // 3 forms
        return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'sl':
        // Slovenian
        // 4 forms
        return n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3;

      case 'mt':
        // Maltese
        // 4 forms
        return n === 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3;

      case 'gd':
        // Scottish Gaelic
        // 4 forms
        return n === 1 || n === 11 ? 0 : n === 2 || n === 12 ? 1 : n > 2 && n < 20 ? 2 : 3;

      case 'cy':
        // Welsh
        // 4 forms
        return n === 1 ? 0 : n === 2 ? 1 : n !== 8 && n !== 11 ? 2 : 3;

      case 'kw':
        // Cornish
        // 4 forms
        return n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3;

      case 'ga':
        // Irish
        // 5 forms
        return n === 1 ? 0 : n === 2 ? 1 : n > 2 && n < 7 ? 2 : n > 6 && n < 11 ? 3 : 4;

      case 'ar':
        // Arabic
        // 6 forms
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;

      default:
        // Everything else
        return n !== 1 ? 1 : 0;
    }
  }
};

var VuexI18nPlugin = {}; // internationalization plugin for vue js using vuex

VuexI18nPlugin.install = function install(Vue, store, config) {
  // TODO: remove this block for next major update (API break)
  if (typeof arguments[2] === 'string' || typeof arguments[3] === 'string') {
    console.warn('i18n: Registering the plugin vuex-i18n with a string for `moduleName` or `identifiers` is deprecated. Use a configuration object instead.', 'https://github.com/dkfbasel/vuex-i18n#setup');
    config = {
      moduleName: arguments[2],
      identifiers: arguments[3]
    };
  } // merge default options with user supplied options


  config = Object.assign({
    warnings: true,
    moduleName: 'i18n',
    identifiers: ['{', '}'],
    preserveState: false,
    translateFilterName: 'translate',
    translateInFilterName: 'translateIn',
    onTranslationNotFound: function onTranslationNotFound() {}
  }, config); // define module name and identifiers as constants to prevent any changes

  var moduleName = config.moduleName;
  var identifiers = config.identifiers;
  var translateFilterName = config.translateFilterName;
  var translateInFilterName = config.translateInFilterName; // initialize the onTranslationNotFound function and make sure it is actually
  // a function

  var onTranslationNotFound = config.onTranslationNotFound;

  if (typeof onTranslationNotFound !== 'function') {
    console.error('i18n: i18n config option onTranslationNotFound must be a function');

    onTranslationNotFound = function onTranslationNotFound() {};
  } // register the i18n module in the vuex store
  // preserveState can be used via configuration if server side rendering is used


  store.registerModule(moduleName, i18nVuexModule, {
    preserveState: config.preserveState
  }); // check if the plugin was correctly initialized

  if (store.state.hasOwnProperty(moduleName) === false) {
    console.error('i18n: i18n vuex module is not correctly initialized. Please check the module name:', moduleName); // always return the key if module is not initialized correctly

    Vue.prototype.$i18n = function (key) {
      return key;
    };

    Vue.prototype.$getLanguage = function () {
      return null;
    };

    Vue.prototype.$setLanguage = function () {
      console.error('i18n: i18n vuex module is not correctly initialized');
    };

    return;
  }

  var render = renderFn(identifiers, config.warnings); // get localized string from store. note that we pass the arguments passed
  // to the function directly to the translateInLanguage function

  var translate = function $t() {
    // get the current language from the store
    var locale = store.state[moduleName].locale;
    return translateInLanguage.apply(void 0, [locale].concat(Array.prototype.slice.call(arguments)));
  }; // get localized string from store in a given language if available.
  // there are two possible signatures for the function.
  // we will check the arguments to make up the options passed.
  // 1: locale, key, options, pluralization
  // 2: locale, key, defaultValue, options, pluralization


  var translateInLanguage = function translateInLanguage(locale) {
    // read the function arguments
    var args = arguments; // initialize options

    var key = '';
    var defaultValue = '';
    var options = {};
    var pluralization = null;
    var count = args.length; // check if a default value was specified and fill options accordingly

    if (count >= 3 && typeof args[2] === 'string') {
      key = args[1];
      defaultValue = args[2];

      if (count > 3) {
        options = args[3];
      }

      if (count > 4) {
        pluralization = args[4];
      }
    } else {
      key = args[1]; // default value was not specified and is therefore the same as the key

      defaultValue = key;

      if (count > 2) {
        options = args[2];
      }

      if (count > 3) {
        pluralization = args[3];
      }
    } // return the default value if the locale is not set (could happen on initialization)


    if (!locale) {
      if (config.warnings) console.warn('i18n: i18n locale is not set when trying to access translations:', key);
      return defaultValue;
    } // get the translations from the store


    var translations = store.state[moduleName].translations; // get the last resort fallback from the store

    var fallback = store.state[moduleName].fallback; // split locale by - to support partial fallback for regional locales
    // like de-CH, en-UK

    var localeRegional = locale.split('-'); // flag for translation to exist or not

    var translationExists = true; // check if the language exists in the store. return the key if not

    if (translations.hasOwnProperty(locale) === false) {
      translationExists = false; // check if the key exists in the store. return the key if not
    } else if (translations[locale].hasOwnProperty(key) === false) {
      translationExists = false;
    } // return the value from the store


    if (translationExists === true) {
      return render(locale, translations[locale][key], options, pluralization);
    } // check if a regional locale translation would be available for the key
    // i.e. de for de-CH


    if (localeRegional.length > 1 && translations.hasOwnProperty(localeRegional[0]) === true && translations[localeRegional[0]].hasOwnProperty(key) === true) {
      return render(localeRegional[0], translations[localeRegional[0]][key], options, pluralization);
    } // invoke a method if a translation is not found


    var asyncTranslation = onTranslationNotFound(locale, key, defaultValue); // resolve async translations by updating the store

    if (asyncTranslation) {
      Promise.resolve(asyncTranslation).then(function (value) {
        var additionalTranslations = {};
        additionalTranslations[key] = value;
        addLocale(locale, additionalTranslations);
      });
    } // check if a vaild fallback exists in the store.
    // return the default value if not


    if (translations.hasOwnProperty(fallback) === false) {
      return render(locale, defaultValue, options, pluralization);
    } // check if the key exists in the fallback locale in the store.
    // return the default value if not


    if (translations[fallback].hasOwnProperty(key) === false) {
      return render(fallback, defaultValue, options, pluralization);
    }

    return render(locale, translations[fallback][key], options, pluralization);
  }; // add a filter function to translate in a given locale (i.e. {{ 'something' | translateIn('en') }})


  var translateInLanguageFilter = function translateInLanguageFilter(key, locale) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return translateInLanguage.apply(void 0, [locale, key].concat(args));
  }; // check if the given key exists in the current locale


  var checkKeyExists = function checkKeyExists(key) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fallback';
    // get the current language from the store
    var locale = store.state[moduleName].locale;
    var fallback = store.state[moduleName].fallback;
    var translations = store.state[moduleName].translations; // check the current translation

    if (translations.hasOwnProperty(locale) && translations[locale].hasOwnProperty(key)) {
      return true;
    }

    if (scope == 'strict') {
      return false;
    } // check any localized translations


    var localeRegional = locale.split('-');

    if (localeRegional.length > 1 && translations.hasOwnProperty(localeRegional[0]) && translations[localeRegional[0]].hasOwnProperty(key)) {
      return true;
    }

    if (scope == 'locale') {
      return false;
    } // check if a fallback locale exists


    if (translations.hasOwnProperty(fallback) && translations[fallback].hasOwnProperty(key)) {
      return true;
    } // key does not exist in the store


    return false;
  }; // set fallback locale


  var setFallbackLocale = function setFallbackLocale(locale) {
    store.dispatch({
      type: "".concat(moduleName, "/setFallbackLocale"),
      locale: locale
    });
  }; // set the current locale


  var setLocale = function setLocale(locale) {
    store.dispatch({
      type: "".concat(moduleName, "/setLocale"),
      locale: locale
    });
  }; // get the current locale


  var getLocale = function getLocale() {
    return store.state[moduleName].locale;
  }; // get all available locales


  var getLocales = function getLocales() {
    return Object.keys(store.state[moduleName].translations);
  }; // add predefined translations to the store (keeping existing information)


  var addLocale = function addLocale(locale, translations) {
    return store.dispatch({
      type: "".concat(moduleName, "/addLocale"),
      locale: locale,
      translations: translations
    });
  }; // replace all locale information in the store


  var replaceLocale = function replaceLocale(locale, translations) {
    return store.dispatch({
      type: "".concat(moduleName, "/replaceLocale"),
      locale: locale,
      translations: translations
    });
  }; // remove the givne locale from the store


  var removeLocale = function removeLocale(locale) {
    if (store.state[moduleName].translations.hasOwnProperty(locale)) {
      store.dispatch({
        type: "".concat(moduleName, "/removeLocale"),
        locale: locale
      });
    }
  }; // we are phasing out the exists function


  var phaseOutExistsFn = function phaseOutExistsFn(locale) {
    if (config.warnings) console.warn('i18n: $i18n.exists is depreceated. Please use $i18n.localeExists instead. It provides exactly the same functionality.');
    return checkLocaleExists(locale);
  }; // check if the given locale is already loaded


  var checkLocaleExists = function checkLocaleExists(locale) {
    return store.state[moduleName].translations.hasOwnProperty(locale);
  }; // register vue prototype methods


  Vue.prototype.$i18n = {
    locale: getLocale,
    locales: getLocales,
    set: setLocale,
    add: addLocale,
    replace: replaceLocale,
    remove: removeLocale,
    fallback: setFallbackLocale,
    localeExists: checkLocaleExists,
    keyExists: checkKeyExists,
    translate: translate,
    translateIn: translateInLanguage,
    exists: phaseOutExistsFn
  }; // register global methods

  Vue.i18n = {
    locale: getLocale,
    locales: getLocales,
    set: setLocale,
    add: addLocale,
    replace: replaceLocale,
    remove: removeLocale,
    fallback: setFallbackLocale,
    translate: translate,
    translateIn: translateInLanguage,
    localeExists: checkLocaleExists,
    keyExists: checkKeyExists,
    exists: phaseOutExistsFn
  }; // register the translation function on the vue instance directly

  Vue.prototype.$t = translate; // register the specific language translation function on the vue instance directly

  Vue.prototype.$tlang = translateInLanguage; // register a filter function for translations

  Vue.filter(translateFilterName, translate);
  Vue.filter(translateInFilterName, translateInLanguageFilter);
}; // renderFn will initialize a function to render the variable substitutions in
// the translation string. identifiers specify the tags will be used to find
// variable substitutions, i.e. {test} or {{test}}, note that we are using a
// closure to avoid recompilation of the regular expression to match tags on
// every render cycle.


var renderFn = function renderFn(identifiers) {
  var warnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (identifiers == null || identifiers.length != 2) {
    console.warn('i18n: You must specify the start and end character identifying variable substitutions');
  } // construct a regular expression ot find variable substitutions, i.e. {test}


  var matcher = new RegExp('' + identifiers[0] + '{1}(\\w{1}|\\w.+?)' + identifiers[1] + '{1}', 'g'); // define the replacement function

  var replace = function replace(translation, replacements) {
    // check if the object has a replace property
    if (!translation.replace) {
      return translation;
    }

    return translation.replace(matcher, function (placeholder) {
      // remove the identifiers (can be set on the module level)
      var key = placeholder.replace(identifiers[0], '').replace(identifiers[1], '');

      if (replacements[key] !== undefined) {
        return replacements[key];
      } // warn user that the placeholder has not been found


      if (warnings) {
        console.group ? console.group('i18n: Not all placeholders found') : console.warn('i18n: Not all placeholders found');
        console.warn('Text:', translation);
        console.warn('Placeholder:', placeholder);

        if (console.groupEnd) {
          console.groupEnd();
        }
      } // return the original placeholder


      return placeholder;
    });
  }; // the render function will replace variable substitutions and prepare the
  // translations for rendering


  var render = function render(locale, translation) {
    var replacements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var pluralization = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    // get the type of the property
    var objType = _typeof(translation);

    var pluralizationType = _typeof(pluralization);

    var resolvePlaceholders = function resolvePlaceholders() {
      if (isArray$1(translation)) {
        // replace the placeholder elements in all sub-items
        return translation.map(function (item) {
          return replace(item, replacements, false);
        });
      } else if (objType === 'string') {
        return replace(translation, replacements, true);
      }
    }; // return translation item directly


    if (pluralization === null) {
      return resolvePlaceholders();
    } // check if pluralization value is countable


    if (pluralizationType !== 'number') {
      if (warnings) console.warn('i18n: pluralization is not a number');
      return resolvePlaceholders();
    } // --- handle pluralizations ---
    // replace all placeholders


    var resolvedTranslation = resolvePlaceholders(); // initialize pluralizations

    var pluralizations = null; // if translations are already an array and have more than one entry,
    // we will not perform a split operation on :::

    if (isArray$1(resolvedTranslation) && resolvedTranslation.length > 0) {
      pluralizations = resolvedTranslation;
    } else {
      // split translation strings by ::: to find create the pluralization array
      pluralizations = resolvedTranslation.split(':::');
    } // determine the pluralization version to use by locale


    var index = plurals.getTranslationIndex(locale, pluralization); // check if the specified index is present in the pluralization

    if (typeof pluralizations[index] === 'undefined') {
      if (warnings) {
        console.warn('i18n: pluralization not provided in locale', translation, locale, index);
      } // return the first element of the pluralization by default


      return pluralizations[0].trim();
    } // return the requested item from the pluralizations


    return pluralizations[index].trim();
  }; // return the render function to the caller


  return render;
}; // check if the given object is an array


function isArray$1(obj) {
  return !!obj && Array === obj.constructor;
}

// import the vuex module for localization

var index = {
  store: i18nVuexModule,
  plugin: VuexI18nPlugin
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable max-len */
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * @param {{ directive: (arg0: string, arg1: { inserted(el: HTMLFormElement, binding: object): void; update(el: HTMLFormElement, binding: object): void; }) => void; }} Vue
   */
  install: function install(Vue) {
    Vue.directive('focus', {
      /**
       * @param {HTMLFormElement} el
       * @param {{ value: any; modifiers: object; }} binding
       */
      inserted: function inserted(el, binding) {
        var modifiers = binding.modifiers,
            value = binding.value;


        if (value || value === undefined) {
          el.focus();
          if (modifiers.select) {
            el.select();
          }
        }
      },

      /**
       * @param {HTMLFormElement} el
       * @param {{ oldValue: any; value: any; }} binding
       */
      update: function update(el, binding) {
        var oldValue = binding.oldValue,
            value = binding.value;

        if (value && value !== oldValue) {
          el.focus();
        }
      }
    });
  }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index--e786f02e.js